import { useState, useEffect, useLayoutEffect, useMemo, useRef, useCallback, Fragment } from 'react';
import { Plus, Trash2, Calculator, Layers, Printer, Save, Database, FolderOpen, FolderPlus, Eye, EyeOff, Move, Type, MessageSquare, Maximize2, History, RotateCcw, RotateCw, FileText, ChevronUp, ChevronDown, ChevronRight, ChevronLeft, GripVertical, Clock, BarChart3, Upload, ClipboardList, TrendingUp, Table, Calendar, Package, Box, Search, Pencil, Trophy, MessageCircle, LayoutGrid, Check, X, Target, ClipboardPaste, BookOpen, RefreshCw, FileSpreadsheet, ListChecks } from 'lucide-react';
import ColarExcelRelatorioModal from '../../components/corte/ColarExcelRelatorioModal';
import {
  gerarNomeUnificadoInteligente,
  numerosLoteDeTexto,
} from '../../components/corte/familiasProdutos';
import { cardTempoCortePertenceAoLote } from '../../utils/tempoProducaoPecaLote';
import {
  loteCadastroCoincide,
  renumerarCardsTempoCorte,
  renumerarListaTextoLote,
  renumerarLotesProdutos,
  renumerarPersistenciaTempoProducaoPeca,
  substituirNumeroLoteEmTexto,
} from '../../utils/renumerarLoteCompleto';
import * as XLSX from 'xlsx';
import { ordemMaterialSort, calcularMinutosUteis } from '../../utils/horarioTrabalho';
import {
  useCorteStore,
  getCorCodigo,
  getEixoNome,
  validarPecasContraChapa,
  sincronizarApenasProjetosSalvosDoDisco,
  flushPersistenciaCatalogo,
} from '../../store/corte/useCorteStore';
import type { EixoCodigo, PecaCorte } from '../../types/corte';
import VisualizacaoCorte from '../../components/corte/VisualizacaoCorte';
import type { CaixaTextoPlano } from '../../types/caixaTextoPlano';
import { layoutCaixaTextoImpressao } from '../../utils/caixaTextoPlanoCoords';
import CatalogoProjetoCard from '../../components/corte/CatalogoProjetoCard';
import AnaliseTempoSection from '../../components/corte/AnaliseTempoSection';
import TempoProducaoPecaSection from '../../components/corte/TempoProducaoPecaSection';
import AdiantamentoMdfSection from '../../components/corte/AdiantamentoMdfSection';
import BoletimLinhaFabrica from '../../components/corte/BoletimLinhaFabrica';
import CalculadoraPlanilhaSection from '../../components/corte/CalculadoraPlanilhaSection';
import ProdutoPorPalete from '../../components/corte/ProdutoPorPalete';
import TempoParaEmbalar from '../../components/corte/TempoParaEmbalar';
import InstrucoesSection from '../../components/corte/InstrucoesSection';
import ResultadosCopa from '../../components/corte/ResultadosCopa';
import ImportarLotesExcelModal, { type LoteImportadoExcel } from '../../components/corte/ImportarLotesExcelModal';
import { type AbaPrincipal, ABA_LABELS, moduloFixoDaUrl } from './abasModulo';
import {
  isJanelaModuloFilha,
  janelaRelatorioAberta,
  navegarParaModulo,
  nwDisponivel,
  focarJanelaRelatorio,
  tituloJanelaModulo,
} from '../../utils/nwModulosJanela';
import {
  enviarCarregarProjetoParaJanelaPrincipal,
  enviarCarregarHistoricoParaJanelaProjeto,
  escutarCarregarProjetoNaJanelaPrincipal,
  escutarCarregarHistoricoNaJanelaProjeto,
  type HistoricoImpressaoCrossPayload,
} from '../../utils/adeCrossWindow';
import {
  atualizarRelatorioEstado,
  lerRelatorioEstado,
  notificarRelatorioAtualizado,
  salvarRelatorioEstado,
} from '../../utils/adeRelatorioPersistencia';
import {
  dadosNecessariosModulo,
  escutarSyncDesktop,
  moduloPrecisaDado,
  montarComponentePesado,
  moduloEscopoJanelaPrincipal,
  notificarSyncDesktop,
  type SyncChave,
} from '../../utils/adeDesktopSync';
import { useDebouncedEffect } from '../../utils/useDebouncedEffect';
import {
  lerArraysLegadoLocalStorage,
  deduplicarProdutosTempoCortePorLoteNome,
  mesclarProdutosTempoCorte,
  mesclarRegistrosPorId,
  resumoRegistrosComLote,
  CHAVES_HISTORICO_IMPRESSOES,
  CHAVES_PRODUTOS_TEMPO_CORTE,
  CHAVES_SOBRA_PASTAS,
  CHAVES_SOBRA_PECAS,
  CHAVES_SOBRA_RISCADOS,
  CHAVES_TEMPO_CORTE_ITENS,
} from '../../utils/adePersistenciaRecuperacao';
import {
  chaveNomeProdutoTempoCorte,
  gerarCardsTempoCorteFaltantes,
  listarPendenciasCardsTempoCorte,
  nomesProdutoIguais,
  resumirPendenciasPorLote,
  resumirPendentesAutoCards,
} from '../../utils/autoCardsTempoCorte';
import {
  filtrarCardsTempoCorteNaoExcluidos,
  lerEpochExclusoesCardsTempoCorte,
  flushExclusoesCardsTempoCorte,
  hidratarExclusoesCardsTempoCorte,
  liberarExclusaoCardTempoCorte,
  registrarExclusaoCardTempoCorte,
  registrarExclusoesCardsTempoCorte,
} from '../../utils/cardsTempoCorteExcluidos';
import { tentarLerCardsTempoCorteDeBackupDisco } from '../../utils/adeBackupAutomatico';
import {
  deveBloquearGravacaoCardsTempoCorte,
  salvarSnapshotUltimoBomCardsTempoCorte,
} from '../../utils/tempoCorteCardsGuard';
import {
  filtrarSobraNaoExcluidas,
  registrarExclusaoEntradaSobra,
  registrarExclusaoLinhaSobra,
} from '../../utils/sobraExcluidas';
import { sincronizarListaPecasProdutoEntreCards } from '../../utils/propagarPecasTempoCorte';
import { descricaoPecaSemCor, nomeProdutoSemCor } from '../../utils/resolverProdutoPontuacao';
import {
  corrigirGrafiaBerlin,
  corrigirListaNomesBerlimBerlin,
  aplicarMigracaoBerlimBerlinLocalStorage,
} from '../../utils/corrigirGrafiaBerlin';
import {
  corrigirListaNomesBuffetAron4Portas,
  aplicarMigracaoBuffetAron4PortasLocalStorage,
} from '../../utils/corrigirNomeBuffetAron';
import {
  agregarPontuacaoPorMesTabelaDias,
  aplicarMigracaoPurgaFantasma8723,
  aplicarMigracaoPurga8833BuffetLume,
  aplicarSyncTabelaDiasComLotes,
  buscarM2ProdutoBoletim,
  calcularPontuacaoLotesPorDia,
  coletarLotesFontesAlternativas,
  colapsarDuplicatasLoteProduto,
  deduplicarLotesPorLoteProduto,
  chaveParLoteProduto,
  chaveParLoteProdutoNome,
  paresExclusaoDeLoteProduto,
  filtrarLotesNaoExcluidos,
  lerChavesTabelaGeradasLotes,
  lerLotesLegadoLocalStorage,
  normalizarMapaTabelaDias,
  mesclarEdicaoLoteSalva,
  mesclarLotesProdutos,
  mesclarTabelaComValoresManuais,
  pontosLinhaLoteBoletim,
  recuperarLotesFaltantesNoFinal,
  registrarIdsLotesExcluidos,
  registrarParesLotesExcluidos,
  liberarParesLotesExcluidos,
  resumoLotes,
  salvarValorTabelaManual,
  salvarChavesTabelaGeradasLotes,
  salvarLotesLegadoLocalStorage,
  somarPontuacaoMesTabelaDias,
} from '../../utils/adePersistenciaLotes';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
// @ts-ignore
import Highcharts3d from 'highcharts/highcharts-3d';
if (typeof Highcharts3d === 'function') Highcharts3d(Highcharts);

const STORAGE_LOTES_IMPRESSOS_PALETE = 'produto-palete-lotes-impressos-ade';
const STORAGE_AUDITORIA_ADE = 'auditoria-acoes-ade';
const STORAGE_LOTES_FINAL_MANUAL = 'lotes-finalizados-manual-ade';
/** Primeiro mês da janela de 13 meses do gráfico do Boletim (formato YYYY-MM). */
const STORAGE_GRAFICO_MES_INICIO_BOLETIM = 'boletim-grafico-mes-inicio-ade';

function mesAnoInicioGraficoBoletimPadrao(): string {
  const hoje = new Date();
  let a = hoje.getFullYear();
  let m = hoje.getMonth() + 1 - 12;
  while (m <= 0) {
    m += 12;
    a -= 1;
  }
  return `${a}-${String(m).padStart(2, '0')}`;
}
const DB_TEMPO_CORTE = 'ade-tempo-corte-db';
const DB_TEMPO_CORTE_VERSION = 9;
const STORE_TEMPO_CORTE = 'tempoCorte';
const KEY_PRODUTOS_TEMPO_CORTE = 'produtosTempoCorteSalvos';
const KEY_TEMPO_CORTE_ITENS = 'tempoCorteItens';
const STORE_HISTORICO_IMPRESSOES = 'historicoImpressoes';
const KEY_HISTORICO_IMPRESSOES = 'historicoImpressoes';
const STORE_AUDITORIA = 'auditoriaAcoes';
const KEY_AUDITORIA = 'auditoriaAcoes';
const STORE_LOTES_PRODUTOS = 'lotesProdutos';
const KEY_LOTES_PRODUTOS = 'lotesProdutos';
const STORE_RELATORIO = 'relatorioPecas';
const KEY_RELATORIO = 'relatorioPecas';
const STORE_SOBRA = 'sobraPecas';
const KEY_SOBRA = 'sobraPecas';
const STORE_SOBRA_RISCADOS = 'sobraRiscados';
const KEY_SOBRA_RISCADOS = 'sobraRiscados';
const STORE_SOBRA_PASTAS = 'sobraPastas';
const KEY_SOBRA_PASTAS = 'sobraPastas';
const STORE_LAYOUT_IMPRESSAO = 'layoutImpressao';
const KEY_LAYOUT_IMPRESSAO = 'layoutImpressao';
const STORE_ZUSTAND_PERSIST = 'zustandPersist';
const abrirDbTempoCorte = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_TEMPO_CORTE, DB_TEMPO_CORTE_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_TEMPO_CORTE)) {
        db.createObjectStore(STORE_TEMPO_CORTE);
      }
      if (!db.objectStoreNames.contains(STORE_HISTORICO_IMPRESSOES)) {
        db.createObjectStore(STORE_HISTORICO_IMPRESSOES);
      }
      if (!db.objectStoreNames.contains(STORE_AUDITORIA)) {
        db.createObjectStore(STORE_AUDITORIA);
      }
      if (!db.objectStoreNames.contains(STORE_LOTES_PRODUTOS)) {
        db.createObjectStore(STORE_LOTES_PRODUTOS);
      }
      if (!db.objectStoreNames.contains(STORE_RELATORIO)) {
        db.createObjectStore(STORE_RELATORIO);
      }
      if (!db.objectStoreNames.contains(STORE_SOBRA)) {
        db.createObjectStore(STORE_SOBRA);
      }
      if (!db.objectStoreNames.contains(STORE_SOBRA_RISCADOS)) {
        db.createObjectStore(STORE_SOBRA_RISCADOS);
      }
      if (!db.objectStoreNames.contains(STORE_SOBRA_PASTAS)) {
        db.createObjectStore(STORE_SOBRA_PASTAS);
      }
      if (!db.objectStoreNames.contains(STORE_LAYOUT_IMPRESSAO)) {
        db.createObjectStore(STORE_LAYOUT_IMPRESSAO);
      }
      if (!db.objectStoreNames.contains(STORE_ZUSTAND_PERSIST)) {
        db.createObjectStore(STORE_ZUSTAND_PERSIST);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

const lerProdutosTempoCorteDB = async (): Promise<any[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_TEMPO_CORTE, 'readonly');
      const store = tx.objectStore(STORE_TEMPO_CORTE);
      const req = store.get(KEY_PRODUTOS_TEMPO_CORTE);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? data : null;
  } catch {
    return null;
  }
};

const salvarProdutosTempoCorteDB = async (items: any[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_TEMPO_CORTE, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    const store = tx.objectStore(STORE_TEMPO_CORTE);
    store.put(items, KEY_PRODUTOS_TEMPO_CORTE);
  });
  db.close();
};

const lerTempoCorteItensDB = async (): Promise<TempoCorteItem[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_TEMPO_CORTE, 'readonly');
      const store = tx.objectStore(STORE_TEMPO_CORTE);
      const req = store.get(KEY_TEMPO_CORTE_ITENS);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? (data as TempoCorteItem[]) : null;
  } catch {
    return null;
  }
};

const salvarTempoCorteItensDB = async (items: TempoCorteItem[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_TEMPO_CORTE, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    const store = tx.objectStore(STORE_TEMPO_CORTE);
    store.put(items, KEY_TEMPO_CORTE_ITENS);
  });
  db.close();
};

/** Evita janela sem escopo / save acidental apagar o acervo de cards. */
const salvarProdutosTempoCorteDBSeguro = async (
  items: unknown[],
  existente?: unknown[]
): Promise<{ gravou: boolean; final?: unknown[] }> => {
  const epochInicio = lerEpochExclusoesCardsTempoCorte();
  await hidratarExclusoesCardsTempoCorte();

  // NÃO usar coletar() aqui: ele pode rematerializar legado do localStorage no meio de um save.
  const backupRaw =
    (existente as Record<string, unknown>[] | undefined) ??
    ((await lerProdutosTempoCorteDB()) as Record<string, unknown>[] | null) ??
    [];

  const limpos = deduplicarProdutosTempoCortePorLoteNome(
    filtrarCardsTempoCorteNaoExcluidos(
      (Array.isArray(items) ? items : []) as { id?: string; nome?: string; lote?: string }[]
    )
  );

  const guarda = deveBloquearGravacaoCardsTempoCorte(backupRaw, limpos);
  if (guarda.bloquear) {
    console.warn('[Sistema Ade] Tempo de Corte:', guarda.motivo);
    // Garante snapshot do que ainda existe no disco
    if (Array.isArray(backupRaw) && backupRaw.length > 0) {
      salvarSnapshotUltimoBomCardsTempoCorte(backupRaw);
    }
    return { gravou: false, final: backupRaw };
  }

  if (limpos.length === 0) {
    const backupLimpo = deduplicarProdutosTempoCortePorLoteNome(
      filtrarCardsTempoCorteNaoExcluidos(
        (Array.isArray(backupRaw) ? backupRaw : []) as { id?: string; nome?: string; lote?: string }[]
      )
    );
    // Nunca gravar [] se ainda houver cards válidos no disco
    if (backupLimpo.length > 0) return { gravou: false, final: backupLimpo };
    // Disco já vazio (ou só cards excluídos): não regrava [] de novo
    if (Array.isArray(backupRaw) && backupRaw.length > 0) {
      return { gravou: false, final: backupRaw };
    }
    return { gravou: false, final: [] };
  }

  await salvarProdutosTempoCorteDB(limpos);
  try {
    localStorage.setItem('produtos-tempo-corte-ade', JSON.stringify(limpos));
  } catch {
    /* ignora quota */
  }
  salvarSnapshotUltimoBomCardsTempoCorte(limpos);

  // Exclusão ocorreu durante a gravação → regrava só o que ainda é válido.
  if (lerEpochExclusoesCardsTempoCorte() !== epochInicio) {
    await hidratarExclusoesCardsTempoCorte();
    const disco =
      ((await lerProdutosTempoCorteDB()) as { id?: string; nome?: string; lote?: string }[] | null) ??
      limpos;
    const refiltrado = deduplicarProdutosTempoCortePorLoteNome(
      filtrarCardsTempoCorteNaoExcluidos(disco)
    );
    const guarda2 = deveBloquearGravacaoCardsTempoCorte(disco, refiltrado);
    if (guarda2.bloquear) {
      console.warn('[Sistema Ade] Tempo de Corte (pós-exclusão):', guarda2.motivo);
      return { gravou: true, final: limpos };
    }
    await salvarProdutosTempoCorteDB(refiltrado);
    try {
      localStorage.setItem('produtos-tempo-corte-ade', JSON.stringify(refiltrado));
    } catch {
      /* ignora */
    }
    if (refiltrado.length > 0) salvarSnapshotUltimoBomCardsTempoCorte(refiltrado);
    return { gravou: true, final: refiltrado };
  }

  return { gravou: true, final: limpos };
};

/** Grava produtos do tempo de corte sem mesclar com backup — uso após edição normal. */
const persistirProdutosTempoCorteDireto = async (items: unknown[]): Promise<void> => {
  const epochInicio = lerEpochExclusoesCardsTempoCorte();
  await hidratarExclusoesCardsTempoCorte();
  let limpos = deduplicarProdutosTempoCortePorLoteNome(
    filtrarCardsTempoCorteNaoExcluidos(
      (Array.isArray(items) ? items : []) as { id?: string; nome?: string; lote?: string }[]
    )
  );

  const existente = await lerProdutosTempoCorteDB();
  const guarda = deveBloquearGravacaoCardsTempoCorte(existente, limpos);
  if (guarda.bloquear) {
    console.warn('[Sistema Ade] Tempo de Corte (direto):', guarda.motivo);
    if (Array.isArray(existente) && existente.length > 0) {
      salvarSnapshotUltimoBomCardsTempoCorte(existente);
    }
    return;
  }

  // Nunca apagar cards existentes com lista vazia acidental.
  if (limpos.length === 0) {
    if (Array.isArray(existente) && existente.length > 0) {
      return;
    }
    return;
  }

  try {
    localStorage.setItem('produtos-tempo-corte-ade', JSON.stringify(limpos));
  } catch {
    /* ignora quota */
  }
  await salvarProdutosTempoCorteDB(limpos);
  salvarSnapshotUltimoBomCardsTempoCorte(limpos);

  if (lerEpochExclusoesCardsTempoCorte() !== epochInicio) {
    await hidratarExclusoesCardsTempoCorte();
    const disco =
      ((await lerProdutosTempoCorteDB()) as { id?: string; nome?: string; lote?: string }[] | null) ??
      limpos;
    limpos = deduplicarProdutosTempoCortePorLoteNome(filtrarCardsTempoCorteNaoExcluidos(disco));
    const guarda2 = deveBloquearGravacaoCardsTempoCorte(disco, limpos);
    if (guarda2.bloquear) return;
    if (limpos.length === 0) return;
    try {
      localStorage.setItem('produtos-tempo-corte-ade', JSON.stringify(limpos));
    } catch {
      /* ignora */
    }
    await salvarProdutosTempoCorteDB(limpos);
    salvarSnapshotUltimoBomCardsTempoCorte(limpos);
  }
};

/** Evita janela sem escopo apagar itens do tempo de corte com gravação vazia acidental. */
const salvarTempoCorteItensDBSeguro = async (items: TempoCorteItem[]): Promise<boolean> => {
  if (items.length === 0) {
    const existente = await lerTempoCorteItensDB();
    if (existente && existente.length > 0) return false;
    if (legadoLocalStorageTemDados('tempo-corte-itens-ade')) return false;
  }
  await salvarTempoCorteItensDB(items);
  try {
    localStorage.setItem('tempo-corte-itens-ade', JSON.stringify(items));
  } catch {
    /* ignora quota */
  }
  return true;
};

const legadoLocalStorageTemDados = (key: string): boolean => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0;
  } catch {
    return false;
  }
};

/** Grava no IndexedDB + localStorage sem sobrescrever dados existentes com lista vazia. */
const salvarArrayIndexedDBSeguro = async <T,>(
  ler: () => Promise<T[] | null>,
  salvar: (items: T[]) => Promise<void>,
  items: T[],
  legadoKey: string
): Promise<boolean> => {
  if (items.length === 0) {
    const existente = await ler();
    if (existente && existente.length > 0) return false;
    if (legadoLocalStorageTemDados(legadoKey)) return false;
  }
  await salvar(items);
  try {
    localStorage.setItem(legadoKey, JSON.stringify(items));
  } catch {
    /* ignora quota */
  }
  return true;
};

const lerHistoricoImpressoesDB = async (): Promise<HistoricoImpressao[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_HISTORICO_IMPRESSOES, 'readonly');
      const store = tx.objectStore(STORE_HISTORICO_IMPRESSOES);
      const req = store.get(KEY_HISTORICO_IMPRESSOES);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? (data as HistoricoImpressao[]) : null;
  } catch {
    return null;
  }
};

const salvarHistoricoImpressoesDB = async (items: HistoricoImpressao[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_HISTORICO_IMPRESSOES, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    const store = tx.objectStore(STORE_HISTORICO_IMPRESSOES);
    store.put(items, KEY_HISTORICO_IMPRESSOES);
  });
  db.close();
};

const lerAuditoriaDB = async (): Promise<AuditoriaAcao[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_AUDITORIA, 'readonly');
      const store = tx.objectStore(STORE_AUDITORIA);
      const req = store.get(KEY_AUDITORIA);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? (data as AuditoriaAcao[]) : null;
  } catch {
    return null;
  }
};

const salvarAuditoriaDB = async (items: AuditoriaAcao[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_AUDITORIA, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    const store = tx.objectStore(STORE_AUDITORIA);
    store.put(items, KEY_AUDITORIA);
  });
  db.close();
};

const lerLotesProdutosDB = async (): Promise<LoteProdutoConfig[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_LOTES_PRODUTOS, 'readonly');
      const store = tx.objectStore(STORE_LOTES_PRODUTOS);
      const req = store.get(KEY_LOTES_PRODUTOS);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? (data as LoteProdutoConfig[]) : null;
  } catch {
    return null;
  }
};

const salvarLotesProdutosDB = async (items: LoteProdutoConfig[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_LOTES_PRODUTOS, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE_LOTES_PRODUTOS).put(items, KEY_LOTES_PRODUTOS);
  });
  db.close();
};

/** Cópia antiga: lotes podem ter ficado no store tempoCorte antes da migração. */
const lerLotesProdutosLegadoStoreTempoCorte = async (): Promise<LoteProdutoConfig[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<unknown>((resolve, reject) => {
      const tx = db.transaction(STORE_TEMPO_CORTE, 'readonly');
      const store = tx.objectStore(STORE_TEMPO_CORTE);
      const req = store.get(KEY_LOTES_PRODUTOS);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? (data as LoteProdutoConfig[]) : null;
  } catch {
    return null;
  }
};

const coletarLotesTodasFontesRecuperacao = async (): Promise<LoteProdutoConfig[]> => {
  const [dbItems, legadoStore] = await Promise.all([
    lerLotesProdutosDB(),
    lerLotesProdutosLegadoStoreTempoCorte(),
  ]);
  const legadoLs = lerLotesLegadoLocalStorage();
  return filtrarLotesNaoExcluidos(
    mesclarLotesProdutos(
      Array.isArray(legadoStore) ? legadoStore : [],
      legadoLs,
      Array.isArray(dbItems) ? dbItems : []
    )
  );
};

/** Cadastro canônico: mescla fontes e aplica exclusões (evita IndexedDB velho ressuscitar linha apagada). */
const coletarLotesCadastro = async (): Promise<LoteProdutoConfig[]> => {
  const [dbItems, legadoStore] = await Promise.all([
    lerLotesProdutosDB(),
    lerLotesProdutosLegadoStoreTempoCorte(),
  ]);
  const legadoLs = lerLotesLegadoLocalStorage();
  // IndexedDB é a verdade quando tem dados — mesclar LS/legado antigo recolocava linha apagada.
  if (Array.isArray(dbItems) && dbItems.length > 0) {
    return deduplicarLotesPorLoteProduto(filtrarLotesNaoExcluidos(dbItems));
  }
  const fontes: LoteProdutoConfig[][] = [];
  if (Array.isArray(legadoStore) && legadoStore.length > 0) fontes.push(legadoStore);
  if (legadoLs.length > 0) fontes.push(legadoLs);
  if (Array.isArray(dbItems) && dbItems.length > 0) fontes.push(dbItems);
  if (fontes.length === 0) return [];
  return deduplicarLotesPorLoteProduto(filtrarLotesNaoExcluidos(mesclarLotesProdutos(...fontes)));
};

const limparLotesLegadoStoreTempoCorte = async (): Promise<void> => {
  try {
    const db = await abrirDbTempoCorte();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE_TEMPO_CORTE, 'readwrite');
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
      tx.objectStore(STORE_TEMPO_CORTE).delete(KEY_LOTES_PRODUTOS);
    });
    db.close();
  } catch {
    /* ignora */
  }
};

/** Grava lotes sem “recuperar” do backup — uso após exclusão ou edição normal. */
const persistirLotesProdutosDireto = async (items: LoteProdutoConfig[]): Promise<void> => {
  const limpos = deduplicarLotesPorLoteProduto(filtrarLotesNaoExcluidos(items), {
    registrarExcluidos: true,
  });
  // localStorage primeiro (síncrono) — sobrevive ao fechar a janela antes do IndexedDB terminar.
  salvarLotesLegadoLocalStorage(limpos);
  await salvarLotesProdutosDB(limpos);
  await limparLotesLegadoStoreTempoCorte();
};

/**
 * Lê produtos do Tempo de Corte.
 * IMPORTANTE: se o IndexedDB tem dados, NÃO mescla localStorage antigo —
 * esse merge era a principal causa de cards apagados voltarem.
 */
const coletarProdutosTempoCorteBruto = async (): Promise<Record<string, unknown>[]> => {
  await hidratarExclusoesCardsTempoCorte();
  const db = await lerProdutosTempoCorteDB();

  let base: Record<string, unknown>[] = [];
  if (Array.isArray(db) && db.length > 0) {
    base = db as Record<string, unknown>[];
  } else {
    const legados = lerArraysLegadoLocalStorage(CHAVES_PRODUTOS_TEMPO_CORTE) as Record<
      string,
      unknown
    >[][];
    const listas: Record<string, unknown>[][] = [];
    for (const leg of legados) {
      if (Array.isArray(leg) && leg.length > 0) listas.push(leg);
    }
    base = listas.length > 0 ? mesclarProdutosTempoCorte(listas) : [];
  }

  const limpos = deduplicarProdutosTempoCortePorLoteNome(
    filtrarCardsTempoCorteNaoExcluidos(base)
  );

  // Só regrava quando há dados. Gravar [] aqui apagava cards se o IDB viesse vazio por falha/corrida.
  if (limpos.length > 0) {
    try {
      localStorage.setItem('produtos-tempo-corte-ade', JSON.stringify(limpos));
    } catch {
      /* quota */
    }
    try {
      await salvarProdutosTempoCorteDB(limpos);
      salvarSnapshotUltimoBomCardsTempoCorte(limpos);
    } catch {
      /* ignora */
    }
  }
  return limpos as Record<string, unknown>[];
};

const coletarTempoCorteItensBruto = async (): Promise<TempoCorteItem[]> => {
  const db = await lerTempoCorteItensDB();
  const legados = lerArraysLegadoLocalStorage(CHAVES_TEMPO_CORTE_ITENS);
  const listas: Record<string, unknown>[][] = [];
  if (Array.isArray(db) && db.length > 0) listas.push(db as Record<string, unknown>[]);
  for (const leg of legados) {
    if (Array.isArray(leg) && leg.length > 0) listas.push(leg as Record<string, unknown>[]);
  }
  return listas.length > 0
    ? (mesclarRegistrosPorId(listas, {
        getId: (i) => String(i.id || '').trim(),
      }) as TempoCorteItem[])
    : [];
};

const coletarHistoricoImpressoesBruto = async (): Promise<HistoricoImpressao[]> => {
  const db = await lerHistoricoImpressoesDB();
  const legados = lerArraysLegadoLocalStorage(CHAVES_HISTORICO_IMPRESSOES);
  const listas: Record<string, unknown>[][] = [];
  if (Array.isArray(db) && db.length > 0) listas.push(db as Record<string, unknown>[]);
  for (const leg of legados) {
    if (Array.isArray(leg) && leg.length > 0) listas.push(leg as Record<string, unknown>[]);
  }
  return listas.length > 0
    ? (mesclarRegistrosPorId(listas, {
        getId: (i) => String(i.id || '').trim(),
      }) as HistoricoImpressao[])
    : [];
};

const coletarSobraBruto = async (): Promise<SobraEntradaADE[]> => {
  const db = await lerSobraDB();
  const legados = lerArraysLegadoLocalStorage(CHAVES_SOBRA_PECAS);
  const listas: SobraEntradaADE[][] = [];
  if (Array.isArray(db) && db.length > 0) {
    listas.push(db.map((e) => normalizarEntradasSobraADE(e as unknown as Record<string, unknown>)));
  }
  for (const leg of legados) {
    if (Array.isArray(leg) && leg.length > 0) {
      listas.push(
        (leg as Record<string, unknown>[]).map((e) => normalizarEntradasSobraADE(e))
      );
    }
  }
  const mesclados = listas.length > 0 ? mesclarEntradasSobraPorId(...listas) : [];
  return filtrarSobraNaoExcluidas(mesclados);
};

/** Grava sobra sem mesclar com cópia antiga — uso após exclusão/edição normal. */
const persistirSobraDireto = async (items: SobraEntradaADE[]): Promise<void> => {
  const limpos = filtrarSobraNaoExcluidas(items);
  try {
    localStorage.setItem('sobra-pecas-ade', JSON.stringify(limpos));
  } catch {
    /* quota */
  }
  await salvarSobraDB(limpos);
};

const coletarSobraPastasBruto = async (): Promise<SobraPastaADE[]> => {
  const db = await lerSobraPastasDB();
  const legados = lerArraysLegadoLocalStorage(CHAVES_SOBRA_PASTAS);
  const listas: Record<string, unknown>[][] = [];
  if (Array.isArray(db) && db.length > 0) listas.push(db as Record<string, unknown>[]);
  for (const leg of legados) {
    if (Array.isArray(leg) && leg.length > 0) listas.push(leg as Record<string, unknown>[]);
  }
  return listas.length > 0
    ? (mesclarRegistrosPorId(listas, {
        getId: (i) => String(i.id || '').trim(),
      }) as SobraPastaADE[])
    : [];
};

const coletarSobraRiscadosBruto = async (): Promise<string[]> => {
  const db = await lerSobraRiscadosDB();
  const legados = lerArraysLegadoLocalStorage(CHAVES_SOBRA_RISCADOS);
  const set = new Set<string>();
  if (Array.isArray(db)) db.forEach((x) => set.add(String(x)));
  for (const leg of legados) {
    if (Array.isArray(leg)) leg.forEach((x) => set.add(String(x)));
  }
  return [...set];
};

/** Salva lotes — só bloqueia gravar lista vazia se ainda houver backup (anti-apagamento acidental). */
const salvarLotesProdutosDBSeguro = async (
  items: LoteProdutoConfig[]
): Promise<{ gravou: boolean; atualizados?: LoteProdutoConfig[] }> => {
  const limpos = filtrarLotesNaoExcluidos(items);

  if (limpos.length === 0) {
    const existente = await coletarLotesCadastro();
    if (existente.length > 0) return { gravou: false };
    await persistirLotesProdutosDireto([]);
    return { gravou: true, atualizados: [] };
  }

  await persistirLotesProdutosDireto(limpos);
  return { gravou: true };
};

const lerSobraDB = async (): Promise<SobraEntradaADE[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_SOBRA, 'readonly');
      const store = tx.objectStore(STORE_SOBRA);
      const req = store.get(KEY_SOBRA);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? (data as SobraEntradaADE[]) : null;
  } catch {
    return null;
  }
};

const salvarSobraDB = async (items: SobraEntradaADE[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_SOBRA, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE_SOBRA).put(items, KEY_SOBRA);
  });
  db.close();
};

const lerSobraRiscadosDB = async (): Promise<string[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_SOBRA_RISCADOS, 'readonly');
      const store = tx.objectStore(STORE_SOBRA_RISCADOS);
      const req = store.get(KEY_SOBRA_RISCADOS);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return Array.isArray(data) ? data.map((x) => String(x)) : null;
  } catch {
    return null;
  }
};

const salvarSobraRiscadosDB = async (items: string[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_SOBRA_RISCADOS, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE_SOBRA_RISCADOS).put(items, KEY_SOBRA_RISCADOS);
  });
  db.close();
};

const lerSobraPastasDB = async (): Promise<SobraPastaADE[] | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_SOBRA_PASTAS, 'readonly');
      const store = tx.objectStore(STORE_SOBRA_PASTAS);
      const req = store.get(KEY_SOBRA_PASTAS);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    if (!Array.isArray(data)) return null;
    return data
      .filter((x: unknown) => x && typeof x === 'object' && typeof (x as SobraPastaADE).id === 'string')
      .map((x: SobraPastaADE) => ({ id: String(x.id), nome: String(x.nome || 'Pasta') }));
  } catch {
    return null;
  }
};

const salvarSobraPastasDB = async (items: SobraPastaADE[]): Promise<void> => {
  const db = await abrirDbTempoCorte();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_SOBRA_PASTAS, 'readwrite');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE_SOBRA_PASTAS).put(items, KEY_SOBRA_PASTAS);
  });
  db.close();
};

const lerLayoutImpressaoDB = async (): Promise<LayoutConfig | null> => {
  try {
    const db = await abrirDbTempoCorte();
    const data = await new Promise<any>((resolve, reject) => {
      const tx = db.transaction(STORE_LAYOUT_IMPRESSAO, 'readonly');
      const store = tx.objectStore(STORE_LAYOUT_IMPRESSAO);
      const req = store.get(KEY_LAYOUT_IMPRESSAO);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return data && typeof data === 'object' ? (data as LayoutConfig) : null;
  } catch {
    return null;
  }
};

const salvarLayoutImpressaoDB = async (layout: LayoutConfig): Promise<void> => {
  const payload = JSON.parse(JSON.stringify(layout)) as LayoutConfig;
  try {
    const db = await abrirDbTempoCorte();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE_LAYOUT_IMPRESSAO, 'readwrite');
      const req = tx.objectStore(STORE_LAYOUT_IMPRESSAO).put(payload, KEY_LAYOUT_IMPRESSAO);
      req.onerror = () => reject(req.error ?? new Error('IndexedDB put layout'));
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error ?? new Error('IndexedDB tx layout'));
    });
    db.close();
  } catch (err) {
    try {
      localStorage.setItem('layout-impressao-ade', JSON.stringify(payload));
    } catch {
      // ignora fallback
    }
    throw err;
  }
};

interface LayoutConfig {
  desenhoX: number;
  desenhoY: number;
  desenhoLargura: number;
  desenhoAltura: number;
  desenhoRotacao: number;
  desenhoEscalaX: number;
  desenhoEscalaY: number;
  infoX: number;
  infoY: number;
  infoLargura: number;
  infoAltura: number;
  infoRotacao: number;
  fontSize: number;
  fontSizeInfo: number;
  observacoes: string;
  obsX: number;
  obsY: number;
  obsLargura: number;
  obsAltura: number;
  obsRotacao: number;
  obsFontSize: number;
  quantidadeChapas: number;
  espessuraMaterial: number;
  tipoMaterial: 'aglomerado' | 'mdf';
  plano: number;
  etapas: number;
  /** Caixas de texto livres sobre o desenho (opcional — projetos antigos não têm). */
  caixasTexto?: CaixaTextoPlano[];
}

interface AuditoriaAcao {
  id: string;
  dataHoraISO: string;
  acao: string;
  contexto?: string;
}

interface HistoricoImpressao {
  id: string;
  data: string;
  dataHora: string;
  projeto: { nomeProduto: string; nomePeca: string };
  configuracao: { larguraTotal: number; comprimentoTotal: number; espessuraSerra: number };
  layoutConfig: LayoutConfig;
  pecas: { codigo: EixoCodigo; medida: number; quantidade: number }[];
  grupos: any[];
}

/** Gera uma "assinatura" determinística do plano de corte com base em: material,
 *  espessura, dimensões da chapa, quantidade de chapas e o conjunto de peças
 *  (medidas + quantidades). Usada para detectar plano repetido. */
function gerarAssinaturaPlano(
  layoutConfig: LayoutConfig,
  configuracao: { larguraTotal: number; comprimentoTotal: number },
  pecas: { codigo: EixoCodigo; medida: number; quantidade: number }[]
): string {
  const material = String(layoutConfig?.tipoMaterial || '').toLowerCase();
  const espessura = Number(layoutConfig?.espessuraMaterial || 0);
  const larguraChapa = Number(configuracao?.larguraTotal || 0);
  const compChapa = Number(configuracao?.comprimentoTotal || 0);
  const qtdChapas = Number(layoutConfig?.quantidadeChapas || 1);
  // Ordena peças para a assinatura ser insensível à ordem de inserção
  const pecasOrdenadas = [...pecas]
    .filter((p) => Number(p?.medida) > 0 && Number(p?.quantidade) > 0)
    .map((p) => `${p.codigo}:${Number(p.medida)}x${Number(p.quantidade)}`)
    .sort()
    .join('|');
  return `${material}_${espessura}_${larguraChapa}x${compChapa}_q${qtdChapas}__${pecasOrdenadas}`;
}

/** Calcula similaridade percentual entre 2 assinaturas (0-100).
 *  Compara as partes "peças" (medidas+quantidades) e considera os
 *  cabeçalhos (material/espessura/chapa). */
function compararAssinaturasPlano(a: string, b: string): number {
  if (!a || !b) return 0;
  if (a === b) return 100;
  const [cabA, ...corpoA] = a.split('__');
  const [cabB, ...corpoB] = b.split('__');
  // Cabeçalho (material, espessura, chapa) PRECISA bater. Se não bate, similaridade 0.
  if (cabA.split('_').slice(0, 3).join('_') !== cabB.split('_').slice(0, 3).join('_')) {
    return 0;
  }
  const pecasA = new Set(corpoA.join('__').split('|'));
  const pecasB = new Set(corpoB.join('__').split('|'));
  const intersecao = Array.from(pecasA).filter((p) => pecasB.has(p));
  const uniao = new Set([...pecasA, ...pecasB]);
  if (uniao.size === 0) return 0;
  return Math.round((intersecao.length / uniao.size) * 100);
}

interface RelatorioItem {
  id: string;
  corteNumero: number;
  nomePeca: string;
  quantidade: number;
  medidaMenor: number;
  medidaMaior: number;
  material: 'aglomerado' | 'mdf';
  espessura: number;
  lote: string;
  inicio: string;
  termino: string;
  observacao: string;
  /** Minutos (mesma base do Tempo de Corte — TEMPO CADA PEÇA⁸). */
  tempoPorPecaMinutos?: number;
  /** Se true, não sobrescreve o tempo automático. */
  tempoPorPecaManual?: boolean;
  planoOrigem: number;
  dataInclusao: string;
  /** Quando true, esta linha não entra na impressão do relatório atual. */
  ocultoRelatorio?: boolean;
  /** Quando true, a linha fica riscada na aba Sobra. */
  riscadoSobra?: boolean;
  /** Aba Sobra: em qual pasta esta linha (peça) está; não usado no Relatório. */
  pastaSobraId?: string | null;
}

function normalizarRelatorioItemLinha(itemRaw: Record<string, unknown>): RelatorioItem {
  return {
    ...(itemRaw as RelatorioItem),
    ocultoRelatorio: Boolean(itemRaw.ocultoRelatorio),
  };
}

/** Pasta na aba Sobra: agrupa linhas (registros) com o mesmo cabeçalho + peças. */
interface SobraPastaADE {
  id: string;
  nome: string;
}

type SobraEntradaADE = {
  id: string;
  dataAdicao: string;
  /** Legado: pasta do card inteiro; migrado para pastaSobraId em cada item. */
  pastaId: string | null;
  cabecalho: { lote: string; nomeProduto: string; tempo: string; dataInicio: string; dataTermino: string };
  itens: RelatorioItem[];
};

function normalizarEntradasSobraADE(entradaRaw: Record<string, unknown>): SobraEntradaADE {
  const legacyPasta =
    entradaRaw.pastaId != null && entradaRaw.pastaId !== '' ? String(entradaRaw.pastaId) : null;
  const rawItens = Array.isArray(entradaRaw.itens) ? entradaRaw.itens : [];
  const itens = rawItens.map((it: Record<string, unknown>) => {
    const row = { ...it } as RelatorioItem;
    const ja = row.pastaSobraId != null && row.pastaSobraId !== '';
    row.pastaSobraId = ja ? String(row.pastaSobraId) : legacyPasta;
    row.riscadoSobra = Boolean(row.riscadoSobra);
    return row;
  });
  return {
    ...entradaRaw,
    pastaId: null,
    cabecalho: entradaRaw.cabecalho as SobraEntradaADE['cabecalho'],
    itens,
  } as SobraEntradaADE;
}

function mesclarLinhaSobraPreferindoPasta(
  a: RelatorioItem | undefined,
  b: RelatorioItem
): RelatorioItem {
  if (!a) return b;
  const pastaA = a.pastaSobraId != null && a.pastaSobraId !== '' ? String(a.pastaSobraId) : null;
  const pastaB = b.pastaSobraId != null && b.pastaSobraId !== '' ? String(b.pastaSobraId) : null;
  return {
    ...a,
    ...b,
    // Preferir pasta preenchida: se b limpou de propósito e a tinha, b (último) manda só se ambos definidos ou b tem valor
    pastaSobraId: pastaB ?? pastaA ?? null,
    riscadoSobra: Boolean(b.riscadoSobra || a.riscadoSobra),
  };
}

/** Une entradas de Sobra por id e linhas por id — preserva pastaSobraId em merges. */
function mesclarEntradasSobraPorId(...listas: SobraEntradaADE[][]): SobraEntradaADE[] {
  const map = new Map<string, SobraEntradaADE>();
  for (const lista of listas) {
    if (!Array.isArray(lista)) continue;
    for (const bruto of lista) {
      if (!bruto || typeof bruto !== 'object') continue;
      const entrada = normalizarEntradasSobraADE(bruto as unknown as Record<string, unknown>);
      const id = String(entrada.id || '').trim();
      if (!id) continue;
      const prev = map.get(id);
      if (!prev) {
        map.set(id, entrada);
        continue;
      }
      const itensMap = new Map<string, RelatorioItem>();
      for (const it of prev.itens || []) {
        const iid = String(it.id || '').trim();
        if (iid) itensMap.set(iid, it);
      }
      for (const it of entrada.itens || []) {
        const iid = String(it.id || '').trim();
        if (!iid) continue;
        itensMap.set(iid, mesclarLinhaSobraPreferindoPasta(itensMap.get(iid), it));
      }
      map.set(id, {
        ...prev,
        ...entrada,
        pastaId: null,
        itens: [...itensMap.values()],
      });
    }
  }
  return [...map.values()];
}

const resumoSobraEntradas = (lista: SobraEntradaADE[]) => ({
  cards: lista.length,
  linhas: lista.reduce((acc, e) => acc + (e.itens?.length ?? 0), 0),
});

/** Grava sobra mesclando com IndexedDB/localStorage — uso ao enviar do Relatório (janela sem escopo sobra). */
const gravarSobraEntradasMescladas = async (memoria: SobraEntradaADE[]): Promise<SobraEntradaADE[]> => {
  const bruto = await coletarSobraBruto();
  const mesclados = filtrarSobraNaoExcluidas(
    mesclarEntradasSobraPorId(bruto, memoria.map((e) => normalizarEntradasSobraADE(e as unknown as Record<string, unknown>)))
  );
  await persistirSobraDireto(mesclados);
  notificarSyncDesktop('sobra');
  return mesclados;
};

type SobraCardComItensFiltrados = { entrada: SobraEntradaADE; itensVisiveis: RelatorioItem[] };

interface TempoCorteItem {
  id: string;
  numero: number;
  descricao: string;
  qtd: number;
  medida: string;
  metrosQuadrados: number;
  material: string;
  selecionado: boolean;
  /** Quando o item vem de um produto unificado, guarda o nome do produto original
   *  para mostrar como cabeçalho/separador na tabela. */
  produtoOrigem?: string;
}

const parseNumeroFlexADE = (valor: unknown): number => {
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
  const texto = String(valor ?? '').trim();
  if (!texto) return 0;
  const normalizado = texto
    .replace(/\s+/g, '')
    .replace(/\.(?=\d{3}(?:\D|$))/g, '')
    .replace(',', '.');
  const n = Number(normalizado);
  return Number.isFinite(n) ? n : 0;
};

function calcularMetrosQuadradosPorMedidaQtdTc(medida: string, qtd: number): number {
  const partes = String(medida ?? '')
    .toLowerCase()
    .split(/[x×*]/)
    .map((p) => parseNumeroFlexADE(p))
    .filter((n) => n > 0);
  if (partes.length < 2 || qtd <= 0) return 0;
  const areaPeca = partes.reduce((acc, n) => acc * n, 1);
  return areaPeca * qtd;
}

function recalcularMetrosQuadradosTempoCorteTc(itens: TempoCorteItem[]): TempoCorteItem[] {
  return (Array.isArray(itens) ? itens : []).map((item, index) => {
    const qtd = parseNumeroFlexADE(item?.qtd);
    const medida = String(item?.medida ?? '').trim();
    const m2Calculado = calcularMetrosQuadradosPorMedidaQtdTc(medida, qtd);
    const m2Atual = parseNumeroFlexADE(item?.metrosQuadrados);
    return {
      ...item,
      numero: index + 1,
      qtd,
      medida,
      metrosQuadrados: m2Calculado > 0 ? m2Calculado : m2Atual,
    };
  });
}

function parametrosTempoExatoPlanoProdutoSalvo(
  produto: any,
  itensPreparados?: TempoCorteItem[]
): {
  itensNorm: TempoCorteItem[];
  porcentagem: number;
  totalMetrosQuadradosAll: number;
  tempoExatoPlano: number;
} {
  const itensNorm = recalcularMetrosQuadradosTempoCorteTc(
    itensPreparados ?? (Array.isArray(produto?.itens) ? (produto.itens as TempoCorteItem[]) : [])
  );
  const pontuacaoProduto = Number(produto?.pontuacaoProduto) || 0;
  const qtdProduto = Number(produto?.qtdProduto) || 0;
  const pontosDiaTodo = Number(produto?.pontosDiaTodo) || 0;
  const tempoDiaTodo = Number(produto?.tempoDiaTodo) || 0;
  const porcentagem = Number(produto?.porcentagem) || 0;
  const totalMetrosQuadradosAll = itensNorm.reduce(
    (acc, item) => acc + (item.metrosQuadrados || 0),
    0
  );
  const pontuacaoRemessaProduzida =
    pontuacaoProduto > 0 ? pontosDiaTodo / pontuacaoProduto : 0;
  const x = tempoDiaTodo > 0 ? pontuacaoRemessaProduzida / tempoDiaTodo : 0;
  const tempoExatoPlano = x > 0 ? qtdProduto / x : 0;
  return { itensNorm, porcentagem, totalMetrosQuadradosAll, tempoExatoPlano };
}

/** Mesma fórmula da caixa "TEMPO EXATO (selecionadas)" ao carregar um card no Tempo de Corte. */
function calcularTempoExatoSelecionadasDeProdutoSalvoTc(produto: any): number {
  const { itensNorm, porcentagem, totalMetrosQuadradosAll, tempoExatoPlano } =
    parametrosTempoExatoPlanoProdutoSalvo(produto);
  const temFlagSelecao = itensNorm.some((i) => typeof i.selecionado === 'boolean');
  if (!tempoExatoPlano || !porcentagem || totalMetrosQuadradosAll <= 0) {
    // Nunca cair em tempoExatoPlano (todas as peças): o Relatório deve refletir só selecionadas.
    if (temFlagSelecao && !itensNorm.some((i) => i.selecionado)) return 0;
    return Number(produto?.tempoExato) || 0;
  }
  const somaSelecionadas = itensNorm
    .filter((i) => i.selecionado)
    .reduce((acc, item) => {
      const metrosConsiderados = item.metrosQuadrados || 0;
      const porcentagemPorPeca =
        totalMetrosQuadradosAll > 0
          ? (metrosConsiderados * porcentagem) / totalMetrosQuadradosAll
          : 0;
      const tempoCadaPeca =
        porcentagem > 0 ? (tempoExatoPlano * porcentagemPorPeca) / porcentagem : 0;
      return acc + tempoCadaPeca;
    }, 0);
  // Com flags de seleção explícitas, respeita desmarcar todas (0) — não usa total do card.
  if (temFlagSelecao) return somaSelecionadas;
  if (somaSelecionadas > 0) return somaSelecionadas;
  return Number(produto?.tempoExato) || 0;
}

const normalizarTextoCabecalhoADE = (s: string) =>
  s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();

function dimensoesRelatorioItemMm(r: RelatorioItem): [number, number] {
  const a = Math.min(r.medidaMenor, r.medidaMaior);
  const b = Math.max(r.medidaMenor, r.medidaMaior);
  return [a, b];
}

/** Gera pares (mm) candidatos a partir da coluna MEDIDA do Tempo de Corte (mm ou metros). */
function candidatosMedidaTempoMm(medidaStr: string): [number, number][] {
  const partes = String(medidaStr ?? '')
    .toLowerCase()
    .split(/[x×*]/)
    .map((p) => parseNumeroFlexADE(p))
    .filter((n) => n > 0);
  if (partes.length < 2) return [];
  let a = partes[0];
  let b = partes[1];
  const norm = (x: number, y: number): [number, number] => {
    const m1 = Math.min(x, y);
    const m2 = Math.max(x, y);
    return [m1, m2];
  };
  const out: [number, number][] = [];
  out.push(norm(a, b));
  // Heurística: dimensões típicas em metros (ex.: 0,451 x 1,702)
  if (Math.max(a, b) <= 4 && Math.min(a, b) <= 2.5) {
    out.push(norm(a * 1000, b * 1000));
  }
  return out;
}

function dimensoesCoincidemRelatorioTempo(r: RelatorioItem, t: TempoCorteItem): boolean {
  const dr = dimensoesRelatorioItemMm(r);
  const cand = candidatosMedidaTempoMm(t.medida);
  const tol = 2;
  for (const dt of cand) {
    if (Math.abs(dr[0] - dt[0]) <= tol && Math.abs(dr[1] - dt[1]) <= tol) return true;
  }
  return false;
}

function materialTempoCorteCompativel(r: RelatorioItem, t: TempoCorteItem): boolean {
  const tStr = (t.material || '').toUpperCase();
  const rIsMdf = r.material === 'mdf';
  const tHasMdf = tStr.includes('MDF');
  const tHasAglo = tStr.includes('AGLO') || tStr.includes('AGLOMER');
  if (rIsMdf && !tHasMdf) return false;
  if (!rIsMdf && !tHasAglo) return false;
  const mEsp = tStr.match(/(\d+)\s*MM/i);
  const tEsp = mEsp ? mEsp[1] : '';
  if (tEsp && String(r.espessura) !== tEsp) return false;
  return true;
}

function nomesPecaCompativeisRelatorioTempo(r: RelatorioItem, t: TempoCorteItem): boolean {
  const nomeRel = normalizarTextoCabecalhoADE(String(r.nomePeca || ''));
  const nomeTempo = normalizarTextoCabecalhoADE(String(t.descricao || ''));
  if (!nomeRel || !nomeTempo) return true;
  if (nomeRel === nomeTempo) return true;
  if (nomeRel.includes(nomeTempo) || nomeTempo.includes(nomeRel)) return true;
  const tokensRel = nomeRel.split(/\s+/).filter((x) => x.length >= 3);
  const tokensTempo = nomeTempo.split(/\s+/).filter((x) => x.length >= 3);
  if (tokensRel.length === 0 || tokensTempo.length === 0) return true;
  return tokensRel.some((tr) => tokensTempo.some((tt) => tr.includes(tt) || tt.includes(tr)));
}

/** Mesmo valor exibido no card "Produtos salvos" do Tempo de Corte (tempo exato das peças selecionadas). */
function obterTempoExatoSalvoProduto(produto: any): number {
  const recalc = calcularTempoExatoSelecionadasDeProdutoSalvoTc(produto);
  // Inclui 0 quando todas as peças foram desmarcadas (recalc explícito).
  const itens = Array.isArray(produto?.itens) ? produto.itens : [];
  const temFlagSelecao = itens.some((i: TempoCorteItem) => typeof i?.selecionado === 'boolean');
  if (temFlagSelecao || recalc > 0) return recalc;
  const salvo = Number(produto?.tempoExato);
  if (salvo > 0) return salvo;
  // Não usar tempoExatoPlano (plano de todas as peças) no Relatório.
  return 0;
}

function tempoCadaPecaDeProdutoSalvo(produto: any, item: TempoCorteItem): number {
  // Mesma regra da caixa "TOTAL TEMPO CADA PEÇA (selecionadas)" do Tempo de Corte.
  if (!item.selecionado) return 0;
  const { itensNorm, porcentagem, totalMetrosQuadradosAll, tempoExatoPlano } =
    parametrosTempoExatoPlanoProdutoSalvo(produto);
  if (!tempoExatoPlano || !porcentagem || totalMetrosQuadradosAll <= 0) return 0;
  const alvo = itensNorm.find((i) => i.id === item.id) ?? item;
  const metrosConsiderados = alvo.metrosQuadrados || 0;
  if (metrosConsiderados <= 0) return 0;
  const porcentagemPorPeca = (metrosConsiderados * porcentagem) / totalMetrosQuadradosAll;
  return (tempoExatoPlano * porcentagemPorPeca) / porcentagem;
}

function extrairLotesCabecalhoRelatorio(loteCabecalho: string): string[] {
  const cru = String(loteCabecalho || '').trim();
  if (!cru) return [];
  const partes = cru
    .split(/(?:\s+E\s+|\s*,\s*|\s*;\s*|\s*\/\s*|\s*\+\s*|\s*&\s*)/i)
    .map((x) => normalizarTextoCabecalhoADE(String(x || '').trim()))
    .filter(Boolean);
  return Array.from(new Set(partes));
}

/** Ex.: "BUFFET ANDORRA/SIERRA" → ["BUFFET ANDORRA", "BUFFET SIERRA", "BUFFET ANDORRA/SIERRA"] */
function extrairVariantesNomeProdutoCabecalho(nomeCabecalho: string): string[] {
  const limparNomeBase = (s: string) =>
    normalizarTextoCabecalhoADE(String(s || ''))
      .replace(/\bMDF\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  const extrairBaseSemSufixoNumerico = (s: string) =>
    limparNomeBase(s).replace(/\s+\d+(?:[.,]\d+)?$/, '').trim();

  const base = extrairBaseSemSufixoNumerico(nomeCabecalho);
  if (!base) return [];

  const partes = base
    .split(/(?:\s*\/\s*|\s+E\s+|\s*,\s*|\s*;\s*|\s*\+\s*|\s*&\s*)/i)
    .map((p) => limparNomeBase(p.trim()))
    .filter(Boolean);

  if (partes.length <= 1) return [base];

  const variantes = new Set<string>([base]);
  const primeira = partes[0];
  variantes.add(primeira);
  const tokensPrimeira = primeira.split(/\s+/).filter(Boolean);
  const prefixo =
    tokensPrimeira.length > 1 ? tokensPrimeira.slice(0, -1).join(' ') : '';

  for (let i = 1; i < partes.length; i++) {
    const p = partes[i];
    const tokens = p.split(/\s+/).filter(Boolean);
    if (tokens.length >= 2 || (prefixo && p.startsWith(prefixo))) {
      variantes.add(p);
    } else if (prefixo) {
      variantes.add(`${prefixo} ${p}`.trim());
    } else {
      variantes.add(p);
    }
  }

  return Array.from(variantes);
}

function nomeSalvoCompativelComVariantesCabecalho(
  nomeSalvo: string,
  variantesCabecalho: string[]
): boolean {
  const limparNomeBase = (s: string) =>
    normalizarTextoCabecalhoADE(String(s || ''))
      .replace(/\bMDF\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  const extrairBaseSemSufixoNumerico = (s: string) =>
    limparNomeBase(s).replace(/\s+\d+(?:[.,]\d+)?$/, '').trim();

  const baseSalvo = extrairBaseSemSufixoNumerico(nomeSalvo);
  if (!baseSalvo) return false;
  return variantesCabecalho.some((variante) => {
    const v = extrairBaseSemSufixoNumerico(variante);
    if (!v) return false;
    return baseSalvo === v || v.includes(baseSalvo) || baseSalvo.includes(v);
  });
}

function produtosSalvosCompativeisComCabecalhoRelatorio(
  produtos: any[],
  loteCabecalho: string,
  nomeCabecalho: string
): any[] {
  const lotesN = extrairLotesCabecalhoRelatorio(loteCabecalho);
  if (lotesN.length === 0) return [];
  const setLotes = new Set(lotesN);
  const comLote = produtos.filter((p) =>
    setLotes.has(normalizarTextoCabecalhoADE(String(p?.lote || '').trim()))
  );
  if (comLote.length === 0) return [];
  const limparNomeBase = (s: string) =>
    normalizarTextoCabecalhoADE(String(s || ''))
      .replace(/\bMDF\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  const extrairBaseSemSufixoNumerico = (s: string) =>
    limparNomeBase(s).replace(/\s+\d+(?:[.,]\d+)?$/, '').trim();

  const nomeCabecalhoBase = extrairBaseSemSufixoNumerico(String(nomeCabecalho || ''));
  const variantesNomeCabecalho = extrairVariantesNomeProdutoCabecalho(nomeCabecalho);
  const principaisLote = comLote.filter(
    (p) => !normalizarTextoCabecalhoADE(String(p?.nome || '')).includes('MDF')
  );
  const candidatosLote = principaisLote.length > 0 ? principaisLote : comLote;
  if (!nomeCabecalhoBase) {
    const unicos = new Map<string, any>();
    candidatosLote.forEach((p) => {
      const lote = normalizarTextoCabecalhoADE(String(p?.lote || '').trim());
      const chave =
        `${lote}::${limparNomeBase(String(p?.nome || ''))}` || String(p?.id || Math.random());
      // Mantém apenas 1 salvo por produto nominal para evitar duplicação quando o mesmo produto
      // foi salvo mais de uma vez no mesmo lote.
      unicos.set(chave, p);
    });
    return Array.from(unicos.values());
  }

  const porNomeBase = candidatosLote.filter((p) =>
    nomeSalvoCompativelComVariantesCabecalho(String(p?.nome || ''), variantesNomeCabecalho)
  );

  // Quando não houver match direto pelo nome do cabeçalho, ainda assim considera os produtos
  // principais do lote: no mesmo lote podem existir produtos distintos (ex.: ARUBA + CAYMAN)
  // com peças iguais que devem somar tempo no Relatório.
  const baseSelecao = porNomeBase.length > 0 ? porNomeBase : candidatosLote;

  const unicos = new Map<string, any>();
  baseSelecao.forEach((p) => {
    const lote = normalizarTextoCabecalhoADE(String(p?.lote || '').trim());
    const chave =
      `${lote}::${limparNomeBase(String(p?.nome || ''))}` || String(p?.id || Math.random());
    unicos.set(chave, p);
  });
  return Array.from(unicos.values());
}

function somarTempoPorPecaRelatorio(relItem: RelatorioItem, produtosFiltrados: any[]): number {
  let sum = 0;
  for (const produto of produtosFiltrados) {
    const itens: TempoCorteItem[] = Array.isArray(produto.itens) ? produto.itens : [];
    for (const tcItem of itens) {
      if (!dimensoesCoincidemRelatorioTempo(relItem, tcItem)) continue;
      if (!materialTempoCorteCompativel(relItem, tcItem)) continue;
      if (!nomesPecaCompativeisRelatorioTempo(relItem, tcItem)) continue;
      sum += tempoCadaPecaDeProdutoSalvo(produto, tcItem);
    }
  }
  return sum;
}

/** Calcula quanto cada produto do Tempo de Corte contribui no tempo total do Relatório
 *  (somando todas as peças que dão match). Usado no painel diagnóstico. */
function calcularContribuicaoProdutoNoRelatorio(
  produto: any,
  relatorioItens: RelatorioItem[]
): number {
  const itensTc: TempoCorteItem[] = Array.isArray(produto.itens) ? produto.itens : [];
  let total = 0;
  for (const relItem of relatorioItens) {
    if (!relItem.nomePeca?.trim()) continue;
    for (const tcItem of itensTc) {
      if (!dimensoesCoincidemRelatorioTempo(relItem, tcItem)) continue;
      if (!materialTempoCorteCompativel(relItem, tcItem)) continue;
      if (!nomesPecaCompativeisRelatorioTempo(relItem, tcItem)) continue;
      total += tempoCadaPecaDeProdutoSalvo(produto, tcItem);
    }
  }
  return total;
}

interface LoteProdutoConfig {
  id: string;
  lote: string;
  produtoNome: string;
  qtd: number;
  dataHoraInicioCorte?: string;
  dataHoraFimEmbalagem?: string;
  corProduto?: string;
  codigoProduto?: string;
}

interface PontuacaoProduto {
  nome: string;
  m2: number;
  /** Produto descontinuado — destaque vermelho na lista. */
  foraDeLinha?: boolean;
}

function normalizarPontuacaoProduto(p: Partial<PontuacaoProduto>): PontuacaoProduto {
  return {
    nome: corrigirGrafiaBerlin(String(p.nome || '').trim()),
    m2: Number(p.m2) || 0,
    foraDeLinha: Boolean(p.foraDeLinha),
  };
}

function deduplicarPontuacoesPorNome(lista: PontuacaoProduto[]): PontuacaoProduto[] {
  const map = new Map<string, PontuacaoProduto>();
  for (const p of lista) {
    const k = p.nome
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .trim();
    if (!k) continue;
    const cur = map.get(k);
    if (!cur) {
      map.set(k, { ...p });
      continue;
    }
    map.set(k, {
      nome: cur.nome,
      m2: Math.max(cur.m2, p.m2) || p.m2 || cur.m2,
      foraDeLinha: Boolean(cur.foraDeLinha && p.foraDeLinha),
    });
  }
  return [...map.values()];
}

function normalizarListaPontuacoes(lista: Partial<PontuacaoProduto>[]): PontuacaoProduto[] {
  return ordenarPontuacoesProdutos(
    deduplicarPontuacoesPorNome(
      lista.filter((p) => p && String(p.nome || '').trim()).map(normalizarPontuacaoProduto)
    )
  );
}

function ordenarPontuacoesProdutos(lista: PontuacaoProduto[]): PontuacaoProduto[] {
  return [...lista].sort((a, b) =>
    a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
  );
}

function remapearProdutoCaixaIndices(
  listaAntiga: PontuacaoProduto[],
  listaNova: PontuacaoProduto[],
  indices: (number | null)[]
): (number | null)[] {
  const chave = (nome: string) =>
    nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
  return indices.map((idx) => {
    if (idx == null || idx < 0) return null;
    const nome = listaAntiga[idx]?.nome;
    if (!nome) return null;
    const alvo = chave(nome);
    const novoIdx = listaNova.findIndex((p) => chave(p.nome) === alvo);
    return novoIdx >= 0 ? novoIdx : null;
  });
}

function remapearIndicesAposExclusao(
  indices: (number | null)[],
  indiceRemovido: number
): (number | null)[] {
  return indices.map((idx) => {
    if (idx == null) return null;
    if (idx === indiceRemovido) return null;
    if (idx > indiceRemovido) return idx - 1;
    return idx;
  });
}


function safeSetLocalStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Falha de quota não pode derrubar a aplicação.
  }
}

function normalizarChaveTexto(v: string): string {
  return String(v || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

const PONTUACOES_PRODUTOS_INICIAL: PontuacaoProduto[] = [
  { nome: 'APARADOR BAR ASTURIAS', m2: 0.8 },
  { nome: 'APARADOR BARI 1.0', m2: 1.2 },
  { nome: 'APARADOR BUFFET BERLIN', m2: 1.3 },
  { nome: 'APARADOR LUIS XV', m2: 1.2 },
  { nome: 'APARADOR MEMPHIS', m2: 1.6 },
  { nome: 'APARADOR MADERATTO', m2: 1.2 },
  { nome: 'ARMARIO BERLIN', m2: 0.8 },
  { nome: 'ARMARIO LIVREIRO SMART', m2: 0.45 },
  { nome: 'ARMARIO OSLO', m2: 2.5 },
  { nome: 'BALCÒO BERLIN', m2: 0.7 },
  { nome: 'BALCÒO OSLO', m2: 3 },
  { nome: 'BANDEIJA ASTURIAS', m2: 0.15 },
  { nome: 'BAR ADEGA BALI', m2: 0.7 },
  { nome: 'BUFFET ASTURIAS', m2: 1.2 },
  { nome: 'BUFFET ASTURIAS 0.92', m2: 0.9 },
  { nome: 'BUFFET ASTURIAS 1.8', m2: 1.5 },
  { nome: 'BUFFET AçORES/DUBLIN 1.4', m2: 2.3 },
  { nome: 'BUFFET AçORES/DUBLIN 1.9', m2: 2.5 },
  { nome: 'BUFFET ANDORRA/SIERRA 1.3', m2: 1.4 },
  { nome: 'BUFFET ANDORRA/SIERRA 1.72', m2: 1.7 },
  { nome: 'BUFFET APARADOR SMART', m2: 0.65 },
  { nome: 'BUFFET ARGO 1.0', m2: 1.3 },
  { nome: 'BUFFET ARGO 1.4', m2: 1.8 },
  { nome: 'BUFFET MADERATTO 3 PTS', m2: 1.6 },
  { nome: 'BUFFET MADERATTO 4 PTS', m2: 2 },
  { nome: 'BUFFET MAGNUM 0.9', m2: 1.2 },
  { nome: 'BUFFET MAGNUM 1.4', m2: 1.65 },
  { nome: 'BUFFET MAGNUM 1.9', m2: 2.1 },
  { nome: 'BUFFET PASSION', m2: 2.5 },
  { nome: 'BUFFET UNION', m2: 1.8 },
  { nome: 'EXPOSITOR 2.1', m2: 1.3 },
  { nome: 'EXPOSITOR FEIRA 2.2', m2: 1.3 },
  { nome: 'EXPOSITOR FEIRA 2.5', m2: 2.5 },
  { nome: 'EXPOSITOR FEIRA 2.7', m2: 2.8 },
  { nome: 'EXPOSITOR LOJAS CEM', m2: 2.5 },
  { nome: 'GAVETEIRO BERLIN', m2: 0.7 },
  { nome: 'GAVETEIRO OSLO', m2: 1 },
  { nome: 'HOME LENI', m2: 3.5 },
  { nome: 'HOME RENO', m2: 3.2 },
  { nome: 'HOME ROYAL', m2: 2.5 },
  { nome: 'KIT DIVISORIA DUPLA GRANDE SMART', m2: 0.25 },
  { nome: 'KIT DIVISORIA DUPLA PEQUENA SMART', m2: 0.22 },
  { nome: 'KIT DIVISORIA TRIPLA SMART', m2: 0.33 },
  { nome: 'LIVREIRO VERSALES', m2: 1 },
  { nome: 'MESA CAB. LUCCA/ARRUNA', m2: 1 },
  { nome: 'MESA CAB. LUIS XV', m2: 1.2 },
  { nome: 'MESA CAB. URBAN/CITY/SIENA/RATTAN', m2: 0.8 },
  { nome: 'MESA CENTRO HOLAMBRA', m2: 1 },
  { nome: 'MESA CENTRO PRATIKA', m2: 1 },
  { nome: 'MESA DE CENTRO MADERATTO', m2: 0.75 },
  { nome: 'MESA DE COMPUTADOR SMART', m2: 0.5 },
  { nome: 'MESA ESCRITORIO BERLIN', m2: 0.8 },
  { nome: 'MESA ESCRITORIO OSLO', m2: 1.8 },
  { nome: 'MODULO ARBO 0.9', m2: 1.4 },
  { nome: 'NICHO ASPEN 1.35', m2: 0.9 },
  { nome: 'NICHO ASPEN 1.8', m2: 1 },
  { nome: 'NICHO ASPEN 2.17', m2: 1.25 },
  { nome: 'NICHO DIOR 1.1', m2: 0.5 },
  { nome: 'NICHO DIOR 1.6', m2: 0.6 },
  { nome: 'NICHO DIOR 2.0', m2: 0.7 },
  { nome: 'NICHO LUXO 1.35', m2: 1 },
  { nome: 'NICHO LUXO 1.8', m2: 1.2 },
  { nome: 'NICHO LUXO 2.2', m2: 1.5 },
  { nome: 'NICHO SLIM 1.1', m2: 0.4 },
  { nome: 'NICHO SLIM 1.6', m2: 0.5 },
  { nome: 'NICHO SLIM 2.0', m2: 0.6 },
  { nome: 'NICHO SUSPENSO MADERATTO 1.8', m2: 0.9 },
  { nome: 'NICHO SUSPENSO MADERATTO 2.0', m2: 1 },
  { nome: 'NICHO SUSPENSO MADERATTO 2.2', m2: 1.1 },
  { nome: 'NICHO UNIVERSAL 1.35', m2: 1 },
  { nome: 'NICHO UNIVERSAL 1.8', m2: 1.2 },
  { nome: 'NICHO UNIVERSAL 2.2', m2: 1.5 },
  { nome: 'NICHO VERSATTI 1.35', m2: 0.65 },
  { nome: 'NICHO VERSATTI 1.8', m2: 0.8 },
  { nome: 'NICHO VERSATTI 2.2', m2: 0.95 },
  { nome: 'PAINEL ARBO 0.9', m2: 1.4 },
  { nome: 'PAINEL ARBO 1.4', m2: 2.2 },
  { nome: 'PAINEL ARBO 1.9', m2: 3 },
  { nome: 'PAINEL ARBO 2.3', m2: 3.6 },
  { nome: 'PAINEL ASTURIAS', m2: 0.7 },
  { nome: 'PAINEL ASTURIAS 1.8', m2: 1.1 },
  { nome: 'PAINEL AVANTI 1.36', m2: 0.9 },
  { nome: 'PAINEL AVANTI 1.8', m2: 1.3 },
  { nome: 'PAINEL BLISS 1.8', m2: 1.6 },
  { nome: 'PAINEL BLISS 2.2', m2: 1.8 },
  { nome: 'PAINEL BRASIL 1.365', m2: 1 },
  { nome: 'PAINEL DAVOS', m2: 0.9 },
  { nome: 'PAINEL DIJON', m2: 0.9 },
  { nome: 'PAINEL EGEO 1.35', m2: 1.2 },
  { nome: 'PAINEL EGEO 1.8', m2: 1.7 },
  { nome: 'PAINEL EGEO 2.25', m2: 2 },
  { nome: 'PAINEL ESTONE 1.4', m2: 1.2 },
  { nome: 'PAINEL ESTONE 1.4 LED', m2: 1.2 },
  { nome: 'PAINEL ESTONE 1.8', m2: 1.7 },
  { nome: 'PAINEL ESTONE 1.8 LED', m2: 1.7 },
  { nome: 'PAINEL ESTONE 2.3', m2: 2 },
  { nome: 'PAINEL ESTONE 2.3 LED', m2: 2 },
  { nome: 'PAINEL FIT 90', m2: 0.4 },
  { nome: 'PAINEL FOX', m2: 0.54 },
  { nome: 'PAINEL GARDEN 1.8', m2: 1.4 },
  { nome: 'PAINEL GARDEN 2.2', m2: 1.8 },
  { nome: 'PAINEL LEGACY 1.6', m2: 1 },
  { nome: 'PAINEL LEGACY 2.0', m2: 1.2 },
  { nome: 'PAINEL MADERATTO 1.8', m2: 1.6 },
  { nome: 'PAINEL MADERATTO 2.0', m2: 1.8 },
  { nome: 'PAINEL MADERATTO 2.2', m2: 2 },
  { nome: 'PAINEL MASTER 1.35', m2: 1.6 },
  { nome: 'PAINEL MASTER 1.8', m2: 2 },
  { nome: 'PAINEL MASTER 2.2', m2: 2.6 },
  { nome: 'PAINEL MAXI', m2: 1 },
  { nome: 'PAINEL MERLOT 1.8', m2: 0.8 },
  { nome: 'PAINEL MURANO', m2: 2 },
  { nome: 'PAINEL PARIS', m2: 1 },
  { nome: 'PAINEL PARIS 2.2', m2: 1.3 },
  { nome: 'PAINEL STUDIO', m2: 1.4 },
  { nome: 'PAINEL STUDIO 2.18', m2: 1.6 },
  { nome: 'PAINEL TOKIO', m2: 0.56 },
  { nome: 'PAINEL TORINO 2', m2: 0.83 },
  { nome: 'PAINEL VEYRON 2.0', m2: 2.6 },
  { nome: 'PAINEL VEYRON 2.4', m2: 3 },
  { nome: 'QUADRO BISOTE', m2: 1.5 },
  { nome: 'RACK ASTURIAS', m2: 0.8 },
  { nome: 'RACK ASTURIAS 1.8', m2: 1.25 },
  { nome: 'RACK ANDES', m2: 1.7 },
  { nome: 'RACK ARUBA/CAYMAN/TREND', m2: 1 },
  { nome: 'RACK ATHOS', m2: 1.4 },
  { nome: 'RACK AUSTIN', m2: 1.2 },
  { nome: 'RACK BLISS 1.8', m2: 1.8 },
  { nome: 'RACK BLISS 2.2', m2: 2.1 },
  { nome: 'RACK BRISE 1.8', m2: 2.2 },
  { nome: 'RACK BRISE 2.2', m2: 2.6 },
  { nome: 'RACK C/ PAINEL AUDAX', m2: 2.2 },
  { nome: 'RACK CARRARA', m2: 1.2 },
  { nome: 'RACK COMODORO 1.8', m2: 1.3 },
  { nome: 'RACK COMODORO 2.2', m2: 1.5 },
  { nome: 'RACK DARIM', m2: 1.8 },
  { nome: 'RACK DENVER', m2: 1 },
  { nome: 'RACK DOMUS', m2: 1.2 },
  { nome: 'RACK FELIX', m2: 1.5 },
  { nome: 'RACK GLOOS 1.8', m2: 1.5 },
  { nome: 'RACK GLOOS 2.2', m2: 1.8 },
  { nome: 'RACK HANOVER 1.8', m2: 2.4 },
  { nome: 'RACK HANOVER 2.2', m2: 3 },
  { nome: 'RACK ITALIA', m2: 1.2 },
  { nome: 'RACK KING/ANDROS/AMBER', m2: 1.3 },
  { nome: 'RACK LEGACY 1.6', m2: 1 },
  { nome: 'RACK LEGACY 1.8', m2: 1.2 },
  { nome: 'RACK LEGACY 2.0', m2: 1.2 },
  { nome: 'RACK LIVERPOOL', m2: 0.8 },
  { nome: 'RACK MADERATTO 1.8', m2: 1.8 },
  { nome: 'RACK MADERATTO 2.2', m2: 2.2 },
  { nome: 'RACK MASTER 1.8', m2: 2.2 },
  { nome: 'RACK MASTER 2.2', m2: 2.6 },
  { nome: 'RACK MERLOT 1.8', m2: 2 },
  { nome: 'RACK MORGAN 1.8', m2: 1.5 },
  { nome: 'RACK MORGAN 2.2', m2: 1.875 },
  { nome: 'RACK NERO', m2: 0.9 },
  { nome: 'RACK REALE', m2: 0.8 },
  { nome: 'RACK STAR', m2: 1 },
  { nome: 'RACK THOR 1.8', m2: 2.4 },
  { nome: 'RACK THOR 2.2', m2: 2.9 },
  { nome: 'RACK THOR 2.6', m2: 4 },
  { nome: 'RACK TITAN', m2: 1 },
  { nome: 'RACK VIGO 1.8', m2: 1.5 },
  { nome: 'RACK VIGO 2.2', m2: 1.8 },
  { nome: 'RACK VINCI', m2: 0.8 },
  { nome: 'RACK VITRAL', m2: 1.4 },
];

/** Mesma sequência que `imprimir` / Visualização: código 5 = subdivisão longitudinal (subLong), não troca longMed/longQtd do bloco. */
type BlocoSeqRelatorio = {
  longMed: number;
  longQtd: number;
  transMed: number;
  transQtd: number;
  codigoTrans: number;
  subLongCortes?: Array<{ med: number; qtd: number; inicio: number }>;
};

function blocosSequenciaisRelatorioProjeto(pecasGrupo: any[]): BlocoSeqRelatorio[] {
  const out: BlocoSeqRelatorio[] = [];
  let longMed = 0;
  let longQtd = 1;
  let transRefMed = 0;
  let transRefQtd = 1;
  let restanteLong5 = 0;
  const serraCorte5 = 5;
  (pecasGrupo || []).forEach((p: any) => {
    if (p.codigo === 3) {
      longMed = Number(p.medida) || 0;
      longQtd = Math.max(1, Number(p.quantidade) || 1);
      return;
    }
    if (p.codigo === 4 || p.codigo === 44) {
      if (longMed <= 0) return;
      const blocoBase: BlocoSeqRelatorio = {
        longMed,
        longQtd,
        transMed: Number(p.medida) || 0,
        transQtd: Math.max(1, Number(p.quantidade) || 1),
        codigoTrans: p.codigo,
      };
      out.push(blocoBase);
      transRefMed = blocoBase.transMed;
      transRefQtd = blocoBase.transQtd;
      restanteLong5 = longMed;
      return;
    }
    if (p.codigo === 5) {
      if (out.length === 0 || transRefMed <= 0) return;
      const last = out[out.length - 1];
      if (!last) return;
      const baseLong = restanteLong5 > 0 ? restanteLong5 : longMed;
      if (baseLong <= 0) return;
      const qtd5 = Math.max(1, Number(p.quantidade) || 1);
      const corteInformado = Number(p.medida) || baseLong;
      const corteEfetivo = Math.min(corteInformado, baseLong);
      const inicio = Math.max(0, longMed - baseLong);
      if (!last.subLongCortes) last.subLongCortes = [];
      last.subLongCortes.push({ med: corteEfetivo, qtd: qtd5, inicio });
      restanteLong5 = Math.max(0, baseLong - (corteEfetivo + serraCorte5) * qtd5);
    }
  });
  return out;
}

function agruparEmTirasRelatorioProjeto(blocos: BlocoSeqRelatorio[]) {
  const tiras: Array<{
    longMed: number;
    longQtd: number;
    transversais: Array<{ med: number; qtd: number; codigo: number; subLongCortes?: Array<{ med: number; qtd: number; inicio: number }> }>;
  }> = [];
  blocos.forEach((b) => {
    const last = tiras[tiras.length - 1];
    const podeMesclar = !!last && last.longMed === b.longMed && last.longQtd === b.longQtd;
    const transEntry: { med: number; qtd: number; codigo: number; subLongCortes?: Array<{ med: number; qtd: number; inicio: number }> } = {
      med: b.transMed,
      qtd: b.transQtd,
      codigo: b.subLongCortes && b.subLongCortes.length > 0 ? 5 : b.codigoTrans,
      ...(b.subLongCortes && b.subLongCortes.length > 0 ? { subLongCortes: b.subLongCortes } : {}),
    };
    if (podeMesclar) {
      last.transversais.push(transEntry);
    } else {
      tiras.push({
        longMed: b.longMed,
        longQtd: b.longQtd,
        transversais: [transEntry],
      });
    }
  });
  return tiras;
}

/** Conta cada peça física como na impressão do projeto (inclui 3º corte / código 5). */
function contarPecasPorDimensaoGruposProjeto(grupos: any[]): Map<string, number> {
  const map = new Map<string, number>();
  (grupos || []).forEach((grupo: any) => {
    const blocos = blocosSequenciaisRelatorioProjeto(grupo.pecas);
    const tiras = agruparEmTirasRelatorioProjeto(blocos);
    tiras.forEach((tira) => {
      for (let l = 0; l < tira.longQtd; l++) {
        tira.transversais.forEach((tr) => {
          if (tr.subLongCortes && tr.subLongCortes.length > 0) {
            for (let t = 0; t < tr.qtd; t++) {
              tr.subLongCortes.forEach((corte) => {
                for (let sub = 0; sub < corte.qtd; sub++) {
                  const medidaTrans = tr.med;
                  const medidaLong = corte.med;
                  const menor = Math.min(medidaTrans, medidaLong);
                  const maior = Math.max(medidaTrans, medidaLong);
                  const chave = `${menor}x${maior}`;
                  map.set(chave, (map.get(chave) ?? 0) + 1);
                }
              });
            }
          } else {
            for (let t = 0; t < tr.qtd; t++) {
              const medidaTrans = tr.med;
              const medidaLong = tira.longMed;
              const menor = Math.min(medidaTrans, medidaLong);
              const maior = Math.max(medidaTrans, medidaLong);
              const chave = `${menor}x${maior}`;
              map.set(chave, (map.get(chave) ?? 0) + 1);
            }
          }
        });
      }
    });
  });
  return map;
}

export default function CalculadoraCorte() {
  const { configuracao, setConfiguracao, materialConfig, setMaterialConfig, pecas, adicionarPeca, atualizarPeca, removerPeca, restaurarPecas, calcularConsumo, novoGrupo, projeto, setProjeto, projetosSalvos, salvarProjeto, carregarProjeto, removerProjetoSalvo, recuperarCatalogoEmergencia, itensProducao, adicionarItemProducao, removerItemProducao, limparProducao, calcularChapasNecessarias, rotacaoDesenho, girarDesenho } = useCorteStore();
  const LAYOUT_PADRAO: LayoutConfig = {
    desenhoX: 5, desenhoY: 35, desenhoLargura: 130, desenhoAltura: 240, desenhoRotacao: 0, desenhoEscalaX: 100, desenhoEscalaY: 100,
    infoX: 140, infoY: 35, infoLargura: 65, infoAltura: 200, infoRotacao: 0, fontSize: 100, fontSizeInfo: 100,
    observacoes: '', obsX: 5, obsY: 250, obsLargura: 200, obsAltura: 35, obsRotacao: 0, obsFontSize: 100,
    quantidadeChapas: 1, espessuraMaterial: 15, tipoMaterial: 'aglomerado',
    plano: 1, etapas: 1,
    caixasTexto: [],
  };

  const normalizarLayoutCarregado = useCallback((layout: LayoutConfig): LayoutConfig => ({
    ...layout,
    fontSizeInfo: Math.max(100, layout.fontSizeInfo || 100),
  }), []);
  
  const moduloFixo = useMemo(() => moduloFixoDaUrl(), []);
  const isJanelaFilha = isJanelaModuloFilha();

  const [abaAtiva, setAbaAtiva] = useState<AbaPrincipal>(() => {
    if (typeof window === 'undefined') return 'projeto';
    const fixo = moduloFixoDaUrl();
    if (fixo) return fixo;
    return new URLSearchParams(window.location.search).get('modo') === 'importar'
      ? 'resultadosCopa'
      : 'projeto';
  });

  /** Janela filha: exibe o módulo da URL imediatamente (evita flash do Projeto). */
  const abaVisivel: AbaPrincipal =
    isJanelaFilha && moduloFixo ? moduloFixo : abaAtiva;

  const escopoDados = useMemo(() => {
    if (isJanelaFilha) return dadosNecessariosModulo(moduloFixo);
    if (nwDisponivel()) return dadosNecessariosModulo(moduloEscopoJanelaPrincipal(abaAtiva));
    return dadosNecessariosModulo(abaAtiva);
  }, [isJanelaFilha, moduloFixo, abaAtiva]);

  useEffect(() => {
    if (moduloFixo && abaAtiva !== moduloFixo) {
      setAbaAtiva(moduloFixo);
    }
  }, [moduloFixo, abaAtiva]);

  useEffect(() => {
    document.title = tituloJanelaModulo(isJanelaFilha ? abaVisivel : null);
  }, [abaVisivel, isJanelaFilha]);

  /** Hidrata catálogo conforme módulo da janela. */
  useEffect(() => {
    aplicarMigracaoBerlimBerlinLocalStorage();
    aplicarMigracaoBuffetAron4PortasLocalStorage();
    if (moduloPrecisaDado(escopoDados, 'catalogo')) {
      void (async () => {
        await useCorteStore.persist.rehydrate();
        if (useCorteStore.getState().projetosSalvos.length === 0) {
          await useCorteStore.getState().recuperarCatalogoEmergencia();
        }
      })();
    }
  }, [escopoDados]);

  /** Grava catálogo pendente ao fechar (debounce 450ms do Zustand). */
  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'catalogo')) return;
    const flush = () => {
      void flushPersistenciaCatalogo();
    };
    window.addEventListener('beforeunload', flush);
    window.addEventListener('pagehide', flush);
    return () => {
      window.removeEventListener('beforeunload', flush);
      window.removeEventListener('pagehide', flush);
    };
  }, [escopoDados]);

  const navegarParaAba = useCallback(
    (id: AbaPrincipal) => {
      navegarParaModulo(id, {
        isJanelaFilha,
        moduloFixo,
        abaAtiva,
        setAbaAtiva,
      });
    },
    [isJanelaFilha, moduloFixo, abaAtiva]
  );
  const [modalColarExcelAberto, setModalColarExcelAberto] = useState(false);
  /** Rola o `<main>` por aba: cada módulo mantém sua própria posição de rolagem ao trocar de aba. */
  const mainScrollAreaRef = useRef<HTMLDivElement>(null);
  const scrollSalvoPorAbaRef = useRef<Partial<Record<AbaPrincipal, number>>>({});
  const abaAtivaAnteriorScrollRef = useRef<AbaPrincipal>(abaVisivel);
  useLayoutEffect(() => {
    const el = mainScrollAreaRef.current;
    if (!el) return;
    const anterior = abaAtivaAnteriorScrollRef.current;
    scrollSalvoPorAbaRef.current[anterior] = el.scrollTop;
    el.scrollTop = scrollSalvoPorAbaRef.current[abaVisivel] ?? 0;
    abaAtivaAnteriorScrollRef.current = abaVisivel;
  }, [abaVisivel]);

  const [menuNavegacaoExpandido, setMenuNavegacaoExpandido] = useState(true);
  const [projetoFoiSalvo, setProjetoFoiSalvo] = useState(true); // true = vazio ou carregado/salvo
  const [mostrarMetaOperador, setMostrarMetaOperador] = useState<boolean>(() => localStorage.getItem('tempo-corte-mostrar-meta-ade') !== '0');
  const [nomeOperadorTempo, setNomeOperadorTempo] = useState<string>(() => localStorage.getItem('tempo-corte-operador-ade') || '');
  const [metaAdiantoMinutos, setMetaAdiantoMinutos] = useState<number>(() => {
    const saved = localStorage.getItem('tempo-corte-meta-adianto-min-ade');
    const n = saved ? Number(saved) : 288;
    return Number.isFinite(n) && n > 0 ? n : 288;
  });
  const [auditoriaAcoes, setAuditoriaAcoes] = useState<AuditoriaAcao[]>([]);
  const carregouAuditoriaRef = useRef(false);
  const erroPersistenciaAuditoriaRef = useRef(false);
  const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>(() => {
    try {
      const saved = localStorage.getItem('layout-impressao-ade');
      if (!saved) return LAYOUT_PADRAO;
      const parsed = JSON.parse(saved);
      return parsed && typeof parsed === 'object' ? { ...LAYOUT_PADRAO, ...parsed } : LAYOUT_PADRAO;
    } catch {
      return LAYOUT_PADRAO;
    }
  });
  const carregouLayoutRef = useRef(false);
  const layoutSalvoJsonRef = useRef('');
  const erroPersistenciaLayoutRef = useRef(false);

  /** Aplica material/espessura do projeto carregado no layout (sem useEffect em loop). */
  const sincronizarLayoutComMaterialStore = useCallback(() => {
    const { tipoMaterial, espessuraMaterial } = useCorteStore.getState().materialConfig;
    setLayoutConfig((prev) =>
      prev.tipoMaterial === tipoMaterial && prev.espessuraMaterial === espessuraMaterial
        ? prev
        : { ...prev, tipoMaterial, espessuraMaterial }
    );
  }, []);

  const carregarProjetoNoEditor = useCallback(
    (projetoId: string) => {
      carregarProjeto(projetoId);
      sincronizarLayoutComMaterialStore();
    },
    [carregarProjeto, sincronizarLayoutComMaterialStore]
  );

  // Layout do Projeto → store (para salvar no catálogo). Uma direção só — evita loop com rehydrate.
  useEffect(() => {
    if (!carregouLayoutRef.current) return;
    if (ignorarSyncMaterialLayoutRef.current) {
      ignorarSyncMaterialLayoutRef.current = false;
      return;
    }
    if (layoutConfig.tipoMaterial !== materialConfig.tipoMaterial) {
      setMaterialConfig({ tipoMaterial: layoutConfig.tipoMaterial });
    }
    if (layoutConfig.espessuraMaterial !== materialConfig.espessuraMaterial) {
      setMaterialConfig({ espessuraMaterial: layoutConfig.espessuraMaterial });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutConfig.tipoMaterial, layoutConfig.espessuraMaterial]);

  /** Janela principal: recebe "carregar projeto" vindo do Catálogo em outra janela. */
  useEffect(() => {
    const escutaCarregar = !isJanelaFilha || moduloFixo === 'projeto';
    if (!escutaCarregar) return;
    return escutarCarregarProjetoNaJanelaPrincipal((projetoId) => {
      carregarProjetoNoEditor(projetoId);
      setProjetoFoiSalvo(true);
      setAbaAtiva('projeto');
    });
  }, [isJanelaFilha, moduloFixo, carregarProjetoNoEditor]);

  const aplicarHistoricoNoProjeto = (item: HistoricoImpressaoCrossPayload) => {
    const layoutMerged = item.layoutConfig
      ? { ...LAYOUT_PADRAO, ...item.layoutConfig }
      : LAYOUT_PADRAO;
    setLayoutConfig(layoutMerged);
    setProjeto(item.projeto);
    setConfiguracao(item.configuracao);
    restaurarPecas(item.pecas as Parameters<typeof restaurarPecas>[0]);
    setProjetoFoiSalvo(true);
  };

  /** Janela Projeto: recebe "Carregar" do Histórico em outra janela. */
  useEffect(() => {
    const escutaCarregar = !isJanelaFilha || moduloFixo === 'projeto';
    if (!escutaCarregar) return;
    return escutarCarregarHistoricoNaJanelaProjeto((item) => {
      aplicarHistoricoNoProjeto(item);
      setAbaAtiva('projeto');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isJanelaFilha, moduloFixo]);

  useEffect(() => {
    safeSetLocalStorage('tempo-corte-operador-ade', nomeOperadorTempo);
  }, [nomeOperadorTempo]);
  useEffect(() => {
    safeSetLocalStorage('tempo-corte-mostrar-meta-ade', mostrarMetaOperador ? '1' : '0');
  }, [mostrarMetaOperador]);

  useEffect(() => {
    safeSetLocalStorage('tempo-corte-meta-adianto-min-ade', String(metaAdiantoMinutos));
  }, [metaAdiantoMinutos]);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'auditoria')) return;
    let cancelado = false;
    (async () => {
      const dbItems = await lerAuditoriaDB();
      if (cancelado) return;
      if (Array.isArray(dbItems)) {
        setAuditoriaAcoes(dbItems.slice(-800));
        carregouAuditoriaRef.current = true;
        return;
      }
      try {
        const s = localStorage.getItem(STORAGE_AUDITORIA_ADE);
        if (!s) {
          carregouAuditoriaRef.current = true;
          return;
        }
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed)) {
          const dados = parsed.slice(-800);
          setAuditoriaAcoes(dados);
          await salvarAuditoriaDB(dados);
        }
      } catch {
        // ignora erro de parse/IO e segue sem auditoria carregada
      } finally {
        carregouAuditoriaRef.current = true;
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useDebouncedEffect(() => {
    if (!carregouAuditoriaRef.current) return;
    if (ignorarSaveAuditoriaRef.current) {
      ignorarSaveAuditoriaRef.current = false;
      return;
    }
    void (async () => {
      try {
        await salvarAuditoriaDB(auditoriaAcoes.slice(-800));
        notificarSyncDesktop('auditoria');
      } catch {
        if (!erroPersistenciaAuditoriaRef.current) {
          alert('Não foi possível salvar a auditoria no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaAuditoriaRef.current = true;
        }
      }
    })();
  }, [auditoriaAcoes], 400);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'historico')) return;
    let cancelado = false;
    (async () => {
      const mesclados = await coletarHistoricoImpressoesBruto();
      if (cancelado) return;
      if (mesclados.length > 0) {
        setHistoricoImpressoes(mesclados);
        await salvarHistoricoImpressoesDB(mesclados);
        try {
          localStorage.setItem('historico-impressoes-ade', JSON.stringify(mesclados));
        } catch {
          /* ignora */
        }
        console.info(`[Sistema Ade] Histórico: ${mesclados.length} impressão(ões) carregada(s).`);
      }
      carregouHistoricoImpressoesRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  // Histórico de impressões (IndexedDB para evitar limite de quota do localStorage)
  const [historicoImpressoes, setHistoricoImpressoes] = useState<HistoricoImpressao[]>([]);
  const carregouHistoricoImpressoesRef = useRef(false);
  const erroPersistenciaHistoricoRef = useRef(false);
  const [filtroDataInicio, setFiltroDataInicio] = useState('');
  const [filtroDataFim, setFiltroDataFim] = useState('');
  const [filtroHistoricoImpressoes, setFiltroHistoricoImpressoes] = useState('');
  const [filtroCatalogoPasta, setFiltroCatalogoPasta] = useState('');
  const [pastasCatalogoAbertas, setPastasCatalogoAbertas] = useState<Record<string, boolean>>({});
  const [filtroPontuacaoProduto, setFiltroPontuacaoProduto] = useState('');
  const [pontuacoesProdutos, setPontuacoesProdutos] = useState<PontuacaoProduto[]>(() => {
    try {
      const saved = localStorage.getItem('pontuacoes-produtos-ade');
      if (!saved) return normalizarListaPontuacoes(PONTUACOES_PRODUTOS_INICIAL);
      const parsed = JSON.parse(saved);
      const lista = Array.isArray(parsed) && parsed.length > 0 ? parsed : PONTUACOES_PRODUTOS_INICIAL;
      return normalizarListaPontuacoes(lista);
    } catch {
      return normalizarListaPontuacoes(PONTUACOES_PRODUTOS_INICIAL);
    }
  });
  const [editandoPontuacao, setEditandoPontuacao] = useState<{
    index: number;
    nome: string;
    m2: number;
    foraDeLinha: boolean;
  } | null>(null);

  const salvarPontuacoesProdutos = () => {
    setEditandoPontuacao(null);
  };
  useDebouncedEffect(() => {
    try {
      localStorage.setItem('pontuacoes-produtos-ade', JSON.stringify(pontuacoesProdutos));
      notificarSyncDesktop('pontuacoes-produtos');
    } catch {
      // ignora erro de storage
    }
  }, [pontuacoesProdutos], 400);
  /** Na 1ª carga, remove duplicatas, reordena e ajusta índices da calculadora do boletim. */
  useEffect(() => {
    try {
      const saved = localStorage.getItem('pontuacoes-produtos-ade');
      if (!saved) return;
      const parsed = JSON.parse(saved) as PontuacaoProduto[];
      if (!Array.isArray(parsed) || parsed.length === 0) return;
      const normalizada = normalizarListaPontuacoes(parsed);
      const mudou =
        normalizada.length !== parsed.length ||
        normalizada.some((p, i) => p.nome !== parsed[i]?.nome);
      if (mudou) {
        setPontuacoesProdutos(normalizada);
        setProdutoCaixaIndices((indices) =>
          remapearProdutoCaixaIndices(parsed, normalizada, indices)
        );
      }
    } catch {
      /* ignore */
    }
  }, []);
  const normalizarTexto = (s: string) =>
    s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();

  const adicionarOuEditarPontuacao = (index: number = -1) => {
    if (index >= 0) {
      const p = pontuacoesProdutos[index];
      setEditandoPontuacao({
        index,
        nome: p.nome,
        m2: p.m2,
        foraDeLinha: Boolean(p.foraDeLinha),
      });
    } else {
      setEditandoPontuacao({ index: -1, nome: '', m2: 0, foraDeLinha: false });
    }
  };
  const aplicarEdicaoPontuacao = () => {
    if (!editandoPontuacao) return;
    const { index, nome, m2, foraDeLinha } = editandoPontuacao;
    const nomeTrim = nome.trim();
    if (!nomeTrim) return;
    setPontuacoesProdutos((prev) => {
      const proxima =
        index >= 0
          ? prev.map((p, i) =>
              i === index ? { nome: nomeTrim, m2, foraDeLinha } : p
            )
          : [...prev, { nome: nomeTrim, m2, foraDeLinha }];
      const ordenada = ordenarPontuacoesProdutos(proxima);
      setProdutoCaixaIndices((indices) => remapearProdutoCaixaIndices(prev, ordenada, indices));
      return ordenada;
    });
    setEditandoPontuacao(null);
  };
  const alternarForaDeLinhaPontuacao = (index: number) => {
    setPontuacoesProdutos((prev) =>
      prev.map((p, i) => (i === index ? { ...p, foraDeLinha: !p.foraDeLinha } : p))
    );
    setEditandoPontuacao((prev) => {
      if (!prev || prev.index !== index) return prev;
      return { ...prev, foraDeLinha: !prev.foraDeLinha };
    });
  };
  const excluirPontuacao = (index: number) => {
    const produto = pontuacoesProdutos[index];
    if (!produto) return;
    if (!confirm(`Excluir "${produto.nome}" da lista de pontuação?`)) return;
    setPontuacoesProdutos((prev) => prev.filter((_, i) => i !== index));
    setProdutoCaixaIndices((indices) => remapearIndicesAposExclusao(indices, index));
    setEditandoPontuacao((prev) => {
      if (!prev) return null;
      if (prev.index === index) return null;
      if (prev.index > index) return { ...prev, index: prev.index - 1 };
      return prev;
    });
  };

  // Calculadora (Boletim)
  const [calculadoraModo, setCalculadoraModo] = useState<'original' | 'automatica' | 'planilha'>(
    'original'
  );
  const [vendas90d, setVendas90d] = useState<number[]>(() => Array(15).fill(0));
  const [diasValores, setDiasValores] = useState<number[]>(() => Array(15).fill(0));
  const [produtoCaixaIndices, setProdutoCaixaIndices] = useState<(number | null)[]>(() => Array(8).fill(null));
  const [subtotalConfigs, setSubtotalConfigs] = useState<{ produtoCaixaIndex: number; diaIndices: number[] }[]>(() =>
    Array(5).fill(null).map((_, i) => ({ produtoCaixaIndex: i % 8, diaIndices: [] }))
  );
  const porDia = vendas90d.map(v => (v || 0) / 90);
  const diaResultados = diasValores.map((v, j) => (v || 0) * (porDia[j] || 0));

  const INCREMENTOS_CALCULADORA_DIAS = [1, 2, 3, 5, 10, 15, 20, 25, 50, 100] as const;

  /** Soma o incremento apenas nas colunas Dia que já têm valor preenchido. */
  const somarIncrementoDiasCalculadora = (incremento: number) => {
    setDiasValores((prev) =>
      prev.map((v) => {
        const atual = Number(v) || 0;
        if (atual === 0) return v;
        return atual + incremento;
      })
    );
  };

  // Calculadora Automática: vendas 90d, dia por produto, meta pontuação
  const [calcAutoVendas90d, setCalcAutoVendas90d] = useState<number[]>(() => Array(8).fill(0));
  const [calcAutoDias, setCalcAutoDias] = useState<number[]>(() => Array(8).fill(0));
  /** Texto em edição no Dia atual (permite "-" antes de fechar o número). */
  const [calcAutoDiasTexto, setCalcAutoDiasTexto] = useState<string[]>(() => Array(8).fill(''));
  const [calcAutoProdutoNomes, setCalcAutoProdutoNomes] = useState<string[]>(() => Array(8).fill(''));
  const [calcAutoMetaPontos, setCalcAutoMetaPontos] = useState<number>(725);
  const [calcAutoResultado, setCalcAutoResultado] = useState<{ dias: number[]; quantidades: number[]; total: number } | null>(null);

  const arredondarParaCinco = (n: number) => Math.round(Math.max(0, n) / 5) * 5;

  const parseDiaAtualCalcAuto = (raw: string): number => {
    const s = String(raw).trim();
    if (s === '' || s === '-') return 0;
    const n = parseInt(s, 10);
    return Number.isFinite(n) ? n : 0;
  };

  const calcularCalculadoraAutomatica = () => {
    const produtos: { m2: number; porDia: number; diaInicial: number; origIdx: number }[] = [];
    for (let i = 0; i < 8; i++) {
      const nome = (calcAutoProdutoNomes[i] || '').trim();
      if (!nome) continue;
      const p = pontuacoesProdutos.find((x) => normalizarTexto(x.nome) === normalizarTexto(nome));
      if (!p) continue;
      const vendas = calcAutoVendas90d[i] || 0;
      const porDiaVal = vendas / 90;
      if (porDiaVal <= 0) continue;
      const diaInicial = Number(calcAutoDias[i]);
      produtos.push({
        m2: p.m2,
        porDia: porDiaVal,
        diaInicial: Number.isFinite(diaInicial) ? diaInicial : 0,
        origIdx: i,
      });
    }
    if (produtos.length === 0) { setCalcAutoResultado(null); return; }
    const meta = Math.max(0, calcAutoMetaPontos || 0);
    let participando = [...produtos];
    let maxDia = Math.max(...participando.map((p) => p.diaInicial));
    let diasExtra = 0;
    let quantidades: number[] = [];
    let diasAjustados: number[] = [];
    let total = 0;

    while (participando.length > 0) {
      const diasQueFaltam = participando.map((p) => maxDia - p.diaInicial + diasExtra);
      quantidades = participando.map((p, i) => arredondarParaCinco(diasQueFaltam[i] * p.porDia));
      total = participando.reduce((s, p, i) => s + p.m2 * quantidades[i], 0);

      if (total >= meta) {
        while (diasExtra > 0) {
          const dqfAnt = participando.map((p) => maxDia - p.diaInicial + diasExtra - 1);
          const qAnt = participando.map((p, i) => arredondarParaCinco(dqfAnt[i] * p.porDia));
          const totalAnt = participando.reduce((s, p, i) => s + p.m2 * qAnt[i], 0);
          if (totalAnt < meta) break;
          diasExtra--;
          quantidades = qAnt;
          total = totalAnt;
        }
        diasAjustados = participando.map(() => maxDia + diasExtra);
        if (total >= meta && total <= meta + 20) break;
      }
      if (total < meta) {
        while (total < meta) {
          diasExtra++;
          const dqf = participando.map((p) => maxDia - p.diaInicial + diasExtra);
          const q = participando.map((p, i) => arredondarParaCinco(dqf[i] * p.porDia));
          total = participando.reduce((s, p, i) => s + p.m2 * q[i], 0);
          quantidades = q;
        }
        while (diasExtra > 0) {
          const dqfAnt = participando.map((p) => maxDia - p.diaInicial + diasExtra - 1);
          const qAnt = participando.map((p, i) => arredondarParaCinco(dqfAnt[i] * p.porDia));
          const totalAnt = participando.reduce((s, p, i) => s + p.m2 * qAnt[i], 0);
          if (totalAnt < meta) break;
          diasExtra--;
          quantidades = qAnt;
          total = totalAnt;
        }
        diasAjustados = participando.map(() => maxDia + diasExtra);
        break;
      }
      const maiorDia = Math.max(...participando.map((p) => p.diaInicial));
      const comDiaMenor = participando.filter((p) => p.diaInicial < maiorDia);
      // Todos no mesmo dia (ex.: todos 0) — não remove ninguém; encerra com o ajuste atual.
      if (comDiaMenor.length === 0) break;
      participando = comDiaMenor;
      if (participando.length === 0) break;
      maxDia = Math.max(...participando.map((p) => p.diaInicial));
      diasExtra = 0;
    }

    const diasResultado = Array(8).fill(0);
    const qtdsResultado = Array(8).fill(0);
    participando.forEach((p, j) => {
      diasResultado[p.origIdx] = diasAjustados[j] ?? p.diaInicial;
      qtdsResultado[p.origIdx] = quantidades[j] ?? 0;
    });
    produtos.filter((pr) => !participando.some((pa) => pa.origIdx === pr.origIdx)).forEach((pr) => {
      diasResultado[pr.origIdx] = pr.diaInicial;
      qtdsResultado[pr.origIdx] = 0;
    });
    total = produtos.reduce((s, p) => s + p.m2 * qtdsResultado[p.origIdx], 0);
    setCalcAutoResultado({ dias: diasResultado, quantidades: qtdsResultado, total });
  };

  const focarESelecionarInput = (el: HTMLInputElement | null | undefined) => {
    if (!el) return;
    el.focus();
    requestAnimationFrame(() => {
      try {
        el.select();
      } catch {
        /* ignora */
      }
    });
  };

  const onFocusSelecionarTudo = (e: React.FocusEvent<HTMLInputElement>) => {
    requestAnimationFrame(() => {
      try {
        e.currentTarget.select();
      } catch {
        /* ignora */
      }
    });
  };

  const onEnterCalcAutoDia = (e: React.KeyboardEvent, row: number) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const nextRow = row >= 7 ? 0 : row + 1;
    focarESelecionarInput(
      document.querySelector(`input[data-calc-auto-dia][data-row="${nextRow}"]`) as HTMLInputElement | null
    );
  };

  const onEnterCalcAutoVendas = (e: React.KeyboardEvent, row: number) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const nextRow = row >= 7 ? 0 : row + 1;
    focarESelecionarInput(
      document.querySelector(`input[data-calc-auto-vendas][data-row="${nextRow}"]`) as HTMLInputElement | null
    );
  };

  // Tabela dos Dias (ano, pontuação por dia do mês)
  const MESES_BR = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  const getDiasNoMes = (ano: number, mes: number) => new Date(ano, mes, 0).getDate();
  const [anoTabelaDias, setAnoTabelaDias] = useState(() => {
    try {
      const saved = localStorage.getItem('tabela-dias-ano-ade');
      if (saved && /^\d{4}$/.test(saved.trim())) return Number(saved.trim());
    } catch { /* ignore */ }
    return new Date().getFullYear();
  });
  const [mesResumoDias, setMesResumoDias] = useState<number>(0); // 0 = todos, 1-12 = mês específico
  const [tabelaDiasPontuacoes, setTabelaDiasPontuacoes] = useState<Record<string, number>>(() => {
    try {
      const saved = localStorage.getItem('tabela-dias-pontuacoes-ade');
      const base = saved ? normalizarMapaTabelaDias(JSON.parse(saved)) : {};
      return mesclarTabelaComValoresManuais(base);
    } catch { return mesclarTabelaComValoresManuais({}); }
  });
  const tabelaDiasExibicao = useMemo(
    () => mesclarTabelaComValoresManuais(tabelaDiasPontuacoes),
    [tabelaDiasPontuacoes]
  );
  const getPontuacaoTabela = (ano: number, mes: number, dia: number) =>
    tabelaDiasExibicao[`${ano}-${mes}-${dia}`] ?? 0;
  const impedirScrollAlterarNumero = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };
  const setPontuacaoTabela = (ano: number, mes: number, dia: number, valor: number) => {
    const key = `${ano}-${mes}-${dia}`;
    salvarValorTabelaManual(key, valor);
    setTabelaDiasPontuacoes((prev) => {
      const next = { ...prev, [key]: valor };
      return next;
    });
  };
  useEffect(() => {
    try { localStorage.setItem('tabela-dias-ano-ade', String(anoTabelaDias)); } catch {}
  }, [anoTabelaDias]);
  useEffect(() => {
    try {
      localStorage.setItem(
        'tabela-dias-pontuacoes-ade',
        JSON.stringify(mesclarTabelaComValoresManuais(tabelaDiasPontuacoes))
      );
    } catch {}
  }, [tabelaDiasPontuacoes]);

  const resumoDiasAnoSelecionado = useMemo(() => {
    const mapaNorm = normalizarMapaTabelaDias(tabelaDiasExibicao);
    const linhas: { data: string; dia: number; mes: number; pontos: number }[] = [];
    let totalPontos = 0;
    Object.entries(mapaNorm).forEach(([key, valorBruto]) => {
      const valor = Number(valorBruto) || 0;
      if (!valor) return;
      const [anoStr, mesStr, diaStr] = key.split('-');
      const ano = Number(anoStr);
      const mes = Number(mesStr);
      const dia = Number(diaStr);
      if (ano !== anoTabelaDias) return;
      if (mesResumoDias && mes !== mesResumoDias) return;
      linhas.push({
        data: `${String(dia).padStart(2, '0')}/${MESES_BR[mes - 1].toLowerCase()}`,
        dia,
        mes,
        pontos: valor,
      });
      totalPontos += valor;
    });
    linhas.sort((a, b) => {
      if (a.mes === b.mes) return a.dia - b.dia;
      return a.mes - b.mes;
    });
    return {
      linhas,
      totalDias: linhas.length,
      totalPontos,
    };
  }, [tabelaDiasExibicao, anoTabelaDias, mesResumoDias]);

  const [graficoMesInicio, setGraficoMesInicio] = useState<string>(() => {
    try {
      const s = localStorage.getItem(STORAGE_GRAFICO_MES_INICIO_BOLETIM);
      if (s && /^\d{4}-\d{2}$/.test(s.trim())) return s.trim();
    } catch {
      /* ignore */
    }
    return mesAnoInicioGraficoBoletimPadrao();
  });

  useEffect(() => {
    safeSetLocalStorage(STORAGE_GRAFICO_MES_INICIO_BOLETIM, graficoMesInicio);
  }, [graficoMesInicio]);

  // Dados do gráfico: soma por mês — 13 meses consecutivos a partir de `graficoMesInicio`
  const dadosGrafico13Meses = useMemo(() => {
    const somaPorMes = agregarPontuacaoPorMesTabelaDias(tabelaDiasExibicao);
    const partes = graficoMesInicio.split('-').map(Number);
    let a = partes[0];
    let m = partes[1];
    if (!Number.isFinite(a) || !Number.isFinite(m) || m < 1 || m > 12) {
      const pad = mesAnoInicioGraficoBoletimPadrao().split('-').map(Number);
      a = pad[0];
      m = pad[1];
    }
    const resultado: { mes: string; mesAno: string; pontuacao: number }[] = [];
    for (let i = 0; i < 13; i++) {
      const k = `${a}-${String(m).padStart(2, '0')}`;
      const pontuacao = somaPorMes[k] ?? 0;
      resultado.push({ mes: MESES_BR[m - 1], mesAno: `${MESES_BR[m - 1]}/${a}`, pontuacao });
      m += 1;
      if (m > 12) {
        m = 1;
        a += 1;
      }
    }
    return resultado;
  }, [tabelaDiasExibicao, graficoMesInicio]);

  const [graficoOrientacaoImpressao, setGraficoOrientacaoImpressao] = useState<'paisagem' | 'retrato'>('paisagem');
  const [graficoTamanho, setGraficoTamanho] = useState({ w: 800, h: 690 });
  const [arrastandoGrafico, setArrastandoGrafico] = useState(false);
  const refGraficoResize = useRef<{ startX: number; startY: number; startW: number; startH: number } | null>(null);

  const handleGraficoResizeStart = (e: React.MouseEvent) => {
    e.preventDefault();
    setArrastandoGrafico(true);
    refGraficoResize.current = { startX: e.clientX, startY: e.clientY, startW: graficoTamanho.w, startH: graficoTamanho.h };
  };
  useEffect(() => {
    if (!arrastandoGrafico) return;
    const onMove = (e: MouseEvent) => {
      if (!refGraficoResize.current) return;
      const dx = e.clientX - refGraficoResize.current.startX;
      const dy = e.clientY - refGraficoResize.current.startY;
      setGraficoTamanho({
        w: Math.max(400, refGraficoResize.current.startW + dx),
        h: Math.max(300, refGraficoResize.current.startH + dy)
      });
    };
    const onUp = () => { setArrastandoGrafico(false); refGraficoResize.current = null; };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
  }, [arrastandoGrafico]);

  // LOTES - cadastro de produtos por lote
  const [lotesProdutos, setLotesProdutos] = useState<LoteProdutoConfig[]>([]);
  const carregouLotesProdutosRef = useRef(false);
  /** Incrementa a cada import Excel — evita o load assíncrono apagar a importação. */
  const lotesImportGenRef = useRef(0);
  const erroPersistenciaLotesRef = useRef(false);
  const [novoLoteNome, setNovoLoteNome] = useState('');
  const [novoProdutoLoteNome, setNovoProdutoLoteNome] = useState('');
  const [novoQtdProdutoLote, setNovoQtdProdutoLote] = useState<number>(0);
  const [novoInicioCorte, setNovoInicioCorte] = useState('');
  const [novoFimEmbalagem, setNovoFimEmbalagem] = useState('');
  const [renumerarLoteAntigo, setRenumerarLoteAntigo] = useState('');
  const [renumerarLoteNovo, setRenumerarLoteNovo] = useState('');
  const [renumerarInicioCorte, setRenumerarInicioCorte] = useState('');
  const [renumerarFimEmbalagem, setRenumerarFimEmbalagem] = useState('');
  const [renumerarAtualizarDatas, setRenumerarAtualizarDatas] = useState(false);
  const [datasLoteAlvo, setDatasLoteAlvo] = useState('');
  const [datasLoteInicio, setDatasLoteInicio] = useState('');
  const [datasLoteFim, setDatasLoteFim] = useState('');
  const [filtroLotes, setFiltroLotes] = useState('');
  const [filtroProdutoNomeLotes, setFiltroProdutoNomeLotes] = useState('');
  const [filtroMesLotes, setFiltroMesLotes] = useState('');
  const [itensParaAdicionar, setItensParaAdicionar] = useState<Array<{ id: string; produtoNome: string; qtd: number }>>([]);
  const [modalImportarLotesExcel, setModalImportarLotesExcel] = useState(false);
  const [editandoLoteItem, setEditandoLoteItem] = useState<LoteProdutoConfig | null>(null);
  const [lotesImpressosPalete, setLotesImpressosPalete] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_LOTES_IMPRESSOS_PALETE);
      if (!saved) return [];
      const parsed = JSON.parse(saved);
      return Array.isArray(parsed) ? parsed.map((x) => normalizarTexto(String(x))) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'lotes')) return;
    let cancelado = false;
    const genAoIniciar = lotesImportGenRef.current;
    (async () => {
      aplicarMigracaoPurgaFantasma8723();
      aplicarMigracaoPurga8833BuffetLume();
      const bruto = await coletarLotesCadastro();
      if (cancelado) return;
      // Import aconteceu enquanto o load lia o disco — não sobrescrever.
      if (lotesImportGenRef.current !== genAoIniciar) {
        carregouLotesProdutosRef.current = true;
        return;
      }
      const mesclados = deduplicarLotesPorLoteProduto(
        corrigirListaNomesBuffetAron4Portas(
          corrigirListaNomesBerlimBerlin(bruto, 'produtoNome'),
          'produtoNome'
        ),
        { registrarExcluidos: true }
      );
      if (lotesImportGenRef.current !== genAoIniciar) {
        carregouLotesProdutosRef.current = true;
        return;
      }
      setLotesProdutos(mesclados);
      if (mesclados.length > 0) {
        const resumo = resumoLotes(mesclados);
        console.info(
          `[Sistema Ade] Lotes: ${resumo.total} registro(s), ${resumo.lotesUnicos} lote(s) único(s), maior nº ${resumo.maiorNumeroLote || '—'}.`
        );
        await persistirLotesProdutosDireto(mesclados);
      }
      // Nunca gravar [] no load vazio — apagava importação / cadastro ainda em disco.
      carregouLotesProdutosRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'lotes')) return;
    if (!carregouLotesProdutosRef.current) return;
    if (ignorarSaveLotesRef.current) {
      ignorarSaveLotesRef.current = false;
      return;
    }
    void (async () => {
      try {
        const { gravou } = await salvarLotesProdutosDBSeguro(lotesProdutos);
        if (gravou) notificarSyncDesktop('lotes-produtos');
      } catch {
        if (!erroPersistenciaLotesRef.current) {
          alert('Não foi possível salvar os lotes no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaLotesRef.current = true;
        }
      }
    })();
  }, [lotesProdutos], 400);

  const lotesProdutosRef = useRef(lotesProdutos);
  lotesProdutosRef.current = lotesProdutos;

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'lotes')) return;
    const flush = () => {
      const atual = filtrarLotesNaoExcluidos(
        deduplicarLotesPorLoteProduto(lotesProdutosRef.current)
      );
      salvarLotesLegadoLocalStorage(atual);
      void persistirLotesProdutosDireto(atual);
    };
    window.addEventListener('beforeunload', flush);
    return () => window.removeEventListener('beforeunload', flush);
  }, [escopoDados]);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'lotes')) return;
    try {
      const saved = localStorage.getItem(STORAGE_LOTES_IMPRESSOS_PALETE);
      if (!saved) return;
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setLotesImpressosPalete(parsed.map((x) => normalizarTexto(String(x))));
      }
    } catch {
      /* mantém estado atual */
    }
  }, [escopoDados]);

  const lotesProdutosFiltrados = useMemo(() => {
    const filtrados = lotesProdutos.filter((lp) => {
      const filtroTexto = filtroLotes.trim().toLowerCase();
      const filtrosLote = filtroTexto
        .split(/[,\n;]+/)
        .map((s) => s.trim())
        .filter(Boolean);
      const filtroProduto = filtroProdutoNomeLotes.trim().toLowerCase();
      const bateLote = filtrosLote.length === 0 || filtrosLote.some((f) => lp.lote.toLowerCase().includes(f));
      const bateProduto = !filtroProduto || lp.produtoNome.toLowerCase().includes(filtroProduto);
      const bateTexto = bateLote && bateProduto;

      let bateMes = true;
      if (filtroMesLotes) {
        const baseMes = lp.dataHoraInicioCorte || lp.dataHoraFimEmbalagem;
        if (!baseMes) {
          bateMes = false;
        } else {
          const data = new Date(baseMes);
          if (isNaN(data.getTime())) {
            bateMes = false;
          } else {
            const mesRegistro = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
            bateMes = mesRegistro === filtroMesLotes;
          }
        }
      }

      return bateTexto && bateMes;
    });
    const extrairNumLote = (s: string) => {
      const m = String(s || '').match(/\d+/);
      return m ? parseInt(m[0], 10) : 999999;
    };
    return [...filtrados].sort((a, b) => {
      const na = extrairNumLote(a.lote);
      const nb = extrairNumLote(b.lote);
      if (na !== nb) return na - nb;
      return (a.lote || '').localeCompare(b.lote || '');
    });
  }, [filtroLotes, filtroProdutoNomeLotes, filtroMesLotes, lotesProdutos]);

  const lotesUnicosCadastro = useMemo(() => {
    const set = new Set<string>();
    for (const lp of lotesProdutos) {
      const n = String(lp.lote || '').trim().toUpperCase();
      if (n) set.add(n);
    }
    return [...set].sort((a, b) => a.localeCompare(b, 'pt-BR', { numeric: true }));
  }, [lotesProdutos]);

  const resumoLotesCadastrados = useMemo(() => resumoLotes(lotesProdutos), [lotesProdutos]);

  const recuperarLotesDoBackup = useCallback(async () => {
    const mesclados = await coletarLotesTodasFontesRecuperacao();
    const alternativas = coletarLotesFontesAlternativas(await coletarProdutosTempoCorteBruto());
    const reunidosBruto = mesclarLotesProdutos(lotesProdutos, mesclados, alternativas);
    const reunidos = deduplicarLotesPorLoteProduto(reunidosBruto, { registrarExcluidos: true });
    const antes = resumoLotes(lotesProdutos);
    const depois = resumoLotes(reunidos);
    if (reunidos.length <= lotesProdutos.length && depois.maiorNumeroLote <= antes.maiorNumeroLote) {
      alert(
        `Nenhum lote adicional encontrado.\nAtual: ${antes.total} registro(s), maior nº ${antes.maiorNumeroLote || '—'}.\n\nDica: os números em "Finalizar lote antigo" (Tempo de Corte) são só marcas manuais — não são o cadastro completo de produtos/qtd.`
      );
      return;
    }
    ignorarSaveLotesRef.current = true;
    setLotesProdutos(reunidos);
    await persistirLotesProdutosDireto(reunidos);
    notificarSyncDesktop('lotes-produtos');
    alert(
      `Lotes recuperados.\nAntes: ${antes.total} reg. (maior nº ${antes.maiorNumeroLote || '—'})\nAgora: ${depois.total} reg. (maior nº ${depois.maiorNumeroLote || '—'})\n\nRevise linhas "(completar — só nº marcado…)" e preencha produto/qtd.`
    );
  }, [lotesProdutos]);

  const recuperarLotesDeTempoCorte = useCallback(async () => {
    const alternativas = coletarLotesFontesAlternativas(await coletarProdutosTempoCorteBruto());
    const reunidosBruto = mesclarLotesProdutos(lotesProdutos, alternativas);
    const reunidos = deduplicarLotesPorLoteProduto(reunidosBruto, { registrarExcluidos: true });
    const antes = resumoLotes(lotesProdutos);
    const depois = resumoLotes(reunidos);
    if (reunidos.length <= lotesProdutos.length && depois.maiorNumeroLote <= antes.maiorNumeroLote) {
      alert(
        `Nada novo no Tempo de Corte / marcas manuais.\nAtual: maior nº ${antes.maiorNumeroLote || '—'}.`
      );
      return;
    }
    ignorarSaveLotesRef.current = true;
    setLotesProdutos(reunidos);
    await persistirLotesProdutosDireto(reunidos);
    notificarSyncDesktop('lotes-produtos');
    alert(
      `Lotes reconstruídos do Tempo de Corte.\nAntes: ${antes.total} reg. (maior nº ${antes.maiorNumeroLote || '—'})\nAgora: ${depois.total} reg. (maior nº ${depois.maiorNumeroLote || '—'})`
    );
  }, [lotesProdutos]);

  const totalPontuacaoLotesFiltrados = useMemo(() => {
    return lotesProdutosFiltrados.reduce(
      (total, lp) => total + pontosLinhaLoteBoletim(lp, pontuacoesProdutos),
      0
    );
  }, [lotesProdutosFiltrados, pontuacoesProdutos]);

  const pontuacaoTotalPorLote = useMemo(() => {
    const map = new Map<string, number>();
    for (const lp of lotesProdutosFiltrados) {
      const k = normalizarTexto(lp.lote);
      map.set(k, (map.get(k) ?? 0) + pontosLinhaLoteBoletim(lp, pontuacoesProdutos));
    }
    return map;
  }, [lotesProdutosFiltrados, pontuacoesProdutos]);

  const chavesTabelaGeradasPorLotesRef = useRef<Set<string>>(lerChavesTabelaGeradasLotes());
  const atualizarTabelaDiasComLotes = useCallback((novos?: LoteProdutoConfig[]) => {
    const fonte = novos ?? lotesProdutos;
    const acumulado = calcularPontuacaoLotesPorDia(fonte, pontuacoesProdutos);

    setTabelaDiasPontuacoes((prev) => {
      const { next, novasChaves } = aplicarSyncTabelaDiasComLotes(
        prev,
        acumulado,
        chavesTabelaGeradasPorLotesRef.current
      );
      chavesTabelaGeradasPorLotesRef.current = novasChaves;
      salvarChavesTabelaGeradasLotes(novasChaves);
      return next;
    });
  }, [lotesProdutos, pontuacoesProdutos]);

  useEffect(() => {
    atualizarTabelaDiasComLotes();
  }, [atualizarTabelaDiasComLotes]);

  const importarLotesDoExcel = useCallback(
    (itens: LoteImportadoExcel[]) => {
      const novos: LoteProdutoConfig[] = itens.map((i) => ({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        lote: i.lote.trim().toUpperCase(),
        produtoNome: i.produtoNome.trim(),
        qtd: i.qtd,
        corProduto: i.corProduto?.trim() || undefined,
        codigoProduto: i.codigoProduto?.trim() || undefined,
        dataHoraInicioCorte: i.dataHoraInicioCorte,
        dataHoraFimEmbalagem: i.dataHoraFimEmbalagem,
      }));
      // Import explícito: libera pares que tinham sido apagados antes (senão filtrar some com tudo).
      liberarParesLotesExcluidos(novos.flatMap((n) => paresExclusaoDeLoteProduto(n)));
      lotesImportGenRef.current += 1;
      const next = deduplicarLotesPorLoteProduto([...lotesProdutos, ...novos], {
        registrarExcluidos: false,
      });
      ignorarSaveLotesRef.current = true;
      setLotesProdutos(next);
      setFiltroLotes('');
      setFiltroProdutoNomeLotes('');
      setFiltroMesLotes('');
      carregouLotesProdutosRef.current = true;
      registrarAuditoria('importar_lotes_excel', `${novos.length} itens do Excel`);
      atualizarTabelaDiasComLotes(next);
      void persistirLotesProdutosDireto(next).then(() => {
        notificarSyncDesktop('lotes-produtos');
      });
      setModalImportarLotesExcel(false);
      alert(`Importação concluída: ${novos.length} linha(s) · total na aba: ${next.length}.`);
    },
    [lotesProdutos, atualizarTabelaDiasComLotes]
  );

  const imprimirGrafico = () => {
    const styleId = 'print-grafico-page-style';
    let styleEl = document.getElementById(styleId) as HTMLStyleElement | null;
    if (!styleEl) { styleEl = document.createElement('style'); styleEl.id = styleId; document.head.appendChild(styleEl); }
    const isPaisagem = graficoOrientacaoImpressao === 'paisagem';
    const largura = isPaisagem ? 3508 : 2480;
    const altura = isPaisagem ? 2480 : 3508;
    styleEl.textContent = `
      @page { size: A4 ${isPaisagem ? 'landscape' : 'portrait'}; margin: 8mm; }
      @media print {
        body.imprimir-grafico-boletim .area-grafico-impressao .grafico-3d-container {
          width: ${largura}px !important; height: ${altura}px !important;
          min-width: ${largura}px !important; min-height: ${altura}px !important;
        }
      }
    `;
    document.body.classList.add('imprimir-grafico-boletim');
    document.body.classList.add(isPaisagem ? 'grafico-print-paisagem' : 'grafico-print-retrato');
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        document.body.classList.remove('imprimir-grafico-boletim', 'grafico-print-paisagem', 'grafico-print-retrato');
      }, 100);
    }, 150);
  };

  const onEnterProximaLinha = (e: React.KeyboardEvent, dataGrid: string, row: number, col: number, maxRow: number) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const nextRow = row >= maxRow ? 0 : row + 1;
    focarESelecionarInput(
      document.querySelector(
        `input[data-grid="${dataGrid}"][data-row="${nextRow}"][data-col="${col}"]`
      ) as HTMLInputElement | null
    );
  };

  const preencherPontuacaoPorNomeTempoCorte = () => {
    const nome = nomeProdutoTempo.trim();
    const lote = loteTempoCorte.trim();
    if (!lote) {
      alert('Informe o lote para buscar a pontuação e a quantidade automaticamente.');
      return;
    }
    setDataHoraInicioProducao('');
    setDataHoraTerminoProducao('');
    const loteAlvo = normalizarTexto(lote);
    const numerosLote = numerosLoteDeTexto(lote);
    const itensDoLote = colapsarDuplicatasLoteProduto(
      filtrarLotesNaoExcluidos(
        lotesProdutos.filter((lp) => {
          const numsLp = numerosLoteDeTexto(String(lp.lote || ''));
          if (numerosLote.length > 0 && numsLp.length > 0) {
            return numsLp.some((n) => numerosLote.includes(n));
          }
          return normalizarTexto(lp.lote) === loteAlvo;
        })
      )
    );
    if (itensDoLote.length === 0) {
      alert(`Nenhum produto encontrado no boletim para o lote ${lote}.`);
      return;
    }
    const buscarM2 = (nomeProd: string): number =>
      buscarM2ProdutoBoletim(nomeProd, pontuacoesProdutos);
    let itensConsiderados = itensDoLote;
    const alvoNome = normalizarTexto(nome);
    if (alvoNome) {
      const matchExato = itensDoLote.filter(
        (lp) => normalizarTexto(lp.produtoNome) === alvoNome
      );
      if (matchExato.length > 0) {
        itensConsiderados = matchExato;
      } else {
        const matchParcial = itensDoLote.filter((lp) => {
          const n = normalizarTexto(lp.produtoNome);
          return n.includes(alvoNome) || alvoNome.includes(n);
        });
        if (matchParcial.length > 0) itensConsiderados = matchParcial;
      }
    }
    const grupos = new Map<string, { nome: string; qtd: number; m2: number }>();
    itensConsiderados.forEach((lp) => {
      const chave = normalizarTexto(lp.produtoNome);
      if (!chave) return;
      const atual = grupos.get(chave);
      const qtd = Number(lp.qtd) || 0;
      if (atual) {
        atual.qtd += qtd;
      } else {
        grupos.set(chave, {
          nome: lp.produtoNome,
          qtd,
          m2: buscarM2(lp.produtoNome),
        });
      }
    });
    if (grupos.size === 0) {
      alert('Não foi possível identificar produtos válidos no boletim para este lote.');
      return;
    }
    let somaPesoPontuacao = 0;
    let somaQtd = 0;
    let semPontuacao = 0;
    const detalhes: string[] = [];
    grupos.forEach((g) => {
      somaQtd += g.qtd;
      somaPesoPontuacao += g.m2 * g.qtd;
      if (g.m2 <= 0) semPontuacao += 1;
      detalhes.push(`  • ${g.nome}: pts ${g.m2 || '?'} × qtd ${g.qtd}`);
    });
    const pontuacaoPonderada =
      somaQtd > 0 ? somaPesoPontuacao / somaQtd : 0;
    setPontuacaoProduto(Number(pontuacaoPonderada.toFixed(4)));
    setQtdProduto(somaQtd);
    if (grupos.size > 1) {
      alert(
        `Pontuação ponderada de ${grupos.size} produto(s) no lote ${lote}:\n` +
          `${detalhes.join('\n')}\n\n` +
          `Σ(pts × qtd) = ${somaPesoPontuacao.toFixed(2)} | Σ qtd = ${somaQtd}\n` +
          `→ Pontuação do produto (média ponderada): ${pontuacaoPonderada.toFixed(4)}\n` +
          (semPontuacao > 0
            ? `\n⚠ ${semPontuacao} produto(s) sem pontuação cadastrada (entram como 0). Cadastre no Boletim e refaça a busca.`
            : '')
      );
    } else if (semPontuacao > 0) {
      alert(
        'O produto deste lote não tem pontuação cadastrada no Boletim. Pontuação ficou 0.'
      );
    }
  };
  
  // Relatório de Peças Produzidas
  const [relatorioItens, setRelatorioItens] = useState<RelatorioItem[]>([]);
  const carregouRelatorioRef = useRef(false);
  const erroPersistenciaRelatorioRef = useRef(false);
  const revisionRelatorioRef = useRef(0);
  const aplicandoSyncRemotoRelatorioRef = useRef(false);
  const ignorarPersistenciaRelatorioRef = useRef(false);
  const ignorarSaveHistoricoRef = useRef(false);
  const ignorarSaveLotesRef = useRef(false);
  const ignorarSaveSobraRef = useRef(false);
  const ignorarSaveSobraPastasRef = useRef(false);
  const ignorarSaveSobraRiscadosRef = useRef(false);
  const ignorarSaveLayoutRef = useRef(false);
  const ignorarSyncMaterialLayoutRef = useRef(false);
  const ignorarSaveTempoCorteProdRef = useRef(false);
  const ignorarSaveTempoCorteItensRef = useRef(false);
  const ignorarSaveAuditoriaRef = useRef(false);
  const [relatorioCabecalho, setRelatorioCabecalho] = useState({
    lote: '',
    nomeProduto: '',
    tempo: '',
    dataInicio: '',
    dataTermino: ''
  });
  /** IDs dos produtos do Tempo de Corte que o usuário pediu pra IGNORAR
   *  no relatório atual (não somam tempo). Reseta quando troca o lote/produto. */
  const [produtosTcIgnoradosRelatorio, setProdutosTcIgnoradosRelatorio] = useState<Set<string>>(
    () => {
      try {
        const raw = localStorage.getItem('relatorio-tc-ignorados-ade');
        if (!raw) return new Set();
        const arr = JSON.parse(raw);
        return new Set(Array.isArray(arr) ? arr : []);
      } catch {
        return new Set();
      }
    }
  );
  useEffect(() => {
    try {
      localStorage.setItem(
        'relatorio-tc-ignorados-ade',
        JSON.stringify(Array.from(produtosTcIgnoradosRelatorio))
      );
    } catch {
      /* quota */
    }
  }, [produtosTcIgnoradosRelatorio]);
  const [sobraMarcados, setSobraMarcados] = useState<Set<string>>(new Set());
  const [pastasSobra, setPastasSobra] = useState<SobraPastaADE[]>(() => {
    try {
      const s = localStorage.getItem('sobra-pastas-ade');
      if (!s) return [];
      const p = JSON.parse(s);
      if (!Array.isArray(p)) return [];
      return p
        .filter((x: unknown) => x && typeof x === 'object' && typeof (x as SobraPastaADE).id === 'string')
        .map((x: SobraPastaADE) => ({ id: x.id, nome: String(x.nome || 'Pasta') }));
    } catch {
      return [];
    }
  });
  const carregouSobraPastasRef = useRef(false);
  const erroPersistenciaSobraPastasRef = useRef(false);
  const [nomeNovaPastaSobra, setNomeNovaPastaSobra] = useState('');
  const [pastaFiltroSobra, setPastaFiltroSobra] = useState<'todas' | 'sem' | string>('todas');
  const [sobraItens, setSobraItens] = useState<SobraEntradaADE[]>([]);
  const carregouSobraRef = useRef(false);
  const erroPersistenciaSobraRef = useRef(false);
  const sobraItensRef = useRef(sobraItens);
  sobraItensRef.current = sobraItens;
  const [filtroSobra, setFiltroSobra] = useState('');
  const [filtroNomePastasSobra, setFiltroNomePastasSobra] = useState('');
  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'relatorio')) return;
    let cancelado = false;
    (async () => {
      const estado = await lerRelatorioEstado();
      if (cancelado) return;
      aplicandoSyncRemotoRelatorioRef.current = true;
      setRelatorioItens(
        estado.itens.map((item) => normalizarRelatorioItemLinha(item as Record<string, unknown>))
      );
      setRelatorioCabecalho(estado.cabecalho);
      revisionRelatorioRef.current = estado.revision;
      ignorarPersistenciaRelatorioRef.current = true;
      carregouRelatorioRef.current = true;
      aplicandoSyncRemotoRelatorioRef.current = false;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    let cancelado = false;
    (async () => {
      const mesclados = await coletarSobraBruto();
      if (cancelado) return;
      setSobraItens(mesclados);
      if (mesclados.length > 0) {
        await persistirSobraDireto(mesclados);
        console.info(`[Sistema Ade] Sobra: ${mesclados.length} entrada(s) carregada(s).`);
      } else {
        await persistirSobraDireto([]);
      }
      carregouSobraRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    const flush = () => {
      const atual = filtrarSobraNaoExcluidas(sobraItensRef.current);
      try {
        localStorage.setItem('sobra-pecas-ade', JSON.stringify(atual));
      } catch {
        /* quota */
      }
      void persistirSobraDireto(atual);
    };
    window.addEventListener('beforeunload', flush);
    window.addEventListener('pagehide', flush);
    return () => {
      window.removeEventListener('beforeunload', flush);
      window.removeEventListener('pagehide', flush);
    };
  }, [escopoDados]);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    let cancelado = false;
    (async () => {
      const mesclados = await coletarSobraPastasBruto();
      if (cancelado) return;
      if (mesclados.length > 0) {
        const normalizadas = mesclados
          .filter((x) => x && typeof x.id === 'string')
          .map((x) => ({ id: String(x.id), nome: String(x.nome || 'Pasta') }));
        setPastasSobra(normalizadas);
        await salvarSobraPastasDB(normalizadas);
        try {
          localStorage.setItem('sobra-pastas-ade', JSON.stringify(normalizadas));
        } catch {
          /* ignora */
        }
        console.info(`[Sistema Ade] Sobra pastas: ${normalizadas.length} pasta(s) carregada(s).`);
      }
      carregouSobraPastasRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);
  const [paginaSobraADE, setPaginaSobraADE] = useState<'lista' | 'pastas'>('lista');
  const [sobraSelecionadosParaImpressao, setSobraSelecionadosParaImpressao] = useState<Set<string>>(new Set());

  const tratarSyncDesktop = useCallback(
    async (chave: SyncChave) => {
      switch (chave) {
        case 'catalogo':
          if (moduloPrecisaDado(escopoDados, 'catalogo')) {
            await sincronizarApenasProjetosSalvosDoDisco();
          }
          break;
        case 'relatorio': {
          if (!moduloPrecisaDado(escopoDados, 'relatorio')) break;
          const estado = await lerRelatorioEstado();
          aplicandoSyncRemotoRelatorioRef.current = true;
          setRelatorioItens(
            estado.itens.map((item) => normalizarRelatorioItemLinha(item as Record<string, unknown>))
          );
          setRelatorioCabecalho(estado.cabecalho);
          revisionRelatorioRef.current = estado.revision;
          ignorarPersistenciaRelatorioRef.current = true;
          aplicandoSyncRemotoRelatorioRef.current = false;
          break;
        }
        case 'historico-impressoes': {
          if (!moduloPrecisaDado(escopoDados, 'historico')) break;
          const mesclados = await coletarHistoricoImpressoesBruto();
          if (mesclados.length === 0) break;
          ignorarSaveHistoricoRef.current = true;
          setHistoricoImpressoes((prev) =>
            mesclarRegistrosPorId([prev as Record<string, unknown>[], mesclados as Record<string, unknown>[]], {
              getId: (i) => String(i.id || '').trim(),
            }) as HistoricoImpressao[]
          );
          break;
        }
        case 'lotes-produtos': {
          if (!moduloPrecisaDado(escopoDados, 'lotes')) break;
          const mesclados = deduplicarLotesPorLoteProduto(
            corrigirListaNomesBuffetAron4Portas(await coletarLotesCadastro(), 'produtoNome')
          );
          if (mesclados.length === 0) break;
          ignorarSaveLotesRef.current = true;
          // Disco é a verdade — não remesclar com memória (reinseria linha apagada).
          setLotesProdutos(mesclados as LoteProdutoConfig[]);
          break;
        }
        case 'tempo-corte-produtos': {
          if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) break;
          await hidratarExclusoesCardsTempoCorte();
          const bruto = await coletarProdutosTempoCorteBruto();
          ignorarSaveTempoCorteProdRef.current = true;
          // Disco (bruto) é a verdade — NÃO remesclar com prev da memória:
          // isso reinseria cards que a outra janela já apagou.
          const limpos = deduplicarProdutosTempoCortePorLoteNome(
            filtrarCardsTempoCorteNaoExcluidos(
              corrigirListaNomesBuffetAron4Portas(
                migrarLotesUnificadosV315(
                  migrarNomesUnificados(migrarUnificadosAntigos(bruto))
                ) as { nome?: string }[],
                'nome'
              )
            )
          );
          setProdutosTempoCorteSalvos((prev) => {
            if (limpos.length === 0 && prev.length > 0) {
              // Leitura vazia suspeita: só limpa o que está na lista de exclusão.
              const soSemExcluidos = filtrarCardsTempoCorteNaoExcluidos(prev);
              return soSemExcluidos as typeof prev;
            }
            const porId = new Map(
              limpos.map((p) => [String(p.id || '').trim(), p as Record<string, unknown>])
            );
            const igual =
              limpos.length === prev.length &&
              prev.every((p) => {
                const id = String(p.id || '').trim();
                const remoto = porId.get(id);
                if (!remoto) return false;
                const itensPrev = Array.isArray(p.itens) ? p.itens : [];
                const itensRem = Array.isArray(remoto.itens) ? remoto.itens : [];
                const selPrev = itensPrev
                  .map((i: any) => `${i?.id}:${i?.selecionado === false ? 0 : 1}`)
                  .join('|');
                const selRem = itensRem
                  .map((i: any) => `${i?.id}:${i?.selecionado === false ? 0 : 1}`)
                  .join('|');
                return (
                  Boolean(p.enviarParaAnalise) === Boolean(remoto.enviarParaAnalise) &&
                  String(p.horarioProduto || '') === String(remoto.horarioProduto || '') &&
                  Number(p.tempoExato || 0) === Number(remoto.tempoExato || 0) &&
                  selPrev === selRem
                );
              });
            if (igual) return prev;
            return limpos as typeof prev;
          });
          break;
        }
        case 'tempo-corte-itens': {
          if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) break;
          const mesclados = await coletarTempoCorteItensBruto();
          if (mesclados.length === 0) break;
          ignorarSaveTempoCorteItensRef.current = true;
          setTempoCorteItens((prev) =>
            mesclarRegistrosPorId(
              [prev as Record<string, unknown>[], mesclados as Record<string, unknown>[]],
              { getId: (i) => String(i.id || '').trim() }
            ) as TempoCorteItem[]
          );
          break;
        }
        case 'sobra': {
          if (!moduloPrecisaDado(escopoDados, 'sobra')) break;
          const mesclados = await coletarSobraBruto();
          ignorarSaveSobraRef.current = true;
          setSobraItens(mesclados);
          break;
        }
        case 'sobra-pastas': {
          if (!moduloPrecisaDado(escopoDados, 'sobra')) break;
          const mesclados = await coletarSobraPastasBruto();
          if (mesclados.length === 0) break;
          ignorarSaveSobraPastasRef.current = true;
          setPastasSobra((prev) =>
            mesclarRegistrosPorId(
              [prev as Record<string, unknown>[], mesclados as Record<string, unknown>[]],
              { getId: (i) => String(i.id || '').trim() }
            ) as SobraPastaADE[]
          );
          break;
        }
        case 'sobra-riscados': {
          if (!moduloPrecisaDado(escopoDados, 'sobra')) break;
          const lista = await coletarSobraRiscadosBruto();
          if (lista.length === 0) break;
          ignorarSaveSobraRiscadosRef.current = true;
          setSobraRiscados((prev) => new Set([...prev, ...lista]));
          break;
        }
        case 'layout-impressao': {
          if (!moduloPrecisaDado(escopoDados, 'layout')) break;
          const dbLayout = await lerLayoutImpressaoDB();
          if (!dbLayout || typeof dbLayout !== 'object') break;
          const merged = normalizarLayoutCarregado({ ...LAYOUT_PADRAO, ...dbLayout });
          ignorarSaveLayoutRef.current = true;
          ignorarSyncMaterialLayoutRef.current = true;
          setLayoutConfig(merged);
          if (moduloFixo !== 'projeto') {
            setMaterialConfig({
              tipoMaterial: merged.tipoMaterial,
              espessuraMaterial: merged.espessuraMaterial,
            });
          }
          break;
        }
        case 'auditoria': {
          if (!moduloPrecisaDado(escopoDados, 'auditoria')) break;
          const dbItems = await lerAuditoriaDB();
          if (!Array.isArray(dbItems)) break;
          ignorarSaveAuditoriaRef.current = true;
          setAuditoriaAcoes(dbItems.slice(-800));
          break;
        }
        case 'pontuacoes-produtos': {
          if (!moduloPrecisaDado(escopoDados, 'pontuacoes')) break;
          try {
            const s = localStorage.getItem('pontuacoes-produtos-ade');
            if (!s) break;
            const parsed = JSON.parse(s);
            if (Array.isArray(parsed)) setPontuacoesProdutos(parsed);
          } catch {
            /* ignora */
          }
          break;
        }
        default:
          break;
      }
    },
    [escopoDados, moduloFixo, normalizarLayoutCarregado]
  );

  const syncCooldownRef = useRef<Partial<Record<SyncChave, number>>>({});
  useEffect(() => {
    return escutarSyncDesktop((chave) => {
      const agora = Date.now();
      const ultimo = syncCooldownRef.current[chave] ?? 0;
      if (agora - ultimo < 500) return;
      syncCooldownRef.current[chave] = agora;
      void tratarSyncDesktop(chave);
    });
  }, [tratarSyncDesktop]);


  // Tempo de Corte
  const [pontuacaoProduto, setPontuacaoProduto] = useState<number>(() => {
    const saved = localStorage.getItem('tempo-corte-pontuacao-ade');
    return saved ? Number(saved) : 0;
  });
  const [qtdProduto, setQtdProduto] = useState<number>(() => {
    const saved = localStorage.getItem('tempo-corte-qtd-ade');
    return saved ? Number(saved) : 0;
  });
  const [pontosDiaTodo, setPontosDiaTodo] = useState<number>(() => {
    const saved = localStorage.getItem('tempo-corte-pontos-ade');
    return saved ? Number(saved) : 0;
  });
  const [tempoDiaTodo, setTempoDiaTodo] = useState<number>(() => {
    const saved = localStorage.getItem('tempo-corte-tempodia-ade');
    return saved ? Number(saved) : 0;
  });
  const [porcentagem, setPorcentagem] = useState<number>(() => {
    const saved = localStorage.getItem('tempo-corte-porcentagem-ade');
    return saved ? Number(saved) : 0;
  });
  const [nomeProdutoTempo, setNomeProdutoTempo] = useState<string>(() => {
    const saved = localStorage.getItem('tempo-corte-nome-ade');
    return saved || '';
  });
  const [loteTempoCorte, setLoteTempoCorte] = useState('');
  const [dataHoraInicioExato, setDataHoraInicioExato] = useState('');
  const [dataHoraTerminoExato, setDataHoraTerminoExato] = useState('');
  const [dataHoraInicioProducao, setDataHoraInicioProducao] = useState('');
  const [dataHoraTerminoProducao, setDataHoraTerminoProducao] = useState('');
  const [horarioExtraManha, setHorarioExtraManha] = useState(false);
  const [horarioExtraAlmoco, setHorarioExtraAlmoco] = useState(false);
  const [trabalhaSabado, setTrabalhaSabado] = useState(false);
  const [trabalhaDomingo, setTrabalhaDomingo] = useState(false);
  const [tempoCorteItens, setTempoCorteItens] = useState<TempoCorteItem[]>([]);
  const carregouTempoCorteItensRef = useRef(false);
  const erroPersistenciaTempoCorteItensRef = useRef(false);

  // Cálculos derivados
  // Pontuação da Remessa = Pontos do Dia Todo ÷ Pontuação do Produto
  const pontuacaoRemessaProduzida = pontuacaoProduto > 0 ? pontosDiaTodo / pontuacaoProduto : 0;
  // Para % por peça e tempo cada peça, considerar apenas METROS² (cancelando efeito da QTD)
  const totalMetrosQuadradosAll = tempoCorteItens.reduce(
    (acc, item) => acc + (item.metrosQuadrados || 0),
    0
  );
  const totalMetrosQuadrados = tempoCorteItens
    .filter(i => i.selecionado)
    .reduce((acc, item) => acc + (item.metrosQuadrados || 0), 0);
  // Tempo Exato = (Pontuação da Remessa ÷ Tempo do Dia Todo) = X, depois Qtd de Produto ÷ X
  const x = tempoDiaTodo > 0 ? pontuacaoRemessaProduzida / tempoDiaTodo : 0;
  const tempoExato = x > 0 ? qtdProduto / x : 0; // em minutos (base: todas as peças)
  const tempoExatoSelecionadas = tempoCorteItens.filter(i => i.selecionado).reduce((acc, item) => {
    const metrosConsiderados = (item.metrosQuadrados || 0);
    const porcentagemPorPeca =
      totalMetrosQuadradosAll > 0 && porcentagem > 0
        ? (metrosConsiderados * porcentagem) / totalMetrosQuadradosAll
        : 0;
    const tempoCadaPeca = porcentagem > 0 ? (tempoExato * porcentagemPorPeca) / porcentagem : 0;
    return acc + tempoCadaPeca;
  }, 0);
  
  // Função para converter minutos em HH:MM:SS (aceita negativo: pendência / atraso na análise)
  const formatarTempo = (minutos: number) => {
    if (minutos == null || isNaN(minutos)) return '00:00:00';
    const neg = minutos < 0;
    const abs = Math.abs(minutos);
    if (abs < 1e-6) return '00:00:00';
    const totalSegundos = Math.round(abs * 60);
    const horas = Math.floor(totalSegundos / 3600);
    const mins = Math.floor((totalSegundos % 3600) / 60);
    const segs = totalSegundos % 60;
    const s = `${horas.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`;
    return neg ? `-${s}` : s;
  };
  // Converter HH:MM:SS ou HH:MM para minutos
  const parseTempoToMinutos = (s: string): number => {
    if (!s || typeof s !== 'string') return 0;
    const partes = s.trim().split(/[:h]/i).map(p => parseInt(p, 10) || 0);
    if (partes.length >= 3) return partes[0] * 60 + partes[1] + partes[2] / 60;
    if (partes.length === 2) return partes[0] * 60 + partes[1];
    if (partes.length === 1) return partes[0];
    return 0;
  };

  const registrarAuditoria = (acao: string, contexto?: string) => {
    const evento: AuditoriaAcao = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      dataHoraISO: new Date().toISOString(),
      acao,
      contexto,
    };
    setAuditoriaAcoes((prev) => [...prev, evento].slice(-800));
  };
  
  // Produtos salvos de Tempo de Corte
  const [produtosTempoCorteSalvos, setProdutosTempoCorteSalvos] = useState<any[]>([]);
  const carregouProdutosTempoCorteRef = useRef(false);
  const erroPersistenciaTempoCorteRef = useRef(false);
  const produtosTempoCorteSalvosRef = useRef<any[]>([]);
  produtosTempoCorteSalvosRef.current = produtosTempoCorteSalvos;

  /** Nunca exibe card excluído nem duplicata lote|nome. */
  const produtosTempoCorteAtivos = useMemo(
    () =>
      deduplicarProdutosTempoCortePorLoteNome(
        filtrarCardsTempoCorteNaoExcluidos(produtosTempoCorteSalvos)
      ),
    [produtosTempoCorteSalvos]
  );

  useEffect(() => {
    if (!carregouProdutosTempoCorteRef.current) return;
    if (produtosTempoCorteAtivos.length >= produtosTempoCorteSalvos.length) return;
    ignorarSaveTempoCorteProdRef.current = true;
    setProdutosTempoCorteSalvos(produtosTempoCorteAtivos);
    void persistirProdutosTempoCorteDireto(produtosTempoCorteAtivos).then(() => {
      notificarSyncDesktop('tempo-corte-produtos');
    });
  }, [produtosTempoCorteAtivos, produtosTempoCorteSalvos]);

  const [lotesFinalizadosManual, setLotesFinalizadosManual] = useState<string[]>(() => {
    try {
      const s = localStorage.getItem(STORAGE_LOTES_FINAL_MANUAL);
      if (!s) return [];
      const p = JSON.parse(s);
      return Array.isArray(p) ? p.map((x) => normalizarTexto(String(x))).filter(Boolean) : [];
    } catch {
      return [];
    }
  });
  const [loteParaFinalizarManual, setLoteParaFinalizarManual] = useState('');

  useEffect(() => {
    safeSetLocalStorage(STORAGE_LOTES_FINAL_MANUAL, JSON.stringify(lotesFinalizadosManual));
  }, [lotesFinalizadosManual]);

  const marcarLoteFinalizadoManual = () => {
    const raw = loteParaFinalizarManual.trim();
    if (!raw) return;
    const lote = normalizarTexto(raw);
    if (!lote) return;
    setLotesFinalizadosManual((prev) => {
      if (prev.includes(lote)) return prev;
      return [...prev, lote].sort((a, b) => a.localeCompare(b, 'pt-BR'));
    });
    setLoteParaFinalizarManual('');
  };

  const removerLoteFinalizadoManual = (lote: string) => {
    setLotesFinalizadosManual((prev) => prev.filter((x) => x !== lote));
  };

  const statusPorLote = useMemo(() => {
    const mapa = new Map<
      string,
      { id: 'cadastrado' | 'emCorte' | 'emEmbalagem' | 'finalizado' | 'pendenteProducao'; label: string; classe: string }
    >();
    const porLote = new Map<string, LoteProdutoConfig[]>();
    lotesProdutos.forEach((lp) => {
      const key = normalizarTexto(lp.lote);
      if (!key) return;
      if (!porLote.has(key)) porLote.set(key, []);
      porLote.get(key)!.push(lp);
    });

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const lotesComProducaoFinalizada = new Set<string>();
    produtosTempoCorteSalvos.forEach((p) => {
      if (!p?.dataHoraTerminoProducao) return;
      const ln = normalizarTexto(String(p?.lote || ''));
      if (ln) lotesComProducaoFinalizada.add(ln);
    });

    porLote.forEach((itens, lote) => {
      if (lotesFinalizadosManual.includes(lote)) {
        mapa.set(lote, { id: 'finalizado', label: 'Finalizado (manual)', classe: 'bg-emerald-100 text-emerald-700' });
        return;
      }
      const temInicio = itens.some((i) => Boolean(i.dataHoraInicioCorte));
      const impressoPalete = lotesImpressosPalete.includes(lote);
      const produzidoFinalizado = lotesComProducaoFinalizada.has(lote);

      let diaInicioCorte: Date | null = null;
      itens.forEach((i) => {
        if (!i.dataHoraInicioCorte) return;
        const d = new Date(i.dataHoraInicioCorte);
        if (isNaN(d.getTime())) return;
        const dia = new Date(d);
        dia.setHours(0, 0, 0, 0);
        if (!diaInicioCorte || dia.getTime() < diaInicioCorte.getTime()) diaInicioCorte = dia;
      });

      if (produzidoFinalizado) {
        mapa.set(lote, { id: 'finalizado', label: 'Finalizado', classe: 'bg-emerald-100 text-emerald-700' });
      } else if (impressoPalete) {
        mapa.set(lote, { id: 'emEmbalagem', label: 'Em embalagem', classe: 'bg-amber-100 text-amber-700' });
      } else if (temInicio && diaInicioCorte) {
        const diffDias = Math.floor((hoje.getTime() - diaInicioCorte.getTime()) / (24 * 60 * 60 * 1000));
        if (diffDias >= 1) {
          mapa.set(lote, {
            id: 'pendenteProducao',
            label: 'Pendente produção',
            classe: 'bg-rose-100 text-rose-800',
          });
        } else {
          mapa.set(lote, { id: 'emCorte', label: 'Em corte', classe: 'bg-[#e8f5ec] text-[#009b3a]' });
        }
      } else if (temInicio) {
        mapa.set(lote, { id: 'emCorte', label: 'Em corte', classe: 'bg-[#e8f5ec] text-[#009b3a]' });
      } else {
        mapa.set(lote, { id: 'cadastrado', label: 'Cadastrado', classe: 'bg-[#e4e6ec] text-black' });
      }
    });
    return mapa;
  }, [lotesProdutos, lotesImpressosPalete, produtosTempoCorteSalvos, lotesFinalizadosManual]);

  const [filtroProdutoSalvoNome, setFiltroProdutoSalvoNome] = useState('');
  const [filtroProdutoSalvoLote, setFiltroProdutoSalvoLote] = useState('');

  const sugestoesProdutosSalvosNome = useMemo(() => {
    const set = new Set<string>();
    produtosTempoCorteSalvos.forEach((p) => {
      const nome = String(p?.nome ?? '').trim();
      if (nome) set.add(nome.toUpperCase());
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [produtosTempoCorteSalvos]);

  const sugestoesProdutosSalvosLote = useMemo(() => {
    const set = new Set<string>();
    produtosTempoCorteSalvos.forEach((p) => {
      const lote = String(p?.lote ?? '').trim();
      if (lote) set.add(lote.toUpperCase());
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [produtosTempoCorteSalvos]);

  const produtosTempoCorteSalvosFiltrados = useMemo(() => {
    const nome = filtroProdutoSalvoNome.trim().toUpperCase();
    const loteFiltroBruto = filtroProdutoSalvoLote.trim();
    return produtosTempoCorteAtivos.filter((p) => {
      const pn = String(p?.nome ?? '').toUpperCase();
      const okNome = !nome || pn.includes(nome);
      if (!okNome) return false;
      if (!loteFiltroBruto) return true;
      return cardTempoCortePertenceAoLote(p, loteFiltroBruto);
    });
  }, [filtroProdutoSalvoLote, filtroProdutoSalvoNome, produtosTempoCorteAtivos]);
  
  /** Migração de cards unificados criados com a fórmula antiga (versões < 0.0.293)
   *  que somava pontuacaoProduto e qtdProduto separadamente, inflando o TEMPO EXATO.
   *  Roda 1× por card, marca como `unificacaoMigradaV293=true` para não repetir. */
  const migrarUnificadosAntigos = (lista: any[]): any[] => {
    if (!Array.isArray(lista) || lista.length === 0) return lista;
    let alguemMigrou = false;
    const migrada = lista.map((p) => {
      if (!p?.eUnificado) return p;
      if (p?.unificacaoMigradaV293) return p;
      const originais: any[] = Array.isArray(p.produtosOrigemCompleto) ? p.produtosOrigemCompleto : [];
      if (originais.length === 0) return p;
      const qtdTotal = originais.reduce(
        (s, o) => s + (Number(o?.qtdProduto) || 0),
        0
      );
      const pontuacaoTotalRemessa = originais.reduce(
        (s, o) => s + (Number(o?.pontuacaoProduto) || 0) * (Number(o?.qtdProduto) || 0),
        0
      );
      const pontuacaoMedia =
        qtdTotal > 0 ? pontuacaoTotalRemessa / qtdTotal : pontuacaoTotalRemessa;
      const temposProducaoUnicos = new Set<number>();
      originais.forEach((o) => {
        const t = Number(o?.tempoProducaoMinutos) || 0;
        if (t > 0) temposProducaoUnicos.add(t);
      });
      const tempoProducaoCorrigido = Array.from(temposProducaoUnicos).reduce(
        (s, t) => s + t,
        0
      );
      const tempoExatoSoma = originais.reduce(
        (s, o) => s + (Number(o?.tempoExato) || 0),
        0
      );
      const tempoExatoPlanoSoma = originais.reduce(
        (s, o) => s + (Number(o?.tempoExatoPlano) || 0),
        0
      );
      alguemMigrou = true;
      return {
        ...p,
        pontuacaoProduto: pontuacaoMedia,
        qtdProduto: qtdTotal,
        tempoExato: tempoExatoSoma,
        tempoExatoPlano: tempoExatoPlanoSoma,
        tempoProducaoMinutos: tempoProducaoCorrigido,
        unificacaoMigradaV293: true,
      };
    });
    if (alguemMigrou) {
      const total = migrada.filter((x: any) => x.unificacaoMigradaV293 && x.eUnificado).length;
      // Notificação não-bloqueante via console; o usuário já é avisado por toast/alert ao abrir.
      console.info(`[Sistema Ade] ${total} card(s) unificado(s) recalculado(s) (v0.0.293).`);
    }
    return migrada;
  };

  /** Migração v0.0.302: renomeia cards unificados antigos usando as famílias
   *  de produtos (ASTURIAS, BERLIN, RACK LEGACY 1.6+2.0, etc.) em vez de
   *  "UNIFICADO LOTE X (N produtos)" ou nomes muito longos. */
  /** Migração v0.0.316: corrige o campo `lote` de cards unificados antigos para
   *  conter TODOS os lotes internos juntos (ex.: "8762" → "8762/8763"). Antes,
   *  a unificação salvava apenas o primeiro lote, e o Painel Principal montava
   *  o display via produtosOrigemCompleto — o que misturava lotes não-sequenciais
   *  e gerava previsões erradas. Agora o card unificado guarda explicitamente
   *  o lote composto, e o painel respeita esse valor. */
  const migrarLotesUnificadosV315 = (lista: any[]): any[] => {
    if (!Array.isArray(lista) || lista.length === 0) return lista;
    let corrigidos = 0;
    const migrada = lista.map((p) => {
      if (!p?.eUnificado) return p;
      if (p?.loteCompostoMigradoV315) return p;
      const originais: any[] = Array.isArray(p.produtosOrigemCompleto)
        ? p.produtosOrigemCompleto
        : Array.isArray(p.produtosOrigem)
        ? p.produtosOrigem
        : [];
      if (originais.length === 0) return { ...p, loteCompostoMigradoV315: true };
      const numSet = new Set<number>();
      numerosLoteDeTexto(String(p.lote || '')).forEach((n) => numSet.add(n));
      originais.forEach((o) => {
        numerosLoteDeTexto(String(o?.lote || '')).forEach((n) => numSet.add(n));
      });
      const nums = Array.from(numSet).sort((a, b) => a - b);
      if (nums.length === 0) return { ...p, loteCompostoMigradoV315: true };
      const loteCorrigido = nums.join('/');
      const loteAtual = String(p.lote || '').trim();
      if (loteAtual === loteCorrigido) {
        return { ...p, loteCompostoMigradoV315: true };
      }
      corrigidos++;
      return {
        ...p,
        lote: loteCorrigido,
        loteOriginalAntesV315: loteAtual,
        loteCompostoMigradoV315: true,
      };
    });
    if (corrigidos > 0) {
      console.info(`[Sistema Ade] ${corrigidos} card(s) unificado(s) com lote corrigido (v0.0.316).`);
    }
    return migrada;
  };

  const migrarNomesUnificados = (lista: any[]): any[] => {
    if (!Array.isArray(lista) || lista.length === 0) return lista;
    let renomeou = 0;
    const migrada = lista.map((p) => {
      if (!p?.eUnificado) return p;
      if (p?.nomeMigradoV302) return p;
      const originais: any[] = Array.isArray(p.produtosOrigemCompleto)
        ? p.produtosOrigemCompleto
        : Array.isArray(p.produtosOrigem)
        ? p.produtosOrigem
        : [];
      if (originais.length === 0) return p;
      const nomes = originais
        .map((o) => String(o?.nome || ''))
        .filter(Boolean);
      if (nomes.length === 0) return p;
      const sugerido = gerarNomeUnificadoInteligente(nomes);
      if (!sugerido) return { ...p, nomeMigradoV302: true };
      const nomeAtualNorm = String(p?.nome || '').trim().toUpperCase();
      const sugeridoNorm = sugerido.trim().toUpperCase();
      if (nomeAtualNorm === sugeridoNorm) {
        return { ...p, nomeMigradoV302: true };
      }
      renomeou++;
      return {
        ...p,
        nome: sugeridoNorm,
        nomeOriginalAntesV302: nomeAtualNorm,
        nomeMigradoV302: true,
      };
    });
    if (renomeou > 0) {
      console.info(`[Sistema Ade] ${renomeou} card(s) unificado(s) renomeado(s) (v0.0.302).`);
    }
    return migrada;
  };

  // Carrega produtos do Tempo de Corte (IndexedDB + backup em disco se vazio).
  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) return;
    let cancelado = false;
    (async () => {
      await hidratarExclusoesCardsTempoCorte();
      if (cancelado) return;
      let bruto = await coletarProdutosTempoCorteBruto();
      if (cancelado) return;

      if (bruto.length === 0) {
        const disco = tentarLerCardsTempoCorteDeBackupDisco();
        if (disco.cards.length > 0) {
          console.info(
            `[Sistema Ade] Tempo de Corte: restaurando ${disco.cards.length} card(s) do backup em disco.`,
            disco.origem
          );
          bruto = disco.cards as Record<string, unknown>[];
        }
      }

      if (bruto.length > 0) {
        const migrados = migrarLotesUnificadosV315(
          migrarNomesUnificados(migrarUnificadosAntigos(bruto))
        );
        const limpos = deduplicarProdutosTempoCortePorLoteNome(
          filtrarCardsTempoCorteNaoExcluidos(
            corrigirListaNomesBuffetAron4Portas(
              corrigirListaNomesBerlimBerlin(migrados as { nome?: string }[], 'nome'),
              'nome'
            ) as typeof migrados
          )
        );
        setProdutosTempoCorteSalvos(limpos);
        const resumo = resumoRegistrosComLote(limpos);
        console.info(
          `[Sistema Ade] Tempo de Corte: ${resumo.total} produto(s) salvo(s), maior lote nº ${resumo.maiorNumeroLote || '—'}.`
        );
        await persistirProdutosTempoCorteDireto(limpos);
      }
      carregouProdutosTempoCorteRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) return;
    if (!carregouProdutosTempoCorteRef.current) return;
    if (ignorarSaveTempoCorteProdRef.current) {
      ignorarSaveTempoCorteProdRef.current = false;
      return;
    }
    void (async () => {
      try {
        const epochInicio = lerEpochExclusoesCardsTempoCorte();
        await hidratarExclusoesCardsTempoCorte();
        const limpos = filtrarCardsTempoCorteNaoExcluidos(produtosTempoCorteSalvos);
        if (limpos.length < produtosTempoCorteSalvos.length) {
          ignorarSaveTempoCorteProdRef.current = true;
          setProdutosTempoCorteSalvos(limpos);
        }
        const { gravou, final } = await salvarProdutosTempoCorteDBSeguro(limpos);
        if (lerEpochExclusoesCardsTempoCorte() !== epochInicio) {
          await hidratarExclusoesCardsTempoCorte();
          const disco =
            ((await lerProdutosTempoCorteDB()) as { id?: string; nome?: string; lote?: string }[] | null) ??
            [];
          const re = filtrarCardsTempoCorteNaoExcluidos(disco);
          ignorarSaveTempoCorteProdRef.current = true;
          setProdutosTempoCorteSalvos(re);
          await persistirProdutosTempoCorteDireto(re);
          notificarSyncDesktop('tempo-corte-produtos');
          return;
        }
        if (gravou) {
          if (Array.isArray(final) && final.length < limpos.length) {
            ignorarSaveTempoCorteProdRef.current = true;
            setProdutosTempoCorteSalvos(final);
          }
          notificarSyncDesktop('tempo-corte-produtos');
        }
      } catch {
        if (!erroPersistenciaTempoCorteRef.current) {
          alert(
            'Não foi possível salvar os produtos do Tempo de Corte no armazenamento local ampliado (IndexedDB).'
          );
          erroPersistenciaTempoCorteRef.current = true;
        }
      }
    })();
  }, [produtosTempoCorteSalvos], 400);

  const resumoProdutosTempoCorte = useMemo(
    () => resumoRegistrosComLote(produtosTempoCorteAtivos),
    [produtosTempoCorteAtivos]
  );

  const cardTempoCorteCorrespondeLoteProduto = useCallback(
    (card: { nome?: string; lote?: string }, lote: string, produtoNome: string): boolean => {
      if (!loteCadastroCoincide(String(card.lote || ''), lote)) return false;
      return nomesProdutoIguais(String(card.nome || ''), produtoNome);
    },
    []
  );

  const removerLoteProduto = useCallback(
    (id: string) => {
      const idLimpo = String(id || '').trim();
      if (!idLimpo) return;

      const prevLotes = lotesProdutosRef.current;
      const alvo = prevLotes.find((item) => String(item.id || '').trim() === idLimpo);
      if (!alvo) return;

      const chavePar = chaveParLoteProduto(alvo);
      const chaveNome = chaveParLoteProdutoNome(alvo);
      const idsRemover = prevLotes
        .filter(
          (lp) =>
            chaveParLoteProduto(lp) === chavePar || chaveParLoteProdutoNome(lp) === chaveNome
        )
        .map((lp) => String(lp.id || '').trim())
        .filter(Boolean);
      registrarIdsLotesExcluidos(idsRemover);
      registrarParesLotesExcluidos(paresExclusaoDeLoteProduto(alvo));

      const nextLotes = prevLotes.filter(
        (lp) =>
          chaveParLoteProduto(lp) !== chavePar && chaveParLoteProdutoNome(lp) !== chaveNome
      );
      const cardsRemovidos = produtosTempoCorteSalvosRef.current.filter((c) =>
        cardTempoCorteCorrespondeLoteProduto(c, alvo.lote, alvo.produtoNome)
      );
      const nextCards =
        cardsRemovidos.length > 0
          ? produtosTempoCorteSalvosRef.current.filter(
              (c) => !cardTempoCorteCorrespondeLoteProduto(c, alvo.lote, alvo.produtoNome)
            )
          : produtosTempoCorteSalvosRef.current;

      ignorarSaveLotesRef.current = true;
      lotesProdutosRef.current = nextLotes;
      setLotesProdutos(nextLotes);

      if (cardsRemovidos.length > 0) {
        registrarExclusoesCardsTempoCorte(cardsRemovidos);
        ignorarSaveTempoCorteProdRef.current = true;
        setProdutosTempoCorteSalvos(nextCards);
      }

      void (async () => {
        await persistirLotesProdutosDireto(nextLotes);
        notificarSyncDesktop('lotes-produtos');
        if (cardsRemovidos.length > 0) {
          await flushExclusoesCardsTempoCorte();
          await persistirProdutosTempoCorteDireto(nextCards);
          notificarSyncDesktop('tempo-corte-produtos');
        }
      })();
    },
    [cardTempoCorteCorrespondeLoteProduto]
  );

  const pendenciasCardsTempoCorte = useMemo(
    () => listarPendenciasCardsTempoCorte(lotesProdutos, produtosTempoCorteSalvos),
    [lotesProdutos, produtosTempoCorteSalvos]
  );

  const lotesComPendenciasCards = useMemo(
    () => resumirPendenciasPorLote(lotesProdutos, produtosTempoCorteSalvos),
    [lotesProdutos, produtosTempoCorteSalvos]
  );

  const criandoCardsTempoCorteRef = useRef(false);
  const tentarCriarCardsTempoCorteAutomaticos = useCallback(
    (silencioso = true): number => {
      if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) return 0;
      if (!carregouProdutosTempoCorteRef.current || !carregouLotesProdutosRef.current) return 0;
      // Evita clique/sync em dobro: duas chamadas com o mesmo `prev` geravam pares lote|nome.
      if (criandoCardsTempoCorteRef.current) return 0;
      criandoCardsTempoCorteRef.current = true;
      let criados = 0;
      try {
        setProdutosTempoCorteSalvos((prev) => {
          const resultado = gerarCardsTempoCorteFaltantes(lotesProdutos, prev, pontuacoesProdutos);
          if (resultado.novos.length === 0) return prev;
          const cardsLimpos = deduplicarProdutosTempoCortePorLoteNome(
            filtrarCardsTempoCorteNaoExcluidos(resultado.cards)
          );
          const novosLimpos = resultado.novos.filter((n) =>
            cardsLimpos.some((c) => String(c.id) === String(n.id))
          );
          if (novosLimpos.length === 0) return prev;
          criados = novosLimpos.length;
          // Persiste na hora (com pontuação do Boletim já aplicada no clone).
          void persistirProdutosTempoCorteDireto(cardsLimpos).then(() => {
            notificarSyncDesktop('tempo-corte-produtos');
          });
          registrarAuditoria(
            'auto_cards_tempo_corte',
            `${criados} card(s): ${novosLimpos
              .map((c) => `${c.nome}|${c.lote}|pts ${c.pontuacaoProduto ?? 0}`)
              .join('; ')}`
          );
          if (!silencioso) {
            const nomes = novosLimpos
              .map((c) => `${c.nome} (lote ${c.lote})`)
              .slice(0, 10)
              .join('\n• ');
            const semModelo = listarPendenciasCardsTempoCorte(lotesProdutos, cardsLimpos).filter(
              (p) => p.motivo === 'sem_template'
            );
            const extraSemModelo =
              semModelo.length > 0
                ? `\n\nAinda sem modelo (crie 1 card manual desse produto em qualquer lote):\n• ${semModelo
                    .slice(0, 12)
                    .map((x) => `${x.produtoNome} — lote ${x.lote}`)
                    .join('\n• ')}${semModelo.length > 12 ? '\n• …' : ''}`
                : '';
            alert(
              `${criados} card(s) criado(s).\n\n• ${nomes}${criados > 10 ? '\n• …' : ''}${extraSemModelo}`
            );
          } else {
            console.info(
              `[Sistema Ade] Tempo de Corte: ${criados} card(s) criado(s) via botão (cadastro de Lotes).`
            );
          }
          return cardsLimpos;
        });
      } finally {
        // Libera após o commit do setState (próximo tick).
        queueMicrotask(() => {
          criandoCardsTempoCorteRef.current = false;
        });
      }
      return criados;
    },
    [escopoDados, lotesProdutos, pontuacoesProdutos]
  );

  const criarTodosCardsTempoCorteFaltantes = useCallback(() => {
    const antes = resumirPendentesAutoCards(lotesProdutos, produtosTempoCorteSalvos);
    if (antes.faltam === 0) {
      alert('Todos os produtos do cadastro de Lotes já têm card no Tempo de Corte.');
      return;
    }
    if (antes.comTemplate === 0) {
      alert(
        `Há ${antes.semTemplate} produto(s) de lote(s) sem card, mas nenhum tem um modelo (outro lote com o mesmo produto e peças cadastradas).\n\nCrie manualmente o primeiro card de cada produto; depois use este botão para os próximos lotes.`
      );
      return;
    }
    if (
      !confirm(
        `Criar ${antes.comTemplate} card(s) automaticamente a partir do cadastro de Lotes?\n\n` +
          `Cards que você apagou manualmente NÃO serão recriados.\n` +
          `Só use este botão quando quiser gerar cards novos.`
      )
    ) {
      return;
    }
    tentarCriarCardsTempoCorteAutomaticos(false);
  }, [lotesProdutos, produtosTempoCorteSalvos, tentarCriarCardsTempoCorteAutomaticos]);

  // NÃO recriar cards sozinho ao apagar / ao mudar Lotes.
  // Motivo: o cadastro de Lotes disparava gerarCardsFaltantes toda vez que
  // produtosTempoCorteSalvos.length mudava — e devolveva os cards apagados.
  // Criação automática só pelo botão "Criar cards faltantes".

  const recuperarSobraDoBackup = useCallback(async () => {
    const mesclados = await coletarSobraBruto();
    const reunidos = filtrarSobraNaoExcluidas(
      mesclarEntradasSobraPorId(sobraItens, mesclados)
    );
    const antes = resumoSobraEntradas(sobraItens);
    const depois = resumoSobraEntradas(reunidos);
    if (
      reunidos.length <= sobraItens.length &&
      depois.linhas <= antes.linhas
    ) {
      alert(
        `Nenhuma sobra adicional no backup.\nAtual: ${antes.cards} card(s), ${antes.linhas} linha(s).`
      );
      return;
    }
    ignorarSaveSobraRef.current = true;
    setSobraItens(reunidos);
    await persistirSobraDireto(reunidos);
    notificarSyncDesktop('sobra');
    alert(
      `Sobras recuperadas do backup.\nAntes: ${antes.cards} card(s), ${antes.linhas} linha(s)\nAgora: ${depois.cards} card(s), ${depois.linhas} linha(s)`
    );
  }, [sobraItens]);

  const recuperarProdutosTempoCorteDoBackup = useCallback(async () => {
    const brutoLocal = await coletarProdutosTempoCorteBruto();
    const disco = tentarLerCardsTempoCorteDeBackupDisco();
    const listas: Record<string, unknown>[][] = [
      produtosTempoCorteSalvos as Record<string, unknown>[],
      brutoLocal as Record<string, unknown>[],
    ];
    if (disco.cards.length > 0) {
      listas.push(disco.cards as Record<string, unknown>[]);
    }
    const reunidos = filtrarCardsTempoCorteNaoExcluidos(
      migrarLotesUnificadosV315(
        migrarNomesUnificados(
          migrarUnificadosAntigos(mesclarProdutosTempoCorte(listas))
        )
      )
    );
    const antes = resumoRegistrosComLote(produtosTempoCorteSalvos);
    const depois = resumoRegistrosComLote(reunidos);
    if (reunidos.length <= produtosTempoCorteSalvos.length && depois.maiorNumeroLote <= antes.maiorNumeroLote) {
      alert(
        `Nenhum produto adicional no backup.\nAtual: ${antes.total} produto(s), maior lote nº ${antes.maiorNumeroLote || '—'}.` +
          (disco.origem ? `\n(Arquivo em disco também sem cards extras.)` : '')
      );
      return;
    }
    ignorarSaveTempoCorteProdRef.current = true;
    setProdutosTempoCorteSalvos(reunidos);
    await persistirProdutosTempoCorteDireto(reunidos);
    try {
      localStorage.setItem('produtos-tempo-corte-ade', JSON.stringify(reunidos));
    } catch {
      /* ignora */
    }
    notificarSyncDesktop('tempo-corte-produtos');
    alert(
      `Produtos recuperados do backup.\nAntes: ${antes.total} (maior lote nº ${antes.maiorNumeroLote || '—'})\nAgora: ${depois.total} (maior lote nº ${depois.maiorNumeroLote || '—'})` +
        (disco.origem ? `\nFonte: ${disco.origem}` : '')
    );
  }, [produtosTempoCorteSalvos]);

  const aplicarRenumerarLoteCompleto = useCallback(async () => {
    const antigo = renumerarLoteAntigo.trim().toUpperCase();
    const novo = renumerarLoteNovo.trim().toUpperCase();
    if (!antigo || !novo) {
      alert('Informe o lote atual e o novo número.');
      return;
    }
    if (antigo === novo) {
      alert('O novo número deve ser diferente do atual.');
      return;
    }
    const qtdCadastro = lotesProdutos.filter((lp) => loteCadastroCoincide(lp.lote, antigo)).length;
    if (qtdCadastro === 0) {
      alert(`Nenhum produto cadastrado no lote ${antigo}.`);
      return;
    }
    const opts = {
      loteAntigo: antigo,
      loteNovo: novo,
      atualizarDatas: renumerarAtualizarDatas,
      dataHoraInicioCorte: renumerarInicioCorte || undefined,
      dataHoraFimEmbalagem: renumerarFimEmbalagem || undefined,
    };
    const msg =
      `Renumerar lote ${antigo} → ${novo}?\n\n` +
      `• ${qtdCadastro} produto(s) na aba Lotes` +
      (renumerarAtualizarDatas
        ? '\n• Datas de início/fim serão atualizadas em todos esses produtos'
        : '') +
      '\n\nTambém atualiza cards do Tempo de Corte, relatório, histórico e tempo por peça vinculados.';
    if (!confirm(msg)) return;

    const { lista: lpNext, alterados: lpAlt } = renumerarLotesProdutos(lotesProdutos, opts);
    const { lista: tcNext, alterados: tcAlt } = renumerarCardsTempoCorte(
      produtosTempoCorteSalvos,
      antigo,
      novo
    );
    const { lista: finNext } = renumerarListaTextoLote(lotesFinalizadosManual, antigo, novo);
    const { lista: palNext } = renumerarListaTextoLote(lotesImpressosPalete, antigo, novo);

    let relItensAlt = 0;
    const relNext = relatorioItens.map((item) => {
      const nl = substituirNumeroLoteEmTexto(item.lote, antigo, novo);
      if (nl === item.lote) return item;
      relItensAlt += 1;
      return { ...item, lote: nl };
    });

    const cabLote = substituirNumeroLoteEmTexto(relatorioCabecalho.lote, antigo, novo);
    const cabNext =
      cabLote !== relatorioCabecalho.lote ? { ...relatorioCabecalho, lote: cabLote } : relatorioCabecalho;

    const nextLotes = deduplicarLotesPorLoteProduto(lpNext, {
      registrarExcluidos: true,
      preservarOrdem: true,
    });

    ignorarSaveLotesRef.current = true;
    ignorarSaveTempoCorteProdRef.current = true;
    setLotesProdutos(nextLotes);
    setProdutosTempoCorteSalvos(tcNext);
    setLotesFinalizadosManual(finNext);
    setLotesImpressosPalete(palNext);
    setRelatorioItens(relNext);
    setRelatorioCabecalho(cabNext);

    if (editandoLoteItem && loteCadastroCoincide(editandoLoteItem.lote, antigo)) {
      setEditandoLoteItem({
        ...editandoLoteItem,
        lote: novo,
        ...(renumerarAtualizarDatas
          ? {
              dataHoraInicioCorte: renumerarInicioCorte || editandoLoteItem.dataHoraInicioCorte,
              dataHoraFimEmbalagem: renumerarFimEmbalagem || editandoLoteItem.dataHoraFimEmbalagem,
            }
          : {}),
      });
    }

    await persistirLotesProdutosDireto(nextLotes);
    await salvarProdutosTempoCorteDBSeguro(tcNext);
    await renumerarPersistenciaTempoProducaoPeca(antigo, novo);

    notificarSyncDesktop('lotes-produtos');
    notificarSyncDesktop('tempo-corte-produtos');

    registrarAuditoria(
      'renumerar_lote',
      `${antigo} → ${novo} | cadastro:${lpAlt} | tc:${tcAlt}`
    );

    alert(
      `Lote renumerado: ${antigo} → ${novo}\n\n` +
        `${lpAlt} produto(s) no cadastro\n` +
        `${tcAlt} card(s) Tempo de Corte\n` +
        `${relItensAlt} linha(s) no relatório`
    );

    setRenumerarLoteAntigo('');
    setRenumerarLoteNovo('');
    setRenumerarInicioCorte('');
    setRenumerarFimEmbalagem('');
    setRenumerarAtualizarDatas(false);
  }, [
    renumerarLoteAntigo,
    renumerarLoteNovo,
    renumerarAtualizarDatas,
    renumerarInicioCorte,
    renumerarFimEmbalagem,
    lotesProdutos,
    produtosTempoCorteSalvos,
    lotesFinalizadosManual,
    lotesImpressosPalete,
    relatorioItens,
    relatorioCabecalho,
    editandoLoteItem,
  ]);

  const preencherDatasDoLoteSelecionado = useCallback(
    (loteRaw: string) => {
      const lote = loteRaw.trim().toUpperCase();
      setDatasLoteAlvo(lote);
      if (!lote) {
        setDatasLoteInicio('');
        setDatasLoteFim('');
        return;
      }
      const itens = lotesProdutos.filter((lp) => loteCadastroCoincide(lp.lote, lote));
      if (itens.length === 0) {
        setDatasLoteInicio('');
        setDatasLoteFim('');
        return;
      }
      const inicio =
        itens.find((lp) => lp.dataHoraInicioCorte)?.dataHoraInicioCorte ||
        itens[0].dataHoraInicioCorte ||
        '';
      const fim =
        itens.find((lp) => lp.dataHoraFimEmbalagem)?.dataHoraFimEmbalagem ||
        itens[0].dataHoraFimEmbalagem ||
        '';
      setDatasLoteInicio(inicio || '');
      setDatasLoteFim(fim || '');
    },
    [lotesProdutos]
  );

  const aplicarDatasLoteCompleto = useCallback(async () => {
    const lote = datasLoteAlvo.trim().toUpperCase();
    if (!lote) {
      alert('Informe o número do lote.');
      return;
    }
    if (!datasLoteInicio.trim() && !datasLoteFim.trim()) {
      alert('Informe ao menos o início do corte ou o fim da embalagem.');
      return;
    }
    const qtd = lotesProdutos.filter((lp) => loteCadastroCoincide(lp.lote, lote)).length;
    if (qtd === 0) {
      alert(`Nenhum produto cadastrado no lote ${lote}.`);
      return;
    }
    const partes: string[] = [];
    if (datasLoteInicio.trim()) partes.push(`início: ${datasLoteInicio}`);
    if (datasLoteFim.trim()) partes.push(`fim: ${datasLoteFim}`);
    if (
      !confirm(
        `Atualizar data/hora de TODOS os ${qtd} produto(s) do lote ${lote}?\n\n${partes.join('\n')}`
      )
    ) {
      return;
    }

    const next = lotesProdutos.map((lp) => {
      if (!loteCadastroCoincide(lp.lote, lote)) return lp;
      return {
        ...lp,
        ...(datasLoteInicio.trim()
          ? { dataHoraInicioCorte: datasLoteInicio.trim() }
          : {}),
        ...(datasLoteFim.trim()
          ? { dataHoraFimEmbalagem: datasLoteFim.trim() }
          : {}),
      };
    });

    ignorarSaveLotesRef.current = true;
    setLotesProdutos(next);
    if (editandoLoteItem && loteCadastroCoincide(editandoLoteItem.lote, lote)) {
      setEditandoLoteItem({
        ...editandoLoteItem,
        ...(datasLoteInicio.trim()
          ? { dataHoraInicioCorte: datasLoteInicio.trim() }
          : {}),
        ...(datasLoteFim.trim()
          ? { dataHoraFimEmbalagem: datasLoteFim.trim() }
          : {}),
      });
    }
    await persistirLotesProdutosDireto(next);
    atualizarTabelaDiasComLotes(next);
    notificarSyncDesktop('lotes-produtos');
    registrarAuditoria(
      'alterar_datas_lote',
      `lote ${lote} | ${qtd} produto(s) | ${partes.join(' | ')}`
    );
    alert(`Datas atualizadas em ${qtd} produto(s) do lote ${lote}.`);
  }, [
    datasLoteAlvo,
    datasLoteInicio,
    datasLoteFim,
    lotesProdutos,
    editandoLoteItem,
    atualizarTabelaDiasComLotes,
  ]);

  const produtosTempoCorteParaAnalise = useMemo(
    () => produtosTempoCorteSalvos.filter((produto) => produto.enviarParaAnalise),
    [produtosTempoCorteSalvos]
  );

  const aplicarProducaoLoteTempoCorte = useCallback(
    (loteDigitado: string, inicio: string, termino: string) => {
      if (!inicio || !termino) return;
      setProdutosTempoCorteSalvos((prev) => {
        let alterou = false;
        const next = prev.map((p) => {
          if (!cardTempoCortePertenceAoLote(p, loteDigitado)) return p;
          if (
            p.dataHoraInicioProducao === inicio &&
            p.dataHoraTerminoProducao === termino
          ) {
            return p;
          }
          alterou = true;
          return {
            ...p,
            dataHoraInicioProducao: inicio,
            dataHoraTerminoProducao: termino,
          };
        });
        return alterou ? next : prev;
      });
    },
    []
  );

  const loteDataPlanejada = useMemo(() => {
    const mapa = new Map<string, Date>();
    lotesProdutos.forEach((lp) => {
      const lote = normalizarTexto(lp.lote);
      const base = lp.dataHoraInicioCorte;
      if (!lote || !base) return;
      const d = new Date(base);
      if (isNaN(d.getTime())) return;
      const atual = mapa.get(lote);
      if (!atual || d.getTime() < atual.getTime()) mapa.set(lote, d);
    });
    return mapa;
  }, [lotesProdutos]);

  const mediaHistoricaPorProduto = useMemo(() => {
    const acc = new Map<string, { total: number; qtd: number }>();
    produtosTempoCorteSalvos.forEach((p) => {
      const nome = normalizarTexto(String(p?.nome || ''));
      const min = Number(p?.tempoProducaoMinutos) || 0;
      if (!nome || min <= 0) return;
      const atual = acc.get(nome) || { total: 0, qtd: 0 };
      atual.total += min;
      atual.qtd += 1;
      acc.set(nome, atual);
    });
    const medias = new Map<string, number>();
    acc.forEach((v, k) => medias.set(k, v.qtd > 0 ? v.total / v.qtd : 0));
    return medias;
  }, [produtosTempoCorteSalvos]);

  const resumoOperacaoTempo = useMemo(() => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const amanha = new Date(hoje);
    amanha.setDate(amanha.getDate() + 1);

    const manualSet = new Set(lotesFinalizadosManual);

    let atrasoBaseMin = 0;
    let creditoAdiantadoMin = 0;
    let concluidosHoje = 0;
    let fatorRitmoSomado = 0;
    let fatorRitmoQtd = 0;

    produtosTempoCorteSalvos.forEach((p) => {
      const loteNorm = normalizarTexto(String(p?.lote || ''));
      if (loteNorm && manualSet.has(loteNorm)) return;

      const dataLote = loteDataPlanejada.get(loteNorm);
      const baseMin = Number(p?.tempoExato) > 0 ? Number(p.tempoExato) : Number(p?.tempoExatoPlano) || 0;
      const prodMin = Number(p?.tempoProducaoMinutos) || 0;
      const terminou = Boolean(p?.dataHoraTerminoProducao);
      const dataTermino = p?.dataHoraTerminoProducao ? new Date(p.dataHoraTerminoProducao) : null;

      // Débito: data planejada (início) até hoje, sem produção terminada — tempo exato
      if (dataLote && dataLote < amanha && !terminou) atrasoBaseMin += Math.max(0, baseMin);
      // Crédito: data futura e já existe tempo de produção registrado (adiantamento real)
      if (dataLote && dataLote >= amanha && prodMin > 0) creditoAdiantadoMin += prodMin;

      if (dataTermino && !isNaN(dataTermino.getTime()) && dataTermino >= hoje && dataTermino < amanha && prodMin > 0 && baseMin > 0) {
        concluidosHoje += 1;
        fatorRitmoSomado += prodMin / baseMin;
        fatorRitmoQtd += 1;
      }
    });

    const lotesComProdutoSalvo = new Set(
      produtosTempoCorteSalvos.map((p) => normalizarTexto(String(p?.lote || ''))).filter(Boolean)
    );
    const minPorUnidadePorProduto = new Map<string, number>();
    produtosTempoCorteSalvos.forEach((p) => {
      const nome = normalizarTexto(String(p?.nome || ''));
      const qtd = Number(p?.qtdProduto) || 0;
      const baseMin = Number(p?.tempoExato) > 0 ? Number(p.tempoExato) : Number(p?.tempoExatoPlano) || 0;
      if (!nome || qtd <= 0 || baseMin <= 0) return;
      const atual = minPorUnidadePorProduto.get(nome);
      const valor = baseMin / qtd;
      minPorUnidadePorProduto.set(nome, atual ? (atual + valor) / 2 : valor);
    });
    const mediaGlobalMinPorUnidade = minPorUnidadePorProduto.size > 0
      ? Array.from(minPorUnidadePorProduto.values()).reduce((s, n) => s + n, 0) / minPorUnidadePorProduto.size
      : 1;

    const itensPorLote = new Map<string, LoteProdutoConfig[]>();
    lotesProdutos.forEach((lp) => {
      const lote = normalizarTexto(lp.lote);
      if (!lote) return;
      if (!itensPorLote.has(lote)) itensPorLote.set(lote, []);
      itensPorLote.get(lote)!.push(lp);
    });
    itensPorLote.forEach((itens, lote) => {
      if (manualSet.has(lote)) return;
      if (lotesComProdutoSalvo.has(lote)) return;
      const dataLote = loteDataPlanejada.get(lote);
      if (!dataLote) return;
      const status = statusPorLote.get(lote)?.id || 'cadastrado';
      const estimadoMin = itens.reduce((acc, item) => {
        const nome = normalizarTexto(item.produtoNome);
        const minPorUn = minPorUnidadePorProduto.get(nome) || mediaGlobalMinPorUnidade;
        return acc + ((Number(item.qtd) || 0) * minPorUn);
      }, 0);
      if (estimadoMin <= 0) return;
      // Só entra débito (estimado) para atraso; crédito futuro exige tempo de produção salvo (loop acima)
      if (dataLote < amanha && status !== 'finalizado') atrasoBaseMin += estimadoMin;
    });

    const saldoAtrasoPosCreditoMin = Math.max(0, atrasoBaseMin - creditoAdiantadoMin);
    const necessarioParaMetaMin = Math.max(0, atrasoBaseMin + metaAdiantoMinutos);
    const compensadoMin = Math.min(necessarioParaMetaMin, creditoAdiantadoMin);
    const progressoMeta = necessarioParaMetaMin > 0 ? (compensadoMin / necessarioParaMetaMin) * 100 : 100;
    const faltaParaMetaMin = Math.max(0, necessarioParaMetaMin - compensadoMin);

    const fatorRitmoHoje = fatorRitmoQtd > 0 ? fatorRitmoSomado / fatorRitmoQtd : 1;
    // Previsão = saldo líquido (débito − crédito), sem somar de novo todos os tempos pendentes
    const previsaoRestanteMin = saldoAtrasoPosCreditoMin;

    return {
      atrasoBaseMin,
      creditoAdiantadoMin,
      saldoAtrasoPosCreditoMin,
      progressoMeta: Math.min(100, Math.max(0, progressoMeta)),
      faltaParaMetaMin,
      fatorRitmoHoje,
      pendenteTotalMin: atrasoBaseMin,
      previsaoRestanteMin,
      concluidosHoje,
    };
  }, [produtosTempoCorteSalvos, lotesProdutos, loteDataPlanejada, statusPorLote, metaAdiantoMinutos, lotesFinalizadosManual]);

  const gargaloAtual = useMemo(() => {
    const mapa = new Map<string, { total: number; qtd: number; lotes: Set<string> }>();
    produtosTempoCorteSalvos.forEach((p) => {
      const nome = normalizarTexto(String(p?.nome || ''));
      if (!nome) return;
      const minBase = Number(p?.tempoProducaoMinutos) > 0
        ? Number(p.tempoProducaoMinutos)
        : (Number(p?.tempoExato) > 0 ? Number(p.tempoExato) : Number(p?.tempoExatoPlano) || 0);
      if (minBase <= 0) return;
      const atual = mapa.get(nome) || { total: 0, qtd: 0, lotes: new Set<string>() };
      atual.total += minBase;
      atual.qtd += 1;
      if (p?.lote) atual.lotes.add(String(p.lote));
      mapa.set(nome, atual);
    });
    let melhor: { nome: string; mediaMin: number; ocorrencias: number; lotes: number } | null = null;
    mapa.forEach((v, k) => {
      const media = v.total / v.qtd;
      if (!melhor || media > melhor.mediaMin) {
        melhor = { nome: k, mediaMin: media, ocorrencias: v.qtd, lotes: v.lotes.size };
      }
    });
    return melhor;
  }, [produtosTempoCorteSalvos]);

  const alternarProdutoNaAnalise = (id: string) => {
    setProdutosTempoCorteSalvos((prev) => {
      const next = prev.map((produto) =>
        produto.id === id
          ? { ...produto, enviarParaAnalise: !produto.enviarParaAnalise }
          : produto
      );
      ignorarSaveTempoCorteProdRef.current = true;
      void persistirProdutosTempoCorteDireto(next).then(() => {
        notificarSyncDesktop('tempo-corte-produtos');
      });
      return next;
    });
  };

  const atualizarHorarioProduto = (id: string, valor: string) => {
    setProdutosTempoCorteSalvos((prev) =>
      prev.map((p) => (p.id === id ? { ...p, horarioProduto: valor } : p))
    );
  };
  
  // Carrega itens do Tempo de Corte (IndexedDB + backup).
  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) return;
    let cancelado = false;
    (async () => {
      const mesclados = await coletarTempoCorteItensBruto();
      if (cancelado) return;
      if (mesclados.length > 0) {
        const comDescLimpa = mesclados.map((it: TempoCorteItem) => ({
          ...it,
          descricao: descricaoPecaSemCor(String(it.descricao || '')).toUpperCase(),
        }));
        setTempoCorteItens(comDescLimpa);
        await salvarTempoCorteItensDB(comDescLimpa);
        try {
          localStorage.setItem('tempo-corte-itens-ade', JSON.stringify(comDescLimpa));
        } catch {
          /* ignora */
        }
        console.info(`[Sistema Ade] Tempo de Corte (peças): ${mesclados.length} item(ns) carregado(s).`);
      }
      carregouTempoCorteItensRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'tempoCorte')) return;
    if (!carregouTempoCorteItensRef.current) return;
    if (ignorarSaveTempoCorteItensRef.current) {
      ignorarSaveTempoCorteItensRef.current = false;
      return;
    }
    void (async () => {
      try {
        const gravou = await salvarTempoCorteItensDBSeguro(tempoCorteItens);
        if (gravou) notificarSyncDesktop('tempo-corte-itens');
      } catch {
        if (!erroPersistenciaTempoCorteItensRef.current) {
          alert(
            'Não foi possível salvar a lista de peças do Tempo de Corte no armazenamento local ampliado (IndexedDB).'
          );
          erroPersistenciaTempoCorteItensRef.current = true;
        }
      }
    })();
  }, [tempoCorteItens], 400);

  useEffect(() => {
    safeSetLocalStorage('tempo-corte-pontuacao-ade', String(pontuacaoProduto));
  }, [pontuacaoProduto]);
  
  useEffect(() => {
    safeSetLocalStorage('tempo-corte-qtd-ade', String(qtdProduto));
  }, [qtdProduto]);
  
  useEffect(() => {
    safeSetLocalStorage('tempo-corte-pontos-ade', String(pontosDiaTodo));
  }, [pontosDiaTodo]);
  
  useEffect(() => {
    safeSetLocalStorage('tempo-corte-tempodia-ade', String(tempoDiaTodo));
  }, [tempoDiaTodo]);
  
  useEffect(() => {
    safeSetLocalStorage('tempo-corte-porcentagem-ade', String(porcentagem));
  }, [porcentagem]);
  
  useEffect(() => {
    safeSetLocalStorage('tempo-corte-nome-ade', nomeProdutoTempo);
  }, [nomeProdutoTempo]);

  const tempoProducaoCalculado = useMemo(() => {
    if (!dataHoraInicioProducao || !dataHoraTerminoProducao) return '00:00:00';
    const minutos = calcularMinutosUteis(
      dataHoraInicioProducao,
      dataHoraTerminoProducao,
      horarioExtraManha,
      horarioExtraAlmoco,
      trabalhaSabado,
      trabalhaDomingo
    );
    return formatarTempo(minutos);
  }, [dataHoraInicioProducao, dataHoraTerminoProducao, horarioExtraManha, horarioExtraAlmoco, trabalhaSabado, trabalhaDomingo]);

  useEffect(() => {
    const loteRaw = String(loteTempoCorte || '').trim();
    if (!loteRaw) {
      setDataHoraInicioExato('');
      setDataHoraTerminoExato('');
      return;
    }

    // Aceita lote único ("8762") ou múltiplos lotes separados por
    // -, /, +, , ou ; ("8762-8763", "8762/8763", "8762+8763"). A ORDEM
    // importa: primeiro lote = data de INÍCIO; último lote = data de FIM.
    const numerosDigitados = numerosLoteDeTexto(loteRaw);

    if (numerosDigitados.length === 0) {
      // Sem números válidos — cai no comportamento antigo (lote textual exato).
      const loteNorm = normalizarTexto(loteRaw);
      const itensDoLote = lotesProdutos.filter(
        (item) => normalizarTexto(item.lote) === loteNorm
      );
      const datasInicio = itensDoLote
        .map((item) => item.dataHoraInicioCorte)
        .filter(Boolean)
        .map((data) => new Date(data as string))
        .filter((data) => !isNaN(data.getTime()));
      const datasFim = itensDoLote
        .map((item) => item.dataHoraFimEmbalagem)
        .filter(Boolean)
        .map((data) => new Date(data as string))
        .filter((data) => !isNaN(data.getTime()));
      const menorInicioFb = datasInicio.length > 0
        ? new Date(Math.min(...datasInicio.map((data) => data.getTime())))
        : null;
      const maiorFimFb = datasFim.length > 0
        ? new Date(Math.max(...datasFim.map((data) => data.getTime())))
        : null;
      const paraInputFb = (data: Date | null) => {
        if (!data) return '';
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        const hora = String(data.getHours()).padStart(2, '0');
        const minuto = String(data.getMinutes()).padStart(2, '0');
        return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
      };
      setDataHoraInicioExato(paraInputFb(menorInicioFb));
      setDataHoraTerminoExato(paraInputFb(maiorFimFb));
      return;
    }

    const primeiroNum = numerosDigitados[0];
    const ultimoNum = numerosDigitados[numerosDigitados.length - 1];

    // Itens do PRIMEIRO lote (8762) → data de início.
    const itensPrimeiro = lotesProdutos.filter((item) =>
      numerosLoteDeTexto(String(item.lote || '')).includes(primeiroNum)
    );
    // Itens do ÚLTIMO lote (8763) → data de fim.
    const itensUltimo = lotesProdutos.filter((item) =>
      numerosLoteDeTexto(String(item.lote || '')).includes(ultimoNum)
    );

    const datasInicio = itensPrimeiro
      .map((item) => item.dataHoraInicioCorte)
      .filter(Boolean)
      .map((data) => new Date(data as string))
      .filter((data) => !isNaN(data.getTime()));

    const datasFim = itensUltimo
      .map((item) => item.dataHoraFimEmbalagem)
      .filter(Boolean)
      .map((data) => new Date(data as string))
      .filter((data) => !isNaN(data.getTime()));

    const menorInicio = datasInicio.length > 0
      ? new Date(Math.min(...datasInicio.map((data) => data.getTime())))
      : null;
    const maiorFim = datasFim.length > 0
      ? new Date(Math.max(...datasFim.map((data) => data.getTime())))
      : null;

    const paraInput = (data: Date | null) => {
      if (!data) return '';
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const dia = String(data.getDate()).padStart(2, '0');
      const hora = String(data.getHours()).padStart(2, '0');
      const minuto = String(data.getMinutes()).padStart(2, '0');
      return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
    };

    setDataHoraInicioExato(paraInput(menorInicio));
    setDataHoraTerminoExato(paraInput(maiorFim));
  }, [loteTempoCorte, lotesProdutos]);
  
  // Limpar histórico com mais de 7 dias
  useEffect(() => {
    const seteDiasAtras = new Date();
    seteDiasAtras.setDate(seteDiasAtras.getDate() - 7);
    const historicoFiltrado = historicoImpressoes.filter(h => new Date(h.dataHora) >= seteDiasAtras);
    if (historicoFiltrado.length !== historicoImpressoes.length) {
      setHistoricoImpressoes(historicoFiltrado);
    }
  }, []);

  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'layout')) return;
    let cancelado = false;
    (async () => {
      const dbLayout = await lerLayoutImpressaoDB();
      if (cancelado) return;
      if (dbLayout && typeof dbLayout === 'object') {
        const merged = normalizarLayoutCarregado({ ...LAYOUT_PADRAO, ...dbLayout });
        layoutSalvoJsonRef.current = JSON.stringify(merged);
        ignorarSyncMaterialLayoutRef.current = true;
        setLayoutConfig(merged);
        setMaterialConfig({
          tipoMaterial: merged.tipoMaterial,
          espessuraMaterial: merged.espessuraMaterial,
        });
        carregouLayoutRef.current = true;
        return;
      }
      try {
        const saved = localStorage.getItem('layout-impressao-ade');
        if (!saved) {
          layoutSalvoJsonRef.current = JSON.stringify(layoutConfig);
          carregouLayoutRef.current = true;
          return;
        }
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed === 'object') {
          const merged = normalizarLayoutCarregado({ ...LAYOUT_PADRAO, ...parsed });
          layoutSalvoJsonRef.current = JSON.stringify(merged);
          ignorarSyncMaterialLayoutRef.current = true;
          setLayoutConfig(merged);
          setMaterialConfig({
            tipoMaterial: merged.tipoMaterial,
            espessuraMaterial: merged.espessuraMaterial,
          });
          try {
            await salvarLayoutImpressaoDB(merged);
          } catch {
            // permanece no localStorage
          }
        }
      } catch {
        // fallback silencioso
      } finally {
        carregouLayoutRef.current = true;
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);
  
  useEffect(() => {
    if (!carregouLayoutRef.current || ignorarSaveLayoutRef.current) {
      if (ignorarSaveLayoutRef.current) ignorarSaveLayoutRef.current = false;
      return;
    }
    const json = JSON.stringify(layoutConfig);
    if (json === layoutSalvoJsonRef.current) return;
    const timer = window.setTimeout(() => {
      void (async () => {
        try {
          await salvarLayoutImpressaoDB(layoutConfig);
          layoutSalvoJsonRef.current = json;
          notificarSyncDesktop('layout-impressao');
        } catch {
          try {
            localStorage.setItem('layout-impressao-ade', json);
            layoutSalvoJsonRef.current = json;
            notificarSyncDesktop('layout-impressao');
          } catch {
            if (!erroPersistenciaLayoutRef.current) {
              console.warn(
                '[Sistema Ade] Layout de impressão: IndexedDB indisponível e localStorage cheio.'
              );
              erroPersistenciaLayoutRef.current = true;
            }
          }
        }
      })();
    }, 400);
    return () => window.clearTimeout(timer);
  }, [layoutConfig]);
  
  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'historico')) return;
    if (!carregouHistoricoImpressoesRef.current) return;
    if (ignorarSaveHistoricoRef.current) {
      ignorarSaveHistoricoRef.current = false;
      return;
    }
    void (async () => {
      try {
        const gravou = await salvarArrayIndexedDBSeguro(
          lerHistoricoImpressoesDB,
          salvarHistoricoImpressoesDB,
          historicoImpressoes,
          'historico-impressoes-ade'
        );
        if (gravou) notificarSyncDesktop('historico-impressoes');
      } catch {
        if (!erroPersistenciaHistoricoRef.current) {
          alert('Não foi possível salvar o histórico de impressões no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaHistoricoRef.current = true;
        }
      }
    })();
  }, [historicoImpressoes], 400);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'relatorio')) return;
    if (!carregouRelatorioRef.current) return;
    if (ignorarPersistenciaRelatorioRef.current) {
      ignorarPersistenciaRelatorioRef.current = false;
      return;
    }
    if (aplicandoSyncRemotoRelatorioRef.current) return;
    void (async () => {
      try {
        const saved = await salvarRelatorioEstado({
          itens: relatorioItens,
          cabecalho: relatorioCabecalho,
          revision: revisionRelatorioRef.current,
        });
        revisionRelatorioRef.current = saved.revision;
        notificarRelatorioAtualizado(saved.revision);
      } catch {
        if (!erroPersistenciaRelatorioRef.current) {
          alert('Não foi possível salvar o Relatório no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaRelatorioRef.current = true;
        }
      }
    })();
  }, [relatorioItens, relatorioCabecalho], 400);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    if (!carregouSobraRef.current) return;
    if (ignorarSaveSobraRef.current) {
      ignorarSaveSobraRef.current = false;
      return;
    }
    void (async () => {
      try {
        await persistirSobraDireto(sobraItens);
        notificarSyncDesktop('sobra');
      } catch {
        if (!erroPersistenciaSobraRef.current) {
          alert('Não foi possível salvar as sobras no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaSobraRef.current = true;
        }
      }
    })();
  }, [sobraItens], 400);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    if (!carregouSobraPastasRef.current) return;
    if (ignorarSaveSobraPastasRef.current) {
      ignorarSaveSobraPastasRef.current = false;
      return;
    }
    void (async () => {
      try {
        const gravou = await salvarArrayIndexedDBSeguro(
          lerSobraPastasDB,
          salvarSobraPastasDB,
          pastasSobra,
          'sobra-pastas-ade'
        );
        if (gravou) notificarSyncDesktop('sobra-pastas');
      } catch {
        if (!erroPersistenciaSobraPastasRef.current) {
          alert('Não foi possível salvar as pastas da aba Sobra no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaSobraPastasRef.current = true;
        }
      }
    })();
  }, [pastasSobra], 400);


  const [sobraRiscados, setSobraRiscados] = useState<Set<string>>(new Set());
  const carregouSobraRiscadosRef = useRef(false);
  const erroPersistenciaSobraRiscadosRef = useRef(false);
  useEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    let cancelado = false;
    (async () => {
      const lista = await coletarSobraRiscadosBruto();
      if (cancelado) return;
      if (lista.length > 0) {
        setSobraRiscados(new Set(lista));
        await salvarSobraRiscadosDB(lista);
        try {
          localStorage.setItem('sobra-riscados-ade', JSON.stringify(lista));
        } catch {
          /* ignora */
        }
        console.info(`[Sistema Ade] Sobra riscados: ${lista.length} item(ns) carregado(s).`);
      }
      carregouSobraRiscadosRef.current = true;
    })();
    return () => {
      cancelado = true;
    };
  }, [escopoDados]);

  useDebouncedEffect(() => {
    if (!moduloPrecisaDado(escopoDados, 'sobra')) return;
    if (!carregouSobraRiscadosRef.current) return;
    if (ignorarSaveSobraRiscadosRef.current) {
      ignorarSaveSobraRiscadosRef.current = false;
      return;
    }
    const lista = [...sobraRiscados];
    void (async () => {
      try {
        const gravou = await salvarArrayIndexedDBSeguro(
          lerSobraRiscadosDB,
          salvarSobraRiscadosDB,
          lista,
          'sobra-riscados-ade'
        );
        if (gravou) notificarSyncDesktop('sobra-riscados');
      } catch {
        if (!erroPersistenciaSobraRiscadosRef.current) {
          alert('Não foi possível salvar os riscados da aba Sobra no armazenamento local ampliado (IndexedDB).');
          erroPersistenciaSobraRiscadosRef.current = true;
        }
      }
    })();
  }, [sobraRiscados], 400);
  const toggleSobraRiscado = (entradaId: string, itemId: string) => {
    const chave = `${entradaId}-${itemId}`;
    setSobraItens((prev) =>
      prev.map((entrada) =>
        entrada.id !== entradaId
          ? entrada
          : {
              ...entrada,
              itens: entrada.itens.map((item) =>
                item.id === itemId ? { ...item, riscadoSobra: !item.riscadoSobra } : item
              ),
            }
      )
    );
    setSobraRiscados(prev => {
      const next = new Set(prev);
      if (next.has(chave)) next.delete(chave);
      else next.add(chave);
      return next;
    });
  };

  const sobraItensFiltrados = useMemo((): SobraCardComItensFiltrados[] => {
    const itensPorPasta = (e: SobraEntradaADE) => {
      if (pastaFiltroSobra === 'todas') return e.itens;
      if (pastaFiltroSobra === 'sem') return e.itens.filter((it) => !it.pastaSobraId);
      return e.itens.filter((it) => it.pastaSobraId === pastaFiltroSobra);
    };

    const passaTexto = (entrada: SobraEntradaADE, vis: RelatorioItem[]) => {
      const termo = filtroSobra.trim().toLowerCase();
      if (!termo) return true;
      const cab = entrada.cabecalho;
      const textoCabecalho = [
        cab.lote ?? '',
        cab.nomeProduto ?? '',
        cab.tempo ?? '',
        cab.dataInicio ?? '',
        cab.dataTermino ?? '',
        new Date(entrada.dataAdicao).toLocaleString('pt-BR'),
      ]
        .join(' ')
        .toLowerCase();
      if (textoCabecalho.includes(termo)) return true;
      return vis.some((item) => {
        const textoItem = [
          item.nomePeca ?? '',
          String(item.medidaMenor ?? ''),
          String(item.medidaMaior ?? ''),
          item.material ?? '',
          String(item.espessura ?? ''),
          item.observacao ?? '',
          item.tempoPorPecaMinutos != null && !Number.isNaN(item.tempoPorPecaMinutos)
            ? formatarTempo(item.tempoPorPecaMinutos)
            : '',
          item.inicio ?? '',
          item.termino ?? '',
        ]
          .join(' ')
          .toLowerCase();
        return textoItem.includes(termo);
      });
    };

    return sobraItens
      .map((entrada) => {
        const itensVisiveis = itensPorPasta(entrada);
        return { entrada, itensVisiveis };
      })
      .filter(({ entrada, itensVisiveis }) => itensVisiveis.length > 0 && passaTexto(entrada, itensVisiveis));
  }, [sobraItens, filtroSobra, pastaFiltroSobra]);

  const contagemLinhasPorPastaSobra = useMemo(() => {
    const map = new Map<string, number>();
    pastasSobra.forEach((p) => map.set(p.id, 0));
    sobraItens.forEach((e) => {
      e.itens.forEach((it) => {
        const pid = it.pastaSobraId;
        if (pid) map.set(pid, (map.get(pid) ?? 0) + 1);
      });
    });
    return map;
  }, [sobraItens, pastasSobra]);

  const linhasSemPastaSobraCount = useMemo(
    () => sobraItens.reduce((acc, e) => acc + e.itens.filter((it) => !it.pastaSobraId).length, 0),
    [sobraItens]
  );

  const pastasSobraFiltradasPorNome = useMemo(() => {
    const q = filtroNomePastasSobra.trim().toLowerCase();
    if (!q) return pastasSobra;
    return pastasSobra.filter((p) => p.nome.toLowerCase().includes(q));
  }, [pastasSobra, filtroNomePastasSobra]);

  const mostrarCardSemPastaSobra = useMemo(() => {
    if (linhasSemPastaSobraCount <= 0) return false;
    const q = filtroNomePastasSobra.trim().toLowerCase();
    if (!q) return true;
    return 'sem pasta'.includes(q) || q.includes('sem');
  }, [linhasSemPastaSobraCount, filtroNomePastasSobra]);

  const historicoImpressoesFiltrado = useMemo(() => {
    const termo = filtroHistoricoImpressoes.trim().toLowerCase();
    return historicoImpressoes.filter((h) => {
      const dataItem = new Date(h.dataHora);
      if (filtroDataInicio && dataItem < new Date(filtroDataInicio)) return false;
      if (filtroDataFim && dataItem > new Date(`${filtroDataFim}T23:59:59`)) return false;
      if (!termo) return true;
      const texto = [
        h.projeto.nomeProduto ?? '',
        h.projeto.nomePeca ?? '',
        h.data ?? '',
        dataItem.toLocaleString('pt-BR'),
        String(h.layoutConfig?.plano ?? ''),
        String(h.layoutConfig?.etapas ?? ''),
        String(h.layoutConfig?.tipoMaterial ?? ''),
        String(h.layoutConfig?.espessuraMaterial ?? ''),
        String(h.pecas?.length ?? ''),
      ]
        .join(' ')
        .toLowerCase();
      return texto.includes(termo);
    });
  }, [historicoImpressoes, filtroDataInicio, filtroDataFim, filtroHistoricoImpressoes]);

  const criarPastaSobraADE = () => {
    const nome = nomeNovaPastaSobra.trim();
    if (!nome) {
      alert('Digite um nome para a pasta.');
      return;
    }
    setPastasSobra((prev) => [
      ...prev,
      { id: `sobra-pasta-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, nome },
    ]);
    setNomeNovaPastaSobra('');
  };

  const excluirPastaSobraADE = (id: string) => {
    if (!confirm('Excluir esta pasta? As linhas que estavam nela ficam em "Sem pasta".')) return;
    setSobraItens((prev) =>
      prev.map((e) => ({
        ...e,
        pastaId: null,
        itens: e.itens.map((it) =>
          it.pastaSobraId === id ? { ...it, pastaSobraId: null } : it
        ),
      }))
    );
    setPastasSobra((prev) => prev.filter((p) => p.id !== id));
    setPastaFiltroSobra((cur) => (cur === id ? 'todas' : cur));
  };

  const toggleSelecionarSobraParaImpressao = (id: string) => {
    setSobraSelecionadosParaImpressao((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const atualizarQuantidadeLinhaSobraADE = (entradaId: string, itemId: string, valor: string) => {
    const somenteDigitos = valor.replace(/\D/g, '');
    const quantidade = somenteDigitos === '' ? 0 : Number(somenteDigitos);
    setSobraItens((prev) =>
      prev.map((entrada) =>
        entrada.id !== entradaId
          ? entrada
          : {
              ...entrada,
              itens: entrada.itens.map((it) =>
                it.id === itemId ? { ...it, quantidade } : it
              ),
            }
      )
    );
  };

  const normalizarQuantidadeLinhaSobraADE = (entradaId: string, itemId: string) => {
    setSobraItens((prev) =>
      prev.map((entrada) =>
        entrada.id !== entradaId
          ? entrada
          : {
              ...entrada,
              itens: entrada.itens.map((it) =>
                it.id === itemId ? { ...it, quantidade: Math.max(1, Number(it.quantidade) || 0) } : it
              ),
            }
      )
    );
  };

  const removerLinhaSobraADE = (entradaId: string, itemId: string) => {
    const chaveRiscado = `${entradaId}-${itemId}`;
    registrarExclusaoLinhaSobra(entradaId, itemId);
    setSobraRiscados((prev) => {
      const next = new Set(prev);
      next.delete(chaveRiscado);
      return next;
    });
    setSobraItens((prev) => {
      const entrada = prev.find((e) => e.id === entradaId);
      if (!entrada) return prev;
      const novosItens = entrada.itens.filter((it) => it.id !== itemId);
      let next: typeof prev;
      if (novosItens.length === 0) {
        registrarExclusaoEntradaSobra(entradaId);
        setSobraSelecionadosParaImpressao((s) => {
          const n = new Set(s);
          n.delete(entradaId);
          return n;
        });
        next = prev.filter((e) => e.id !== entradaId);
      } else {
        const renumerados = novosItens.map((it, i) => ({ ...it, corteNumero: i + 1 }));
        next = prev.map((e) => (e.id === entradaId ? { ...e, itens: renumerados } : e));
      }
      ignorarSaveSobraRef.current = true;
      void persistirSobraDireto(next).then(() => {
        notificarSyncDesktop('sobra');
      });
      return next;
    });
  };

  const escaparHtmlBasico = (s: string) =>
    String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const montarHtmlSobraEntrada = (entrada: SobraEntradaADE, idx?: number) => {
    const nomePastaLinha = (pid: string | null | undefined) =>
      pid && pastasSobra.length ? pastasSobra.find((p) => p.id === pid)?.nome ?? '' : '';
    return `
    <section style="margin-bottom:10px;break-inside:avoid;page-break-inside:avoid;">
      <div style="background:#fef3c7;padding:8px;border:1px solid #f59e0b;margin-bottom:6px;font-size:12px;">
        <div><strong>Lote:</strong> ${entrada.cabecalho.lote || '-'}</div>
        <div><strong>Produto:</strong> ${entrada.cabecalho.nomeProduto || '-'}</div>
        <div><strong>Incluído:</strong> ${new Date(entrada.dataAdicao).toLocaleString('pt-BR')}</div>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:11px;">
        <thead>
          <tr style="background:#f1f5f9">
            <th style="border:1px solid #334155;padding:4px;text-align:left;">PASTA</th>
            <th style="border:1px solid #334155;padding:4px;text-align:left;">CORTE</th>
            <th style="border:1px solid #334155;padding:4px;text-align:left;">PEÇA</th>
            <th style="border:1px solid #334155;padding:4px;text-align:center;">QTD</th>
            <th style="border:1px solid #334155;padding:4px;text-align:center;">MEDIDA</th>
            <th style="border:1px solid #334155;padding:4px;text-align:left;">MATERIAL</th>
            <th style="border:1px solid #334155;padding:4px;text-align:left;">PRODUTO</th>
            <th style="border:1px solid #334155;padding:4px;text-align:left;">OBS</th>
          </tr>
        </thead>
        <tbody>
          ${
            entrada.itens
              .map(
                (item) => `
              <tr>
                <td style="border:1px solid #334155;padding:4px;">${nomePastaLinha(item.pastaSobraId) || '—'}</td>
                <td style="border:1px solid #334155;padding:4px;">${item.corteNumero}º</td>
                <td style="border:1px solid #334155;padding:4px;">${item.nomePeca || '-'}</td>
                <td style="border:1px solid #334155;padding:4px;text-align:center;">${item.quantidade}</td>
                <td style="border:1px solid #334155;padding:4px;text-align:center;">${item.medidaMenor}×${item.medidaMaior}</td>
                <td style="border:1px solid #334155;padding:4px;">${item.material === 'mdf' ? 'MDF' : 'AGLO'} - ${item.espessura}MM</td>
                <td style="border:1px solid #334155;padding:4px;">${item.inicio || '-'}</td>
                <td style="border:1px solid #334155;padding:4px;">${item.observacao || ''}</td>
              </tr>`
              )
              .join('')
          }
        </tbody>
      </table>
    </section>
  `;
  };

  const imprimirEntradasSobra = (entradas: SobraEntradaADE[], opts?: { titulo?: string }) => {
    if (!entradas.length) return;
    const corpo = entradas.map((e, i) => montarHtmlSobraEntrada(e, i)).join('');
    const tituloBloco = opts?.titulo
      ? `<header style="margin-bottom:12px;padding-bottom:10px;border-bottom:2px solid #f59e0b;"><h1 style="font-size:16px;margin:0;color:#0f172a;">${escaparHtmlBasico(opts.titulo)}</h1></header>`
      : '';
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Sobra</title>
      <style>
        @page{size:A4 portrait;margin:10mm;}
        body{font-family:Arial,sans-serif;color:#0f172a;}
        section{break-inside:avoid;page-break-inside:avoid;}
      </style>
      </head><body>${tituloBloco}${corpo}</body></html>`;
    const win = window.open('', '_blank');
    if (!win) return;
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 300);
  };

  const coletarEntradasParaImpressaoPasta = (pastaId: string): SobraEntradaADE[] => {
    return sobraItens
      .map((e) => {
        const itens = e.itens.filter((it) => it.pastaSobraId === pastaId);
        if (itens.length === 0) return null;
        return { ...e, itens };
      })
      .filter((e): e is SobraEntradaADE => e != null);
  };

  const imprimirPastaSobraADE = (pastaId: string) => {
    const entradas = coletarEntradasParaImpressaoPasta(pastaId);
    if (!entradas.length) {
      alert('Não há linhas classificadas nesta pasta.');
      return;
    }
    const nome = pastasSobra.find((p) => p.id === pastaId)?.nome ?? 'Pasta';
    imprimirEntradasSobra(entradas, { titulo: `Sobra — ${nome}` });
  };

  // Funções do Relatório - NÒO junta peças da mesma medida com material/espessura diferente
  const mesclarImpressaoNoRelatorio = (
    prev: RelatorioItem[],
    impressao: HistoricoImpressao
  ): RelatorioItem[] => {
    const tipoMat = impressao.layoutConfig?.tipoMaterial ?? 'aglomerado';
    const espMat = impressao.layoutConfig?.espessuraMaterial ?? 15;
    const qtdChapas = impressao.layoutConfig?.quantidadeChapas ?? 1;
    const contagemDim = contarPecasPorDimensaoGruposProjeto(impressao.grupos);
    const pecasAgrupadas = new Map<string, { menor: number; maior: number; total: number }>();

    contagemDim.forEach((count, chaveDim) => {
      const parts = chaveDim.split('x');
      const menor = Number(parts[0]) || 0;
      const maior = Number(parts[1]) || 0;
      const chave = `${menor}x${maior}-${tipoMat}-${espMat}`;
      const total = count * qtdChapas;
      if (pecasAgrupadas.has(chave)) {
        pecasAgrupadas.get(chave)!.total += total;
      } else {
        pecasAgrupadas.set(chave, { menor, maior, total });
      }
    });

    const novosItens = [...prev];

    pecasAgrupadas.forEach((dados) => {
      const existente = novosItens.find(
        (item) =>
          item.medidaMenor === dados.menor &&
          item.medidaMaior === dados.maior &&
          item.material === tipoMat &&
          item.espessura === espMat
      );

      if (existente) {
        existente.quantidade += dados.total;
      } else {
        novosItens.push({
          id: Date.now().toString() + Math.random(),
          corteNumero: novosItens.length + 1,
          nomePeca: impressao.projeto.nomePeca || '',
          quantidade: dados.total,
          medidaMenor: dados.menor,
          medidaMaior: dados.maior,
          material: tipoMat,
          espessura: espMat,
          lote: '',
          inicio: '',
          termino: '',
          observacao: '',
          tempoPorPecaManual: false,
          planoOrigem: impressao.layoutConfig.plano,
          dataInclusao: new Date().toLocaleDateString('pt-BR'),
          ocultoRelatorio: false,
        });
      }
    });

    return novosItens;
  };

  const adicionarAoRelatorio = (impressao: HistoricoImpressao) => {
    void (async () => {
      try {
        const saved = await atualizarRelatorioEstado((estado) => ({
          ...estado,
          itens: mesclarImpressaoNoRelatorio(estado.itens as RelatorioItem[], impressao),
        }));
        aplicandoSyncRemotoRelatorioRef.current = true;
        setRelatorioItens(saved.itens as RelatorioItem[]);
        revisionRelatorioRef.current = saved.revision;
        ignorarPersistenciaRelatorioRef.current = true;
        aplicandoSyncRemotoRelatorioRef.current = false;

        if (janelaRelatorioAberta()) {
          focarJanelaRelatorio();
        } else if (!nwDisponivel() && !isJanelaFilha) {
          setAbaAtiva('relatorio');
        }
      } catch {
        if (!erroPersistenciaRelatorioRef.current) {
          alert('Não foi possível atualizar o Relatório após a impressão.');
          erroPersistenciaRelatorioRef.current = true;
        }
      }
    })();
  };
  
  const moverItemRelatorio = (id: string, direcao: 'cima' | 'baixo') => {
    setRelatorioItens(prev => {
      const index = prev.findIndex(item => item.id === id);
      if (index === -1) return prev;
      
      const novosItens = [...prev];
      if (direcao === 'cima' && index > 0) {
        [novosItens[index - 1], novosItens[index]] = [novosItens[index], novosItens[index - 1]];
      } else if (direcao === 'baixo' && index < novosItens.length - 1) {
        [novosItens[index], novosItens[index + 1]] = [novosItens[index + 1], novosItens[index]];
      }
      
      // Atualizar números de corte
      novosItens.forEach((item, i) => {
        item.corteNumero = i + 1;
      });
      
      return novosItens;
    });
  };
  
  const editarItemRelatorio = (id: string, campo: keyof RelatorioItem, valor: any) => {
    setRelatorioItens((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        const next: RelatorioItem = { ...item, [campo]: valor };
        if (campo === 'tempoPorPecaMinutos') {
          if (valor == null || valor === '') {
            next.tempoPorPecaManual = false;
            next.tempoPorPecaMinutos = undefined;
          } else {
            next.tempoPorPecaManual = true;
          }
        }
        if (campo === 'medidaMenor' || campo === 'medidaMaior') {
          next.tempoPorPecaManual = false;
        }
        return next;
      })
    );
  };

  const toggleOcultoRelatorio = (id: string) => {
    setRelatorioItens((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, ocultoRelatorio: !item.ocultoRelatorio } : item
      )
    );
  };
  
  const removerItemRelatorio = (id: string) => {
    setRelatorioItens(prev => {
      const novosItens = prev.filter(item => item.id !== id);
      // Renumerar cortes
      novosItens.forEach((item, i) => {
        item.corteNumero = i + 1;
      });
      return novosItens;
    });
  };
  
  const adicionarLinhaManual = () => {
    setRelatorioItens(prev => [...prev, {
      id: Date.now().toString(),
      corteNumero: prev.length + 1,
      nomePeca: '',
      quantidade: 0,
      medidaMenor: 0,
      medidaMaior: 0,
      material: 'aglomerado',
      espessura: 15,
      lote: '',
      inicio: '',
      termino: '',
      observacao: '',
      tempoPorPecaManual: false,
      planoOrigem: 0,
      dataInclusao: new Date().toLocaleDateString('pt-BR'),
      ocultoRelatorio: false,
    }]);
  };

  const importarLinhasColadasExcel = (linhas: {
    nomePeca: string;
    quantidade: number;
    medidaMenor: number;
    medidaMaior: number;
    material: 'mdf' | 'aglomerado';
    espessura: number;
  }[]) => {
    const loteCab = relatorioCabecalho.lote?.trim() || '';
    setRelatorioItens((prev) => {
      let n = prev.length;
      const novas = linhas.map((l) => {
        n += 1;
        return {
          id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
          corteNumero: n,
          nomePeca: l.nomePeca,
          quantidade: l.quantidade,
          medidaMenor: l.medidaMenor,
          medidaMaior: l.medidaMaior,
          material: l.material,
          espessura: l.espessura,
          lote: loteCab,
          inicio: '',
          termino: '',
          observacao: '',
          tempoPorPecaManual: false,
          planoOrigem: 0,
          dataInclusao: new Date().toLocaleDateString('pt-BR'),
          ocultoRelatorio: false,
        } satisfies RelatorioItem;
      });
      return [...prev, ...novas];
    });
    registrarAuditoria('importar_excel_relatorio', `${linhas.length} linha(s) coladas do Excel`);
  };
  
  const limparRelatorio = () => {
    if (confirm('Tem certeza que deseja limpar todo o relatório?')) {
      setRelatorioItens([]);
    }
  };
  
  // Funções do Tempo de Corte
  const adicionarTempoCorteItem = () => {
    setTempoCorteItens(prev => [...prev, {
      id: Date.now().toString(),
      numero: prev.length + 1,
      descricao: '',
      qtd: 0,
      medida: '',
      metrosQuadrados: 0,
      material: '',
      selecionado: true
    }]);
  };
  
  const editarTempoCorteItem = (id: string, campo: keyof TempoCorteItem, valor: any) => {
    const valorAplicar =
      campo === 'descricao' ? descricaoPecaSemCor(String(valor || '')).toUpperCase() : valor;
    setTempoCorteItens((prev) => {
      const novos = prev.map((item) => {
        if (item.id !== id) return item;
        const atualizado = { ...item, [campo]: valorAplicar };
        if (campo === 'qtd' || campo === 'medida') {
          const qtd = parseNumeroFlex(campo === 'qtd' ? valor : atualizado.qtd);
          const medida = String(campo === 'medida' ? valor : atualizado.medida ?? '').trim();
          const m2Calculado = calcularMetrosQuadradosPorMedidaQtd(medida, qtd);
          if (m2Calculado > 0) {
            atualizado.metrosQuadrados = m2Calculado;
          }
        }
        return atualizado;
      });

      // Descrição / QTD / Medida / Material: espelha em cards do mesmo produto (qualquer lote).
      // Checkbox (selecionado): só no mesmo lote — para Tempo por Peça em Produção não sumir em outro lote.
      if (
        (campo === 'descricao' ||
          campo === 'qtd' ||
          campo === 'medida' ||
          campo === 'material' ||
          campo === 'selecionado') &&
        nomeProdutoTempo.trim()
      ) {
        const indexOrigem = prev.findIndex((i) => i.id === id);
        const pecaEditada = novos.find((i) => i.id === id);
        if (pecaEditada && indexOrigem >= 0) {
          const nomeAlvo = nomeProdutoTempo.trim();
          const loteAlvo = String(loteTempoCorte || '').trim();
          setProdutosTempoCorteSalvos((cards) => {
            let alterados = 0;
            const next = cards.map((card) => {
              if (!nomesProdutoIguais(String(card.nome || ''), nomeAlvo)) return card;
              if (campo === 'selecionado') {
                const mesmoLote =
                  !loteAlvo ||
                  cardTempoCortePertenceAoLote(card, loteAlvo) ||
                  String(card.lote || '').trim().toLowerCase() === loteAlvo.toLowerCase();
                if (!mesmoLote) return card;
              }
              const itens = Array.isArray(card.itens) ? [...card.itens] : [];
              if (itens.length === 0) return card;
              let idx = -1;
              const num = Number(pecaEditada.numero) || 0;
              if (num > 0) idx = itens.findIndex((i: any) => Number(i.numero) === num);
              if (idx < 0 && indexOrigem < itens.length) idx = indexOrigem;
              if (idx < 0) {
                const desc = String(prev[indexOrigem]?.descricao || '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toUpperCase()
                  .trim();
                if (desc) {
                  idx = itens.findIndex(
                    (i: any) =>
                      String(i.descricao || '')
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toUpperCase()
                        .trim() === desc
                  );
                }
              }
              if (idx < 0) return card;
              const atual = { ...itens[idx], [campo]: valorAplicar };
              if (campo === 'qtd' || campo === 'medida') {
                const qtd = parseNumeroFlex(atual.qtd);
                const medida = String(atual.medida ?? '').trim();
                const m2Calculado = calcularMetrosQuadradosPorMedidaQtd(medida, qtd);
                if (m2Calculado > 0) atual.metrosQuadrados = m2Calculado;
              }
              itens[idx] = atual;
              alterados += 1;
              const tempoExatoRecalc = calcularTempoExatoSelecionadasDeProdutoSalvoTc({
                ...card,
                itens,
              });
              return { ...card, itens, tempoExato: tempoExatoRecalc };
            });
            if (alterados > 0) {
              ignorarSaveTempoCorteProdRef.current = true;
              void persistirProdutosTempoCorteDireto(next).then(() => {
                notificarSyncDesktop('tempo-corte-produtos');
              });
            }
            return alterados > 0 ? next : cards;
          });
        }
      }

      return novos;
    });
  };

  const alterarDescricaoPecaTempoCorte = (produtoId: string, itemId: string, novaDescricao: string) => {
    const limpo = descricaoPecaSemCor(novaDescricao).toUpperCase();
    setProdutosTempoCorteSalvos((cards) => {
      const cardAlvo = cards.find((c) => String(c.id) === produtoId);
      if (!cardAlvo) return cards;
      const itensAlvo = Array.isArray(cardAlvo.itens) ? cardAlvo.itens : [];
      const idxAlvo = itensAlvo.findIndex((i: any) => String(i.id) === itemId);
      if (idxAlvo < 0) return cards;
      const num = Number(itensAlvo[idxAlvo]?.numero) || 0;
      const nomeAlvo = String(cardAlvo.nome || '');
      let alterados = 0;
      const next = cards.map((card) => {
        const mesmoProduto =
          String(card.id) === produtoId || nomesProdutoIguais(String(card.nome || ''), nomeAlvo);
        if (!mesmoProduto) return card;
        const itens = Array.isArray(card.itens) ? [...card.itens] : [];
        let idx = itens.findIndex((i: any) => String(i.id) === itemId);
        if (idx < 0 && num > 0) idx = itens.findIndex((i: any) => Number(i.numero) === num);
        if (idx < 0 && idxAlvo < itens.length) idx = idxAlvo;
        if (idx < 0) return card;
        itens[idx] = { ...itens[idx], descricao: limpo };
        alterados += 1;
        const tempoExatoRecalc = calcularTempoExatoSelecionadasDeProdutoSalvoTc({
          ...card,
          itens,
        });
        return { ...card, itens, tempoExato: tempoExatoRecalc };
      });
      if (alterados > 0) {
        ignorarSaveTempoCorteProdRef.current = true;
        void persistirProdutosTempoCorteDireto(next).then(() => {
          notificarSyncDesktop('tempo-corte-produtos');
        });
      }
      return alterados > 0 ? next : cards;
    });
    if (nomesProdutoIguais(nomeProdutoTempo, String(
      produtosTempoCorteSalvos.find((c) => String(c.id) === produtoId)?.nome || ''
    ))) {
      setTempoCorteItens((prev) => {
        const cardAlvo = produtosTempoCorteSalvos.find((c) => String(c.id) === produtoId);
        const itensAlvo = Array.isArray(cardAlvo?.itens) ? cardAlvo.itens : [];
        const idxAlvo = itensAlvo.findIndex((i: any) => String(i.id) === itemId);
        const num = Number(itensAlvo[idxAlvo]?.numero) || 0;
        let idx = prev.findIndex((i) => String(i.id) === itemId);
        if (idx < 0 && num > 0) idx = prev.findIndex((i) => Number(i.numero) === num);
        if (idx < 0 && idxAlvo >= 0 && idxAlvo < prev.length) idx = idxAlvo;
        if (idx < 0) return prev;
        const copy = [...prev];
        copy[idx] = { ...copy[idx], descricao: limpo };
        return copy;
      });
    }
  };

  const aplicarSelecaoEmMassaTempoCorte = (selecionado: boolean) => {
    setTempoCorteItens((prev) => prev.map((item) => ({ ...item, selecionado })));
    if (!nomeProdutoTempo.trim()) return;
    const nomeAlvo = nomeProdutoTempo.trim();
    const loteAlvo = String(loteTempoCorte || '').trim();
    setProdutosTempoCorteSalvos((cards) => {
      let alterados = 0;
      const next = cards.map((card) => {
        if (!nomesProdutoIguais(String(card.nome || ''), nomeAlvo)) return card;
        const mesmoLote =
          !loteAlvo ||
          cardTempoCortePertenceAoLote(card, loteAlvo) ||
          String(card.lote || '').trim().toLowerCase() === loteAlvo.toLowerCase();
        if (!mesmoLote) return card;
        const itens = Array.isArray(card.itens)
          ? card.itens.map((it: any) => ({ ...it, selecionado }))
          : [];
        if (itens.length === 0) return card;
        alterados += 1;
        const tempoExatoRecalc = calcularTempoExatoSelecionadasDeProdutoSalvoTc({
          ...card,
          itens,
        });
        return { ...card, itens, tempoExato: tempoExatoRecalc };
      });
      if (alterados > 0) {
        ignorarSaveTempoCorteProdRef.current = true;
        void persistirProdutosTempoCorteDireto(next).then(() => {
          notificarSyncDesktop('tempo-corte-produtos');
        });
      }
      return alterados > 0 ? next : cards;
    });
  };

  const desmarcarTodosTempoCorteItens = () => {
    aplicarSelecaoEmMassaTempoCorte(false);
  };

  const marcarTodosTempoCorteItens = () => {
    aplicarSelecaoEmMassaTempoCorte(true);
  };
  
  const removerTempoCorteItem = (id: string, indexLinha?: number) => {
    setTempoCorteItens((prev) => {
      let novosItens: TempoCorteItem[];
      if (typeof indexLinha === 'number' && indexLinha >= 0 && indexLinha < prev.length) {
        // Remove só esta linha (ids duplicados não apagam as duas de uma vez)
        novosItens = prev.filter((_, i) => i !== indexLinha);
      } else {
        let jaRemoveu = false;
        novosItens = prev.filter((item) => {
          if (!jaRemoveu && String(item.id) === String(id)) {
            jaRemoveu = true;
            return false;
          }
          return true;
        });
      }
      // Renumerar + garantir id único (evita React/delete quebrado com ids iguais)
      novosItens = novosItens.map((item, i) => ({
        ...item,
        numero: i + 1,
        id: `${Date.now()}-${i}-${Math.random().toString(36).slice(2, 7)}`,
        metrosQuadrados:
          Number.isFinite(Number(item.metrosQuadrados))
            ? Math.round(Number(item.metrosQuadrados) * 1e6) / 1e6
            : 0,
      }));

      const nomeAlvo = nomeProdutoTempo.trim();
      const loteAlvo = String(loteTempoCorte || '').trim();
      if (nomeAlvo && loteAlvo) {
        setProdutosTempoCorteSalvos((cards) => {
          let alterados = 0;
          const next = cards.map((card) => {
            if (!nomesProdutoIguais(String(card.nome || ''), nomeAlvo)) return card;
            const mesmoLote =
              cardTempoCortePertenceAoLote(card, loteAlvo) ||
              String(card.lote || '').trim().toLowerCase() === loteAlvo.toLowerCase();
            if (!mesmoLote) return card;
            alterados += 1;
            const tempoExatoRecalc = calcularTempoExatoSelecionadasDeProdutoSalvoTc({
              ...card,
              itens: novosItens,
            });
            return { ...card, itens: novosItens, tempoExato: tempoExatoRecalc };
          });
          if (alterados > 0) {
            ignorarSaveTempoCorteProdRef.current = true;
            void persistirProdutosTempoCorteDireto(next).then(() => {
              notificarSyncDesktop('tempo-corte-produtos');
            });
          }
          return alterados > 0 ? next : cards;
        });
      }

      return novosItens;
    });
  };
  
  const limparTempoCorte = () => {
    if (confirm('Tem certeza que deseja limpar todos os dados de tempo de corte?')) {
      setTempoCorteItens([]);
      setPontuacaoProduto(0);
      setQtdProduto(0);
      setPontosDiaTodo(0);
      setTempoDiaTodo(0);
      setPorcentagem(0);
      setNomeProdutoTempo('');
      setLoteTempoCorte('');
      setDataHoraInicioExato('');
      setDataHoraTerminoExato('');
      setDataHoraInicioProducao('');
      setDataHoraTerminoProducao('');
      setHorarioExtraManha(false);
      setHorarioExtraAlmoco(false);
      setTrabalhaSabado(false);
      setTrabalhaDomingo(false);
    }
  };
  
  const [modalProdutoExistente, setModalProdutoExistente] = useState<{ aberto: boolean; produto: any }>({ aberto: false, produto: null });

  const ehMesmoNomeELote = (p: any, nome: string, lote: string) =>
    String(p?.nome ?? '').trim().toLowerCase() === String(nome ?? '').trim().toLowerCase() &&
    String(p?.lote ?? '').trim().toLowerCase() === String(lote ?? '').trim().toLowerCase();

  const executarGerarProduto = (substituir: boolean) => {
    if (!nomeProdutoTempo.trim()) return;
    const nomeLimpo = nomeProdutoSemCor(nomeProdutoTempo).toUpperCase();
    const tempoProducaoMin = parseTempoToMinutos(tempoProducaoCalculado);
    const itensLimpos = recalcularMetrosQuadradosTempoCorte(tempoCorteItens).map((it) => ({
      ...it,
      descricao: descricaoPecaSemCor(String(it.descricao || '')).toUpperCase(),
    }));
    const produto = {
      id: substituir ? (modalProdutoExistente.produto?.id ?? Date.now().toString()) : Date.now().toString(),
      nome: nomeLimpo,
      pontuacaoProduto,
      qtdProduto,
      pontosDiaTodo,
      tempoDiaTodo,
      porcentagem,
      itens: itensLimpos,
      tempoExato: tempoExatoSelecionadas,
      /** Tempo exato teórico (todas as peças). Na análise, se tempoExato vier 0, usa -tempoExatoPlano na conta. */
      tempoExatoPlano: tempoExato,
      tempoProducaoMinutos: tempoProducaoMin,
      lote: loteTempoCorte,
      dataHoraInicioExato,
      dataHoraTerminoExato,
      dataHoraInicioProducao,
      dataHoraTerminoProducao,
      horarioExtraManha,
      horarioExtraAlmoco,
      trabalhaSabado,
      trabalhaDomingo: false,
      compartilharTempoProducao: substituir ? (modalProdutoExistente.produto?.compartilharTempoProducao ?? true) : true,
      horarioProduto: substituir ? (modalProdutoExistente.produto?.horarioProduto ?? '') : '',
      enviarParaAnalise: substituir ? (modalProdutoExistente.produto?.enviarParaAnalise ?? false) : false,
      dataCriacao: new Date().toLocaleDateString('pt-BR'),
      dataCriacaoISO: new Date().toISOString()
    };
    setProdutosTempoCorteSalvos(prev => {
      const existente = prev.find(
        (p) =>
          ehMesmoNomeELote(p, nomeProdutoTempo, loteTempoCorte) ||
          ehMesmoNomeELote(p, nomeLimpo, loteTempoCorte)
      );
      liberarExclusaoCardTempoCorte(loteTempoCorte, nomeProdutoTempo, produto.id);
      liberarExclusaoCardTempoCorte(loteTempoCorte, nomeLimpo, produto.id);
      let base: typeof prev;
      if (substituir && existente) {
        base = prev.map(p => p.id === existente.id ? produto : p);
      } else if (!substituir && existente) {
        base = [...prev, produto];
      } else {
        base = [...prev, produto];
      }
      // Peças (medida/qtd/etc.) aplicam a todos os cards com o mesmo nome; checkbox só no mesmo lote.
      return sincronizarListaPecasProdutoEntreCards(
        base,
        nomeProdutoTempo,
        produto.itens || [],
        produto.id,
        loteTempoCorte
      ).map((card) => {
        if (
          !nomesProdutoIguais(String(card.nome || ''), nomeProdutoTempo) &&
          !nomesProdutoIguais(String(card.nome || ''), nomeLimpo)
        ) {
          return card;
        }
        if (String(card.id) === String(produto.id)) return card;
        const tempoExatoRecalc = calcularTempoExatoSelecionadasDeProdutoSalvoTc(card);
        return { ...card, tempoExato: tempoExatoRecalc };
      });
    });
    registrarAuditoria('gerar_produto_tempo_corte', `${nomeLimpo} | lote ${loteTempoCorte || '-'} | tempo ${formatarTempo(tempoExatoSelecionadas)}`);
    setNomeProdutoTempo(nomeLimpo);
    setTempoCorteItens(itensLimpos);
    setModalProdutoExistente({ aberto: false, produto: null });
    alert(`Produto "${nomeLimpo}" salvo com sucesso!`);
  };

  const gerarProdutoTempoCorte = () => {
    if (!nomeProdutoTempo.trim()) {
      alert('Por favor, preencha o nome do produto antes de gerar.');
      return;
    }
    const existente = produtosTempoCorteSalvos.find(
      (p) =>
        ehMesmoNomeELote(p, nomeProdutoTempo, loteTempoCorte) ||
        ehMesmoNomeELote(p, nomeProdutoSemCor(nomeProdutoTempo).toUpperCase(), loteTempoCorte)
    );
    if (existente) {
      setModalProdutoExistente({ aberto: true, produto: existente });
      return;
    }
    executarGerarProduto(false);
  };
  
  // Seleção para unificar cards de Produtos Salvos
  const [idsParaUnificar, setIdsParaUnificar] = useState<Set<string>>(new Set());

  const alternarSelecaoUnificar = (id: string) => {
    setIdsParaUnificar((prev) => {
      const nova = new Set(prev);
      if (nova.has(id)) nova.delete(id);
      else nova.add(id);
      return nova;
    });
  };

  /** Detecta se o card é "complemento MDF" — ou seja, uma chapa que faz parte
   *  do mesmo produto físico mas NÃO conta na soma de quantidade nem na
   *  pontuação total (só entra no tempo de produção e no tempo exato). */
  const produtoEhComplementoMDF = (nome: unknown): boolean => {
    const upper = String(nome || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
    return /\bMDF\b/.test(upper);
  };

  /** Modal de unificação. Quantidade e pontuação são SEMPRE somadas
   *  automaticamente, ignorando cards de complemento MDF.
   *  O usuário só escolhe o nome e como tratar o Tempo exato. */
  const [modalUnificar, setModalUnificar] = useState<{
    aberto: boolean;
    nome: string;
    modoTempoExato: 'somar' | 'recalcular';
  }>({
    aberto: false,
    nome: '',
    modoTempoExato: 'somar',
  });

  /** Abre o modal de unificação com defaults inteligentes (detecta qtds e
   *  pontuações iguais entre os cards selecionados para sugerir o modo certo). */
  const unificarProdutosSelecionados = () => {
    const selecionados = produtosTempoCorteSalvos.filter((p) => idsParaUnificar.has(p.id));
    if (selecionados.length < 2) {
      alert('Selecione pelo menos 2 produtos para unificar.');
      return;
    }
    const lotes = Array.from(
      new Set(selecionados.map((p) => String(p.lote || '').trim().toUpperCase()).filter(Boolean))
    );
    if (lotes.length > 1) {
      const ok = confirm(
        `Os produtos selecionados têm lotes diferentes (${lotes.join(', ')}).\n` +
          'Quer unificar mesmo assim?'
      );
      if (!ok) return;
    }
    const nomesParaSugerir = selecionados.map((p) => String(p.nome || ''));
    const nomeInteligente = gerarNomeUnificadoInteligente(nomesParaSugerir);
    const numerosUnificadosSet = new Set<number>();
    selecionados.forEach((p) => {
      numerosLoteDeTexto(String(p.lote || '')).forEach((n) =>
        numerosUnificadosSet.add(n)
      );
    });
    const numerosUnificados = Array.from(numerosUnificadosSet).sort((a, b) => a - b);
    const loteUnificado =
      numerosUnificados.length > 0
        ? numerosUnificados.join('/')
        : lotes[0] || '';
    const nomeSugerido =
      nomeInteligente ||
      (selecionados.length <= 3
        ? selecionados.map((p) => p.nome).join(' + ')
        : `UNIFICADO LOTE ${loteUnificado || '-'} (${selecionados.length} produtos)`);
    setModalUnificar({
      aberto: true,
      nome: nomeSugerido.toUpperCase(),
      modoTempoExato: 'somar',
    });
  };

  /** Cria o card unificado de fato, respeitando as escolhas feitas no modal. */
  const confirmarUnificacao = (removerOriginais: boolean) => {
    const selecionados = produtosTempoCorteSalvos.filter((p) => idsParaUnificar.has(p.id));
    if (selecionados.length < 2) {
      setModalUnificar((prev) => ({ ...prev, aberto: false }));
      return;
    }
    const numerosUnificadosSet = new Set<number>();
    selecionados.forEach((p) => {
      numerosLoteDeTexto(String(p.lote || '')).forEach((n) =>
        numerosUnificadosSet.add(n)
      );
    });
    const numerosUnificados = Array.from(numerosUnificadosSet).sort((a, b) => a - b);
    const lotes = Array.from(
      new Set(selecionados.map((p) => String(p.lote || '').trim().toUpperCase()).filter(Boolean))
    );
    const loteUnificado =
      numerosUnificados.length > 0
        ? numerosUnificados.join('/')
        : lotes[0] || '';
    const itensCombinados = selecionados.flatMap((p) =>
      (Array.isArray(p.itens) ? p.itens : []).map((it: any) => ({
        ...it,
        id:
          typeof crypto !== 'undefined' && 'randomUUID' in crypto
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        selecionado: it.selecionado !== false,
        produtoOrigem: String(p?.nome || '').trim().toUpperCase(),
      }))
    );
    const itensRenumerados = itensCombinados.map((it, i) => ({ ...it, numero: i + 1 }));
    const itensRecalculados = recalcularMetrosQuadradosTempoCorte(itensRenumerados as TempoCorteItem[]);
    const baseTempo = [...selecionados].sort((a, b) => {
      const da = Date.parse(a?.dataHoraTerminoProducao || a?.salvoEm || a?.dataCriacaoISO || '') || 0;
      const db = Date.parse(b?.dataHoraTerminoProducao || b?.salvoEm || b?.dataCriacaoISO || '') || 0;
      return db - da;
    })[0];
    const temposProducaoUnicos = new Set<number>();
    selecionados.forEach((p) => {
      const t = Number(p.tempoProducaoMinutos) || 0;
      if (t > 0) temposProducaoUnicos.add(t);
    });
    const tempoProducaoUnificado = Array.from(temposProducaoUnicos).reduce((s, t) => s + t, 0);

    // === QTD: SEMPRE somar, excluindo cards MDF (complementos não contam) ===
    const selecionadosNaoMDF = selecionados.filter(
      (p) => !produtoEhComplementoMDF(p?.nome)
    );
    const baseQtd =
      selecionadosNaoMDF.length > 0 ? selecionadosNaoMDF : selecionados;
    const qtdUnificada = baseQtd.reduce(
      (s, p) => s + (Number(p.qtdProduto) || 0),
      0
    );

    // === PONTUAÇÃO: SEMPRE média ponderada, ignorando cards MDF ===
    const somaPesoPts = baseQtd.reduce(
      (s, p) => s + (Number(p.pontuacaoProduto) || 0) * (Number(p.qtdProduto) || 0),
      0
    );
    const somaQtdParaPts = baseQtd.reduce(
      (s, p) => s + (Number(p.qtdProduto) || 0),
      0
    );
    const pontuacaoUnificada =
      somaQtdParaPts > 0 ? somaPesoPts / somaQtdParaPts : 0;

    // === TEMPO EXATO: somar ou recalcular ===
    let tempoExatoUnificado = 0;
    let tempoExatoPlanoUnificado = 0;
    if (modalUnificar.modoTempoExato === 'somar') {
      tempoExatoUnificado = selecionados.reduce(
        (s, p) => s + calcularTempoExatoSelecionadasDeProdutoSalvo(p),
        0
      );
      tempoExatoPlanoUnificado = selecionados.reduce(
        (s, p) => s + calcularTempoExatoPlanoDeProdutoSalvo(p),
        0
      );
    } else {
      // Recalcular usando pontos/tempo do dia do baseTempo (mais recente).
      const pontosDia = Number(baseTempo?.pontosDiaTodo) || 0;
      const tempoDia = Number(baseTempo?.tempoDiaTodo) || 0;
      if (pontuacaoUnificada > 0 && qtdUnificada > 0 && pontosDia > 0 && tempoDia > 0) {
        tempoExatoUnificado =
          (pontuacaoUnificada * qtdUnificada * tempoDia) / pontosDia;
        tempoExatoPlanoUnificado = tempoExatoUnificado;
      } else {
        tempoExatoUnificado = selecionados.reduce(
          (s, p) => s + calcularTempoExatoSelecionadasDeProdutoSalvo(p),
          0
        );
        tempoExatoPlanoUnificado = selecionados.reduce(
          (s, p) => s + calcularTempoExatoPlanoDeProdutoSalvo(p),
          0
        );
      }
    }

    const novoProduto = {
      ...baseTempo,
      id: Date.now().toString(),
      nome: modalUnificar.nome.trim().toUpperCase() || 'UNIFICADO',
      lote: loteUnificado || baseTempo?.lote || '',
      itens: itensRecalculados,
      tempoExato: tempoExatoUnificado,
      tempoExatoPlano: tempoExatoPlanoUnificado,
      tempoProducaoMinutos: tempoProducaoUnificado,
      pontuacaoProduto: pontuacaoUnificada,
      qtdProduto: qtdUnificada,
      compartilharTempoProducao: true,
      dataCriacao: new Date().toLocaleDateString('pt-BR'),
      dataCriacaoISO: new Date().toISOString(),
      eUnificado: true,
      unificacaoMigradaV293: true,
      loteCompostoMigradoV315: true,
      modoUnificacao: {
        qtd: 'somar-sem-mdf',
        pts: 'ponderada-sem-mdf',
        tempoExato: modalUnificar.modoTempoExato,
      },
      complementosMDF: selecionados
        .filter((p) => produtoEhComplementoMDF(p?.nome))
        .map((p) => p.nome),
      produtosOrigemCompleto: selecionados.map((p) => JSON.parse(JSON.stringify(p))),
      produtosOrigem: selecionados.map((p) => ({
        id: p.id,
        nome: p.nome,
        lote: p.lote,
        qtdItens: Array.isArray(p.itens) ? p.itens.length : 0,
      })),
    };
    setProdutosTempoCorteSalvos((prev) => {
      if (removerOriginais) {
        const removidos = prev.filter((p) => idsParaUnificar.has(p.id));
        registrarExclusoesCardsTempoCorte(removidos);
      }
      const base = removerOriginais
        ? prev.filter((p) => !idsParaUnificar.has(p.id))
        : prev;
      return [...base, novoProduto];
    });
    setIdsParaUnificar(new Set());
    const qtdComplementos = selecionados.length - baseQtd.length;
    registrarAuditoria(
      'unificar_produtos_tc',
      `${novoProduto.nome} | ${selecionados.length} produtos (${qtdComplementos} MDF complemento) | lote ${loteUnificado || '-'} | qtd ${qtdUnificada} | pts ${pontuacaoUnificada.toFixed(3)} | tempo prod ${formatarTempo(tempoProducaoUnificado)} | exato ${formatarTempo(tempoExatoUnificado)} | originais ${removerOriginais ? 'removidos' : 'mantidos'}`
    );
    setModalUnificar({
      aberto: false,
      nome: '',
      modoTempoExato: 'somar',
    });
  };

  /** Desagrupa um produto unificado: restaura os produtos originais como cards
   *  separados e remove o unificado. Só funciona se os dados originais foram
   *  preservados (eUnificado + produtosOrigemCompleto). */
  const desagruparProdutoUnificado = (produto: any) => {
    if (!produto?.eUnificado || !Array.isArray(produto.produtosOrigemCompleto) || produto.produtosOrigemCompleto.length === 0) {
      alert('Este produto não tem dados originais salvos para desagrupar.');
      return;
    }
    const qtd = produto.produtosOrigemCompleto.length;
    if (
      !confirm(
        `Desagrupar "${produto.nome}" e restaurar os ${qtd} produtos originais?\n` +
          'O card unificado será removido.'
      )
    ) {
      return;
    }
    setProdutosTempoCorteSalvos((prev) => {
      const semUnificado = prev.filter((p) => p.id !== produto.id);
      const idsExistentes = new Set(semUnificado.map((p: any) => p.id));
      const restaurados = produto.produtosOrigemCompleto.map((orig: any) => {
        if (idsExistentes.has(orig.id)) {
          // Se o original já existe (usuário não removeu), gera novo ID
          return { ...orig, id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}` };
        }
        return orig;
      });
      return [...semUnificado, ...restaurados];
    });
    registrarAuditoria('desagrupar_produtos_tc', `${produto.nome} | ${qtd} restaurados`);
    alert(`Produto desagrupado. ${qtd} produtos originais restaurados.`);
  };

  /** Busca um produto já salvo no Tempo de Corte com o mesmo nº de lote
   *  e copia os campos de tempo/horário (mantendo o produto e itens atuais). */
  const buscarTempoNoMesmoLote = () => {
    const lote = (loteTempoCorte || '').trim();
    if (!lote) {
      alert('Informe o nº do lote primeiro.');
      return;
    }
    const norm = (s: string) => String(s || '').trim().toUpperCase();
    const candidatos = produtosTempoCorteSalvos.filter(
      (p) => norm(p?.lote) === norm(lote)
    );
    if (candidatos.length === 0) {
      alert(`Nenhum produto salvo no lote ${lote} ainda.`);
      return;
    }
    candidatos.sort((a, b) => {
      const da = a?.dataHoraTerminoProducao ? Date.parse(a.dataHoraTerminoProducao) : 0;
      const db = b?.dataHoraTerminoProducao ? Date.parse(b.dataHoraTerminoProducao) : 0;
      return db - da;
    });
    const ref = candidatos[0];
    setPontosDiaTodo(Number(ref.pontosDiaTodo) || 0);
    setTempoDiaTodo(Number(ref.tempoDiaTodo) || 0);
    setPorcentagem(Number(ref.porcentagem) || 0);
    setDataHoraInicioExato(ref.dataHoraInicioExato ?? '');
    setDataHoraTerminoExato(ref.dataHoraTerminoExato ?? '');
    setDataHoraInicioProducao(ref.dataHoraInicioProducao ?? '');
    setDataHoraTerminoProducao(ref.dataHoraTerminoProducao ?? '');
    setHorarioExtraManha(Boolean(ref.horarioExtraManha));
    setHorarioExtraAlmoco(Boolean(ref.horarioExtraAlmoco));
    setTrabalhaSabado(Boolean(ref.trabalhaSabado));
    setTrabalhaDomingo(false);
    registrarAuditoria(
      'buscar_tempo_mesmo_lote',
      `Lote ${lote} | base: ${ref.nome || '-'} (${candidatos.length} produto(s) no lote)`
    );
    alert(
      `Tempo do lote ${lote} preenchido a partir de "${ref.nome || '-'}".\n` +
        `${candidatos.length} produto(s) salvo(s) neste lote.`
    );
  };

  const carregarProdutoTempoCorte = (produto: any) => {
    setNomeProdutoTempo(nomeProdutoSemCor(String(produto.nome || '')).toUpperCase());
    setPontuacaoProduto(produto.pontuacaoProduto);
    setQtdProduto(produto.qtdProduto);
    setPontosDiaTodo(produto.pontosDiaTodo);
    setTempoDiaTodo(produto.tempoDiaTodo);
    setPorcentagem(produto.porcentagem);
    const itensBrutos = recalcularMetrosQuadradosTempoCorte(
      (Array.isArray(produto.itens) ? produto.itens : []) as TempoCorteItem[]
    );
    // Ids únicos por linha — duplicatas com o mesmo id impediam apagar só uma.
    setTempoCorteItens(
      itensBrutos.map((item, i) => ({
        ...item,
        descricao: descricaoPecaSemCor(String(item.descricao || '')).toUpperCase(),
        numero: i + 1,
        id: `${String(produto.id || 'card')}-${i}-${Date.now().toString(36)}`,
        metrosQuadrados:
          Number.isFinite(Number(item.metrosQuadrados))
            ? Math.round(Number(item.metrosQuadrados) * 1e6) / 1e6
            : 0,
      }))
    );
    setLoteTempoCorte(produto.lote ?? '');
    setDataHoraInicioExato(produto.dataHoraInicioExato ?? '');
    setDataHoraTerminoExato(produto.dataHoraTerminoExato ?? '');
    setDataHoraInicioProducao(produto.dataHoraInicioProducao ?? '');
    setDataHoraTerminoProducao(produto.dataHoraTerminoProducao ?? '');
    setHorarioExtraManha(produto.horarioExtraManha ?? false);
    setHorarioExtraAlmoco(produto.horarioExtraAlmoco ?? false);
    setTrabalhaSabado(produto.trabalhaSabado ?? false);
    setTrabalhaDomingo(false);
  };
  
  const removerProdutoTempoCorteSalvo = (id: string) => {
    if (confirm('Deseja remover este produto salvo?')) {
      void (async () => {
        const removido = produtosTempoCorteSalvosRef.current.find((p) => p.id === id);
        if (removido) registrarExclusaoCardTempoCorte(removido);
        await flushExclusoesCardsTempoCorte();
        const next = filtrarCardsTempoCorteNaoExcluidos(
          produtosTempoCorteSalvosRef.current.filter((p) => p.id !== id)
        );
        ignorarSaveTempoCorteProdRef.current = true;
        setProdutosTempoCorteSalvos(next);
        await persistirProdutosTempoCorteDireto(next);
        notificarSyncDesktop('tempo-corte-produtos');
        registrarAuditoria('remover_produto_tempo_corte', `id ${id}`);
      })();
    }
  };

  /** Editor manual de um card salvo no Tempo de Corte. Útil para corrigir cards
   *  unificados antigos cuja migração automática não conseguiu reconstruir os
   *  valores certos (ex.: lote 8662 ARUBA+CAYMAN que ficou com pontos/tempo
   *  do dia errados). Permite ajustar pontuação, qtd, pontos do dia, tempo
   *  do dia, tempo exato e tempo de produção sem precisar refazer o card. */
  const [modalEditarProdutoSalvo, setModalEditarProdutoSalvo] = useState<{
    aberto: boolean;
    produtoId: string | null;
    pontuacaoProduto: string;
    qtdProduto: string;
    pontosDiaTodo: string;
    tempoDiaTodo: string;
    tempoExato: string;
    tempoProducaoMinutos: string;
  }>({
    aberto: false,
    produtoId: null,
    pontuacaoProduto: '',
    qtdProduto: '',
    pontosDiaTodo: '',
    tempoDiaTodo: '',
    tempoExato: '',
    tempoProducaoMinutos: '',
  });

  const abrirEditarProdutoSalvo = (produto: any) => {
    setModalEditarProdutoSalvo({
      aberto: true,
      produtoId: produto.id,
      pontuacaoProduto: String(Number(produto.pontuacaoProduto) || 0),
      qtdProduto: String(Number(produto.qtdProduto) || 0),
      pontosDiaTodo: String(Number(produto.pontosDiaTodo) || 0),
      tempoDiaTodo: String(Number(produto.tempoDiaTodo) || 0),
      tempoExato: String(Number(produto.tempoExato) || Number(produto.tempoExatoPlano) || 0),
      tempoProducaoMinutos: String(Number(produto.tempoProducaoMinutos) || 0),
    });
  };

  const salvarEdicaoProdutoSalvo = () => {
    const id = modalEditarProdutoSalvo.produtoId;
    if (!id) return;
    const pontuacao = Number(modalEditarProdutoSalvo.pontuacaoProduto) || 0;
    const qtd = Number(modalEditarProdutoSalvo.qtdProduto) || 0;
    const pontosDia = Number(modalEditarProdutoSalvo.pontosDiaTodo) || 0;
    const tempoDia = Number(modalEditarProdutoSalvo.tempoDiaTodo) || 0;
    const tempoExatoManual = Number(modalEditarProdutoSalvo.tempoExato) || 0;
    const tempoProd = Number(modalEditarProdutoSalvo.tempoProducaoMinutos) || 0;
    setProdutosTempoCorteSalvos((prev) =>
      prev.map((p) => {
        if (p.id !== id) return p;
        // Se o usuário deixou o tempo exato em 0 e pontos/tempo do dia válidos,
        // recalcula: tempoExato = (pontuacao × qtd × tempoDia) / pontosDia.
        let tempoExatoFinal = tempoExatoManual;
        if (tempoExatoFinal <= 0 && pontuacao > 0 && qtd > 0 && pontosDia > 0 && tempoDia > 0) {
          tempoExatoFinal = (pontuacao * qtd * tempoDia) / pontosDia;
        }
        return {
          ...p,
          pontuacaoProduto: pontuacao,
          qtdProduto: qtd,
          pontosDiaTodo: pontosDia,
          tempoDiaTodo: tempoDia,
          tempoExato: tempoExatoFinal,
          tempoExatoPlano: tempoExatoFinal,
          tempoProducaoMinutos: tempoProd,
          edicaoManualV322: true,
        };
      })
    );
    registrarAuditoria(
      'editar_produto_tempo_corte_manual',
      `id ${id} | pts ${pontuacao} × qtd ${qtd} | pontos dia ${pontosDia} | tempo dia ${tempoDia}min | exato ${tempoExatoManual}min | prod ${tempoProd}min`
    );
    setModalEditarProdutoSalvo({
      aberto: false,
      produtoId: null,
      pontuacaoProduto: '',
      qtdProduto: '',
      pontosDiaTodo: '',
      tempoDiaTodo: '',
      tempoExato: '',
      tempoProducaoMinutos: '',
    });
  };

  const parseNumeroFlex = (valor: unknown): number => {
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
    const texto = String(valor ?? '').trim();
    if (!texto) return 0;
    // Suporta "1.234,56", "1234.56" e variações com espaços.
    const normalizado = texto
      .replace(/\s+/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.');
    const n = Number(normalizado);
    return Number.isFinite(n) ? n : 0;
  };

  const calcularMetrosQuadradosPorMedidaQtd = (medida: string, qtd: number): number => {
    const partes = String(medida ?? '')
      .toLowerCase()
      .split(/[x×*]/)
      .map((p) => parseNumeroFlex(p))
      .filter((n) => n > 0);
    if (partes.length < 2 || qtd <= 0) return 0;
    const areaPeca = partes.reduce((acc, n) => acc * n, 1);
    return areaPeca * qtd;
  };

  const recalcularMetrosQuadradosTempoCorte = (itens: TempoCorteItem[]): TempoCorteItem[] =>
    (Array.isArray(itens) ? itens : []).map((item, index) => {
      const qtd = parseNumeroFlex(item?.qtd);
      const medida = String(item?.medida ?? '').trim();
      const m2Calculado = calcularMetrosQuadradosPorMedidaQtd(medida, qtd);
      const m2Atual = parseNumeroFlex(item?.metrosQuadrados);
      return {
        ...item,
        numero: index + 1,
        qtd,
        medida,
        metrosQuadrados: m2Calculado > 0 ? m2Calculado : m2Atual,
      };
    });

  /** Mesma fórmula da caixa "TOTAL TEMPO CADA PEÇA (selecionadas)" ao carregar um card. */
  const calcularTempoExatoSelecionadasDeProdutoSalvo = (produto: any): number =>
    calcularTempoExatoSelecionadasDeProdutoSalvoTc(produto);

  /** Tempo exato teórico (todas as peças), igual ao salvo em tempoExatoPlano ao gerar o card. */
  const calcularTempoExatoPlanoDeProdutoSalvo = (produto: any): number => {
    const pontuacaoProduto = Number(produto?.pontuacaoProduto) || 0;
    const qtdProduto = Number(produto?.qtdProduto) || 0;
    const pontosDiaTodo = Number(produto?.pontosDiaTodo) || 0;
    const tempoDiaTodo = Number(produto?.tempoDiaTodo) || 0;
    const pontuacaoRemessaProduzida =
      pontuacaoProduto > 0 ? pontosDiaTodo / pontuacaoProduto : 0;
    const x = tempoDiaTodo > 0 ? pontuacaoRemessaProduzida / tempoDiaTodo : 0;
    const tempoExato = x > 0 ? qtdProduto / x : 0;
    if (tempoExato > 0) return tempoExato;
    return Number(produto?.tempoExatoPlano) || Number(produto?.tempoExato) || 0;
  };

  const importarExcelTempoCorte = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const data = ev.target?.result;
        const wb = XLSX.read(data, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json<any[]>(ws, { header: 1, defval: '' });
        if (!json || !Array.isArray(json) || json.length < 2) { alert('Planilha vazia ou sem cabeçalho.'); return; }
        const row0 = json[0];
        if (!row0 || !Array.isArray(row0)) { alert('Cabeçalho inválido.'); return; }
        const header = row0.map((h: unknown) => String(h != null ? h : '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
        const safe = (s: string) => (typeof s === 'string' ? s : '');
        let descIdx = header.findIndex(h => safe(h).includes('descri') || safe(h) === 'descricao'); if (descIdx < 0) descIdx = 1;
        let qtdIdx = header.findIndex(h => safe(h) === 'qtd' || safe(h).includes('quant') || safe(h) === 'quantidade'); if (qtdIdx < 0) qtdIdx = 2;
        let medIdx = header.findIndex(h => safe(h).includes('medida')); if (medIdx < 0) medIdx = 3;
        let m2Idx = header.findIndex(h => safe(h).includes('metro') || safe(h).includes('m2') || safe(h).includes('m²')); if (m2Idx < 0) m2Idx = 4;
        let matIdx = header.findIndex(h => safe(h).includes('material')); if (matIdx < 0) matIdx = 5;
        const novos: TempoCorteItem[] = [];
        for (let i = 1; i < json.length; i++) {
          const row = json[i];
          if (!row || !Array.isArray(row)) continue;
          const desc = String(row[descIdx] != null ? row[descIdx] : '').trim();
          const qtd = parseNumeroFlex(row[qtdIdx]);
          const med = String(row[medIdx] != null ? row[medIdx] : '').trim();
          const m2Planilha = parseNumeroFlex(row[m2Idx]);
          const m2Calculado = calcularMetrosQuadradosPorMedidaQtd(med, qtd);
          const m2 = m2Calculado > 0 ? m2Calculado : m2Planilha;
          const mat = String(row[matIdx] != null ? row[matIdx] : '').trim().toUpperCase();
          if (!desc && !qtd && !med && !m2 && !mat) continue;
          novos.push({
            id: crypto.randomUUID(),
            numero: novos.length + 1,
            descricao: descricaoPecaSemCor(desc).toUpperCase(),
            qtd,
            medida: med,
            metrosQuadrados: m2,
            material: mat,
            selecionado: true
          });
        }
        const ordenados = [...novos].sort((a, b) => ordemMaterialSort(a.material, b.material));
        ordenados.forEach((item, i) => { item.numero = i + 1; });
        setTempoCorteItens(prev => [...prev, ...ordenados]);
        alert(`${ordenados.length} linhas importadas e ordenadas por material.`);
      } catch (err) {
        alert('Erro ao ler o arquivo Excel: ' + (err as Error).message);
      }
      e.target.value = '';
    };
    reader.readAsBinaryString(file);
  };
  
   const imprimirTempoCorte = () => {
    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Tempo de Corte - ${nomeProdutoSemCor(nomeProdutoTempo)}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Arial, sans-serif; padding: 10mm; background: #fff; }
    @page { size: A4 landscape; margin: 10mm; }
    .cabecalho { text-align: center; margin-bottom: 5mm; border-bottom: 2px solid #000; padding-bottom: 3mm; }
    .cabecalho h1 { font-size: 18pt; }
    .produto-nome { font-size: 14pt; font-weight: bold; margin-top: 2mm; }
    .caixas { display: flex; flex-wrap: wrap; gap: 2mm; margin-bottom: 5mm; justify-content: center; }
    .caixa { border: 1px solid #000; padding: 2mm; text-align: center; min-width: 38mm; }
    .caixa label { display: block; font-size: 7pt; font-weight: bold; text-transform: uppercase; margin-bottom: 1mm; }
    .caixa .valor { font-size: 11pt; font-weight: bold; }
    .caixa-destaque { background: #eee; border: 2px solid #000; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid #000; padding: 1.5mm; text-align: center; font-size: 9pt; }
    th { background: #ddd; font-weight: bold; }
    .cabecalho-produto td { background: #cdd6f3; font-size: 10pt; text-align: left !important; padding: 2mm 3mm; border-top: 2px solid #3a51a8; }
    .ocultar-impressao { display: none !important; }
    .rodape { margin-top: 5mm; display: flex; justify-content: flex-end; }
    .total-final { border: 2px solid #000; padding: 3mm; text-align: center; min-width: 70mm; }
    .total-final label { font-size: 9pt; font-weight: bold; display: block; }
    .total-final .valor { font-size: 16pt; font-weight: bold; }
  </style>
</head>
<body>
  <div class="cabecalho">
    <h1>RELATÓRIO: TEMPO DE CORTE</h1>
    <div class="produto-nome">PRODUTO: ${nomeProdutoSemCor(nomeProdutoTempo) || 'AVULSO'}</div>
  </div>
  <div class="caixas">
    <div class="caixa"><label>PONTOS PRODUTO</label><div class="valor">${pontuacaoProduto}</div></div>
    <div class="caixa"><label>QTD PRODUTO</label><div class="valor">${qtdProduto}</div></div>
    <div class="caixa"><label>PONTOS DIA TODO</label><div class="valor">${pontosDiaTodo}</div></div>
    <div class="caixa caixa-destaque"><label>TEMPO DIA TODO</label><div class="valor">${formatarTempo(tempoDiaTodo)}</div></div>
    <div class="caixa"><label>PORCENTAGEM</label><div class="valor">${porcentagem}%</div></div>
    <div class="caixa caixa-destaque"><label>TEMPO EXATO</label><div class="valor">${formatarTempo(tempoExatoSelecionadas)}</div></div>
  </div>
  <table>
    <thead>
      <tr>
        <th>Nº</th>
        <th>DESCRIçãO</th>
        <th>QTD</th>
        <th>MEDIDA</th>
        <th>M²</th>
        <th>MATERIAL</th>
        <th>TEMPO ESTIMADO</th>
      </tr>
    </thead>
    <tbody>
      ${tempoCorteItens.map((item, idx) => {
        const percPeca =
          totalMetrosQuadradosAll > 0 && porcentagem > 0
            ? ((item.metrosQuadrados || 0) * porcentagem) / totalMetrosQuadradosAll
            : 0;
        const tempoItem = porcentagem > 0 ? (tempoExato * percPeca) / porcentagem : 0;
        const origemAtual = (item.produtoOrigem || '').trim();
        const origemAnterior = idx > 0 ? (tempoCorteItens[idx - 1]?.produtoOrigem || '').trim() : '';
        const cabecalho = origemAtual && origemAtual !== origemAnterior
          ? `<tr class="cabecalho-produto"><td colspan="7"><strong>${origemAtual}</strong></td></tr>`
          : '';
        return `
          ${cabecalho}
          <tr class="${item.selecionado ? '' : 'ocultar-impressao'}">
            <td>${item.numero}</td>
            <td>${descricaoPecaSemCor(item.descricao || '-') || '-'}</td>
            <td>${item.qtd}</td>
            <td>${item.medida}</td>
            <td>${item.metrosQuadrados.toFixed(4)}</td>
            <td>${item.material || 'NÒO INFORMADO'}</td>
            <td>${formatarTempo(tempoItem)}</td>
          </tr>
        `;
      }).join('')}
    </tbody>
  </table>
  <div class="rodape">
    <div class="total-final">
      <label>TEMPO TOTAL POR CADA PEÇA (selecionadas)</label>
      <div class="valor">${formatarTempo(tempoExatoSelecionadas)}</div>
    </div>
  </div>
</body>
</html>`;

    const win = window.open('', '_blank');
    if (win) {
      win.document.write(html);
      win.document.close();
      win.print();
    }
  };
  
  const toggleSobraMarcado = (id: string) => {
    setSobraMarcados(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const imprimirRelatorio = () => {
    const itensParaImprimir = relatorioItens.filter(i => !sobraMarcados.has(i.id) && !i.ocultoRelatorio);
    const itensParaSobra = relatorioItens.filter(i => sobraMarcados.has(i.id));

    if (itensParaImprimir.length === 0 && itensParaSobra.length === 0) {
      alert('Não há linhas para imprimir. Reexiba alguma linha oculta ou adicione itens ao relatório.');
      return;
    }

    if (itensParaSobra.length > 0) {
      const entrada: SobraEntradaADE = {
        id: Date.now().toString(),
        dataAdicao: new Date().toISOString(),
        pastaId: null,
        cabecalho: { ...relatorioCabecalho },
        itens: itensParaSobra
      };
      setSobraItens((prev) => {
        const next = [...prev, entrada];
        void gravarSobraEntradasMescladas(next).catch(() => {
          if (!erroPersistenciaSobraRef.current) {
            erroPersistenciaSobraRef.current = true;
            alert(
              'As peças foram para Sobra na tela, mas não foi possível gravar no armazenamento local. Abra a aba Sobra e use "Recuperar do backup" se precisar.'
            );
          }
        });
        return next;
      });
      setRelatorioItens(prev => {
        const novos = prev.filter(i => !sobraMarcados.has(i.id));
        novos.forEach((item, i) => { item.corteNumero = i + 1; });
        return novos;
      });
      setSobraMarcados(new Set());
    }

    if (itensParaImprimir.length === 0) {
      alert('As linhas marcadas foram enviadas para Sobra. Nenhuma linha visível ficou para impressão.');
      return;
    }

    const itensNoPrint = itensParaImprimir;
    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Relatório de Peças Produzidas</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Arial, sans-serif; padding: 10mm; }
    
    @page { size: A4 landscape; margin: 10mm; }
    
    .cabecalho { text-align: center; margin-bottom: 5mm; }
    .cabecalho h1 { font-size: 17pt; margin-bottom: 2mm; }
    .cabecalho .info { display: flex; justify-content: space-between; font-size: 13pt; }
    .cabecalho .info div { border: 1px solid #000; padding: 2mm 5mm; text-align: left; }
    .cabecalho .info .produto { flex: 2; margin: 0 3mm; }
    .cabecalho .info .lote, .cabecalho .info .tempo { flex: 1; }
    .cabecalho .info strong { margin-right: 3mm; }
    
    table { width: 100%; border-collapse: collapse; margin-top: 3mm; }
    th, td { border: 1px solid #000; padding: 2mm; text-align: center; font-size: 12pt; }
    th { background: #e2e8f0; font-weight: bold; text-transform: uppercase; }
    .col-manual { background: #f9f9f9; min-width: 20mm; }
    .material { min-width: 30mm; text-transform: uppercase; }
    
    .rodape { margin-top: 5mm; display: flex; justify-content: space-between; font-size: 12pt; }
  </style>
</head>
<body>
  <div class="cabecalho">
    <h1>RELATÓRIO DE PEÇAS PRODUZIDAS</h1>
    <div class="info">
      <div class="lote"><strong>LOTE</strong> ${relatorioCabecalho.lote || '____________'}</div>
      <div class="produto"><strong>PRODUTO</strong> ${relatorioCabecalho.nomeProduto || '____________'}</div>
      <div class="tempo"><strong>TEMPO</strong> ${relatorioCabecalho.tempo || '____________'}</div>
    </div>
    <div class="info" style="margin-top: 3mm;">
      <div class="lote"><strong>DATA DE INÍCIO</strong> ${relatorioCabecalho.dataInicio || '____/____/______'}</div>
      <div class="lote"><strong>DATA DE TéRMINO</strong> ${relatorioCabecalho.dataTermino || '____/____/______'}</div>
    </div>
  </div>
  
  <table>
    <thead>
      <tr>
        <th style="width: 12mm;">CORTE</th>
        <th style="width: 35mm;">PEÇA</th>
        <th style="width: 15mm;">QTD</th>
        <th style="width: 25mm;">MEDIDA</th>
        <th class="material">MATERIAL</th>
        <th class="col-manual">INÍCIO</th>
        <th class="col-manual">TéRMINO</th>
        <th class="col-manual">TEMPO POR PEÇA</th>
      </tr>
    </thead>
    <tbody>
      ${itensNoPrint.map(item => `
        <tr>
          <td>${item.corteNumero}º</td>
          <td>${item.nomePeca || '-'}</td>
          <td>${item.quantidade}</td>
          <td>${item.medidaMenor}×${item.medidaMaior}</td>
          <td class="material">${item.material === 'mdf' ? 'MDF' : 'AGLO'} - ${item.espessura}MM</td>
          <td class="col-manual">${item.inicio || ''}</td>
          <td class="col-manual">${item.termino || ''}</td>
          <td class="col-manual">${item.tempoPorPecaMinutos != null && !Number.isNaN(item.tempoPorPecaMinutos) ? formatarTempo(item.tempoPorPecaMinutos) : ''}</td>
        </tr>
      `).join('')}
    </tbody>
  </table>
  
  <div class="rodape">
    <span>Data: ${new Date().toLocaleDateString('pt-BR')}</span>
  </div>
</body>
</html>`;
    
    const win = window.open('', '_blank');
    if (win) {
      win.document.write(html);
      win.document.close();
      win.focus();
      setTimeout(() => win.print(), 300);
    }
  };
  
  const [novaPeca, setNovaPeca] = useState({ codigo: 3 as EixoCodigo, medida: 0, quantidade: 1 });
  const [novoItemProducao, setNovoItemProducao] = useState({ medidaLongitudinal: 0, medidaTransversal: 0, quantidadeNecessaria: 1 });
  const [rotacaoFolha, setRotacaoFolha] = useState(0);
  const [erroLancamentoPeca, setErroLancamentoPeca] = useState('');
  const [pecaEditandoId, setPecaEditandoId] = useState<string | null>(null);
  const [editMedida, setEditMedida] = useState(0);
  const [editQuantidade, setEditQuantidade] = useState(1);
  
  const girarFolha = () => setRotacaoFolha((prev) => (prev + 90) % 360);
  
  const resultado = calcularConsumo();
  const { chapas: chapasNecessarias } = calcularChapasNecessarias();
  const inconsistenciasImpressao = useMemo(() => {
    const criticas: string[] = [];
    if (!projeto.nomeProduto.trim()) criticas.push('Nome do produto não foi preenchido.');
    if (!projeto.nomePeca.trim()) criticas.push('Nome da peça não foi preenchido.');
    if (pecas.length === 0) criticas.push('Não há peças lançadas para imprimir.');
    if ((Number(layoutConfig.quantidadeChapas) || 0) <= 0) criticas.push('Quantidade de chapas deve ser maior que zero.');
    if ((Number(configuracao.larguraTotal) || 0) <= 0 || (Number(configuracao.comprimentoTotal) || 0) <= 0) {
      criticas.push('Dimensões da chapa inválidas.');
    }
    if (resultado.grupos.some((g: any) => Number(g?.larguraDisponivel) < 0 || Number(g?.comprimentoDisponivel) < 0)) {
      criticas.push('Há grupo com consumo acima da capacidade da chapa.');
    }
    return criticas;
  }, [projeto.nomeProduto, projeto.nomePeca, pecas.length, layoutConfig.quantidadeChapas, configuracao.larguraTotal, configuracao.comprimentoTotal, resultado.grupos]);
  const handleAdicionar = () => {
    if (!(novaPeca.medida > 0 && novaPeca.quantidade > 0)) return;

    const grupoAlvo = novaPeca.codigo === 3 ? crypto.randomUUID() : (pecas[pecas.length - 1]?.grupoId ?? '');
    const simuladas: PecaCorte[] = [
      ...pecas,
      {
        id: 'simulacao',
        grupoId: grupoAlvo,
        codigo: novaPeca.codigo,
        medida: Number(novaPeca.medida) || 0,
        quantidade: Number(novaPeca.quantidade) || 1,
      },
    ];

    const erro = validarPecasContraChapa(simuladas, configuracao);
    if (erro) {
      setErroLancamentoPeca(erro);
      return;
    }

    setErroLancamentoPeca('');
    adicionarPeca(novaPeca);
    setProjetoFoiSalvo(false);
    setNovaPeca({ codigo: 3, medida: 0, quantidade: 1 });
  };

  const iniciarEdicaoPeca = (peca: PecaCorte) => {
    setPecaEditandoId(peca.id);
    setEditMedida(peca.medida);
    setEditQuantidade(peca.quantidade);
    setErroLancamentoPeca('');
  };

  const cancelarEdicaoPeca = () => {
    setPecaEditandoId(null);
    setErroLancamentoPeca('');
  };

  const confirmarEdicaoPeca = () => {
    if (!pecaEditandoId || !(editMedida > 0 && editQuantidade > 0)) return;
    const simuladas = pecas.map((p) =>
      p.id === pecaEditandoId ? { ...p, medida: editMedida, quantidade: editQuantidade } : p
    );
    const erro = validarPecasContraChapa(simuladas, configuracao);
    if (erro) {
      setErroLancamentoPeca(erro);
      return;
    }
    setErroLancamentoPeca('');
    atualizarPeca(pecaEditandoId, { medida: editMedida, quantidade: editQuantidade });
    setProjetoFoiSalvo(false);
    setPecaEditandoId(null);
  };
  const handleAdicionarProducao = () => { if (novoItemProducao.medidaLongitudinal > 0 && novoItemProducao.medidaTransversal > 0 && novoItemProducao.quantidadeNecessaria > 0) { adicionarItemProducao({ ...novoItemProducao, nome: '', pecaSalvaId: '' }); setNovoItemProducao({ medidaLongitudinal: 0, medidaTransversal: 0, quantidadeNecessaria: 1 }); } };
  const handleSalvarProjeto = () => {
    if (pecas.length === 0 || !projeto.nomeProduto) return;
    salvarProjeto();
    setProjetoFoiSalvo(true);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => { if (e.key === 'Enter') handleAdicionar(); };
  const resetLayout = () => setLayoutConfig(LAYOUT_PADRAO);
  
  // Reset completo do projeto
  const resetProjeto = () => {
    const temConteudo = pecas.length > 0 || projeto.nomeProduto.trim() || projeto.nomePeca.trim();
    const msg = !projetoFoiSalvo && temConteudo 
      ? 'Seu projeto ainda não foi salvo. Tem certeza que deseja apagá-lo?' 
      : 'Tem certeza que deseja resetar todo o projeto? Esta ação não pode ser desfeita.';
    if (!confirm(msg)) return;
      // Limpar peças
      pecas.forEach(p => removerPeca(p.id));
      // Limpar produção
      limparProducao();
      // Resetar projeto
      setProjeto({ nomeProduto: '', nomePeca: '' });
      // Resetar layout
      setLayoutConfig(LAYOUT_PADRAO);
      // Resetar rotação
      setRotacaoFolha(0);
      setProjetoFoiSalvo(true);
  };
  
  // Carregar do histórico
  const carregarDoHistorico = (item: HistoricoImpressao) => {
    if (isJanelaFilha && moduloFixo !== 'projeto') {
      enviarCarregarHistoricoParaJanelaProjeto(item);
      navegarParaAba('projeto');
      return;
    }
    aplicarHistoricoNoProjeto(item);
    navegarParaAba('projeto');
  };
  
  // Deletar item do histórico
  const deletarDoHistorico = (id: string) => {
    setHistoricoImpressoes(prev => prev.filter(h => h.id !== id));
  };
  
    // Função de impressão - LAYOUT FIXO E PRECISO
  const imprimir = () => {
    if (inconsistenciasImpressao.length > 0) {
      alert(`Impressão bloqueada por inconsistências:\n- ${inconsistenciasImpressao.join('\n- ')}`);
      return;
    }

    const blocosSequenciais = (pecasGrupo: any[]) => {
      const out: Array<{ longMed: number; longQtd: number; transMed: number; transQtd: number; codigoTrans: number; subLongCortes?: Array<{ med: number; qtd: number; inicio: number }> }> = [];
      let longMed = 0;
      let longQtd = 1;
      let transRefMed = 0;
      let transRefQtd = 1;
      let restanteLong5 = 0;
      (pecasGrupo || []).forEach((p: any) => {
        if (p.codigo === 3) {
          longMed = Number(p.medida) || 0;
          longQtd = Math.max(1, Number(p.quantidade) || 1);
          return;
        }
        if (p.codigo === 4 || p.codigo === 44) {
          if (longMed <= 0) return;
          const blocoBase = {
            longMed,
            longQtd,
            transMed: Number(p.medida) || 0,
            transQtd: Math.max(1, Number(p.quantidade) || 1),
            codigoTrans: p.codigo,
          };
          out.push(blocoBase);
          transRefMed = blocoBase.transMed;
          transRefQtd = blocoBase.transQtd;
          restanteLong5 = longMed;
          return;
        }
        if (p.codigo === 5) {
          if (out.length === 0 || transRefMed <= 0) return;
          const last = out[out.length - 1];
          if (!last) return;
          const baseLong = restanteLong5 > 0 ? restanteLong5 : longMed;
          if (baseLong <= 0) return;
          const qtd5 = Math.max(1, Number(p.quantidade) || 1);
          const corteInformado = Number(p.medida) || baseLong;
          const corteEfetivo = Math.min(corteInformado, baseLong);
          const inicio = Math.max(0, longMed - baseLong);
          if (!last.subLongCortes) last.subLongCortes = [];
          last.subLongCortes.push({ med: corteEfetivo, qtd: qtd5, inicio });
          restanteLong5 = Math.max(0, baseLong - (corteEfetivo + serra) * qtd5);
        }
      });
      return out;
    };

    const agruparEmTiras = (blocos: Array<{ longMed: number; longQtd: number; transMed: number; transQtd: number; codigoTrans: number; subLongCortes?: Array<{ med: number; qtd: number; inicio: number }> }>) => {
      const tiras: Array<{ longMed: number; longQtd: number; transversais: Array<{ med: number; qtd: number; codigo: number; subLongCortes?: Array<{ med: number; qtd: number; inicio: number }> }> }> = [];
      blocos.forEach((b) => {
        const last = tiras[tiras.length - 1];
        const podeMesclar =
          !!last &&
          last.longMed === b.longMed &&
          last.longQtd === b.longQtd;
        const transEntry: { med: number; qtd: number; codigo: number; subLongCortes?: Array<{ med: number; qtd: number; inicio: number }> } = {
          med: b.transMed,
          qtd: b.transQtd,
          codigo: b.subLongCortes && b.subLongCortes.length > 0 ? 5 : b.codigoTrans,
          ...(b.subLongCortes && b.subLongCortes.length > 0 ? { subLongCortes: b.subLongCortes } : {}),
        };
        if (podeMesclar) {
          last.transversais.push(transEntry);
        } else {
          tiras.push({
            longMed: b.longMed,
            longQtd: b.longQtd,
            transversais: [transEntry],
          });
        }
      });
      return tiras;
    };

    const serra = Number(configuracao?.espessuraSerra) || 4;

    // Calcular peças visuais (mesma lógica que VisualizacaoCorte)
    const pecasVisuais: { x: number; y: number; width: number; height: number; medidaTrans: number; medidaLong: number; codigo: number }[] = [];
    let offsetXGlobal = 0;
    
    resultado.grupos.forEach(grupo => {
      const blocos = blocosSequenciais(grupo.pecas);
      const tiras = agruparEmTiras(blocos);
      if (tiras.length === 0) return;
      let offsetXGrupo = offsetXGlobal;
      
      tiras.forEach((tira) => {
        for (let l = 0; l < tira.longQtd; l++) {
          let offsetY = 0;
          tira.transversais.forEach((tr) => {
            if (tr.subLongCortes && tr.subLongCortes.length > 0) {
              for (let t = 0; t < tr.qtd; t++) {
                tr.subLongCortes.forEach((corte) => {
                  for (let sub = 0; sub < corte.qtd; sub++) {
                    pecasVisuais.push({
                      x: offsetXGrupo + corte.inicio + sub * (corte.med + serra),
                      y: offsetY,
                      width: corte.med,
                      height: tr.med,
                      medidaTrans: tr.med,
                      medidaLong: corte.med,
                      codigo: 5
                    });
                  }
                });
                offsetY += tr.med + serra;
              }
            } else {
              for (let t = 0; t < tr.qtd; t++) {
                pecasVisuais.push({
                  x: offsetXGrupo,
                  y: offsetY,
                  width: tira.longMed,
                  height: tr.med,
                  medidaTrans: tr.med,
                  medidaLong: tira.longMed,
                  codigo: tr.codigo
                });
                offsetY += tr.med + serra;
              }
            }
          });
          offsetXGrupo += tira.longMed + serra;
        }
      });
      offsetXGlobal = offsetXGrupo;
    });
    
    const todasPecas = resultado.grupos.flatMap(g => g.pecas);
    
    // AGRUPAR PEÇAS POR MEDIDA (normalizado: menor x maior)
    const pecasAgrupadas = new Map<string, { menor: number; maior: number; total: number }>();
    
    pecasVisuais.forEach(p => {
      const menor = Math.min(p.medidaTrans, p.medidaLong);
      const maior = Math.max(p.medidaTrans, p.medidaLong);
      const chave = `${menor}x${maior}`;
      
      if (pecasAgrupadas.has(chave)) {
        pecasAgrupadas.get(chave)!.total += 1;
      } else {
        pecasAgrupadas.set(chave, { menor, maior, total: 1 });
      }
    });
    
    // Converter para array e ordenar
    const listaPecasAgrupadas = Array.from(pecasAgrupadas.entries()).map(([chave, dados]) => ({
      chave,
      ...dados,
      totalGeral: dados.total * layoutConfig.quantidadeChapas
    }));
    
    // Dimensões para A4 paisagem = 297mm x 210mm
    // Área útil: 260mm x 180mm
    
    const margem = 30; // mm (3cm)
    const deslocamentoDireita = 15; // mm (1.5cm) - mover desenho e info para direita
    const recuoInfoDireita = 15; // mm (1.5cm) - recuar informações da direita para esquerda
    const desenhoW = 190; // mm
    const infoW = 60; // mm (6cm)
    const cabecalhoH = 25; // mm (aumentado para fonte maior)
    const obsH = 20; // mm (2cm)
    
    // Fontes do layoutConfig (em percentual)
    const fonteDesenho = layoutConfig.fontSize || 100;
    const fonteInfo = Math.max(100, layoutConfig.fontSizeInfo || 100);
    const fonteObs = layoutConfig.obsFontSize || 100;
    
    // Calcular escala para o desenho caber (180mm - 25mm cabeçalho - 20mm obs - 5mm margens = 130mm)
    const desenhoH = 130; // mm
    const scale = Math.min(desenhoW / configuracao.comprimentoTotal, desenhoH / configuracao.larguraTotal);
    
    // Gerar SVG com texto seguindo a linha maior e fonte editável
    const svgRects = pecasVisuais.map(p => {
      const fill = p.codigo === 3 ? '#bbf7d0' : p.codigo === 5 ? '#e9d5ff' : '#bfdbfe';
      const stroke = p.codigo === 3 ? '#22c55e' : p.codigo === 5 ? '#9333ea' : '#3b82f6';
      
      // Desenho deitado: trocar x/y
      const drawX = p.y * scale;
      const drawY = p.x * scale;
      const drawW = Math.max(p.height * scale, 1);
      const drawH = Math.max(p.width * scale, 1);
      
      // Texto segue a linha maior da peça
      const isHorizontal = drawW >= drawH;
      const baseFontSize = Math.max(5, Math.min(Math.min(drawW, drawH) / 4, 8));
      const fontSize = baseFontSize * (fonteDesenho / 100); // aplica percentual
      const texto = `${p.medidaTrans}×${p.medidaLong}`;
      
      if (isHorizontal) {
        // Texto horizontal (segue a largura)
        return `<rect x="${drawX}" y="${drawY}" width="${drawW}" height="${drawH}" fill="${fill}" stroke="${stroke}" stroke-width="0.5"/>
<text x="${drawX + drawW/2}" y="${drawY + drawH/2}" text-anchor="middle" dominant-baseline="middle" font-family="Arial" font-size="${fontSize}" font-weight="bold" fill="#333">${texto}</text>`;
      } else {
        // Texto vertical (segue a altura) - rotacionar -90 graus
        return `<rect x="${drawX}" y="${drawY}" width="${drawW}" height="${drawH}" fill="${fill}" stroke="${stroke}" stroke-width="0.5"/>
<text x="${drawX + drawW/2}" y="${drawY + drawH/2}" text-anchor="middle" dominant-baseline="middle" font-family="Arial" font-size="${fontSize}" font-weight="bold" fill="#333" transform="rotate(-90 ${drawX + drawW/2} ${drawY + drawH/2})">${texto}</text>`;
      }
    }).join('\n');
    
    const svgWidth = configuracao.comprimentoTotal * scale;
    const svgHeight = configuracao.larguraTotal * scale;

    const escapeHtmlPrint = (s: string) =>
      String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '<br/>');

    const caixasTextoImpressao = layoutConfig.caixasTexto ?? [];
    const caixasTextoHtml = caixasTextoImpressao
      .map((c) => {
        const lay = layoutCaixaTextoImpressao(c, svgWidth, svgHeight);
        const ws = lay.nowrap ? 'nowrap' : 'pre-wrap';
        return `<div class="caixa-texto-plano" style="left:${lay.x}mm;top:${lay.y}mm;width:${lay.width}mm;min-height:${lay.height}mm;height:auto;font-size:${lay.fontMm.toFixed(2)}mm;padding:${lay.padMm}mm;white-space:${ws};">${escapeHtmlPrint(lay.texto)}</div>`;
      })
      .join('\n');
    
    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Plano de Corte</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { 
      font-family: Arial, sans-serif; 
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
    }
    
    @page { size: A4 landscape; margin: ${margem}mm; }
    
    .pagina { 
      width: 260mm; 
      height: 180mm;
      display: flex;
      flex-direction: column;
    }
    
    .cabecalho {
      border-bottom: 2px solid #334155;
      padding-bottom: 2mm;
      margin-bottom: 2mm;
    }
    .cabecalho h1 { font-size: 16pt; }
    .cabecalho p { font-size: 11pt; margin: 0.5mm 0; }
    .cabecalho .info-direita { margin-left: -${recuoInfoDireita}mm; }
    
    .conteudo {
      display: flex;
      gap: 4mm;
      margin-left: ${deslocamentoDireita}mm;
    }
    
    .desenho {
      width: ${desenhoW}mm;
      height: ${desenhoH}mm;
      background: #fef9c3;
      border: 1px solid #94a3b8;
      overflow: hidden;
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .desenho-placa {
      position: relative;
      width: ${svgWidth}mm;
      height: ${svgHeight}mm;
      flex-shrink: 0;
    }
    .desenho-placa svg {
      display: block;
      width: 100%;
      height: 100%;
    }
    .caixa-texto-plano {
      position: absolute;
      z-index: 2;
      box-sizing: border-box;
      overflow: visible;
      background: #ffffff;
      border: 0.4mm solid #64748b;
      border-radius: 0.5mm;
      line-height: 1.25;
      word-break: break-word;
      writing-mode: horizontal-tb;
      direction: ltr;
      font-family: Arial, sans-serif;
      color: #111;
      display: block;
      text-align: center;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    
    .informacoes {
      width: ${infoW}mm;
      border: 1px solid #000;
      padding: 2mm;
    }
    .informacoes h4 { font-size: ${12 * fonteInfo / 100}pt; border-bottom: 1px solid #ccc; padding-bottom: 1mm; margin-bottom: 1mm; }
    .informacoes table { width: 100%; border-collapse: collapse; font-size: ${10 * fonteInfo / 100}pt; }
    .informacoes th, .informacoes td { border: 1px solid #000; padding: 0.5mm; text-align: center; }
    .informacoes th { background: #e2e8f0; }
    .informacoes .total { font-size: ${10 * fonteInfo / 100}pt; margin-top: 2mm; }
    .informacoes .total p { margin: 0.3mm 0; font-size: ${10 * fonteInfo / 100}pt; }
    
    .observacoes {
      margin-top: 2mm;
      height: ${obsH}mm;
      background: #fef3c7;
      border: 1px solid #f59e0b;
      padding: 1.5mm;
      overflow: hidden;
    }
    .observacoes h5 { font-size: ${9 * fonteObs / 100}pt; margin-bottom: 0.5mm; }
    .observacoes p { font-size: ${8 * fonteObs / 100}pt; }
    
    .code-3 { background: #bbf7d0; }
    .code-4 { background: #bfdbfe; }
  </style>
</head>
<body>
  <div class="pagina">
    <div class="cabecalho">
      <div style="display: flex; justify-content: space-between;">
        <div>
          <h1>Planos de Corte Ade</h1>
          <p><strong>Peça:</strong> ${projeto.nomePeca || '-'}</p>
          <p><strong>Produto:</strong> ${projeto.nomeProduto || '-'}</p>
        </div>
        <div style="text-align: center;">
          <p style="font-size: 14pt; font-weight: bold;">Plano: ${layoutConfig.plano || 1}</p>
          <p style="font-size: 14pt; font-weight: bold;">Etapa: ${layoutConfig.etapas || 1}</p>
        </div>
        <div class="info-direita" style="text-align: right;">
          <p><strong>Chapa:</strong> ${configuracao.larguraTotal} × ${configuracao.comprimentoTotal} mm</p>
          <p><strong>Material:</strong> ${layoutConfig.tipoMaterial === 'mdf' ? 'MDF' : 'Aglomerado'} ${layoutConfig.espessuraMaterial}mm</p>
          <p><strong>Qtd Chapas:</strong> ${layoutConfig.quantidadeChapas} | <strong>Serra:</strong> ${configuracao.espessuraSerra}mm</p>
          <p><strong>Data:</strong> ${new Date().toLocaleDateString('pt-BR')}</p>
        </div>
      </div>
    </div>
    
    <div class="conteudo">
      <div class="desenho">
        <div class="desenho-placa">
          <svg width="${svgWidth}mm" height="${svgHeight}mm" viewBox="0 0 ${svgWidth} ${svgHeight}">
            ${svgRects}
          </svg>
          ${caixasTextoHtml}
        </div>
      </div>
      <div class="informacoes">
        <h4>Lista de Peças</h4>
        <table>
          <thead><tr><th>Cód</th><th>Medida</th><th>Qtd</th></tr></thead>
          <tbody>
            ${todasPecas.filter(p => p.codigo !== 5).map(p => `<tr><td class="${p.codigo === 3 ? 'code-3' : 'code-4'}">${p.codigo}</td><td>${p.medida}</td><td>${p.quantidade}</td></tr>`).join('')}
          </tbody>
        </table>
        <div class="total">
          <p style="font-weight: bold; border-bottom: 1px solid #ccc; padding-bottom: 0.5mm; margin-bottom: 0.5mm;">Total por Peça (${layoutConfig.quantidadeChapas} chapas):</p>
          ${listaPecasAgrupadas.map(p => `<p>${p.menor}×${p.maior}: <strong>${p.totalGeral}</strong> peças</p>`).join('')}
        </div>
      </div>
    </div>
    
    ${layoutConfig.observacoes ? `<div class="observacoes"><h5>Observações:</h5><p>${layoutConfig.observacoes}</p></div>` : ''}
  </div>
</body>
</html>`;
    
    const largura = Number(configuracao?.larguraTotal) || 2200;
    const comprimento = Number(configuracao?.comprimentoTotal) || 2750;
    const qtdChapas = layoutConfig.quantidadeChapas || 1;
    const rotuloMaterial = `${layoutConfig.tipoMaterial} ${layoutConfig.espessuraMaterial}mm`;

    // ============================================================
    // DETECTOR DE PLANO REPETIDO (últimos 2 dias)
    // Compara medidas+qtds+material+espessura+chapa contra o histórico recente.
    // Se achar plano >= 90% parecido, oferece SUBSTITUIR (não desconta de novo).
    // ============================================================
    let planoParaSubstituirId: string | null = null;
    {
      const assinaturaAtual = gerarAssinaturaPlano(layoutConfig, configuracao, pecas);
      const limiteMs = 2 * 24 * 60 * 60 * 1000; // 2 dias em ms
      const agoraMs = Date.now();
      const candidatos = historicoImpressoes
        .map((h) => {
          const dataMs = h.dataHora ? new Date(h.dataHora).getTime() : 0;
          if (!dataMs || agoraMs - dataMs > limiteMs) return null;
          const assinaturaHist = gerarAssinaturaPlano(
            h.layoutConfig,
            h.configuracao,
            h.pecas as any[]
          );
          const similaridade = compararAssinaturasPlano(assinaturaAtual, assinaturaHist);
          return { hist: h, similaridade, dataMs };
        })
        .filter((x): x is { hist: HistoricoImpressao; similaridade: number; dataMs: number } =>
          x !== null && x.similaridade >= 90
        )
        .sort((a, b) => b.similaridade - a.similaridade || b.dataMs - a.dataMs);

      if (candidatos.length > 0) {
        const melhor = candidatos[0].hist;
        const sim = candidatos[0].similaridade;
        const dataFmt = new Date(melhor.dataHora).toLocaleString('pt-BR', {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit',
        });
        const produtoAntes = `${melhor.projeto?.nomeProduto || '-'} ${
          melhor.projeto?.nomePeca ? `/ ${melhor.projeto.nomePeca}` : ''
        }`.trim();
        const produtoAgora = `${projeto.nomeProduto || '-'} ${
          projeto.nomePeca ? `/ ${projeto.nomePeca}` : ''
        }`.trim();
        const msg =
          `⚠️ PLANO PARECIDO DETECTADO (${sim}% igual)\n\n` +
          `Já foi impresso em ${dataFmt}:\n` +
          `   • ${produtoAntes}\n` +
          `   • ${melhor.layoutConfig?.quantidadeChapas || 0} chapa(s) ${rotuloMaterial} ${melhor.configuracao?.larguraTotal}×${melhor.configuracao?.comprimentoTotal}mm\n\n` +
          `Agora você está imprimindo:\n` +
          `   • ${produtoAgora}\n` +
          `   • ${qtdChapas} chapa(s) ${rotuloMaterial} ${largura}×${comprimento}mm\n\n` +
          `OK     = SUBSTITUIR o antigo\n` +
          `CANCEL = Salvar como NOVO\n\n` +
          `Use SUBSTITUIR quando errou o primeiro plano e refez. ` +
          `Se for produção nova com mesmas medidas, escolha NOVO.`;
        if (confirm(msg)) {
          planoParaSubstituirId = melhor.id;
          registrarAuditoria(
            'plano_repetido_substituido',
            `Substituiu plano ${melhor.id} (${sim}% sim.).`
          );
        } else {
          registrarAuditoria(
            'plano_repetido_ignorado',
            `Usuário escolheu NOVO mesmo após detectar ${sim}% sim. com plano ${melhor.id}.`
          );
        }
      }
    }

    const win = window.open('', '_blank');
    if (win) {
      win.document.write(html);
      win.document.close();
      win.focus();
      setTimeout(() => win.print(), 300);
    }

    registrarAuditoria('imprimir_plano_corte', `${projeto.nomeProduto || '-'} | ${projeto.nomePeca || '-'} | chapas: ${qtdChapas}`);

    const novoHistorico: HistoricoImpressao = {
      id: Date.now().toString(),
      data: new Date().toLocaleDateString('pt-BR'),
      dataHora: new Date().toISOString(),
      projeto: { ...projeto },
      configuracao: { ...configuracao },
      layoutConfig: { ...layoutConfig },
      pecas: [...pecas],
      grupos: [...resultado.grupos]
    };
    
    // Se o detector de plano repetido marcou um plano para substituir, removê-lo do histórico
    // antes de inserir o novo (não precisa perguntar de novo — usuário já confirmou no detector).
    if (planoParaSubstituirId) {
      setHistoricoImpressoes(prev => [novoHistorico, ...prev.filter(h => h.id !== planoParaSubstituirId)]);
    } else {
      // Histórico: perguntar se já existir impressão com mesmo nomeProduto e nomePeca
      const existenteHistorico = historicoImpressoes.find(h =>
        (h.projeto.nomeProduto || '').trim().toLowerCase() === (projeto.nomeProduto || '').trim().toLowerCase() &&
        (h.projeto.nomePeca || '').trim().toLowerCase() === (projeto.nomePeca || '').trim().toLowerCase()
      );
      if (existenteHistorico) {
        if (!confirm('Já existe uma impressão no histórico com este Nome do Produto e Nome da Peça. Deseja substituir?')) return;
        setHistoricoImpressoes(prev => [novoHistorico, ...prev.filter(h => h.id !== existenteHistorico.id)]);
      } else {
        setHistoricoImpressoes(prev => [novoHistorico, ...prev]);
      }
    }
    
    adicionarAoRelatorio(novoHistorico);
    notificarSyncDesktop('historico-impressoes');
  };

  const cartaoNavAtivo = (id: AbaPrincipal) => {
    const ativo = nwDisponivel()
      ? isJanelaFilha
        ? moduloFixo === id
        : id === 'projeto'
      : abaVisivel === id;
    return ativo
      ? 'border-[#009b3a] bg-[#e8e8ed] shadow-neu ring-2 ring-[#009b3a]/35'
      : 'border border-neutral-300/80 bg-[#ebebf0] shadow-[6px_6px_14px_#c5c6ca,-6px_-6px_14px_#ffffff] hover:border-[#009b3a]/40';
  };

  const tabBarRapida: { id: AbaPrincipal; icon: typeof Save; label: string }[] = [
    { id: 'projeto', icon: Save, label: 'Projeto' },
    { id: 'relatorio', icon: FileText, label: 'Relatório' },
    { id: 'tempoCorte', icon: Clock, label: 'Tempo' },
    { id: 'catalogo', icon: Database, label: 'Catálogo' },
    { id: 'historico', icon: History, label: 'Histórico' },
    { id: 'sobra', icon: Package, label: 'Sobra' },
    { id: 'analiseTempo', icon: BarChart3, label: 'Análise' },
    { id: 'boletimPontuacao', icon: ClipboardList, label: 'Boletim' },
  ];

  return (
  <div className="ade-app-shell flex h-screen flex-col overflow-hidden relative font-sans text-black">
    <header className="print:hidden shrink-0 z-30 px-3 pt-3 sm:px-4">
      <div className="ade-glass-panel mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-[#009b3a]/35 bg-[#ebebf0] shadow-neu-in">
            <Calculator className="h-6 w-6 text-[#009b3a]" />
          </div>
          <div className="min-w-0">
            <h1 className="truncate text-base font-bold tracking-tight text-black">Sistema Ade</h1>
            <p className="text-[10px] uppercase tracking-widest text-neutral-600">
              {isJanelaFilha ? ABA_LABELS[abaVisivel] : 'Planos de corte — Projeto'}
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setMenuNavegacaoExpandido(!menuNavegacaoExpandido)}
          className="ade-glass flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold text-black hover:brightness-[1.02]"
        >
          <LayoutGrid className="h-4 w-4 text-[#009b3a]" />
          <span className="hidden sm:inline">{menuNavegacaoExpandido ? 'Ocultar módulos' : 'Módulos'}</span>
        </button>
      </div>
    </header>

    {menuNavegacaoExpandido && (
      <div className="print:hidden shrink-0 px-3 pb-2 sm:px-4">
        <div className="ade-glass-panel mx-auto max-h-[min(40vh,340px)] max-w-7xl overflow-y-auto p-4 custom-scrollbar">
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
            <div className="space-y-2">
              <p className="text-[10px] font-bold uppercase tracking-wider text-[#1F4E78]">Painel</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'instrucoes' as const, icon: BookOpen, label: 'Instruções' },
                ].map((aba) => (
                  <button
                    key={aba.id}
                    type="button"
                    onClick={() => navegarParaAba(aba.id)}
                    className={`flex flex-col gap-1 rounded-2xl border p-3 text-left transition ${cartaoNavAtivo(aba.id)}`}
                  >
                    <aba.icon className="h-4 w-4 text-[#1F4E78]" />
                    <span className="text-[11px] font-semibold leading-tight text-black">{aba.label}</span>
                  </button>
                ))}
              </div>
            </div>
            <div className="space-y-2">
              <p className="text-[10px] font-bold uppercase tracking-wider text-[#009b3a]">Plano de corte</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'projeto' as const, icon: Save, label: 'Projeto' },
                  { id: 'catalogo' as const, icon: Database, label: 'Catálogo' },
                  { id: 'historico' as const, icon: History, label: 'Histórico' },
                  { id: 'relatorio' as const, icon: FileText, label: 'Relatório' },
                  { id: 'sobra' as const, icon: Package, label: 'Sobra' },
                  { id: 'produtoPorPalete' as const, icon: Layers, label: 'Prod. palete' },
                ].map((aba) => (
                  <button
                    key={aba.id}
                    type="button"
                    onClick={() => navegarParaAba(aba.id)}
                    className={`flex flex-col gap-1 rounded-2xl border p-3 text-left transition ${cartaoNavAtivo(aba.id)}`}
                  >
                    <aba.icon className="h-4 w-4 text-[#009b3a]" />
                    <span className="text-[11px] font-semibold leading-tight text-black">{aba.label}</span>
                  </button>
                ))}
              </div>
            </div>
            <div className="space-y-2">
              <p className="text-[10px] font-bold uppercase tracking-wider text-[#009b3a]">Tempo de produção</p>
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                {[
                  { id: 'tempoCorte' as const, icon: Clock, label: 'TC exato pontuação' },
                  { id: 'tempoProducaoPeca' as const, icon: Clock, label: 'Tempo corte por peça' },
                  { id: 'lotes' as const, icon: Layers, label: 'Lotes' },
                  { id: 'analiseTempo' as const, icon: BarChart3, label: 'Análise tempo' },
                  { id: 'adiantamentoMdf' as const, icon: ListChecks, label: 'Adiantamento MDF' },
                ].map((aba) => (
                  <button
                    key={aba.id}
                    type="button"
                    onClick={() => navegarParaAba(aba.id)}
                    className={`flex flex-col gap-1 rounded-2xl border p-3 text-left transition ${cartaoNavAtivo(aba.id)}`}
                  >
                    <aba.icon className="h-4 w-4 text-[#009b3a]" />
                    <span className="text-[11px] font-semibold leading-tight text-black">{aba.label}</span>
                  </button>
                ))}
              </div>
            </div>
            <div className="space-y-2">
              <p className="text-[10px] font-bold uppercase tracking-wider text-[#009b3a]">Boletim</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'boletimPontuacao' as const, icon: ClipboardList, label: 'Pontuação' },
                  { id: 'tempoEmbalar' as const, icon: Clock, label: 'Tempo embalagem' },
                  { id: 'boletimCalculadora' as const, icon: Calculator, label: 'Calculadora' },
                  { id: 'boletimLinhaFabrica' as const, icon: Box, label: 'Linha pintura' },
                  { id: 'boletimTabelaDias' as const, icon: Table, label: 'Tabela dias' },
                  { id: 'boletimResumoDias' as const, icon: Calendar, label: 'Resumo dias' },
                  { id: 'boletimGrafico' as const, icon: TrendingUp, label: 'Gráfico' },
                ].map((aba) => (
                  <button
                    key={aba.id}
                    type="button"
                    onClick={() => navegarParaAba(aba.id)}
                    className={`flex flex-col gap-1 rounded-2xl border p-3 text-left transition ${cartaoNavAtivo(aba.id)}`}
                  >
                    <aba.icon className="h-4 w-4 text-[#009b3a]" />
                    <span className="text-[11px] font-semibold leading-tight text-black">{aba.label}</span>
                  </button>
                ))}
              </div>
            </div>
            <div className="space-y-2">
              <p className="text-[10px] font-bold uppercase tracking-wider text-amber-700">Entretenimento</p>
              <div className="grid grid-cols-1 gap-2">
                {[
                  { id: 'resultadosCopa' as const, icon: Trophy, label: 'Resultados da Copa' },
                ].map((aba) => (
                  <button
                    key={aba.id}
                    type="button"
                    onClick={() => navegarParaAba(aba.id)}
                    className={`flex flex-col gap-1 rounded-2xl border p-3 text-left transition ${cartaoNavAtivo(aba.id)}`}
                  >
                    <aba.icon className="h-4 w-4 text-amber-700" />
                    <span className="text-[11px] font-semibold leading-tight text-black">{aba.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
          <p className="mt-3 text-center text-[9px] text-neutral-500">YOUWARE v1.0</p>
        </div>
      </div>
    )}

    <main
      ref={mainScrollAreaRef}
      className="ade-app-shell flex-1 overflow-auto px-3 pb-28 pt-2 sm:px-4 md:pb-32"
    >
      <div className="ade-main-content mx-auto max-w-6xl rounded-[2rem] p-5 md:p-10">
        {abaVisivel === 'instrucoes' && (
          <InstrucoesSection onIrParaAba={(id) => navegarParaAba(id as AbaPrincipal)} />
        )}

        {/* --- ABA PROJETO --- */}
        {abaVisivel === 'projeto' && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-black mb-2">Nome do Produto *</label>
                <input type="text" value={projeto.nomeProduto} onChange={(e) => { setProjeto({ nomeProduto: e.target.value }); setProjetoFoiSalvo(false); }} placeholder="Ex: Cômoda 6 Gavetas" className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 focus:ring-2 focus:ring-[#009b3a]/45" />
              </div>
              <div>
                <label className="block text-sm font-medium text-black mb-2">Nome da Peça</label>
                <input type="text" value={projeto.nomePeca} onChange={(e) => { setProjeto({ nomePeca: e.target.value }); setProjetoFoiSalvo(false); }} placeholder="Ex: Frente de Gaveta" className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 focus:ring-2 focus:ring-[#009b3a]/45" />
              </div>
            </div>
            <div className="flex gap-2 mb-6">
              <button onClick={handleSalvarProjeto} disabled={pecas.length === 0 || !projeto.nomeProduto} className="ade-btn-gold relative z-10 flex flex-1 items-center justify-center gap-2 rounded-xl px-6 py-3 font-semibold disabled:opacity-40"><Save className="w-5 h-5" />Salvar Projeto no Catálogo</button>
              <button onClick={resetProjeto} className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2"><RotateCcw className="w-5 h-5" />Resetar Projeto</button>
            </div>
            {/* Configurações (ex-aba Configuração) */}
            <div className="p-4 bg-[#eef0f4] rounded-xl border border-[#009b3a]/15 space-y-4">
              <h4 className="font-semibold text-black flex items-center gap-2"><Calculator className="w-4 h-4" />Configurações da Chapa</h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div><label className="block text-sm font-medium text-neutral-700 mb-1">Largura Total (mm)</label><input type="number" value={configuracao.larguraTotal} onChange={(e) => { const n = Number(e.target.value); if (!Number.isFinite(n) || n <= 0) return; setConfiguracao({ larguraTotal: n }); setProjetoFoiSalvo(false); }} className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 text-lg font-semibold text-center" /></div>
                <div><label className="block text-sm font-medium text-neutral-700 mb-1">Comprimento Total (mm)</label><input type="number" value={configuracao.comprimentoTotal} onChange={(e) => { const n = Number(e.target.value); if (!Number.isFinite(n) || n <= 0) return; setConfiguracao({ comprimentoTotal: n }); setProjetoFoiSalvo(false); }} className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 text-lg font-semibold text-center" /></div>
                <div><label className="block text-sm font-medium text-neutral-700 mb-1">Espessura da Serra (mm)</label><input type="number" value={configuracao.espessuraSerra} onChange={(e) => { const n = Number(e.target.value); if (!Number.isFinite(n) || n < 0) return; setConfiguracao({ espessuraSerra: n }); setProjetoFoiSalvo(false); }} className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 text-lg font-semibold text-center" /></div>
              </div>
              <div className="ade-neu-card-sm grid grid-cols-1 gap-4 rounded-lg p-3 md:grid-cols-3">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-black mb-1">Observações (impressão)</label>
                  <textarea
                    value={layoutConfig.observacoes}
                    onChange={(e) => setLayoutConfig({ ...layoutConfig, observacoes: e.target.value })}
                    placeholder="Digite observações que serão impressas no plano de corte..."
                    className="w-full px-2 py-1.5 text-xs border border-[#009b3a]/22 rounded h-16 resize-vertical"
                  />
                </div>
                <div className="space-y-1">
                  <label className="block text-xs text-neutral-700">Posição X (mm)</label>
                  <input
                    type="number"
                    value={layoutConfig.obsX}
                    onChange={(e) => setLayoutConfig({ ...layoutConfig, obsX: Number(e.target.value) })}
                    className="w-full px-2 py-1 text-xs border rounded"
                  />
                  <label className="block text-xs text-neutral-700 mt-1">Posição Y (mm)</label>
                  <input
                    type="number"
                    value={layoutConfig.obsY}
                    onChange={(e) => setLayoutConfig({ ...layoutConfig, obsY: Number(e.target.value) })}
                    className="w-full px-2 py-1 text-xs border rounded"
                  />
                  <label className="block text-xs text-neutral-700 mt-1">Largura (mm)</label>
                  <input
                    type="number"
                    value={layoutConfig.obsLargura}
                    onChange={(e) => setLayoutConfig({ ...layoutConfig, obsLargura: Number(e.target.value) })}
                    className="w-full px-2 py-1 text-xs border rounded"
                  />
                  <label className="block text-xs text-neutral-700 mt-1">Fonte Obs (%)</label>
                  <input
                    type="number"
                    value={layoutConfig.obsFontSize}
                    onChange={(e) => setLayoutConfig({ ...layoutConfig, obsFontSize: Number(e.target.value) })}
                    className="w-full px-2 py-1 text-xs border rounded"
                  />
                  <label className="block text-xs text-neutral-700 mt-1">
                    Fonte lista de peças (%)<span className="block text-[10px] text-neutral-600">Afeta apenas a lista impressa</span>
                  </label>
                  <input
                    type="number"
                    min={50}
                    max={200}
                    value={layoutConfig.fontSizeInfo}
                    onChange={(e) =>
                      setLayoutConfig({
                        ...layoutConfig,
                        fontSizeInfo: Math.max(100, Number(e.target.value) || 100),
                      })
                    }
                    className="w-full px-2 py-1 text-xs border rounded"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-3 bg-[#f0faf3] rounded-lg border border-[#009b3a]/22 mb-4">
                <div><label className="block text-sm font-medium text-[#009b3a] mb-1">Plano (1-100)</label>
                  <select value={layoutConfig.plano} onChange={(e) => setLayoutConfig({...layoutConfig, plano: Number(e.target.value)})} className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/28 text-lg font-semibold text-center bg-[#fafbfc]">
                    {Array.from({length: 100}, (_, i) => i + 1).map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
                <div><label className="block text-sm font-medium text-[#009b3a] mb-1">Etapas (1-10)</label>
                  <select value={layoutConfig.etapas} onChange={(e) => setLayoutConfig({...layoutConfig, etapas: Number(e.target.value)})} className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/28 text-lg font-semibold text-center bg-[#fafbfc]">
                    {Array.from({length: 10}, (_, i) => i + 1).map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-3 bg-rose-50 rounded-lg border border-rose-200">
                <div><label className="block text-sm font-medium text-rose-700 mb-1">Quantidade de Chapas</label>
                  <input type="number" value={layoutConfig.quantidadeChapas} onChange={(e) => setLayoutConfig({...layoutConfig, quantidadeChapas: Math.max(1, Number(e.target.value))})} min={1} className="w-full px-4 py-3 rounded-xl border border-rose-300 text-lg font-semibold text-center text-rose-800 bg-[#fafbfc]" />
                </div>
                <div><label className="block text-sm font-medium text-rose-700 mb-1">Tipo de Material</label>
                  <select value={layoutConfig.tipoMaterial} onChange={(e) => setLayoutConfig({...layoutConfig, tipoMaterial: e.target.value as 'aglomerado' | 'mdf'})} className="w-full px-4 py-3 rounded-xl border border-rose-300 text-lg font-semibold text-center text-rose-800 bg-[#fafbfc]">
                    <option value="aglomerado">Aglomerado</option>
                    <option value="mdf">MDF</option>
                  </select>
                </div>
                <div><label className="block text-sm font-medium text-rose-700 mb-1">Espessura (mm)</label>
                  <select value={layoutConfig.espessuraMaterial} onChange={(e) => setLayoutConfig({...layoutConfig, espessuraMaterial: Number(e.target.value)})} className="w-full px-4 py-3 rounded-xl border border-rose-300 text-lg font-semibold text-center text-rose-800 bg-[#fafbfc]">
                    <option value={6}>6mm</option>
                    <option value={9}>9mm</option>
                    <option value={12}>12mm</option>
                    <option value={15}>15mm</option>
                    <option value={18}>18mm</option>
                    <option value={25}>25mm</option>
                    <option value={30}>30mm</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}

            
            {abaVisivel === 'catalogo' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-black flex items-center gap-2"><FolderOpen className="w-5 h-5" />Projetos Salvos ({projetosSalvos.length})</h3>
                {projetosSalvos.length === 0 ? (
                  <div className="text-center py-8 space-y-3">
                    <p className="text-neutral-600">Nenhum projeto salvo ainda.</p>
                    <button
                      type="button"
                      className="px-4 py-2 rounded-lg bg-[#009b3a] text-white text-sm font-semibold hover:bg-[#007a2e]"
                      onClick={() => {
                        void recuperarCatalogoEmergencia().then((n) => {
                          if (n > 0) alert(`Restaurados ${n} projetos do backup.`);
                          else alert('Nenhum backup encontrado nesta versão do app.');
                        });
                      }}
                    >
                      Restaurar projetos do backup
                    </button>
                  </div>
                ) : (
                  (() => {
                    const pastaDe = (nomeProduto: string) => {
                      const base = (nomeProduto || '').trim().replace(/\s+\d+(?:[.,]\d+)?$/, '').trim();
                      return base || nomeProduto || 'Outros';
                    };
                    const porPasta = new Map<string, typeof projetosSalvos>();
                    projetosSalvos.forEach(proj => {
                      const pasta = pastaDe(proj.nomeProduto);
                      if (!porPasta.has(pasta)) porPasta.set(pasta, []);
                      porPasta.get(pasta)!.push(proj);
                    });
                    let pastas = Array.from(porPasta.entries()).sort((a, b) => a[0].localeCompare(b[0]));
                    const f = (filtroCatalogoPasta || '').trim().toLowerCase();
                    if (f) pastas = pastas.filter(([pasta]) => pasta.toLowerCase().includes(f));
                    return (
                      <div className="space-y-4">
                        <div className="flex items-center gap-2">
                          <label className="text-sm font-medium text-neutral-700">Buscar pasta:</label>
                          <input type="text" value={filtroCatalogoPasta} onChange={(e) => setFiltroCatalogoPasta(e.target.value)} placeholder="Ex: NICHO ASPEN" className="flex-1 max-w-xs px-3 py-2 rounded-lg border border-[#009b3a]/22 focus:ring-2 focus:ring-[#009b3a]/45" />
                          <button
                            type="button"
                            onClick={() => {
                              const abertas: Record<string, boolean> = {};
                              pastas.forEach(([nome]) => { abertas[nome] = true; });
                              setPastasCatalogoAbertas(abertas);
                            }}
                            className="px-3 py-2 text-xs rounded-lg bg-[#dde0e6] hover:bg-[#cfd3dc] text-black font-medium"
                          >
                            Expandir tudo
                          </button>
                          <button
                            type="button"
                            onClick={() => setPastasCatalogoAbertas({})}
                            className="px-3 py-2 text-xs rounded-lg bg-[#dde0e6] hover:bg-[#cfd3dc] text-black font-medium"
                          >
                            Recolher tudo
                          </button>
                        </div>
                        {pastas.map(([pasta, projs]) => (
                          <div key={pasta} className="border-2 border-[#009b3a]/15 rounded-xl overflow-visible">
                            <button
                              type="button"
                              onClick={() =>
                                setPastasCatalogoAbertas((prev) => ({ ...prev, [pasta]: !(prev[pasta] ?? false) }))
                              }
                              className="w-full bg-[#e4e6ec] px-4 py-2 font-semibold text-black flex items-center justify-between gap-2 hover:bg-[#dde0e6]"
                            >
                              <span className="flex items-center gap-2">
                                <FolderOpen className="w-4 h-4" />{pasta} ({projs.length})
                              </span>
                              {(pastasCatalogoAbertas[pasta] ?? false) ? (
                                <ChevronDown className="w-4 h-4" />
                              ) : (
                                <ChevronRight className="w-4 h-4" />
                              )}
                            </button>
                            {(pastasCatalogoAbertas[pasta] ?? false) && (
                              <div className="p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                {projs.map((proj) => (
                                  <CatalogoProjetoCard
                                    key={proj.id}
                                    projeto={proj}
                                    onCarregar={() => {
                                      if (isJanelaFilha) {
                                        enviarCarregarProjetoParaJanelaPrincipal(proj.id);
                                        navegarParaAba('projeto');
                                      } else {
                                        carregarProjetoNoEditor(proj.id);
                                        setProjetoFoiSalvo(true);
                                        navegarParaAba('projeto');
                                      }
                                    }}
                                    onRemover={() => removerProjetoSalvo(proj.id)}
                                  />
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    );
                  })()
                )}
              </div>
            )}
            
            {abaVisivel === 'tempoCorte' && (
              <div className="space-y-6">
                <h3 className="font-semibold text-black flex items-center gap-2"><Clock className="w-5 h-5" />Tempo de Corte Exato por Pontuação</h3>

                {lotesComPendenciasCards.length > 0 && (
                  <div className="rounded-xl border-2 border-indigo-300 bg-indigo-50/95 p-4 space-y-3 shadow-sm">
                    <div className="flex flex-wrap items-start justify-between gap-3">
                      <div className="min-w-0 flex-1">
                        <h4 className="font-semibold text-indigo-950 flex items-center gap-2 text-sm">
                          <Layers className="w-4 h-4 shrink-0" />
                          Lotes incompletos no Tempo de Corte ({pendenciasCardsTempoCorte.length} produto
                          {pendenciasCardsTempoCorte.length !== 1 ? 's' : ''} faltando)
                        </h4>
                        <p className="text-xs text-indigo-900 mt-1.5 leading-relaxed max-w-3xl">
                          Produtos do <strong>cadastro de Lotes</strong> sem card aparecem aqui.
                          Use o botão <strong>Criar cards faltantes</strong> só quando quiser gerar —{' '}
                          <strong>nada é recriado sozinho</strong> (cards que você apagou ficam
                          apagados). Um card por produto, com o mesmo nome (ex.: PAINEL LUMI 1.8, 2.18
                          e 2.8 são três cards). O botão copia peças de um card idêntico em outro lote.
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={criarTodosCardsTempoCorteFaltantes}
                        className="shrink-0 px-3 py-2 rounded-lg border border-indigo-500 bg-indigo-600 text-white text-xs font-semibold hover:bg-indigo-700 flex items-center gap-1.5"
                      >
                        <Layers className="w-3.5 h-3.5" />
                        Criar cards faltantes
                      </button>
                    </div>
                    <div className="max-h-72 overflow-y-auto space-y-2 pr-1">
                      {lotesComPendenciasCards.map((grupo) => (
                        <div
                          key={grupo.lote}
                          className="rounded-lg border border-indigo-200/90 bg-white p-2.5"
                        >
                          <div className="font-bold text-indigo-950 text-xs mb-2">
                            Lote {grupo.lote}
                          </div>
                          <ul className="space-y-1 text-[11px]">
                            {grupo.cadastro.map((row) => {
                              const pend = grupo.faltam.find(
                                (f) =>
                                  chaveNomeProdutoTempoCorte(f.produtoNome) ===
                                  chaveNomeProdutoTempoCorte(row.produtoNome)
                              );
                              return (
                                <li
                                  key={`${grupo.lote}-${row.produtoNome}`}
                                  className={`flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded px-1.5 py-1 ${
                                    row.temCard ? 'text-emerald-900 bg-emerald-50' : 'text-rose-900 bg-rose-50'
                                  }`}
                                >
                                  <span className="font-semibold w-4">{row.temCard ? '✓' : '✗'}</span>
                                  <span className="font-medium flex-1 min-w-[140px]">{row.produtoNome}</span>
                                  {row.qtd > 0 && (
                                    <span className="text-neutral-600">qtd {row.qtd}</span>
                                  )}
                                  {!row.temCard && pend?.motivo === 'pronto_para_criar' && (
                                    <span className="text-indigo-700">
                                      → copiar de lote {pend.templateLote} ({pend.templateNome})
                                    </span>
                                  )}
                                  {!row.temCard && pend?.motivo === 'sem_template' && (
                                    <span className="text-amber-800 font-medium">
                                      sem modelo — crie 1 card manual deste produto
                                    </span>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => setMostrarMetaOperador((v) => !v)}
                    className="px-3 py-1.5 rounded-lg bg-[#dde0e6] hover:bg-[#cfd3dc] text-black text-xs font-semibold"
                  >
                    {mostrarMetaOperador ? 'Ocultar meta/operador' : 'Mostrar meta/operador'}
                  </button>
                </div>

                <div className="bg-[#fafbfc] border border-[#009b3a]/15 rounded-xl p-4">
                  <h4 className="font-semibold text-black mb-1">Finalizar lote antigo (sem tempo de produção)</h4>
                  <p className="text-xs text-neutral-700 mb-3">
                    Use quando o lote já saiu mas você não tem dado de tempo: ele deixa de entrar no débito da previsão e aparece como &quot;Finalizado (manual)&quot; no painel.
                    <strong className="block mt-1 text-amber-800">Esta lista guarda só o número do lote — não substitui o cadastro na aba Lotes (produto, qtd, datas).</strong>
                  </p>
                  <div className="flex flex-wrap gap-2 items-end">
                    <div className="flex-1 min-w-[180px]">
                      <label className="block text-xs font-medium text-neutral-700 mb-1">Número do lote</label>
                      <input
                        type="text"
                        value={loteParaFinalizarManual}
                        onChange={(e) => setLoteParaFinalizarManual(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && marcarLoteFinalizadoManual()}
                        className="w-full px-2 py-1.5 rounded border border-[#009b3a]/22 text-sm"
                        placeholder="Ex.: 12345"
                      />
                    </div>
                    <button
                      type="button"
                      onClick={marcarLoteFinalizadoManual}
                      className="px-4 py-2 ade-btn-gold relative z-10 text-sm font-semibold rounded-lg"
                    >
                      Marcar finalizado
                    </button>
                  </div>
                  {lotesFinalizadosManual.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-2">
                      {lotesFinalizadosManual.map((l) => (
                        <span
                          key={l}
                          className="inline-flex items-center gap-1 pl-2 pr-1 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-medium"
                        >
                          {l}
                          <button
                            type="button"
                            onClick={() => removerLoteFinalizadoManual(l)}
                            className="rounded-full p-0.5 hover:bg-emerald-200 text-emerald-900 leading-none"
                            title="Desfazer"
                          >
                            —
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {mostrarMetaOperador && (
                <div className="bg-[#eef0f4] border border-[#009b3a]/15 rounded-xl p-4 space-y-3">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-neutral-700 mb-1">Operador</label>
                      <input
                        type="text"
                        value={nomeOperadorTempo}
                        onChange={(e) => setNomeOperadorTempo(e.target.value.toUpperCase())}
                        className="w-full px-2 py-1.5 rounded border border-[#009b3a]/22 text-sm uppercase"
                        placeholder="Nome do operador"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-neutral-700 mb-1">Meta de adiantamento (min)</label>
                      <input
                        type="number"
                        min={60}
                        value={metaAdiantoMinutos}
                        onChange={(e) => setMetaAdiantoMinutos(Math.max(60, Number(e.target.value) || 288))}
                        className="w-full px-2 py-1.5 rounded border border-[#009b3a]/22 text-sm"
                      />
                    </div>
                    <div className="bg-[#e8f5ec] rounded-lg p-2">
                      <p className="text-[11px] text-[#009b3a]">Meta diária ({nomeOperadorTempo || 'operador'})</p>
                      <p className="text-lg font-bold text-black">{resumoOperacaoTempo.progressoMeta.toFixed(1)}%</p>
                      <p className="text-[11px] text-[#009b3a]">Falta: {formatarTempo(resumoOperacaoTempo.faltaParaMetaMin)}</p>
                    </div>
                    <div className="bg-rose-100 rounded-lg p-2">
                      <p className="text-[11px] text-rose-700">Atraso líquido</p>
                      <p className="text-lg font-bold text-rose-900">{formatarTempo(resumoOperacaoTempo.saldoAtrasoPosCreditoMin)}</p>
                      <p className="text-[11px] text-rose-700">Crédito adiantado: {formatarTempo(resumoOperacaoTempo.creditoAdiantadoMin)}</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                      <p className="text-xs text-amber-700 font-semibold">Gargalo automático</p>
                      {gargaloAtual ? (
                        <>
                          <p className="text-base font-bold text-amber-900">{gargaloAtual.nome}</p>
                          <p className="text-xs text-amber-700">Média: {formatarTempo(gargaloAtual.mediaMin)} | ocorrências: {gargaloAtual.ocorrencias} | lotes: {gargaloAtual.lotes}</p>
                        </>
                      ) : (
                        <p className="text-xs text-amber-700">Sem histórico suficiente para calcular.</p>
                      )}
                    </div>
                    <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3">
                      <p className="text-xs text-emerald-700 font-semibold">Previsão dinâmica (horas)</p>
                      <p className="text-base font-bold text-emerald-900">{formatarTempo(resumoOperacaoTempo.previsaoRestanteMin)}</p>
                      <p className="text-xs text-emerald-700">
                        Débito: {formatarTempo(resumoOperacaoTempo.atrasoBaseMin)} | Crédito: {formatarTempo(resumoOperacaoTempo.creditoAdiantadoMin)} | Ritmo: x{resumoOperacaoTempo.fatorRitmoHoje.toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
                )}
                
                {/* Nome do Produto */}
                <div className="bg-[#f0faf3] p-4 rounded-xl flex flex-col md:flex-row md:items-end gap-3">
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-[#009b3a] mb-2">PRODUTO</label>
                    <input
                      type="text"
                      list="produtos-tempo-corte-sugestoes"
                      value={nomeProdutoTempo}
                      onChange={(e) => setNomeProdutoTempo(e.target.value.toUpperCase())}
                      onBlur={() =>
                        setNomeProdutoTempo(nomeProdutoSemCor(nomeProdutoTempo).toUpperCase())
                      }
                      placeholder="DIGITE O NOME DO PRODUTO"
                      className="w-full px-4 py-3 rounded-lg border border-[#009b3a]/28 font-bold uppercase"
                    />
                    <datalist id="produtos-tempo-corte-sugestoes">
                      {pontuacoesProdutos.map((p, idx) => (
                        <option key={idx} value={p.nome.toUpperCase()} />
                      ))}
                    </datalist>
                    <p className="mt-1 text-[11px] text-[#009b3a]">Digite o nome e escolha uma das opcoes sugeridas abaixo.</p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <button
                      type="button"
                      onClick={preencherPontuacaoPorNomeTempoCorte}
                      className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg text-sm"
                    >
                      Buscar pontuação no Boletim pelo lote
                    </button>
                    <button
                      type="button"
                      onClick={buscarTempoNoMesmoLote}
                      className="px-4 py-2 bg-[#1F4E78] hover:bg-[#2a5f8f] text-white font-semibold rounded-lg text-sm flex items-center justify-center gap-1"
                      title="Copia pontos/tempo/horários de outro produto já salvo no mesmo lote"
                    >
                      <Clock className="w-4 h-4" /> Buscar tempo do mesmo lote
                    </button>
                  </div>
                </div>
                
                {/* Caixas de entrada */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 p-4 bg-[#eef0f4] rounded-xl">
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">PONTUAçãO DO PRODUTO¹</label>
                    <input type="number" value={pontuacaoProduto} onChange={(e) => setPontuacaoProduto(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center font-bold" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">QTD DE PRODUTO²</label>
                    <input type="number" value={qtdProduto} onChange={(e) => setQtdProduto(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center font-bold" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">PONTOS DO DIA TODO³</label>
                    <input type="number" value={pontosDiaTodo} onChange={(e) => setPontosDiaTodo(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center font-bold" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">TEMPO DO DIA TODO⁴</label>
                    <input type="number" value={tempoDiaTodo} onChange={(e) => setTempoDiaTodo(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center font-bold" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">PORCENTAGEM⁵</label>
                    <input type="number" value={porcentagem} onChange={(e) => setPorcentagem(Number(e.target.value))} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center font-bold" />
                  </div>
                  <div className="bg-[#e8f5ec] p-2 rounded-lg">
                    <label className="block text-sm font-medium text-[#009b3a] mb-1">PONTUAçãO DA REMESSA⁶</label>
                    <p className="text-2xl font-bold text-black text-center">{pontuacaoRemessaProduzida.toFixed(2)}</p>
                  </div>
                {/* NOVO CAMPO DE TEMPO EXATO EM HORAS */}
                  <div className="bg-[#e4eaf5] p-2 rounded-lg">
                    <label className="block text-sm font-medium text-blue-700 mb-1">TEMPO EXATO⁷ (selecionadas)</label>
                    <p className="text-2xl font-bold text-blue-800 text-center">{formatarTempo(tempoExatoSelecionadas)}</p>
                  </div>
                </div>
                
                {/* Horários de trabalho - Legenda */}
                <div className="bg-[#e4e6ec] p-3 rounded-xl border border-[#009b3a]/22 text-xs">
                  <p className="font-semibold text-black mb-1">Horários contados: seg-sex 07:00-11:00 e 12:12-17:00</p>
                  <div className="flex flex-wrap gap-4">
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input type="checkbox" checked={horarioExtraManha} onChange={(e) => setHorarioExtraManha(e.target.checked)} />
                      <span>Incluir 05:00-07:00</span>
                    </label>
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input type="checkbox" checked={horarioExtraAlmoco} onChange={(e) => setHorarioExtraAlmoco(e.target.checked)} />
                      <span>Incluir 11:00-12:12</span>
                    </label>
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input type="checkbox" checked={trabalhaSabado} onChange={(e) => setTrabalhaSabado(e.target.checked)} />
                      <span>Trabalha sábado (05:00-11:00)</span>
                    </label>
                    <label className="flex items-center gap-1.5 cursor-not-allowed opacity-70">
                      <input type="checkbox" checked={trabalhaDomingo} disabled />
                      <span>Trabalha domingo (não contabiliza)</span>
                    </label>
                  </div>
                </div>
                {/* Linha 1: Lote + Planejado automático */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div className="bg-[#e4e6ec] p-3 rounded-xl border-2 border-[#009b3a]/22">
                    <label className="block text-xs font-medium text-black mb-1">LOTE</label>
                    <input type="text" value={loteTempoCorte} onChange={(e) => setLoteTempoCorte(e.target.value.toUpperCase())} placeholder="Ex: 8762 ou 8762-8763" className="w-full px-2 py-1.5 rounded border border-[#009b3a]/30 text-sm font-semibold uppercase" />
                    <p className="mt-1 text-[11px] text-neutral-600">Aceita 1 ou 2 lotes (ex.: <strong>8762-8763</strong>). Início = primeiro lote · Fim = último lote.</p>
                  </div>
                  <div className="rounded-xl border-2 border-[#009b3a]/28 bg-[#f0faf3] p-3">
                    <label className="block text-xs font-medium text-green-700 mb-1">Data/Hora Início (Planejado)</label>
                    <input type="datetime-local" value={dataHoraInicioExato} readOnly className="w-full px-2 py-1.5 rounded border border-[#009b3a]/35 bg-[#e8f5ec] text-sm text-black" />
                  </div>
                  <div className="rounded-xl border-2 border-[#009b3a]/28 bg-[#f0faf3] p-3">
                    <label className="block text-xs font-medium text-green-700 mb-1">Data/Hora Término (Planejado)</label>
                    <input type="datetime-local" value={dataHoraTerminoExato} readOnly className="w-full px-2 py-1.5 rounded border border-[#009b3a]/35 bg-[#e8f5ec] text-sm text-black" />
                  </div>
                </div>

                {/* Importar Excel */}
                <div className="flex flex-wrap items-center gap-3">
                  <label className="flex items-center gap-2 px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg cursor-pointer">
                    <Upload className="w-4 h-4" />
                    Importar Excel
                    <input type="file" accept=".xlsx,.xls" onChange={importarExcelTempoCorte} className="hidden" />
                  </label>
                  <button
                    type="button"
                    onClick={marcarTodosTempoCorteItens}
                    disabled={tempoCorteItens.length === 0}
                    className="px-3 py-2 rounded-lg border border-[#009b3a]/35 bg-[#e8f5ec] text-[#006b28] text-sm font-semibold hover:bg-[#d4edda] disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    Marcar todos
                  </button>
                  <button
                    type="button"
                    onClick={desmarcarTodosTempoCorteItens}
                    disabled={tempoCorteItens.length === 0 || !tempoCorteItens.some((i) => i.selecionado)}
                    className="px-3 py-2 rounded-lg border border-neutral-300 bg-[#eef0f4] text-neutral-800 text-sm font-semibold hover:bg-[#e4e6ec] disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    Desmarcar todos
                  </button>
                  <span className="text-xs text-neutral-600">Colunas: Nº, DESCRIçãO, QTD, MEDIDA, METROS², MATERIAL. Metros² = medidas × qtd (ex.: 500×300×2). Ao editar QTD ou MEDIDA na tabela, o m² recalcula igual ao Excel.</span>
                </div>
                {/* Tabela */}
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-[#009b3a]/22">
                    <thead className="bg-[#e4e6ec]">
                      <tr>
                        <th className="px-2 py-2 text-center font-medium text-sm border">Nº</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">Nº</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">DESCRIçãO</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">QTD</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">MEDIDA</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">METROS²</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">MATERIAL</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border bg-yellow-100">% POR PEÇA</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border bg-[#e4eaf5]">TEMPO CADA PEÇA⁸</th>
                        <th className="px-2 py-2 text-center font-medium text-sm border">AçõES</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tempoCorteItens.map((item, index) => {
                        const metrosConsiderados = (item.metrosQuadrados || 0);
                        const porcentagemPorPeca =
                          totalMetrosQuadradosAll > 0 && porcentagem > 0
                            ? (metrosConsiderados * porcentagem) / totalMetrosQuadradosAll
                            : 0;
                        const tempoCadaPeca =
                          porcentagem > 0 ? (tempoExato * porcentagemPorPeca) / porcentagem : 0;
                        const origemAtual = (item.produtoOrigem || '').trim();
                        const origemAnterior =
                          index > 0 ? (tempoCorteItens[index - 1]?.produtoOrigem || '').trim() : '';
                        const mostrarCabecalhoGrupo =
                          origemAtual && origemAtual !== origemAnterior;
                        return (
                          <Fragment key={`${item.id}-${index}`}>
                            {mostrarCabecalhoGrupo && (
                              <tr className="bg-indigo-100 border-t-4 border-indigo-400">
                                <td colSpan={10} className="px-3 py-1.5 font-bold text-indigo-900 text-sm uppercase tracking-wide">
                                  <span className="inline-block px-2 py-0.5 mr-2 rounded bg-indigo-600 text-white text-[10px] font-bold">
                                    PRODUTO
                                  </span>
                                  {origemAtual}
                                </td>
                              </tr>
                            )}
                            <tr className={`hover:bg-[#eef0f4] ${item.selecionado ? 'bg-[#f0faf3]' : 'print:hidden'}`}>
                              <td className="px-2 py-2 text-center border">
                                <input type="checkbox" checked={item.selecionado} onChange={(e) => editarTempoCorteItem(item.id, 'selecionado', e.target.checked)} className="w-5 h-5 cursor-pointer" />
                              </td>
                              <td className="px-2 py-2 text-center border font-bold">{index + 1}</td>
                              <td className="px-2 py-2 border"><input type="text" value={descricaoPecaSemCor(item.descricao || '').toUpperCase()} onChange={(e) => editarTempoCorteItem(item.id, 'descricao', e.target.value)} className="w-full px-1 py-1 text-sm border rounded uppercase" /></td>
                              <td className="px-2 py-2 border"><input type="number" value={item.qtd} onChange={(e) => editarTempoCorteItem(item.id, 'qtd', Number(e.target.value))} className="w-full px-1 py-1 text-sm border rounded text-center" /></td>
                              <td className="px-2 py-2 border"><input type="text" value={item.medida} onChange={(e) => editarTempoCorteItem(item.id, 'medida', e.target.value)} className="w-full px-1 py-1 text-sm border rounded text-center uppercase" /></td>
                              <td className="px-2 py-2 border"><input type="number" step="0.01" value={Number(Number(item.metrosQuadrados || 0).toFixed(6))} onChange={(e) => editarTempoCorteItem(item.id, 'metrosQuadrados', Number(e.target.value))} className="w-full px-1 py-1 text-sm border rounded text-center" /></td>
                              <td className="px-2 py-2 border"><input type="text" value={item.material} onChange={(e) => editarTempoCorteItem(item.id, 'material', e.target.value)} className="w-full px-1 py-1 text-sm border rounded text-center uppercase" /></td>
                              <td className="px-2 py-2 text-center border bg-yellow-50 font-bold">{porcentagemPorPeca.toFixed(2)}%</td>
                              <td className="px-2 py-2 text-center border bg-[#eef2f8] font-bold">{formatarTempo(tempoCadaPeca)}</td>
                              <td className="px-2 py-2 text-center border">
                                <button type="button" onClick={() => removerTempoCorteItem(item.id, index)} className="text-red-500 hover:text-red-700" title="Remover esta linha"><Trash2 className="w-4 h-4" /></button>
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                
                {/* Totais */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-[#e8f5ec] p-4 rounded-xl">
                    <p className="text-sm text-[#009b3a]">TOTAL METROS²</p>
                    <p className="text-3xl font-bold text-black">{totalMetrosQuadrados.toFixed(4)}</p>
                  </div>
                  <div className="bg-[#e4eaf5] p-4 rounded-xl">
                    <p className="text-sm text-blue-600">TOTAL TEMPO CADA PEÇA (selecionadas)</p>
                    <p className="text-3xl font-bold text-blue-800">{formatarTempo(tempoCorteItens.filter(i => i.selecionado).reduce((acc, item) => {
                      const metrosConsiderados = (item.metrosQuadrados || 0);
                      const porcentagemPorPeca =
                        totalMetrosQuadradosAll > 0 && porcentagem > 0
                          ? (metrosConsiderados * porcentagem) / totalMetrosQuadradosAll
                          : 0;
                      const tempoCadaPeca =
                        porcentagem > 0 ? (tempoExato * porcentagemPorPeca) / porcentagem : 0;
                      return acc + tempoCadaPeca;
                    }, 0))}</p>
                  </div>
                  <div className="flex gap-2 items-end">
                    <button onClick={adicionarTempoCorteItem} className="flex-1 px-4 py-3 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center justify-center gap-2"><Plus className="w-4 h-4" />ADICIONAR LINHA</button>
                    <button onClick={gerarProdutoTempoCorte} className="flex-1 px-4 py-3 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center justify-center gap-2"><Save className="w-4 h-4" />GERAR</button>
                    <button onClick={imprimirTempoCorte} className="flex-1 px-4 py-3 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center justify-center gap-2"><Printer className="w-4 h-4" />IMPRIMIR</button>
                    <button onClick={limparTempoCorte} className="px-4 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg flex items-center justify-center gap-2"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </div>
                
                {/* Produtos Salvos — barra de busca sempre visível (mesmo com 0 cards) */}
                <div className="bg-[#eef0f4] p-4 rounded-xl border border-[#009b3a]/15">
                    <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
                      <h4 className="font-semibold text-black">
                        PRODUTOS SALVOS ({produtosTempoCorteAtivos.length})
                        {resumoProdutosTempoCorte.maiorNumeroLote > 0 && (
                          <span className="ml-2 text-sm font-normal text-neutral-600">
                            · maior lote nº {resumoProdutosTempoCorte.maiorNumeroLote}
                          </span>
                        )}
                      </h4>
                      <div className="flex items-center gap-2 flex-wrap">
                        <button
                          type="button"
                          onClick={criarTodosCardsTempoCorteFaltantes}
                          className="px-3 py-1.5 rounded-lg border border-indigo-400 bg-indigo-50 text-indigo-900 text-xs font-medium hover:bg-indigo-100 flex items-center gap-1.5"
                          title="Para cada lote do cadastro sem card: copia as peças de outro card do mesmo produto"
                        >
                          <Layers className="w-3.5 h-3.5" />
                          Criar cards faltantes
                        </button>
                        <button
                          type="button"
                          onClick={() => void recuperarProdutosTempoCorteDoBackup()}
                          className="px-3 py-1.5 rounded-lg border border-amber-400 bg-amber-50 text-amber-900 text-xs font-medium hover:bg-amber-100"
                          title="Busca produtos no IndexedDB, localStorage e pasta Backups do app"
                        >
                          Recuperar do backup
                        </button>
                        <span className="text-xs font-semibold px-3 py-1 rounded-full bg-[#e8f5ec] text-[#009b3a]">
                          Na análise: {produtosTempoCorteParaAnalise.length}
                        </span>
                        {idsParaUnificar.size > 0 && (
                          <>
                            <span className="text-xs font-semibold px-3 py-1 rounded-full bg-indigo-100 text-indigo-800">
                              {idsParaUnificar.size} selecionado(s)
                            </span>
                            {idsParaUnificar.size >= 2 && (
                              <button
                                type="button"
                                onClick={unificarProdutosSelecionados}
                                className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-bold rounded-lg flex items-center gap-1"
                                title="Cria um produto único somando todas as peças"
                              >
                                <Layers className="w-3.5 h-3.5" /> Unificar em 1 card
                              </button>
                            )}
                            <button
                              type="button"
                              onClick={() => setIdsParaUnificar(new Set())}
                              className="px-2 py-1 bg-[#dde0e6] hover:bg-[#cfd3dc] text-black text-xs font-medium rounded-lg"
                            >
                              Limpar seleção
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    <p className="text-[11px] text-neutral-600 mb-3">
                      Marque 2 ou mais cards para unificar as peças num só. Útil quando vários produtos do mesmo lote compartilham o mesmo tempo.
                      {produtosTempoCorteAtivos.length === 0 && (
                        <span className="block mt-1 text-amber-800 font-semibold">
                          Nenhum card na memória. Use &quot;Recuperar do backup&quot; ou reinicie o app — há backup de hoje com os cards.
                        </span>
                      )}
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3">
                      <div className="relative">
                        <input
                          type="text"
                          list="filtro-produto-salvo-nome"
                          value={filtroProdutoSalvoNome}
                          onChange={(e) => setFiltroProdutoSalvoNome(e.target.value.toUpperCase())}
                          placeholder="Filtrar por NOME do produto..."
                          className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-sm font-semibold uppercase"
                        />
                        <datalist id="filtro-produto-salvo-nome">
                          {sugestoesProdutosSalvosNome.map((n) => (
                            <option key={n} value={n} />
                          ))}
                        </datalist>
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          list="filtro-produto-salvo-lote"
                          value={filtroProdutoSalvoLote}
                          onChange={(e) => setFiltroProdutoSalvoLote(e.target.value.toUpperCase())}
                          placeholder="Filtrar por LOTE (ex.: 8762 ou 8762-8763)..."
                          className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-sm font-semibold uppercase"
                        />
                        <datalist id="filtro-produto-salvo-lote">
                          {sugestoesProdutosSalvosLote.map((l) => (
                            <option key={l} value={l} />
                          ))}
                        </datalist>
                      </div>
                      {(filtroProdutoSalvoNome || filtroProdutoSalvoLote) && (
                        <div className="md:col-span-2 flex items-center justify-between text-xs text-neutral-600">
                          <span>
                            Mostrando <strong>{produtosTempoCorteSalvosFiltrados.length}</strong> de{' '}
                            <strong>{produtosTempoCorteAtivos.length}</strong>
                          </span>
                          <button
                            onClick={() => { setFiltroProdutoSalvoNome(''); setFiltroProdutoSalvoLote(''); }}
                            className="px-3 py-1 rounded bg-[#dde0e6] hover:bg-[#cfd3dc] text-black font-semibold"
                          >
                            Limpar filtro
                          </button>
                        </div>
                      )}
                    </div>
                    {produtosTempoCorteSalvosFiltrados.length > 0 && (() => {
                      const idsFiltrados = produtosTempoCorteSalvosFiltrados.map((p) => p.id);
                      const totalFiltrados = idsFiltrados.length;
                      const marcadosFiltrados = idsFiltrados.filter((id) => idsParaUnificar.has(id)).length;
                      const todosMarcados = marcadosFiltrados === totalFiltrados;
                      const algumMarcado = marcadosFiltrados > 0;
                      const ref = (el: HTMLInputElement | null) => {
                        if (el) el.indeterminate = algumMarcado && !todosMarcados;
                      };
                      return (
                        <div className="mb-2 flex items-center gap-2 px-2 py-1.5 rounded-lg bg-white/70 border border-[#009b3a]/15 text-xs">
                          <input
                            type="checkbox"
                            ref={ref}
                            checked={todosMarcados}
                            onChange={(e) => {
                              setIdsParaUnificar((prev) => {
                                const nova = new Set(prev);
                                if (e.target.checked) {
                                  idsFiltrados.forEach((id) => nova.add(id));
                                } else {
                                  idsFiltrados.forEach((id) => nova.delete(id));
                                }
                                return nova;
                              });
                            }}
                            className="w-4 h-4 accent-indigo-600 cursor-pointer"
                            title="Selecionar/desmarcar todos os itens filtrados"
                          />
                          <span className="font-semibold text-neutral-700">
                            Selecionar todos os filtrados ({marcadosFiltrados}/{totalFiltrados})
                          </span>
                        </div>
                      );
                    })()}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                      {produtosTempoCorteSalvosFiltrados.map(produto => {
                        const estaSelecionado = idsParaUnificar.has(produto.id);
                        return (
                        <div
                          key={produto.id}
                          className={`p-2 rounded-lg border ${
                            estaSelecionado
                              ? 'bg-indigo-50 border-indigo-400 ring-2 ring-indigo-300'
                              : produto.enviarParaAnalise
                              ? 'bg-[#f0faf3] border-[#009b3a]/28'
                              : 'bg-[#fafbfc] border-[#009b3a]/15'
                          }`}
                        >
                          <div className="flex items-start justify-between gap-2">
                            <div className="flex items-start gap-2 flex-1">
                              <input
                                type="checkbox"
                                checked={estaSelecionado}
                                onChange={() => alternarSelecaoUnificar(produto.id)}
                                className="mt-1 w-4 h-4 cursor-pointer accent-indigo-600"
                                title="Selecionar para unificar"
                              />
                              <div className="flex-1">
                                <p className="font-bold text-black text-sm flex items-center gap-1">
                                  {produto.eUnificado && (
                                    <span
                                      className="text-[9px] px-1.5 py-0.5 rounded bg-indigo-600 text-white font-bold"
                                      title={`Unificado de ${produto.produtosOrigem?.length || 0} produtos`}
                                    >
                                      UNI
                                    </span>
                                  )}
                                  {nomeProdutoSemCor(String(produto.nome || ''))}
                                </p>
                              <p className="text-xs text-neutral-600">{produto.dataCriacao} ⬢ {produto.itens?.length || 0} itens</p>
                              <p className="text-[11px] text-neutral-600 mt-1">Lote: {produto.lote || '-'}</p>
                              <p className="text-[11px] text-neutral-700 mt-0.5">
                                TEMPO EXATO:{' '}
                                <span className="font-semibold text-black tabular-nums">
                                  {(() => {
                                    const t =
                                      Number(produto.tempoExato) > 0
                                        ? Number(produto.tempoExato)
                                        : calcularTempoExatoSelecionadasDeProdutoSalvoTc(produto);
                                    return t > 0 ? formatarTempo(t) : '—';
                                  })()}
                                </span>
                              </p>
                              </div>
                            </div>
                            <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${produto.enviarParaAnalise ? 'bg-[#009b3a] text-white' : 'bg-[#dde0e6] text-neutral-700'}`}>
                              {produto.enviarParaAnalise ? 'EM ANALISE' : 'FORA DA ANALISE'}
                            </span>
                          </div>
                          {produto.enviarParaAnalise && (
                            <div className="mt-1.5">
                              <label className="block text-[10px] text-neutral-600 mb-0.5">Horário prazo (análise)</label>
                              <select
                                value={produto.horarioProduto || ''}
                                onChange={(e) => atualizarHorarioProduto(produto.id, e.target.value)}
                                className="w-full text-[11px] px-2 py-1 rounded border border-[#009b3a]/22 bg-[#fafbfc]"
                              >
                                <option value="">Selecione...</option>
                                <option value="04:00">04:00 (até 740 pts)</option>
                                <option value="04:48">04:48 (741–900 pts)</option>
                                <option value="08:48">08:48 (1600+ pts)</option>
                                <option value="apenas">Apenas adiantamento (sem lote)</option>
                              </select>
                            </div>
                          )}
                          <div className="flex gap-1 mt-2 flex-wrap">
                            <button
                              onClick={() => alternarProdutoNaAnalise(produto.id)}
                              className={`px-2 py-1 text-xs rounded ${produto.enviarParaAnalise ? 'bg-amber-500 text-white hover:bg-amber-600' : 'bg-[#009b3a] text-white hover:bg-[#007a2e]'}`}
                            >
                              {produto.enviarParaAnalise ? 'RETIRAR DA ANALISE' : 'JOGAR PARA ANALISE'}
                            </button>
                            <button onClick={() => carregarProdutoTempoCorte(produto)} className="px-2 py-1 ade-btn-gold relative z-10 text-xs">CARREGAR</button>
                            <button
                              onClick={() => abrirEditarProdutoSalvo(produto)}
                              className="px-2 py-1 bg-amber-500 hover:bg-amber-600 text-white text-xs rounded flex items-center gap-1"
                              title="Editar manualmente pontuação, qtd, tempo do dia, tempo exato e tempo de produção"
                            >
                              <Pencil className="w-3 h-3" /> EDITAR
                            </button>
                            {produto.eUnificado && Array.isArray(produto.produtosOrigemCompleto) && produto.produtosOrigemCompleto.length > 0 && (
                              <button
                                onClick={() => desagruparProdutoUnificado(produto)}
                                className="px-2 py-1 bg-indigo-600 hover:bg-indigo-700 text-white text-xs rounded flex items-center gap-1"
                                title={`Restaurar os ${produto.produtosOrigemCompleto.length} produtos originais`}
                              >
                                <RotateCcw className="w-3 h-3" /> DESAGRUPAR
                              </button>
                            )}
                            <button onClick={() => removerProdutoTempoCorteSalvo(produto.id)} className="px-2 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700"><Trash2 className="w-3 h-3" /></button>
                          </div>
                        </div>
                        );
                      })}
                    </div>
                  </div>

                {/* Modal: configurar unificação de cards */}
                {modalUnificar.aberto && (() => {
                  const selecionados = produtosTempoCorteSalvos.filter((p) =>
                    idsParaUnificar.has(p.id)
                  );
                  const baseTempo = [...selecionados].sort((a, b) => {
                    const da = Date.parse(
                      a?.dataHoraTerminoProducao || a?.salvoEm || a?.dataCriacaoISO || ''
                    ) || 0;
                    const db = Date.parse(
                      b?.dataHoraTerminoProducao || b?.salvoEm || b?.dataCriacaoISO || ''
                    ) || 0;
                    return db - da;
                  })[0];
                  // Cards MDF são considerados COMPLEMENTOS — não somam qtd
                  // nem pontuação. Entram no tempo de produção e no tempo exato.
                  const complementos = selecionados.filter((p) =>
                    produtoEhComplementoMDF(p?.nome)
                  );
                  const principais = selecionados.filter(
                    (p) => !produtoEhComplementoMDF(p?.nome)
                  );
                  const base = principais.length > 0 ? principais : selecionados;
                  const qtdFinal = base.reduce(
                    (s, p) => s + (Number(p.qtdProduto) || 0),
                    0
                  );
                  const ptsPonderado = (() => {
                    const sQ = base.reduce(
                      (s, p) => s + (Number(p.qtdProduto) || 0),
                      0
                    );
                    const sP = base.reduce(
                      (s, p) =>
                        s +
                        (Number(p.pontuacaoProduto) || 0) * (Number(p.qtdProduto) || 0),
                      0
                    );
                    return sQ > 0 ? sP / sQ : 0;
                  })();
                  const ptsFinal = ptsPonderado;
                  const pontosDia = Number(baseTempo?.pontosDiaTodo) || 0;
                  const tempoDia = Number(baseTempo?.tempoDiaTodo) || 0;
                  const tempoExatoSoma = selecionados.reduce(
                    (s, p) => s + calcularTempoExatoSelecionadasDeProdutoSalvo(p),
                    0
                  );
                  const tempoExatoRecalc =
                    ptsFinal > 0 && qtdFinal > 0 && pontosDia > 0 && tempoDia > 0
                      ? (ptsFinal * qtdFinal * tempoDia) / pontosDia
                      : 0;
                  const tempoExatoFinal =
                    modalUnificar.modoTempoExato === 'somar'
                      ? tempoExatoSoma
                      : tempoExatoRecalc;
                  return (
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                      <div className="bg-white rounded-xl p-5 max-w-3xl w-full shadow-2xl max-h-[92vh] overflow-y-auto">
                        <div className="flex items-start justify-between mb-3">
                          <h4 className="font-bold text-black text-lg">
                            Unificar {selecionados.length} cards
                          </h4>
                          <button
                            onClick={() =>
                              setModalUnificar((prev) => ({ ...prev, aberto: false }))
                            }
                            className="p-1 rounded hover:bg-neutral-100"
                            title="Cancelar"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>

                        <div className="mb-3">
                          <label className="block text-xs font-semibold text-neutral-700 mb-1">
                            Nome do produto unificado
                          </label>
                          <input
                            type="text"
                            value={modalUnificar.nome}
                            onChange={(e) =>
                              setModalUnificar((prev) => ({
                                ...prev,
                                nome: e.target.value.toUpperCase(),
                              }))
                            }
                            className="w-full px-3 py-2 rounded border border-neutral-300 font-semibold uppercase"
                          />
                        </div>

                        <div className="mb-3 overflow-x-auto rounded border border-neutral-200">
                          <table className="w-full text-[11px]">
                            <thead className="bg-neutral-100">
                              <tr>
                                <th className="px-2 py-1 text-left">Nome</th>
                                <th className="px-2 py-1 text-left">Lote</th>
                                <th className="px-2 py-1 text-center">Tipo</th>
                                <th className="px-2 py-1 text-right">Qtd</th>
                                <th className="px-2 py-1 text-right">Pts</th>
                                <th className="px-2 py-1 text-right">Tempo exato</th>
                                <th className="px-2 py-1 text-right">Tempo prod.</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selecionados.map((p) => {
                                const isMdf = produtoEhComplementoMDF(p?.nome);
                                return (
                                  <tr
                                    key={p.id}
                                    className={`border-t border-neutral-200 ${
                                      isMdf ? 'bg-amber-50' : ''
                                    }`}
                                  >
                                    <td className="px-2 py-1 truncate max-w-[180px]" title={p.nome}>
                                      {p.nome}
                                    </td>
                                    <td className="px-2 py-1 font-mono">{p.lote || '—'}</td>
                                    <td className="px-2 py-1 text-center">
                                      {isMdf ? (
                                        <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-amber-200 text-amber-900">
                                          COMPLEMENTO MDF
                                        </span>
                                      ) : (
                                        <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-800">
                                          PRINCIPAL
                                        </span>
                                      )}
                                    </td>
                                    <td
                                      className={`px-2 py-1 text-right font-mono ${
                                        isMdf ? 'text-neutral-400 line-through' : ''
                                      }`}
                                    >
                                      {Number(p.qtdProduto) || 0}
                                    </td>
                                    <td
                                      className={`px-2 py-1 text-right font-mono ${
                                        isMdf ? 'text-neutral-400 line-through' : ''
                                      }`}
                                    >
                                      {(Number(p.pontuacaoProduto) || 0).toFixed(3)}
                                    </td>
                                    <td className="px-2 py-1 text-right font-mono">
                                      {formatarTempo(
                                        calcularTempoExatoSelecionadasDeProdutoSalvo(p)
                                      )}
                                    </td>
                                    <td className="px-2 py-1 text-right font-mono">
                                      {formatarTempo(Number(p.tempoProducaoMinutos) || 0)}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>

                        <div className="mb-3 p-2.5 rounded-lg bg-blue-50 border border-blue-200 text-[11px] text-blue-900">
                          <p className="font-bold mb-0.5">Regra automática:</p>
                          <p>
                            <strong>Qtd</strong> e <strong>pontuação</strong> são sempre
                            somadas dos cards <span className="text-emerald-700 font-semibold">PRINCIPAIS</span>.
                            Cards <span className="text-amber-700 font-semibold">COMPLEMENTO MDF</span>{' '}
                            são detectados pelo nome (contém &quot;MDF&quot;) e <strong>não entram</strong>{' '}
                            na qtd nem na pontuação — só entram no <strong>tempo de produção</strong>{' '}
                            (que precisa deles para o produto completar) e no tempo exato somado.
                            {complementos.length > 0 && (
                              <>
                                {' '}
                                <span className="font-bold">
                                  {complementos.length} complemento(s) detectado(s):
                                </span>{' '}
                                {complementos.map((p) => p.nome).join(' · ')}
                              </>
                            )}
                          </p>
                        </div>

                        <fieldset className="border border-neutral-300 rounded-lg p-2.5">
                          <legend className="text-xs font-bold px-1 text-neutral-700">
                            Tempo exato
                          </legend>
                          <div className="flex flex-col md:flex-row gap-2">
                            <label className="flex items-start gap-2 cursor-pointer flex-1">
                              <input
                                type="radio"
                                checked={modalUnificar.modoTempoExato === 'somar'}
                                onChange={() =>
                                  setModalUnificar((prev) => ({
                                    ...prev,
                                    modoTempoExato: 'somar',
                                  }))
                                }
                                className="mt-0.5"
                              />
                              <span className="text-xs">
                                <strong>Somar</strong> (peças selecionadas, igual ao carregar o
                                card):{' '}
                                <span className="font-mono">{formatarTempo(tempoExatoSoma)}</span>
                              </span>
                            </label>
                            <label className="flex items-start gap-2 cursor-pointer flex-1">
                              <input
                                type="radio"
                                checked={modalUnificar.modoTempoExato === 'recalcular'}
                                onChange={() =>
                                  setModalUnificar((prev) => ({
                                    ...prev,
                                    modoTempoExato: 'recalcular',
                                  }))
                                }
                                className="mt-0.5"
                              />
                              <span className="text-xs">
                                <strong>Recalcular</strong> (pts × qtd × tempoDia ÷ pontosDia):{' '}
                                <span className="font-mono">
                                  {tempoExatoRecalc > 0
                                    ? formatarTempo(tempoExatoRecalc)
                                    : '— sem pontos/tempo do dia válidos no card mais recente'}
                                </span>
                              </span>
                            </label>
                          </div>
                        </fieldset>

                        <div className="mt-3 p-3 rounded-lg bg-[#f0faf3] border border-[#009b3a]/30 text-xs">
                          <p className="font-bold text-[#006d28] mb-1">Resultado do card unificado:</p>
                          <p>
                            <strong>Qtd:</strong>{' '}
                            <span className="font-mono">{qtdFinal}</span> ·{' '}
                            <strong>Pts:</strong>{' '}
                            <span className="font-mono">{ptsFinal.toFixed(4)}</span> ·{' '}
                            <strong>Pontuação da remessa:</strong>{' '}
                            <span className="font-mono">{(ptsFinal * qtdFinal).toFixed(2)}</span>
                          </p>
                          <p>
                            <strong>Tempo exato:</strong>{' '}
                            <span className="font-mono">{formatarTempo(tempoExatoFinal)}</span>
                          </p>
                        </div>

                        <div className="flex flex-wrap gap-3 mt-4">
                          <button
                            onClick={() =>
                              setModalUnificar((prev) => ({ ...prev, aberto: false }))
                            }
                            className="px-4 py-2.5 bg-[#dde0e6] hover:bg-[#cfd3dc] text-black font-semibold rounded-lg"
                          >
                            Cancelar
                          </button>
                          <button
                            onClick={() => confirmarUnificacao(false)}
                            className="flex-1 px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg"
                          >
                            Unificar (manter originais)
                          </button>
                          <button
                            onClick={() => confirmarUnificacao(true)}
                            className="flex-1 px-4 py-2.5 ade-btn-gold relative z-10 font-semibold rounded-lg"
                          >
                            Unificar e remover originais
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Modal: editar manualmente os valores de um produto salvo */}
                {modalEditarProdutoSalvo.aberto && (() => {
                  const produtoAtual = produtosTempoCorteSalvos.find(
                    (p) => p.id === modalEditarProdutoSalvo.produtoId
                  );
                  const pts = Number(modalEditarProdutoSalvo.pontuacaoProduto) || 0;
                  const qtd = Number(modalEditarProdutoSalvo.qtdProduto) || 0;
                  const pontosDia = Number(modalEditarProdutoSalvo.pontosDiaTodo) || 0;
                  const tempoDia = Number(modalEditarProdutoSalvo.tempoDiaTodo) || 0;
                  const pontuacaoRemessa = pts * qtd;
                  const exatoRecalculado =
                    pts > 0 && qtd > 0 && pontosDia > 0 && tempoDia > 0
                      ? (pts * qtd * tempoDia) / pontosDia
                      : 0;
                  return (
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                      <div className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl max-h-[92vh] overflow-y-auto">
                        <div className="flex items-start justify-between mb-3">
                          <div>
                            <h4 className="font-bold text-black text-lg">Editar produto salvo</h4>
                            <p className="text-xs text-neutral-600">
                              {produtoAtual?.nome || '(produto)'} · Lote: {produtoAtual?.lote || '—'}
                              {produtoAtual?.eUnificado && (
                                <span className="ml-1 text-[9px] px-1.5 py-0.5 rounded bg-indigo-600 text-white font-bold">
                                  UNI
                                </span>
                              )}
                            </p>
                          </div>
                          <button
                            onClick={() =>
                              setModalEditarProdutoSalvo((prev) => ({ ...prev, aberto: false }))
                            }
                            className="p-1 rounded hover:bg-neutral-100"
                            title="Cancelar"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        <p className="text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded p-2 mb-3">
                          Use para corrigir manualmente cards (especialmente unificados antigos)
                          que ficaram com pontos do dia, tempo do dia ou tempo exato fora do
                          esperado. Se você deixar <strong>Tempo exato em 0</strong>, ele é
                          recalculado automaticamente como
                          <strong> (pontuação × qtd × tempo do dia) ÷ pontos do dia</strong>.
                        </p>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div>
                            <label className="block text-xs font-semibold text-neutral-700 mb-1">
                              Pontuação do produto
                            </label>
                            <input
                              type="number"
                              step="0.001"
                              value={modalEditarProdutoSalvo.pontuacaoProduto}
                              onChange={(e) =>
                                setModalEditarProdutoSalvo((prev) => ({
                                  ...prev,
                                  pontuacaoProduto: e.target.value,
                                }))
                              }
                              className="w-full px-2 py-1.5 rounded border border-neutral-300 font-mono"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-semibold text-neutral-700 mb-1">
                              Qtd do produto
                            </label>
                            <input
                              type="number"
                              value={modalEditarProdutoSalvo.qtdProduto}
                              onChange={(e) =>
                                setModalEditarProdutoSalvo((prev) => ({
                                  ...prev,
                                  qtdProduto: e.target.value,
                                }))
                              }
                              className="w-full px-2 py-1.5 rounded border border-neutral-300 font-mono"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-semibold text-neutral-700 mb-1">
                              Pontos do dia todo
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              value={modalEditarProdutoSalvo.pontosDiaTodo}
                              onChange={(e) =>
                                setModalEditarProdutoSalvo((prev) => ({
                                  ...prev,
                                  pontosDiaTodo: e.target.value,
                                }))
                              }
                              className="w-full px-2 py-1.5 rounded border border-neutral-300 font-mono"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-semibold text-neutral-700 mb-1">
                              Tempo do dia todo (min)
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              value={modalEditarProdutoSalvo.tempoDiaTodo}
                              onChange={(e) =>
                                setModalEditarProdutoSalvo((prev) => ({
                                  ...prev,
                                  tempoDiaTodo: e.target.value,
                                }))
                              }
                              className="w-full px-2 py-1.5 rounded border border-neutral-300 font-mono"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-semibold text-neutral-700 mb-1">
                              Tempo exato (min) — 0 = recalcular
                            </label>
                            <input
                              type="number"
                              step="0.001"
                              value={modalEditarProdutoSalvo.tempoExato}
                              onChange={(e) =>
                                setModalEditarProdutoSalvo((prev) => ({
                                  ...prev,
                                  tempoExato: e.target.value,
                                }))
                              }
                              className="w-full px-2 py-1.5 rounded border border-neutral-300 font-mono"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-semibold text-neutral-700 mb-1">
                              Tempo produção (min)
                            </label>
                            <input
                              type="number"
                              step="0.001"
                              value={modalEditarProdutoSalvo.tempoProducaoMinutos}
                              onChange={(e) =>
                                setModalEditarProdutoSalvo((prev) => ({
                                  ...prev,
                                  tempoProducaoMinutos: e.target.value,
                                }))
                              }
                              className="w-full px-2 py-1.5 rounded border border-neutral-300 font-mono"
                            />
                          </div>
                        </div>
                        <div className="mt-3 p-2 rounded bg-[#f0faf3] border border-[#009b3a]/22 text-[11px] text-neutral-700">
                          <p>
                            <strong>Pontuação da remessa:</strong>{' '}
                            <span className="font-mono">{pontuacaoRemessa.toFixed(2)}</span>{' '}
                            <span className="text-neutral-500">(pts × qtd)</span>
                          </p>
                          {exatoRecalculado > 0 && (
                            <p>
                              <strong>Tempo exato recalculado:</strong>{' '}
                              <span className="font-mono">
                                {formatarTempo(exatoRecalculado)}
                              </span>{' '}
                              <span className="text-neutral-500">
                                ({pts} × {qtd} × {tempoDia} ÷ {pontosDia})
                              </span>
                            </p>
                          )}
                        </div>
                        <div className="flex gap-3 mt-4">
                          <button
                            onClick={() =>
                              setModalEditarProdutoSalvo((prev) => ({ ...prev, aberto: false }))
                            }
                            className="flex-1 px-4 py-2.5 bg-[#dde0e6] hover:bg-[#cfd3dc] text-black font-semibold rounded-lg"
                          >
                            Cancelar
                          </button>
                          <button
                            onClick={salvarEdicaoProdutoSalvo}
                            className="flex-1 px-4 py-2.5 ade-btn-gold relative z-10 font-semibold rounded-lg"
                          >
                            Salvar alterações
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Modal: produto com mesmo nome e mesmo lote */}
                {modalProdutoExistente.aberto && (
                  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 rounded-xl">
                    <div className="bg-[#fafbfc] rounded-xl p-6 max-w-md w-full shadow-neu">
                      <h4 className="font-bold text-black mb-2">Produto já existe</h4>
                      <p className="text-sm text-neutral-700 mb-4">
                        Já existe um produto salvo com o nome &quot;{nomeProdutoTempo}&quot; e lote &quot;{loteTempoCorte || '-'}&quot;.
                        O que deseja fazer?
                      </p>
                      <div className="flex gap-3">
                        <button
                          onClick={() => executarGerarProduto(true)}
                          className="flex-1 px-4 py-2.5 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg"
                        >
                          Substituir
                        </button>
                        <button
                          onClick={() => executarGerarProduto(false)}
                          className="flex-1 px-4 py-2.5 ade-btn-gold relative z-10 font-semibold rounded-lg"
                        >
                          Gerar novo
                        </button>
                        <button
                          onClick={() => setModalProdutoExistente({ aberto: false, produto: null })}
                          className="px-4 py-2.5 bg-[#dde0e6] hover:bg-[#cfd3dc] text-black font-semibold rounded-lg"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            
            {abaVisivel === 'analiseTempo' && (
              <AnaliseTempoSection
                produtos={produtosTempoCorteParaAnalise}
                lotesProdutos={lotesProdutos}
                formatarTempo={formatarTempo}
                onAtualizarHorarioProduto={atualizarHorarioProduto}
                onRetirarDaAnalise={alternarProdutoNaAnalise}
              />
            )}
            {abaVisivel === 'tempoProducaoPeca' && (
              <TempoProducaoPecaSection
                lotesProdutos={lotesProdutos}
                produtosTempoCorteSalvos={produtosTempoCorteAtivos}
                formatarTempo={formatarTempo}
                onAplicarProducaoLote={aplicarProducaoLoteTempoCorte}
              />
            )}
            {abaVisivel === 'adiantamentoMdf' && (
              <AdiantamentoMdfSection
                produtosTempoCorte={produtosTempoCorteAtivos}
                lotesProdutos={lotesProdutos}
                onAlterarDescricaoPeca={alterarDescricaoPecaTempoCorte}
              />
            )}
            {abaVisivel === 'lotes' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-black flex items-center gap-2">
                  <Layers className="w-5 h-5" />
                  Lotes de Produção
                </h3>
                <p className="text-sm text-neutral-600">
                  Cadastre quais produtos entram em cada lote. Depois, ao informar o nome do produto em Tempo de Corte,
                  a quantidade total será preenchida automaticamente apenas para o lote informado.
                </p>
                <div className="flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={() => setModalImportarLotesExcel(true)}
                    className="px-4 py-2 bg-[#e8f5ec] hover:bg-[#d4edda] text-[#006b28] text-sm font-semibold rounded-lg flex items-center gap-2 border border-[#009b3a]/35"
                  >
                    <Upload className="w-4 h-4" />
                    Importar Excel
                  </button>
                </div>
                <div className="bg-amber-50 rounded-xl border border-amber-300 p-4 space-y-3">
                  <h4 className="font-semibold text-amber-900 flex items-center gap-2">
                    <RefreshCw className="w-4 h-4" />
                    Renumerar lote inteiro
                  </h4>
                  <p className="text-xs text-amber-800">
                    Troca o número do lote em todos os produtos cadastrados de uma vez. Opcionalmente atualiza
                    início do corte e fim da embalagem em todos eles. Também ajusta cards do Tempo de Corte,
                    relatório, histórico e tempo por peça vinculados.
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-amber-900 mb-1">Lote atual</label>
                      <input
                        type="text"
                        list="lotes-renumerar-opcoes"
                        value={renumerarLoteAntigo}
                        onChange={(e) => setRenumerarLoteAntigo(e.target.value.toUpperCase())}
                        placeholder="Ex: 8798"
                        className="w-full px-3 py-2 rounded-lg border border-amber-400 text-sm uppercase font-semibold"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-amber-900 mb-1">Novo número</label>
                      <input
                        type="text"
                        value={renumerarLoteNovo}
                        onChange={(e) => setRenumerarLoteNovo(e.target.value.toUpperCase())}
                        placeholder="Ex: 8800"
                        className="w-full px-3 py-2 rounded-lg border border-amber-400 text-sm uppercase font-semibold"
                      />
                    </div>
                    <div className="md:col-span-2 flex items-end">
                      <p className="text-xs text-amber-700 pb-2">
                        {renumerarLoteAntigo.trim()
                          ? `${lotesProdutos.filter((lp) => loteCadastroCoincide(lp.lote, renumerarLoteAntigo)).length} produto(s) serão alterados no cadastro`
                          : 'Selecione ou digite o lote atual'}
                      </p>
                    </div>
                  </div>
                  <datalist id="lotes-renumerar-opcoes">
                    {lotesUnicosCadastro.map((l) => (
                      <option key={l} value={l} />
                    ))}
                  </datalist>
                  <label className="flex items-center gap-2 text-sm text-amber-900 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={renumerarAtualizarDatas}
                      onChange={(e) => setRenumerarAtualizarDatas(e.target.checked)}
                    />
                    Atualizar datas de todos os produtos deste lote
                  </label>
                  {renumerarAtualizarDatas && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs font-medium text-amber-900 mb-1">Novo início do corte</label>
                        <input
                          type="datetime-local"
                          value={renumerarInicioCorte}
                          onChange={(e) => setRenumerarInicioCorte(e.target.value)}
                          className="w-full px-2 py-2 rounded-lg border border-amber-400 text-xs"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-amber-900 mb-1">Novo fim da embalagem</label>
                        <input
                          type="datetime-local"
                          value={renumerarFimEmbalagem}
                          onChange={(e) => setRenumerarFimEmbalagem(e.target.value)}
                          className="w-full px-2 py-2 rounded-lg border border-amber-400 text-xs"
                        />
                      </div>
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={() => void aplicarRenumerarLoteCompleto()}
                    className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold rounded-lg"
                  >
                    Aplicar renumeracao do lote
                  </button>
                </div>
                <div className="bg-[#e8f5ec] rounded-xl border border-[#009b3a]/28 p-4 space-y-3">
                  <h4 className="font-semibold text-[#006b28] flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    Alterar data/hora do lote inteiro
                  </h4>
                  <p className="text-xs text-[#006b28]">
                    Atualiza início do corte e/ou fim da embalagem em todos os produtos do mesmo lote,
                    sem trocar o número do lote.
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-[#006b28] mb-1">Lote</label>
                      <input
                        type="text"
                        list="lotes-datas-opcoes"
                        value={datasLoteAlvo}
                        onChange={(e) => preencherDatasDoLoteSelecionado(e.target.value)}
                        placeholder="Ex: 8824"
                        className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/35 text-sm uppercase font-semibold"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-[#006b28] mb-1">Início do corte</label>
                      <input
                        type="datetime-local"
                        value={datasLoteInicio}
                        onChange={(e) => setDatasLoteInicio(e.target.value)}
                        className="w-full px-2 py-2 rounded-lg border border-[#009b3a]/35 text-xs"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-[#006b28] mb-1">Fim da embalagem</label>
                      <input
                        type="datetime-local"
                        value={datasLoteFim}
                        onChange={(e) => setDatasLoteFim(e.target.value)}
                        className="w-full px-2 py-2 rounded-lg border border-[#009b3a]/35 text-xs"
                      />
                    </div>
                  </div>
                  <datalist id="lotes-datas-opcoes">
                    {lotesUnicosCadastro.map((l) => (
                      <option key={l} value={l} />
                    ))}
                  </datalist>
                  <p className="text-xs text-[#006b28]">
                    {datasLoteAlvo.trim()
                      ? `${lotesProdutos.filter((lp) => loteCadastroCoincide(lp.lote, datasLoteAlvo)).length} produto(s) deste lote serão atualizados`
                      : 'Selecione ou digite o lote'}
                  </p>
                  <button
                    type="button"
                    onClick={() => void aplicarDatasLoteCompleto()}
                    className="px-4 py-2 bg-[#009b3a] hover:bg-[#007a2e] text-white text-sm font-semibold rounded-lg"
                  >
                    Aplicar data/hora em todos os produtos do lote
                  </button>
                </div>
                <div className="bg-[#fafbfc] rounded-xl border border-[#009b3a]/15 p-4 space-y-3">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-neutral-700 mb-1">Lote</label>
                      <input
                        type="text"
                        value={novoLoteNome}
                        onChange={(e) => setNovoLoteNome(e.target.value.toUpperCase())}
                        placeholder="Ex: LOTE 001"
                        className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-sm uppercase"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-neutral-700 mb-1">Início do corte / Fim da embalagem</label>
                      <div className="flex gap-2">
                        <input
                          type="datetime-local"
                          value={novoInicioCorte}
                          onChange={(e) => setNovoInicioCorte(e.target.value)}
                          className="flex-1 px-2 py-2 rounded-lg border border-[#009b3a]/22 text-xs"
                          title="Início do corte"
                        />
                        <input
                          type="datetime-local"
                          value={novoFimEmbalagem}
                          onChange={(e) => setNovoFimEmbalagem(e.target.value)}
                          className="flex-1 px-2 py-2 rounded-lg border border-[#009b3a]/22 text-xs"
                          title="Fim da embalagem"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="border-t border-[#009b3a]/15 pt-3 mt-3">
                    <h4 className="text-sm font-semibold text-black mb-2">Produtos a adicionar (vários de uma vez)</h4>
                    <div className="space-y-2">
                      {itensParaAdicionar.map((item) => (
                        <div key={item.id} className="flex gap-2 items-center">
                          <input
                            type="text"
                            list="produtos-lote-sugestoes"
                            value={item.produtoNome}
                            onChange={(e) => setItensParaAdicionar((prev) =>
                              prev.map((p) => p.id === item.id ? { ...p, produtoNome: e.target.value } : p)
                            )}
                            placeholder="Nome do produto"
                            className="flex-1 px-3 py-2 rounded-lg border border-[#009b3a]/22 text-sm"
                          />
                          <input
                            type="number"
                            value={item.qtd || ''}
                            onChange={(e) => setItensParaAdicionar((prev) =>
                              prev.map((p) => p.id === item.id ? { ...p, qtd: Number(e.target.value) || 0 } : p)
                            )}
                            placeholder="Qtd"
                            className="w-20 px-2 py-2 rounded-lg border border-[#009b3a]/22 text-sm text-center"
                            min={0}
                          />
                          <button
                            type="button"
                            onClick={() => setItensParaAdicionar((prev) => prev.filter((p) => p.id !== item.id))}
                            className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                            title="Remover linha"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                      <datalist id="produtos-lote-sugestoes">
                        {pontuacoesProdutos.map((p, idx) => (
                          <option key={idx} value={p.nome} />
                        ))}
                      </datalist>
                    </div>
                    <div className="flex gap-2 mt-2">
                      <button
                        type="button"
                        onClick={() => setItensParaAdicionar((prev) => [...prev, { id: Date.now().toString(), produtoNome: '', qtd: 0 }])}
                        className="px-3 py-2 bg-[#e4e6ec] hover:bg-[#dde0e6] text-black text-sm font-medium rounded-lg flex items-center gap-1"
                      >
                        <Plus className="w-4 h-4" /> Adicionar linha
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          if (!novoLoteNome.trim()) {
                            alert('Informe o nome do lote.');
                            return;
                          }
                          const loteNome = novoLoteNome.trim().toUpperCase();
                          const itensValidos = itensParaAdicionar.filter((i) => {
                            const nome = pontuacoesProdutos.find((p) => normalizarTexto(p.nome) === normalizarTexto(i.produtoNome))?.nome || '';
                            return nome && (i.qtd || 0) > 0;
                          });
                          if (itensValidos.length === 0) {
                            alert('Adicione ao menos um produto válido com quantidade maior que zero.');
                            return;
                          }
                          const novos: LoteProdutoConfig[] = itensValidos.map((i) => {
                            const produtoNome = pontuacoesProdutos.find((p) => normalizarTexto(p.nome) === normalizarTexto(i.produtoNome))?.nome || i.produtoNome;
                            return {
                              id: Date.now().toString() + Math.random(),
                              lote: loteNome,
                              produtoNome,
                              qtd: i.qtd,
                              dataHoraInicioCorte: novoInicioCorte || undefined,
                              dataHoraFimEmbalagem: novoFimEmbalagem || undefined,
                            };
                          });
                          setLotesProdutos((prev) => [...prev, ...novos]);
                          registrarAuditoria('adicionar_lote', `${loteNome} | itens: ${novos.length}`);
                          atualizarTabelaDiasComLotes(novos);
                          setItensParaAdicionar([]);
                          setNovoLoteNome('');
                          setNovoInicioCorte('');
                          setNovoFimEmbalagem('');
                        }}
                        className="px-4 py-2 ade-btn-gold relative z-10 text-sm font-semibold rounded-lg"
                      >
                        Adicionar todos ao lote
                      </button>
                    </div>
                  </div>
                </div>
                {lotesProdutos.length === 0 ? (
                        <div className="bg-[#eef0f4] rounded-xl p-6 text-center text-neutral-600">
                    Nenhum lote cadastrado ainda. Use o formulário acima para adicionar produtos aos lotes.
                  </div>
                ) : (
                  <div className="bg-[#fafbfc] rounded-xl border border-[#009b3a]/15 p-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-3 flex-wrap">
                      <h4 className="font-semibold text-black">
                        Lotes cadastrados
                        {resumoLotesCadastrados.total > 0 && (
                          <span className="ml-2 text-sm font-normal text-neutral-600">
                            ({resumoLotesCadastrados.total} reg. · maior lote nº{' '}
                            {resumoLotesCadastrados.maiorNumeroLote || '—'})
                          </span>
                        )}
                      </h4>
                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          type="button"
                          onClick={() => void recuperarLotesDeTempoCorte()}
                          className="px-3 py-1.5 rounded-lg border border-[#009b3a]/40 bg-[#e8f5ec] text-[#006b28] text-sm font-medium hover:bg-[#d4edda]"
                          title="Reconstrói lotes a partir dos produtos salvos no Tempo de Corte e dos nº marcados em Finalizar lote antigo"
                        >
                          Recuperar do Tempo de Corte
                        </button>
                        <button
                          type="button"
                          onClick={() => void recuperarLotesDoBackup()}
                          className="px-3 py-1.5 rounded-lg border border-amber-400 bg-amber-50 text-amber-900 text-sm font-medium hover:bg-amber-100"
                          title="Busca lotes no IndexedDB, localStorage, Tempo de Corte e marcas manuais"
                        >
                          Recuperar tudo
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            try {
                              const margem = 30;
                              const porLote = new Map<string, typeof lotesProdutosFiltrados>();
                              for (const lp of lotesProdutosFiltrados) {
                                const key = lp.lote || '(sem lote)';
                                if (!porLote.has(key)) porLote.set(key, []);
                                porLote.get(key)!.push(lp);
                              }
                              const linhas: string[] = [];
                              for (const [loteNome, itens] of porLote.entries()) {
                                let totalLote = 0;
                                for (const lp of itens) {
                                  const pont = pontosLinhaLoteBoletim(lp, pontuacoesProdutos);
                                  totalLote += pont;
                                  linhas.push(`<tr>
                                    <td>${lp.lote}</td>
                                    <td>${lp.produtoNome}</td>
                                    <td style="text-align:right">${lp.qtd}</td>
                                    <td style="text-align:right">${pont.toFixed(2)}</td>
                                    <td style="text-align:center;font-size:9pt">${lp.dataHoraInicioCorte ? new Date(lp.dataHoraInicioCorte).toLocaleString('pt-BR') : '-'}</td>
                                    <td style="text-align:center;font-size:9pt">${lp.dataHoraFimEmbalagem ? new Date(lp.dataHoraFimEmbalagem).toLocaleString('pt-BR') : '-'}</td>
                                  </tr>`);
                                }
                                linhas.push(`<tr style="background:#e2e8f0;font-weight:bold"><td colspan="3" style="text-align:right">Total do lote ${loteNome}:</td><td style="text-align:right">${totalLote.toFixed(2)}</td><td colspan="2"></td></tr>`);
                              }
                              const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Lotes Cadastrados</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Arial, sans-serif; }
    @page { size: A4 landscape; margin: ${margem}mm; }
    .pagina { width: 260mm; min-height: 180mm; padding: 2mm; }
    .cabecalho { border-bottom: 2px solid #334155; padding-bottom: 2mm; margin-bottom: 3mm; }
    .cabecalho h1 { font-size: 16pt; }
    .cabecalho p { font-size: 11pt; margin: 0.5mm 0; }
    table { width: 100%; border-collapse: collapse; font-size: 10pt; }
    th, td { border: 1px solid #1e293b; padding: 2mm; }
    th { background: #e2e8f0; font-weight: bold; text-align: left; }
    .rodape { margin-top: 3mm; font-size: 10pt; font-weight: bold; }
  </style></head><body>
  <div class="pagina">
    <div class="cabecalho">
      <h1>Lotes Cadastrados</h1>
      <p><strong>Data:</strong> ${new Date().toLocaleString('pt-BR')} | <strong>Total:</strong> ${lotesProdutosFiltrados.length} registro(s)</p>
    </div>
    <table><thead><tr><th>Lote</th><th>Produto</th><th style="text-align:right">Qtd.</th><th style="text-align:right">Pontuação</th><th>Início Corte</th><th>Fim Embalagem</th></tr></thead><tbody>${linhas.length ? linhas.join('') : '<tr><td colspan="6" style="text-align:center">Nenhum lote.</td></tr>'}</tbody></table>
    <div class="rodape">Total pontuação: ${totalPontuacaoLotesFiltrados.toFixed(2)}</div>
  </div></body></html>`;
                              const win = window.open('', '_blank');
                              if (win) {
                                win.document.write(html);
                                win.document.close();
                                win.focus();
                                setTimeout(() => win.print(), 300);
                              }
                            } catch (err: any) {
                              alert(`Erro ao imprimir: ${err?.message || err}`);
                            }
                          }}
                          className="px-3 py-1.5 text-xs font-semibold rounded-lg ade-btn-gold relative z-10 flex items-center gap-1"
                        >
                          <Printer className="w-3.5 h-3.5" />
                          Imprimir
                        </button>
                        <div className="relative flex-1 min-w-[180px]">
                          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-600" />
                          <input
                            type="text"
                            value={filtroProdutoNomeLotes}
                            onChange={(e) => setFiltroProdutoNomeLotes(e.target.value)}
                            placeholder="Buscar por nome do produto..."
                            className="w-full pl-8 pr-3 py-1.5 text-xs rounded-lg border border-[#009b3a]/22 focus:ring-2 focus:ring-[#009b3a]/45"
                          />
                        </div>
                        <input
                          type="text"
                          value={filtroLotes}
                          onChange={(e) => setFiltroLotes(e.target.value)}
                          placeholder="Filtrar por lote..."
                          className="px-3 py-1.5 text-xs rounded-lg border border-[#009b3a]/22 min-w-[120px]"
                        />
                        <input
                          type="month"
                          value={filtroMesLotes}
                          onChange={(e) => setFiltroMesLotes(e.target.value)}
                          className="px-3 py-1.5 text-xs rounded-lg border border-[#009b3a]/22"
                          title="Filtrar por mes"
                        />
                      </div>
                    </div>
                    {editandoLoteItem && (
                      <div className="mb-3 p-4 bg-[#f0faf3] rounded-xl border border-[#009b3a]/22">
                        <h4 className="font-semibold text-black mb-2 flex items-center gap-2"><Pencil className="w-4 h-4" />Editar item do lote</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                          <div>
                            <label className="block text-xs font-medium text-[#009b3a] mb-1">Lote</label>
                            <input type="text" value={editandoLoteItem.lote} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, lote: e.target.value.toUpperCase() } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm uppercase" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-[#009b3a] mb-1">Produto</label>
                            <input type="text" list="produtos-lote-sugestoes" value={editandoLoteItem.produtoNome} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, produtoNome: e.target.value } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-[#009b3a] mb-1">Cor</label>
                            <input type="text" value={editandoLoteItem.corProduto || ''} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, corProduto: e.target.value || undefined } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm" placeholder="Ex: cedro/off" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-[#009b3a] mb-1">Código</label>
                            <input type="text" value={editandoLoteItem.codigoProduto || ''} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, codigoProduto: e.target.value || undefined } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm" placeholder="Ex: 37869" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-[#009b3a] mb-1">Qtd.</label>
                            <input type="number" value={editandoLoteItem.qtd} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, qtd: Number(e.target.value) || 0 } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm" min={0} />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-[#009b3a] mb-1">Início / Fim</label>
                            <div className="flex gap-1">
                              <input type="datetime-local" value={editandoLoteItem.dataHoraInicioCorte || ''} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, dataHoraInicioCorte: e.target.value || undefined } : null)} className="flex-1 px-2 py-1.5 text-xs rounded-lg border border-[#009b3a]/28" />
                              <input type="datetime-local" value={editandoLoteItem.dataHoraFimEmbalagem || ''} onChange={(e) => setEditandoLoteItem((p) => p ? { ...p, dataHoraFimEmbalagem: e.target.value || undefined } : null)} className="flex-1 px-2 py-1.5 text-xs rounded-lg border border-[#009b3a]/28" />
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-2 mt-2">
                          <button
                            type="button"
                            onClick={() => {
                              const produtoNome =
                                pontuacoesProdutos.find(
                                  (p) =>
                                    normalizarTexto(p.nome) ===
                                    normalizarTexto(editandoLoteItem!.produtoNome)
                                )?.nome || editandoLoteItem!.produtoNome;
                              const atualizado: LoteProdutoConfig = {
                                ...editandoLoteItem!,
                                produtoNome,
                              };
                              const antes = lotesProdutos.find(
                                (lp) => lp.id === editandoLoteItem!.id
                              );
                              const mesclado = antes
                                ? mesclarEdicaoLoteSalva(lotesProdutos, antes, atualizado)
                                : lotesProdutos.map((lp) =>
                                    lp.id === editandoLoteItem!.id ? atualizado : lp
                                  );
                              const next = deduplicarLotesPorLoteProduto(mesclado, {
                                registrarExcluidos: true,
                                preservarOrdem: true,
                              });
                              // Mantém o card do Tempo de Corte com o mesmo nome — senão o nome antigo volta via sync/recuperação.
                              if (
                                antes &&
                                !nomesProdutoIguais(antes.produtoNome, atualizado.produtoNome)
                              ) {
                                const cardsNext = produtosTempoCorteSalvosRef.current.map((c) => {
                                  if (
                                    !loteCadastroCoincide(String(c.lote || ''), antes.lote) ||
                                    !nomesProdutoIguais(String(c.nome || ''), antes.produtoNome)
                                  ) {
                                    return c;
                                  }
                                  return { ...c, nome: atualizado.produtoNome };
                                });
                                ignorarSaveTempoCorteProdRef.current = true;
                                setProdutosTempoCorteSalvos(cardsNext);
                                void persistirProdutosTempoCorteDireto(cardsNext).then(() => {
                                  notificarSyncDesktop('tempo-corte-produtos');
                                });
                              }
                              ignorarSaveLotesRef.current = true;
                              setLotesProdutos(next);
                              setEditandoLoteItem(null);
                              void persistirLotesProdutosDireto(next).then(() => {
                                notificarSyncDesktop('lotes-produtos');
                              });
                            }}
                            className="px-4 py-2 ade-btn-gold relative z-10 text-sm font-semibold rounded-lg"
                          >
                            Salvar alterações
                          </button>
                          <button type="button" onClick={() => setEditandoLoteItem(null)} className="px-4 py-2 ade-neu-card-sm text-black hover:brightness-105 text-sm font-semibold rounded-lg">Cancelar</button>
                        </div>
                      </div>
                    )}
                    <div className="mb-3 rounded-lg bg-[#f0faf3] border border-[#009b3a]/22 px-3 py-2 text-sm text-black">
                      Pontuacao total dos produtos filtrados: <span className="font-bold">{totalPontuacaoLotesFiltrados.toFixed(2)}</span>
                    </div>
                    <div className="mb-3 text-xs text-neutral-700 flex flex-wrap gap-2">
                      <span className="px-2 py-0.5 rounded-full bg-[#e4e6ec] text-black">Cadastrado</span>
                      <span className="px-2 py-0.5 rounded-full bg-[#e8f5ec] text-[#009b3a]">Em corte</span>
                      <span className="px-2 py-0.5 rounded-full bg-rose-100 text-rose-800">Pendente produção</span>
                      <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">Em embalagem</span>
                      <span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">Finalizado</span>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm border-collapse">
                        <thead className="bg-[#e4e6ec]">
                          <tr>
                            <th className="px-3 py-2 text-left border border-[#009b3a]/15">Lote</th>
                            <th className="px-3 py-2 text-center border border-[#009b3a]/15">Status</th>
                            <th className="px-3 py-2 text-left border border-[#009b3a]/15">Produto</th>
                            <th className="px-3 py-2 text-left border border-[#009b3a]/15">Cor</th>
                            <th className="px-3 py-2 text-left border border-[#009b3a]/15">Código</th>
                            <th className="px-3 py-2 text-right border border-[#009b3a]/15">Qtd.</th>
                            <th className="px-3 py-2 text-right border border-[#009b3a]/15">Pontuacao</th>
                            <th className="px-3 py-2 text-center border border-[#009b3a]/15">Início Corte</th>
                            <th className="px-3 py-2 text-center border border-[#009b3a]/15">Fim Embalagem</th>
                            <th className="px-3 py-2 text-center border border-[#009b3a]/15">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lotesProdutosFiltrados.map((lp, idx) => {
                            const loteKey = normalizarTexto(lp.lote);
                            const proximoLote =
                              idx < lotesProdutosFiltrados.length - 1
                                ? normalizarTexto(lotesProdutosFiltrados[idx + 1].lote)
                                : null;
                            const fechaLote = proximoLote !== loteKey;
                            const totalLote = pontuacaoTotalPorLote.get(loteKey) ?? 0;
                            return (
                              <Fragment key={lp.id}>
                            <tr className="odd:bg-[#fafbfc] even:bg-[#eef0f4]">
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 font-semibold text-black">
                                {lp.lote}
                              </td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-center">
                                <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${statusPorLote.get(normalizarTexto(lp.lote))?.classe || 'bg-[#e4e6ec] text-black'}`}>
                                  {statusPorLote.get(normalizarTexto(lp.lote))?.label || 'Cadastrado'}
                                </span>
                              </td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-black">{lp.produtoNome}</td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-neutral-700 text-xs">{lp.corProduto || '-'}</td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-neutral-700 text-xs">{lp.codigoProduto || '-'}</td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-right font-semibold">
                                {lp.qtd}
                              </td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-right font-semibold text-[#009b3a]">
                                {pontosLinhaLoteBoletim(lp, pontuacoesProdutos).toFixed(2)}
                              </td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-center text-xs">
                                {lp.dataHoraInicioCorte
                                  ? new Date(lp.dataHoraInicioCorte).toLocaleString('pt-BR')
                                  : '-'}
                              </td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-center text-xs">
                                {lp.dataHoraFimEmbalagem
                                  ? new Date(lp.dataHoraFimEmbalagem).toLocaleString('pt-BR')
                                  : '-'}
                              </td>
                              <td className="px-3 py-1.5 border border-[#009b3a]/10 text-center">
                                <div className="flex items-center justify-center gap-1">
                                  {(() => {
                                    const loteKey = normalizarTexto(lp.lote);
                                    const estaFinalizado = lotesFinalizadosManual.includes(loteKey);
                                    return (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          if (estaFinalizado) {
                                            removerLoteFinalizadoManual(loteKey);
                                            registrarAuditoria(
                                              'desfazer_finalizado_manual',
                                              `Lote ${lp.lote}`
                                            );
                                          } else {
                                            setLotesFinalizadosManual((prev) => {
                                              if (prev.includes(loteKey)) return prev;
                                              return [...prev, loteKey].sort((a, b) =>
                                                a.localeCompare(b, 'pt-BR')
                                              );
                                            });
                                            registrarAuditoria(
                                              'finalizado_manual',
                                              `Lote ${lp.lote}`
                                            );
                                          }
                                        }}
                                        className={`p-1.5 rounded ${
                                          estaFinalizado
                                            ? 'text-amber-700 hover:bg-amber-50'
                                            : 'text-emerald-700 hover:bg-emerald-50'
                                        }`}
                                        title={
                                          estaFinalizado
                                            ? 'Desmarcar como finalizado'
                                            : 'Marcar como finalizado (anula no cálculo de tempo)'
                                        }
                                      >
                                        {estaFinalizado ? (
                                          <X className="w-4 h-4" />
                                        ) : (
                                          <Check className="w-4 h-4" />
                                        )}
                                      </button>
                                    );
                                  })()}
                                  <button
                                    type="button"
                                    onClick={() => setEditandoLoteItem({ ...lp })}
                                    className="p-1.5 text-[#009b3a] hover:bg-[#f0faf3] rounded"
                                    title="Editar"
                                  >
                                    <Pencil className="w-4 h-4" />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => removerLoteProduto(lp.id)}
                                    className="p-1.5 text-red-500 hover:bg-red-50 rounded"
                                    title="Remover"
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                            {fechaLote && (
                              <tr className="bg-[#e8f5ec]/80">
                                <td colSpan={6} className="px-3 py-1.5 border border-[#009b3a]/15 text-right text-xs font-semibold text-[#006b28]">
                                  Total do lote {lp.lote}
                                </td>
                                <td className="px-3 py-1.5 border border-[#009b3a]/15 text-right font-bold text-[#009b3a]">
                                  {totalLote.toFixed(2)}
                                </td>
                                <td colSpan={3} className="px-3 py-1.5 border border-[#009b3a]/15" />
                              </tr>
                            )}
                              </Fragment>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr className="bg-[#e4e6ec] font-semibold">
                            <td colSpan={6} className="px-3 py-2 text-right border border-[#009b3a]/15">Total filtrado</td>
                            <td className="px-3 py-2 text-right border border-[#009b3a]/15 text-[#009b3a]">{totalPontuacaoLotesFiltrados.toFixed(2)}</td>
                            <td colSpan={3} className="px-3 py-2 border border-[#009b3a]/15"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}
                {modalImportarLotesExcel && (
                  <ImportarLotesExcelModal
                    nomesPontuacao={pontuacoesProdutos.map((p) => p.nome)}
                    onImportar={importarLotesDoExcel}
                    onFechar={() => setModalImportarLotesExcel(false)}
                  />
                )}
              </div>
            )}

            {/* --- BOLETIM --- */}
            {abaVisivel === 'boletimPontuacao' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-black flex items-center gap-2"><ClipboardList className="w-5 h-5" />Pontuação dos Produtos</h3>
                <div className="flex flex-wrap gap-2">
                  <button onClick={() => adicionarOuEditarPontuacao(-1)} className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg text-sm">Adicionar / Editar</button>
                  <button onClick={salvarPontuacoesProdutos} className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg text-sm">Salvar</button>
                </div>
                {editandoPontuacao && (
                  <div className="bg-[#f0faf3] rounded-xl p-4 border border-[#009b3a]/22 flex flex-wrap gap-3 items-end">
                    <div className="flex-1 min-w-[200px]">
                      <label className="block text-sm font-medium text-[#009b3a] mb-1">Produto</label>
                      <input type="text" value={editandoPontuacao.nome} onChange={(e) => setEditandoPontuacao(prev => prev ? { ...prev, nome: e.target.value } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm" placeholder="Nome do produto" />
                    </div>
                    <div className="w-24">
                      <label className="block text-sm font-medium text-[#009b3a] mb-1">MT²</label>
                      <input type="number" step="0.01" value={editandoPontuacao.m2 || ''} onChange={(e) => setEditandoPontuacao(prev => prev ? { ...prev, m2: Number(e.target.value) || 0 } : null)} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/28 text-sm" />
                    </div>
                    <label className="flex items-center gap-2 text-sm font-medium text-[#8b0000] pb-2 cursor-pointer select-none">
                      <input
                        type="checkbox"
                        checked={editandoPontuacao.foraDeLinha}
                        onChange={(e) =>
                          setEditandoPontuacao((prev) =>
                            prev ? { ...prev, foraDeLinha: e.target.checked } : null
                          )
                        }
                        className="rounded border-red-400 text-red-700 focus:ring-red-500"
                      />
                      Fora de linha
                    </label>
                    <button type="button" onClick={aplicarEdicaoPontuacao} className="ade-btn-gold relative z-10 rounded-lg px-4 py-2 text-sm">Aplicar</button>
                    <button onClick={() => setEditandoPontuacao(null)} className="px-4 py-2 ade-neu-card-sm text-black font-semibold rounded-lg text-sm">Cancelar</button>
                  </div>
                )}
                <div className="bg-[#fafbfc] rounded-xl p-4 border border-[#009b3a]/15 flex flex-col md:flex-row md:items-end gap-3">
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-black mb-1">Buscar produto</label>
                    <input
                      type="text"
                      value={filtroPontuacaoProduto}
                      onChange={(e) => setFiltroPontuacaoProduto(e.target.value)}
                      placeholder="Digite parte do nome do produto"
                      className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 focus:ring-2 focus:ring-[#009b3a]/45 text-sm"
                    />
                  </div>
                  <div className="text-xs text-neutral-600">
                    <p>Total de produtos: <span className="font-semibold text-black">{pontuacoesProdutos.length}</span></p>
                    <p className="mt-0.5">
                      Fora de linha:{' '}
                      <span className="font-semibold text-[#8b0000]">
                        {pontuacoesProdutos.filter((p) => p.foraDeLinha).length}
                      </span>
                    </p>
                    <p className="mt-1 text-[#8b0000]">Linha vermelha sangue = fora de linha</p>
                  </div>
                </div>
                <div className="bg-[#eef0f4] rounded-xl border border-[#009b3a]/15 max-h-[480px] overflow-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-[#e4e6ec] sticky top-0 z-10">
                      <tr>
                        <th className="px-3 py-2 text-left font-semibold text-black">Produto</th>
                        <th className="px-3 py-2 text-center font-semibold text-black w-24">MT²</th>
                        <th className="px-3 py-2 text-center font-semibold text-black w-24">Linha</th>
                        <th className="px-3 py-2 text-center font-semibold text-black w-28">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pontuacoesProdutos
                        .map((p, idx) => ({ p, idx }))
                        .filter(({ p }) => {
                          const f = filtroPontuacaoProduto.trim().toLowerCase();
                          if (!f) return true;
                          return p.nome.toLowerCase().includes(f);
                        })
                        .map(({ p, idx }) => (
                        <tr
                          key={`${p.nome}-${idx}`}
                          className={
                            p.foraDeLinha
                              ? 'border-t border-[#5c0000] bg-gradient-to-r from-[#6b0a0a] via-[#8b0000] to-[#6b0a0a] text-white shadow-[inset_0_0_0_1px_rgba(0,0,0,0.15)]'
                              : 'border-t border-[#009b3a]/15 odd:bg-[#fafbfc] even:bg-[#eef0f4] text-black'
                          }
                        >
                          <td className="px-3 py-1.5 whitespace-nowrap">
                            <span className={p.foraDeLinha ? 'font-semibold' : ''}>{p.nome}</span>
                            {p.foraDeLinha && (
                              <span className="ml-2 text-[10px] font-bold uppercase tracking-wide text-red-100/90">
                                fora de linha
                              </span>
                            )}
                          </td>
                          <td className={`px-3 py-1.5 text-center font-semibold ${p.foraDeLinha ? 'text-white' : 'text-black'}`}>
                            {p.m2.toFixed(2)}
                          </td>
                          <td className="px-3 py-1.5 text-center">
                            <label
                              className={`inline-flex items-center justify-center gap-1.5 cursor-pointer select-none text-xs ${
                                p.foraDeLinha ? 'text-red-100' : 'text-neutral-700'
                              }`}
                              title={p.foraDeLinha ? 'Voltar para linha ativa' : 'Marcar fora de linha'}
                            >
                              <input
                                type="checkbox"
                                checked={Boolean(p.foraDeLinha)}
                                onChange={() => alternarForaDeLinhaPontuacao(idx)}
                                className="rounded border-red-300 text-red-800 focus:ring-red-500"
                              />
                              <span className="hidden sm:inline">Fora</span>
                            </label>
                          </td>
                          <td className="px-3 py-1.5 text-center">
                            <div className="flex items-center justify-center gap-2">
                              <button
                                type="button"
                                onClick={() => adicionarOuEditarPontuacao(idx)}
                                className={`hover:underline text-xs ${
                                  p.foraDeLinha ? 'text-red-100 hover:text-white' : 'text-[#009b3a]'
                                }`}
                              >
                                Editar
                              </button>
                              <button
                                type="button"
                                onClick={() => excluirPontuacao(idx)}
                                className={`p-0.5 rounded ${
                                  p.foraDeLinha
                                    ? 'text-red-200 hover:text-white'
                                    : 'text-red-600 hover:text-red-800'
                                }`}
                                title={`Excluir ${p.nome}`}
                                aria-label={`Excluir ${p.nome}`}
                              >
                                <Trash2 className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {abaVisivel === 'boletimCalculadora' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between gap-4 flex-wrap">
                  <h3 className="font-semibold text-black flex items-center gap-2"><Calculator className="w-5 h-5" />Calculadora</h3>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setCalculadoraModo('original')}
                      className={`px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 ${calculadoraModo === 'original' ? 'ring-2 ring-[#009b3a] bg-[#e8f5ec] text-black shadow-neu-in' : 'bg-[#dde0e6] text-neutral-700 hover:bg-[#cfd3dc]'}`}
                    >
                      <ChevronLeft className="w-4 h-4" /> Original
                    </button>
                    <button
                      onClick={() => setCalculadoraModo('automatica')}
                      className={`px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 ${calculadoraModo === 'automatica' ? 'ring-2 ring-[#009b3a] bg-[#e8f5ec] text-black shadow-neu-in' : 'bg-[#dde0e6] text-neutral-700 hover:bg-[#cfd3dc]'}`}
                    >
                      <Target className="w-4 h-4" /> Automática
                    </button>
                    <button
                      onClick={() => setCalculadoraModo('planilha')}
                      className={`px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 ${calculadoraModo === 'planilha' ? 'ring-2 ring-[#009b3a] bg-[#e8f5ec] text-black shadow-neu-in' : 'bg-[#dde0e6] text-neutral-700 hover:bg-[#cfd3dc]'}`}
                    >
                      <FileSpreadsheet className="w-4 h-4" /> Planilha
                    </button>
                  </div>
                </div>
                {calculadoraModo === 'original' && (
                <>
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs font-semibold text-neutral-600 mr-1">Somar nos dias:</span>
                  {INCREMENTOS_CALCULADORA_DIAS.map((n) => (
                    <button
                      key={n}
                      type="button"
                      onClick={() => somarIncrementoDiasCalculadora(n)}
                      title={`Somar ${n} em cada Dia que já tiver valor`}
                      className="min-w-[2.35rem] h-9 px-2 rounded-lg bg-[#ebebf0] border border-[#009b3a]/12 shadow-neu font-bold text-sm text-black select-none transition-all duration-75 hover:bg-[#e4e6ec] active:shadow-neu-in active:scale-95 active:translate-y-px"
                    >
                      {n}
                    </button>
                  ))}
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border-collapse border border-[#009b3a]/22">
                    <thead>
                      <tr className="bg-[#e4e6ec]">
                        <th className="border border-[#009b3a]/22 px-2 py-1 text-center font-semibold w-28">Vendas em 90 dias</th>
                        <th className="border border-[#009b3a]/22 px-2 py-1 text-center font-semibold w-24">Vendas por dia</th>
                        <th className="border border-[#009b3a]/22 px-2 py-1 text-center font-semibold w-12">DIAS</th>
                        {Array.from({ length: 15 }, (_, i) => (
                          <th key={i} className="border border-[#009b3a]/22 px-1 py-1 text-center font-semibold w-16">Dia {i + 1}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="bg-[#eef0f4]">
                        <td colSpan={3} className="border border-[#009b3a]/22 px-2 py-1 text-xs text-neutral-600">Valor do dia</td>
                        {Array.from({ length: 15 }, (_, i) => (
                            <td key={i} className="border border-[#009b3a]/22 p-0">
                            <input type="number" step="0.01" inputMode="decimal" value={diasValores[i] || ''} onChange={(e) => setDiasValores(prev => { const n = [...prev]; n[i] = Number(e.target.value) || 0; return n; })} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); focarESelecionarInput(document.querySelector('input[data-grid="calculadoraVendas"][data-row="0"]') as HTMLInputElement); } }} onFocus={onFocusSelecionarTudo} data-grid="calculadoraDias" data-row={0} data-col={i} className="input-numerico w-full px-1 py-0.5 text-center text-xs border-0 focus:ring-1 focus:ring-[#009b3a]/45" placeholder="Dia" />
                          </td>
                        ))}
                      </tr>
                      {Array.from({ length: 15 }, (_, row) => (
                        <tr key={row}>
                          <td className="border border-[#009b3a]/22 p-0">
                            <input type="number" step="0.01" inputMode="decimal" value={vendas90d[row] || ''} onChange={(e) => setVendas90d(prev => { const n = [...prev]; n[row] = Number(e.target.value) || 0; return n; })} onKeyDown={(e) => onEnterProximaLinha(e, 'calculadoraVendas', row, 0, 14)} onFocus={onFocusSelecionarTudo} data-grid="calculadoraVendas" data-row={row} data-col={0} className="input-numerico w-full px-1 py-0.5 text-center border-0 focus:ring-1 focus:ring-[#009b3a]/45" />
                          </td>
                          <td className="border border-[#009b3a]/22 px-2 py-1 text-center bg-[#eef0f4] font-medium">{porDia[row]?.toFixed(2) ?? '0.00'}</td>
                          <td className="border border-[#009b3a]/22 px-1 py-1 text-center bg-[#eef0f4] text-neutral-600">{row + 1}</td>
                          {Array.from({ length: 15 }, (_, col) => (
                            <td key={col} className="border border-[#009b3a]/22 px-1 py-1 text-center bg-[#eef0f4]">
                              {row === col ? ((diasValores[col] || 0) * (porDia[col] || 0)).toFixed(2) : ''}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-xs text-neutral-600">Vendas = editável. Por dia = Vendas / 90. Cada coluna Dia: valor na 1ª linha, resultado (dia a dia) abaixo. Dia 1 usa por dia linha 1, Dia 2 usa linha 2, etc.</p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {Array.from({ length: 8 }, (_, i) => (
                    <div key={i} className="p-3 bg-[#fafbfc] rounded-xl border border-[#009b3a]/15">
                      <label className="block text-xs font-medium text-neutral-700 mb-1">Produto {i + 1}</label>
                      <select value={produtoCaixaIndices[i] ?? ''} onChange={(e) => setProdutoCaixaIndices(prev => { const n = [...prev]; n[i] = e.target.value === '' ? null : Number(e.target.value); return n; })} className="w-full px-2 py-1.5 rounded border border-[#009b3a]/22 text-sm">
                        <option value="">-- escolher --</option>
                        {pontuacoesProdutos.map((p, idx) => (
                          <option key={idx} value={idx}>{p.nome} (MT²: {p.m2.toFixed(2)})</option>
                        ))}
                      </select>
                      {produtoCaixaIndices[i] != null && (
                        <p className="text-xs text-neutral-600 mt-1">MT²: {pontuacoesProdutos[produtoCaixaIndices[i]!]?.m2.toFixed(2)}</p>
                      )}
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                  {Array.from({ length: 5 }, (_, i) => {
                    const cfg = subtotalConfigs[i];
                    const prodIdx = cfg?.produtoCaixaIndex ?? 0;
                    const prod = produtoCaixaIndices[prodIdx] != null ? pontuacoesProdutos[produtoCaixaIndices[prodIdx]!] : null;
                    const m2 = prod?.m2 ?? 0;
                    const somaDias = (cfg?.diaIndices ?? []).reduce((s, j) => s + diaResultados[j], 0);
                    const subtotal = m2 * somaDias;
                    return (
                      <div key={i} className="p-3 bg-[#f0faf3] rounded-xl border border-[#009b3a]/22">
                        <h4 className="font-semibold text-[#009b3a] mb-2">Sub total {i + 1}</h4>
                        <div className="mb-2">
                          <label className="block text-xs text-[#009b3a] mb-1">Produto (caixa 1-8)</label>
                          <select value={cfg?.produtoCaixaIndex ?? 0} onChange={(e) => setSubtotalConfigs(prev => { const n = [...prev]; n[i] = { ...n[i], produtoCaixaIndex: Number(e.target.value), diaIndices: n[i]?.diaIndices ?? [] }; return n; })} className="w-full px-2 py-1 rounded border border-[#009b3a]/28 text-sm">
                            {Array.from({ length: 8 }, (_, j) => (
                              <option key={j} value={j}>Caixa {j + 1} {produtoCaixaIndices[j] != null ? `(${pontuacoesProdutos[produtoCaixaIndices[j]!]?.nome})` : ''}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-xs text-[#009b3a] mb-1">Dias a somar (por dia a dia)</label>
                          <div className="flex flex-wrap gap-1">
                            {Array.from({ length: 15 }, (_, j) => (
                              <label key={j} className="flex items-center gap-0.5 text-xs">
                                <input type="checkbox" checked={(cfg?.diaIndices ?? []).includes(j)} onChange={(e) => setSubtotalConfigs(prev => { const n = [...prev]; const diaIndices = n[i]?.diaIndices ?? []; if (e.target.checked) n[i] = { ...n[i], produtoCaixaIndex: n[i]?.produtoCaixaIndex ?? 0, diaIndices: [...diaIndices, j].sort((a,b)=>a-b) }; else n[i] = { ...n[i], produtoCaixaIndex: n[i]?.produtoCaixaIndex ?? 0, diaIndices: diaIndices.filter(x => x !== j) }; return n; })} />
                                D{j + 1}
                              </label>
                            ))}
                          </div>
                        </div>
                        <p className="mt-2 font-bold text-black">MT² — Soma = {subtotal.toFixed(2)}</p>
                      </div>
                    );
                  })}
                </div>
                <div className="p-4 bg-[#e8f5ec] rounded-xl border-2 border-[#009b3a]/28">
                  <h4 className="font-bold text-black text-lg">Total</h4>
                  <p className="text-xl font-bold text-black">
                    {Array.from({ length: 5 }, (_, i) => {
                      const cfg = subtotalConfigs[i];
                      const prodIdx = cfg?.produtoCaixaIndex ?? 0;
                      const prod = produtoCaixaIndices[prodIdx] != null ? pontuacoesProdutos[produtoCaixaIndices[prodIdx]!] : null;
                      const m2 = prod?.m2 ?? 0;
                      const somaDias = (cfg?.diaIndices ?? []).reduce((s, j) => s + diaResultados[j], 0);
                      return m2 * somaDias;
                    }).reduce((a, b) => a + b, 0).toFixed(2)}
                  </p>
                </div>
                </>
                )}
                {calculadoraModo === 'automatica' && (
                <div className="space-y-4">
                  <p className="text-sm text-neutral-700">
                    Vendas 90 dias ÷ venda por dia. Informe o dia atual de cada produto (pode ser negativo, ex.: -15 = atraso).
                    Defina a meta de pontuação. Os dias serão igualados e ajustados para atingir a meta. Quantidades sempre em 0 ou 5 (ex: 500, 505).
                  </p>
                  <div className="p-4 bg-amber-50 rounded-xl border border-amber-200">
                    <label className="block text-sm font-medium text-amber-800 mb-2">Meta de pontuação</label>
                    <input type="text" inputMode="numeric" pattern="[0-9]*" value={calcAutoMetaPontos} onChange={(e) => setCalcAutoMetaPontos(Math.max(0, parseInt(String(e.target.value).replace(/\D/g, ''), 10) || 0))} className="w-32 px-3 py-2 rounded-lg border border-amber-300 text-lg font-bold" />
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border-collapse border border-[#009b3a]/22">
                      <thead>
                        <tr className="bg-[#e4e6ec]">
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold">Produto</th>
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold w-28">Vendas 90 dias</th>
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold w-24">Vendas/dia</th>
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold w-20">Dia atual</th>
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold w-20">Dia ajustado</th>
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold w-24">Qtd (0 ou 5)</th>
                          <th className="border border-[#009b3a]/22 px-2 py-1.5 font-semibold w-24">Pontuação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: 8 }, (_, i) => {
                          const nome = calcAutoProdutoNomes[i] || '';
                          const p = nome.trim() ? pontuacoesProdutos.find((x) => normalizarTexto(x.nome) === normalizarTexto(nome)) : null;
                          const vendas = calcAutoVendas90d[i] || 0;
                          const porDia = vendas / 90;
                          const diaAtual = calcAutoDias[i] ?? 0;
                          const diaAtualExibicao =
                            calcAutoDiasTexto[i] !== '' ? calcAutoDiasTexto[i] : String(diaAtual);
                          const diaAjust = calcAutoResultado?.dias[i] ?? '-';
                          const qtd = calcAutoResultado?.quantidades[i] ?? '-';
                          const pts = p && calcAutoResultado ? (p.m2 * (calcAutoResultado.quantidades[i] || 0)).toFixed(2) : '-';
                          return (
                            <tr key={i}>
                              <td className="border border-[#009b3a]/22 px-2 py-1">
                                <input
                                  type="text"
                                  list="calc-auto-produtos-datalist"
                                  value={nome}
                                  onChange={(e) => setCalcAutoProdutoNomes(prev => { const n = [...prev]; n[i] = e.target.value; return n; })}
                                  placeholder="Digite o nome do produto..."
                                  className="w-full px-2 py-1 rounded border border-[#009b3a]/22 text-xs"
                                />
                              </td>
                              <td className="border border-[#009b3a]/22 px-2 py-1">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  value={vendas || ''}
                                  onChange={(e) => setCalcAutoVendas90d(prev => { const v = String(e.target.value).replace(',', '.'); const n = [...prev]; n[i] = parseFloat(v) || 0; return n; })}
                                  onKeyDown={(e) => onEnterCalcAutoVendas(e, i)}
                                  onFocus={onFocusSelecionarTudo}
                                  data-calc-auto-vendas
                                  data-row={i}
                                  className="w-full px-2 py-1 text-center border border-[#009b3a]/22 rounded"
                                />
                              </td>
                              <td className="border border-[#009b3a]/22 px-2 py-1 text-center bg-[#eef0f4]">{porDia > 0 ? porDia.toFixed(2) : '-'}</td>
                              <td className="border border-[#009b3a]/22 px-2 py-1">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  value={diaAtualExibicao}
                                  onChange={(e) => {
                                    const raw = String(e.target.value).trim();
                                    if (raw !== '' && !/^-?\d*$/.test(raw)) return;
                                    setCalcAutoDiasTexto((prev) => {
                                      const t = [...prev];
                                      t[i] = raw;
                                      return t;
                                    });
                                    setCalcAutoDias((prev) => {
                                      const n = [...prev];
                                      n[i] = parseDiaAtualCalcAuto(raw);
                                      return n;
                                    });
                                  }}
                                  onBlur={() =>
                                    setCalcAutoDiasTexto((prev) => {
                                      const t = [...prev];
                                      t[i] = '';
                                      return t;
                                    })
                                  }
                                  onKeyDown={(e) => onEnterCalcAutoDia(e, i)}
                                  onFocus={onFocusSelecionarTudo}
                                  data-calc-auto-dia
                                  data-row={i}
                                  placeholder="0"
                                  title="Dia atual (negativo = atraso, ex.: -15)"
                                  className="w-full px-2 py-1 text-center border border-[#009b3a]/22 rounded"
                                />
                              </td>
                              <td className="border border-[#009b3a]/22 px-2 py-1 text-center bg-[#f0faf3] font-semibold">{diaAjust}</td>
                              <td className="border border-[#009b3a]/22 px-2 py-1 text-center bg-emerald-50 font-semibold">{qtd}</td>
                              <td className="border border-[#009b3a]/22 px-2 py-1 text-center bg-amber-50">{pts}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <datalist id="calc-auto-produtos-datalist">
                    {pontuacoesProdutos.map((prod, k) => (
                      <option key={k} value={prod.nome} />
                    ))}
                  </datalist>
                  <button onClick={calcularCalculadoraAutomatica} className="px-6 py-3 ade-btn-gold relative z-10 font-semibold rounded-xl">
                    Calcular e ajustar dias
                  </button>
                  {calcAutoResultado && (
                    <div className="p-4 bg-[#e8f5ec] rounded-xl border-2 border-[#009b3a]/28">
                      <h4 className="font-bold text-black text-lg">Total alcançado</h4>
                      <p className="text-2xl font-bold text-black">{calcAutoResultado.total.toFixed(2)}</p>
                      <p className="text-xs text-[#009b3a] mt-1">Foco na meta exata; se não der, passa o mínimo possível. Quantidades em 0 ou 5.</p>
                    </div>
                  )}
                </div>
                )}
                {calculadoraModo === 'planilha' && (
                  <CalculadoraPlanilhaSection pontuacoesProdutos={pontuacoesProdutos} />
                )}
              </div>
            )}
            {montarComponentePesado(isJanelaFilha, moduloFixo, 'boletimLinhaFabrica', abaVisivel) && (
            <div hidden={abaVisivel !== 'boletimLinhaFabrica'}>
              <BoletimLinhaFabrica produtosTempoCorteSalvos={produtosTempoCorteSalvos} lotesProdutos={lotesProdutos} />
            </div>
            )}
            {abaVisivel === 'boletimTabelaDias' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-black flex items-center gap-2"><Table className="w-5 h-5" />Tabela dos Dias</h3>
                <div className="flex items-center gap-4">
                  <label className="flex items-center gap-2">
                    <span className="text-sm font-medium text-neutral-700">Ano:</span>
                    <select value={anoTabelaDias} onChange={(e) => setAnoTabelaDias(Number(e.target.value))} className="px-3 py-2 rounded-lg border-2 border-cyan-400 bg-cyan-50 text-cyan-900 font-medium text-sm">
                      {Array.from({ length: 21 }, (_, i) => 2025 + i).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </label>
                  <button
                    type="button"
                    onClick={() => atualizarTabelaDiasComLotes()}
                    className="px-3 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-700 text-white text-sm font-semibold"
                  >
                    Atualizar pelos lotes
                  </button>
                </div>
                <div className="overflow-x-auto rounded-xl overflow-hidden shadow-neu border-2 border-cyan-400">
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="bg-gradient-to-r from-cyan-500 via-teal-500 to-emerald-500">
                        <th className="border-2 border-cyan-700 px-2 py-1.5 text-center font-bold text-white sticky left-0 z-10 bg-cyan-600">Dia</th>
                        {MESES_BR.map((nome, mes) => (
                          <th key={mes} className="border-2 border-cyan-700 px-1 py-1.5 text-center font-bold text-white min-w-[72px]">{nome}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from({ length: 31 }, (_, i) => {
                        const dia = i + 1;
                        const coresLinha = ['bg-amber-50', 'bg-orange-50', 'bg-rose-50', 'bg-pink-50', 'bg-fuchsia-50', 'bg-violet-50', 'bg-[#f0faf3]', 'bg-sky-50', 'bg-cyan-50', 'bg-teal-50'];
                        const cor = coresLinha[i % 10];
                        return (
                          <tr key={dia} className={`hover:bg-yellow-100 ${cor}`}>
                            <td className="border-2 border-cyan-300 px-2 py-1 text-center font-bold text-cyan-900 sticky left-0 bg-inherit z-10">{dia}</td>
                            {MESES_BR.map((_, mes) => {
                              const mesNum = mes + 1;
                              const diasNoMes = getDiasNoMes(anoTabelaDias, mesNum);
                              const coresMes = ['bg-amber-100/50', 'bg-orange-100/50', 'bg-rose-100/50', 'bg-pink-100/50', 'bg-fuchsia-100/50', 'bg-violet-100/50', 'bg-[#e8f5ec]/50', 'bg-sky-100/50', 'bg-cyan-100/50', 'bg-teal-100/50', 'bg-emerald-100/50', 'bg-lime-100/50'];
                                if (dia > diasNoMes) return <td key={mes} className={`border-2 border-[#009b3a]/15 ${coresMes[mes]}`} />;
                              const val = getPontuacaoTabela(anoTabelaDias, mesNum, dia);
                              return (
                                <td key={mes} className={`border-2 border-cyan-200 p-0 ${coresMes[mes]}`}>
                                  <input type="number" step="0.01" inputMode="decimal" value={val || ''} onChange={(e) => setPontuacaoTabela(anoTabelaDias, mesNum, dia, Number(e.target.value) || 0)} onWheel={impedirScrollAlterarNumero} onKeyDown={(e) => onEnterProximaLinha(e, 'tabelaDias', dia - 1, mes, 30)} data-grid="tabelaDias" data-row={dia - 1} data-col={mes} className="input-numerico w-full px-1 py-0.5 text-center border-0 focus:ring-2 focus:ring-cyan-400 focus:bg-[#fafbfc] min-w-[60px] bg-transparent" />
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                      <tr className="bg-gradient-to-r from-[#009b3a] via-[#0abf4f] to-[#007a2e] font-bold text-white">
                        <td className="border-2 border-cyan-800 px-2 py-1.5 text-center sticky left-0 bg-teal-600 z-10">Soma</td>
                        {MESES_BR.map((_, mes) => {
                          const mesNum = mes + 1;
                          const diasNoMes = getDiasNoMes(anoTabelaDias, mesNum);
                          const soma = somarPontuacaoMesTabelaDias(tabelaDiasExibicao, anoTabelaDias, mesNum);
                          return <td key={mes} className="border-2 border-cyan-800 px-2 py-1.5 text-center">{soma.toFixed(2)}</td>;
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-xs text-neutral-600">Calendário do Brasil (Gregoriano). Edite a pontuação de cada dia. A soma de cada mês aparece ao final da coluna.</p>
              </div>
            )}
            {abaVisivel === 'boletimResumoDias' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between gap-4 flex-wrap">
                  <div>
                    <h3 className="font-semibold text-black flex items-center gap-2">
                      <Calendar className="w-5 h-5" />
                      Resumo dos Dias com Pontuação
                    </h3>
                    <p className="text-sm text-neutral-600">
                      Mostra apenas os dias que têm pontuação na Tabela dos Dias, com total de dias e de pontos
                      (estilo planilha).
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      const styleId = 'print-resumo-dias-page-style';
                      const existente = document.getElementById(styleId);
                      if (existente) existente.remove();
                      const style = document.createElement('style');
                      style.id = styleId;
                      style.innerHTML = `
                        @media print {
                          @page { size: A4 portrait; margin: 8mm; }
                        }
                      `;
                      document.head.appendChild(style);
                      document.body.classList.add('imprimir-resumo-dias');
                      setTimeout(() => {
                        window.print();
                        document.body.classList.remove('imprimir-resumo-dias');
                        const s = document.getElementById(styleId);
                        if (s) s.remove();
                      }, 50);
                    }}
                    className="px-4 py-2 ade-btn-gold relative z-10 font-semibold text-sm rounded-lg shadow-sm"
                  >
                    <Printer className="w-4 h-4 mr-1 inline-block" /> Imprimir resumo
                  </button>
                </div>

                <div className="flex items-center gap-4 flex-wrap">
                  <label className="flex items-center gap-2">
                    <span className="text-sm font-medium text-neutral-700">Ano:</span>
                    <select
                      value={anoTabelaDias}
                      onChange={(e) => setAnoTabelaDias(Number(e.target.value))}
                      className="px-3 py-2 rounded-lg border border-[#009b3a]/22 text-sm"
                    >
                      {Array.from({ length: 21 }, (_, i) => 2025 + i).map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="flex items-center gap-2">
                    <span className="text-sm font-medium text-neutral-700">Mês:</span>
                    <select
                      value={mesResumoDias}
                      onChange={(e) => setMesResumoDias(Number(e.target.value))}
                      className="px-3 py-2 rounded-lg border border-[#009b3a]/22 text-sm"
                    >
                      <option value={0}>Todos</option>
                      {MESES_BR.map((m, idx) => (
                        <option key={m} value={idx + 1}>
                          {m}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>

                {resumoDiasAnoSelecionado.linhas.length === 0 ? (
                  <div className="bg-[#eef0f4] rounded-xl p-8 text-center text-neutral-600">
                    Nenhum dia com pontuação para o filtro selecionado.
                  </div>
                ) : (
                  <div className="bg-[#fafbfc] rounded-xl border border-black overflow-hidden shadow-sm area-resumo-dias">
                    <table className="w-full text-sm border-collapse border border-black">
                      <thead className="bg-yellow-300">
                        <tr>
                          <th className="px-3 py-2 text-center font-bold text-black border border-black">
                            DIA
                          </th>
                          <th className="px-3 py-2 text-center font-bold text-black border border-black">
                            PONTUAçãO
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {resumoDiasAnoSelecionado.linhas.map((linha, idx) => (
                          <tr key={`${linha.data}-${idx}`} className="bg-yellow-50">
                            <td className="px-3 py-1.5 text-center font-semibold text-black border border-black">
                              {linha.data}
                            </td>
                            <td className="px-3 py-1.5 text-right font-semibold text-black border border-black">
                              {linha.pontos.toFixed(2)}
                            </td>
                          </tr>
                        ))}
                        <tr className="bg-[#dde0e6]">
                          <td className="px-3 py-2 text-center font-bold text-black border border-black">
                            TOTAL DE DIAS
                          </td>
                          <td className="px-3 py-2 text-right font-bold text-black border border-black">
                            {resumoDiasAnoSelecionado.totalDias}
                          </td>
                        </tr>
                        <tr className="bg-[#dde0e6]">
                          <td className="px-3 py-2 text-center font-bold text-black border border-black">
                            PONTUAçãO TOTAL
                          </td>
                          <td className="px-3 py-2 text-right font-bold text-black border border-black">
                            {resumoDiasAnoSelecionado.totalPontos.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
            {abaVisivel === 'boletimGrafico' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between flex-wrap gap-2 no-print-grafico">
                  <h3 className="font-semibold text-black flex items-center gap-2"><TrendingUp className="w-5 h-5" />Gráfico de Pontuação por Mês (3D)</h3>
                  <div className="flex items-center gap-4 flex-wrap">
                    <label className="flex items-center gap-2 text-sm text-neutral-700">
                      <span className="font-medium text-black">Mês inicial:</span>
                      <input
                        type="month"
                        value={graficoMesInicio}
                        onChange={(e) => setGraficoMesInicio(e.target.value)}
                        className="px-2 py-1 rounded border border-[#009b3a]/22 bg-[#fafbfc] text-black"
                      />
                      <button
                        type="button"
                        onClick={() => setGraficoMesInicio(mesAnoInicioGraficoBoletimPadrao())}
                        className="px-2 py-1 text-xs font-semibold rounded-lg bg-[#dde0e6] hover:bg-[#cfd3dc] text-black"
                        title="13 meses terminando no mês atual (comportamento anterior)"
                      >
                        Auto (até hoje)
                      </button>
                    </label>
                    <div className="flex items-center gap-2 text-sm text-neutral-700">
                      <span>Largura:</span>
                      <input type="number" value={graficoTamanho.w} onChange={(e) => setGraficoTamanho(p => ({ ...p, w: Math.max(400, Number(e.target.value) || 400) }))} className="w-20 px-2 py-1 rounded border border-[#009b3a]/22 text-center" min={400} />
                      <span>px</span>
                      <button type="button" onClick={() => setGraficoTamanho(p => ({ ...p, w: Math.max(400, p.w - 50) }))} className="px-2 py-0.5 bg-[#dde0e6] hover:bg-[#cfd3dc] rounded">«»</button>
                      <button type="button" onClick={() => setGraficoTamanho(p => ({ ...p, w: p.w + 50 }))} className="px-2 py-0.5 bg-[#dde0e6] hover:bg-[#cfd3dc] rounded">+</button>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-neutral-700">
                      <span>Altura (eixo Y):</span>
                      <input type="number" value={graficoTamanho.h} onChange={(e) => setGraficoTamanho(p => ({ ...p, h: Math.max(300, Number(e.target.value) || 300) }))} className="w-20 px-2 py-1 rounded border border-[#009b3a]/22 text-center" min={300} />
                      <span>px</span>
                      <button type="button" onClick={() => setGraficoTamanho(p => ({ ...p, h: Math.max(300, p.h - 50) }))} className="px-2 py-0.5 bg-[#dde0e6] hover:bg-[#cfd3dc] rounded">«»</button>
                      <button type="button" onClick={() => setGraficoTamanho(p => ({ ...p, h: p.h + 50 }))} className="px-2 py-0.5 bg-[#dde0e6] hover:bg-[#cfd3dc] rounded">+</button>
                    </div>
                    <label className="flex items-center gap-2 text-sm text-neutral-700">
                      <span>Orientação:</span>
                      <select value={graficoOrientacaoImpressao} onChange={(e) => setGraficoOrientacaoImpressao(e.target.value as 'paisagem' | 'retrato')} className="px-2 py-1 rounded border border-[#009b3a]/22">
                        <option value="paisagem">Paisagem (A4)</option>
                        <option value="retrato">Retrato (A4)</option>
                      </select>
                    </label>
                    <button onClick={imprimirGrafico} className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center gap-2"><Printer className="w-4 h-4" />Imprimir</button>
                  </div>
                </div>
                <div className="area-grafico-impressao bg-[#fafbfc] rounded-xl p-4 border-2 border-[#009b3a]/15 shadow-neu">
                  <p className="text-sm text-neutral-700 mb-2 no-print-grafico">
                    13 meses consecutivos a partir de{' '}
                    <strong className="text-black">{graficoMesInicio}</strong>
                    {' '}× Ajuste largura/altura acima ou arraste o canto
                  </p>
                  <div className="relative grafico-3d-container border-2 border-dashed border-[#009b3a]/45 rounded-lg overflow-hidden bg-[#eef0f4]" style={{ width: graficoTamanho.w, height: graficoTamanho.h }}>
                    <button type="button" onMouseDown={handleGraficoResizeStart} className="absolute bottom-0 right-0 z-10 flex h-10 w-10 cursor-se-resize items-center justify-center rounded-tl-lg bg-[#009b3a] text-white no-print-grafico hover:bg-[#007a2e]" title="Arraste para redimensionar">
                      <GripVertical className="w-5 h-5 rotate-90" />
                    </button>
                    <HighchartsReact
                      key={`graf-boletim-${graficoMesInicio}-${dadosGrafico13Meses.map((d) => d.pontuacao.toFixed(2)).join('_')}`}
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          type: 'column',
                          width: graficoTamanho.w,
                          height: graficoTamanho.h,
                          options3d: { enabled: true, alpha: 10, beta: 0, depth: 60, viewDistance: 30 },
                          style: { fontFamily: 'inherit' }
                        },
                        title: { text: 'Pontuação por Mês', style: { fontSize: '18px' } },
                        xAxis: {
                          categories: dadosGrafico13Meses.map((d) => d.mesAno),
                          labels: { style: { fontSize: '11px' }, rotation: -35 }
                        },
                        yAxis: {
                          title: { text: 'Pontuação' },
                          min: 0,
                          labels: { style: { fontSize: '16px' } }
                        },
                        plotOptions: {
                          column: {
                            depth: 35,
                            dataLabels: { enabled: true, format: '{y:.1f}', style: { fontWeight: 'bold', textOutline: 'none', fontSize: '16px' } },
                            borderWidth: 2,
                            borderColor: '#1e293b'
                          }
                        },
                        tooltip: { pointFormat: '<b>{point.y:.1f}</b> pt' },
                        series: [{
                          name: 'Pontuação',
                          data: dadosGrafico13Meses.map((d, i) => ({
                            y: d.pontuacao,
                            color: ['#06b6d4', '#0d9488', '#10b981', '#22c55e', '#84cc16', '#eab308', '#f97316', '#ef4444', '#ec4899', '#a855f7', '#6366f1', '#3b82f6', '#0ea5e9'][i % 13]
                          }))
                        }]
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {abaVisivel === 'historico' && (
              <div className="space-y-4">
                <h3 className="font-semibold text-black flex items-center gap-2"><History className="w-5 h-5" />Histórico de Impressões (últimos 7 dias)</h3>
                
                {/* Filtros */}
                <div className="flex flex-wrap gap-4 items-end p-4 bg-[#eef0f4] rounded-xl">
                  <div className="flex-1 min-w-[220px]">
                    <label className="block text-sm font-medium text-neutral-700 mb-1">Buscar</label>
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-500 pointer-events-none" />
                      <input
                        type="search"
                        value={filtroHistoricoImpressoes}
                        onChange={(e) => setFiltroHistoricoImpressoes(e.target.value)}
                        placeholder="Produto, peça, data, material..."
                        className="w-full pl-9 pr-9 py-2 rounded-lg border border-[#009b3a]/22 text-sm bg-[#fafbfc]"
                      />
                      {filtroHistoricoImpressoes.trim() && (
                        <button
                          type="button"
                          onClick={() => setFiltroHistoricoImpressoes('')}
                          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-neutral-500 hover:text-black hover:bg-neutral-100"
                          title="Limpar busca"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">Data Início</label>
                    <input type="date" value={filtroDataInicio} onChange={(e) => setFiltroDataInicio(e.target.value)} className="px-3 py-2 rounded-lg border border-[#009b3a]/22" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">Data Fim</label>
                    <input type="date" value={filtroDataFim} onChange={(e) => setFiltroDataFim(e.target.value)} className="px-3 py-2 rounded-lg border border-[#009b3a]/22" />
                  </div>
                  <button
                    onClick={() => {
                      setFiltroDataInicio('');
                      setFiltroDataFim('');
                      setFiltroHistoricoImpressoes('');
                    }}
                    className="px-4 py-2 bg-[#dde0e6] hover:bg-[#cfd3dc] rounded-lg text-sm font-medium"
                  >
                    Limpar filtros
                  </button>
                  {(filtroHistoricoImpressoes.trim() || filtroDataInicio || filtroDataFim) && (
                    <p className="w-full text-xs text-neutral-600 -mt-1">
                      {historicoImpressoesFiltrado.length} de {historicoImpressoes.length} impressão(ões)
                    </p>
                  )}
                </div>
                
                {historicoImpressoes.length === 0 ? (
                  <p className="text-neutral-600 text-center py-8">Nenhuma impressão registrada nos últimos 7 dias.</p>
                ) : historicoImpressoesFiltrado.length === 0 ? (
                  <p className="text-neutral-600 text-center py-8">
                    Nenhum resultado
                    {filtroHistoricoImpressoes.trim() ? ` para "${filtroHistoricoImpressoes.trim()}"` : ''}
                    {filtroDataInicio || filtroDataFim ? ' no período selecionado' : ''}.
                  </p>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    {historicoImpressoesFiltrado.map(item => (
                        <div key={item.id} className="p-4 rounded-lg border-2 border-[#009b3a]/15 bg-[#fafbfc] hover:border-[#009b3a]/28 transition-all">
                          <div className="flex justify-between items-start mb-2">
                            <div>
                              <p className="font-bold text-black">{item.projeto.nomeProduto || 'Sem nome'}</p>
                              {item.projeto.nomePeca && <p className="text-sm text-neutral-600">{item.projeto.nomePeca}</p>}
                            </div>
                            <button onClick={() => deletarDoHistorico(item.id)} className="text-red-500 hover:text-red-700"><Trash2 className="w-4 h-4" /></button>
                          </div>
                          <p className="text-xs text-neutral-600 mb-1">{item.data} ⬢ {item.pecas.length} cortes</p>
                          <p className="text-xs text-[#009b3a] mb-2">Plano: {item.layoutConfig?.plano ?? 1} | Etapa: {item.layoutConfig?.etapas ?? 1}</p>
                          <button onClick={() => carregarDoHistorico(item)} className="w-full px-3 py-2 ade-btn-gold relative z-10 text-sm flex items-center justify-center gap-2"><History className="w-4 h-4" />Carregar</button>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}

            {abaVisivel === 'relatorio' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-black flex items-center gap-2"><FileText className="w-5 h-5" />Relatório de Peças Produzidas</h3>
                  <div className="flex gap-2">
                    <button onClick={imprimirRelatorio} className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center gap-2"><Printer className="w-4 h-4" />Imprimir</button>
                    <button type="button" onClick={() => setModalColarExcelAberto(true)} className="px-4 py-2 bg-[#1F4E78] hover:bg-[#2a5f8f] text-white font-semibold rounded-lg flex items-center gap-2"><ClipboardPaste className="w-4 h-4" />Colar do Excel</button>
                    <button onClick={adicionarLinhaManual} className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center gap-2"><Plus className="w-4 h-4" />Adicionar Linha</button>
                    <button onClick={limparRelatorio} className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg flex items-center gap-2"><Trash2 className="w-4 h-4" />Limpar</button>
                  </div>
                </div>
                
                {/* Cabeçalho editável */}
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4 p-4 bg-[#eef0f4] rounded-xl">
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">LOTE</label>
                    <input type="text" value={relatorioCabecalho.lote} onChange={(e) => setRelatorioCabecalho({...relatorioCabecalho, lote: e.target.value})} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22" placeholder="Número do lote" />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-neutral-700 mb-1">PRODUTO</label>
                    <input type="text" value={relatorioCabecalho.nomeProduto} onChange={(e) => setRelatorioCabecalho({...relatorioCabecalho, nomeProduto: e.target.value})} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22" placeholder="Nome do produto" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">TEMPO</label>
                    <input type="text" value={relatorioCabecalho.tempo} onChange={(e) => setRelatorioCabecalho({...relatorioCabecalho, tempo: e.target.value})} className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22" placeholder="Tempo" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">DATA DE INÍCIO</label>
                    <input type="text" value={relatorioCabecalho.dataInicio} onChange={(e) => setRelatorioCabecalho({...relatorioCabecalho, dataInicio: e.target.value})} placeholder="____/____/______" className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">DATA DE TéRMINO</label>
                    <input type="text" value={relatorioCabecalho.dataTermino} onChange={(e) => setRelatorioCabecalho({...relatorioCabecalho, dataTermino: e.target.value})} placeholder="____/____/______" className="w-full px-3 py-2 rounded-lg border border-[#009b3a]/22 text-center" />
                  </div>
                </div>

                {/* Painel diagnóstico: produtos do Tempo de Corte usados nesta análise */}
                {(() => {
                  const lote = relatorioCabecalho.lote?.trim();
                  const nome = relatorioCabecalho.nomeProduto?.trim();
                  if (!lote || !nome) return null;
                  const compativeis = produtosSalvosCompativeisComCabecalhoRelatorio(
                    produtosTempoCorteSalvos,
                    lote,
                    nome
                  );
                  if (compativeis.length === 0) return null;
                  const linhas = compativeis.map((p) => ({
                    id: String(p?.id || ''),
                    nome: String(p?.nome || '(sem nome)'),
                    lote: String(p?.lote || ''),
                    tempo: obterTempoExatoSalvoProduto(p),
                    ignorado: produtosTcIgnoradosRelatorio.has(String(p?.id || '')),
                  }));
                  const totalAtivos = linhas
                    .filter((l) => !l.ignorado)
                    .reduce((acc, l) => acc + l.tempo, 0);
                  const totalIgnorados = linhas
                    .filter((l) => l.ignorado)
                    .reduce((acc, l) => acc + l.tempo, 0);
                  return (
                    <div className="rounded-xl border-2 border-blue-200 bg-blue-50/60 p-4">
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="font-semibold text-blue-900 flex items-center gap-2">
                          <Database className="w-4 h-4" />
                          Produtos do "Tempo de Corte" usados nesta análise ({linhas.length})
                        </h4>
                        <div className="text-xs text-blue-800">
                          Soma ativa: <span className="font-bold">{formatarTempo(totalAtivos)}</span>
                          {totalIgnorados > 0 && (
                            <span className="ml-3 text-neutral-500">
                              (ignorados: {formatarTempo(totalIgnorados)})
                            </span>
                          )}
                        </div>
                      </div>
                      <p className="text-xs text-blue-700 mb-3">
                        Se algum produto não deveria entrar no tempo, clique no <EyeOff className="w-3 h-3 inline" /> pra ignorar.
                        Vai recalcular o tempo do relatório imediatamente.
                      </p>
                      <div className="space-y-1.5">
                        {linhas.map((l) => (
                          <div
                            key={l.id}
                            className={`flex items-center justify-between gap-3 px-3 py-2 rounded-lg border ${
                              l.ignorado
                                ? 'bg-neutral-100 border-neutral-300 opacity-60'
                                : 'bg-white border-blue-200'
                            }`}
                          >
                            <div className="flex-1 min-w-0">
                              <div className={`text-sm font-medium ${l.ignorado ? 'line-through text-neutral-500' : 'text-neutral-800'}`}>
                                {l.nome}
                              </div>
                              <div className="text-xs text-neutral-500">
                                Lote: {l.lote || '—'}
                                {l.ignorado && <span className="ml-2 text-amber-700 font-semibold">(IGNORADO)</span>}
                              </div>
                            </div>
                            <div className={`text-sm font-mono ${l.ignorado ? 'text-neutral-400 line-through' : 'text-blue-900 font-semibold'}`}>
                              {formatarTempo(l.tempo)}
                            </div>
                            <button
                              onClick={() => {
                                setProdutosTcIgnoradosRelatorio((prev) => {
                                  const next = new Set(prev);
                                  if (next.has(l.id)) next.delete(l.id);
                                  else next.add(l.id);
                                  return next;
                                });
                              }}
                              title={l.ignorado ? 'Voltar a contar este produto' : 'Ignorar este produto'}
                              className={`p-1.5 rounded-lg ${
                                l.ignorado
                                  ? 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'
                                  : 'bg-amber-100 text-amber-700 hover:bg-amber-200'
                              }`}
                            >
                              {l.ignorado ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}

                {/* Tabela do relatório */}
                {relatorioItens.length === 0 ? (
                  <p className="text-neutral-600 text-center py-8">Nenhuma peça no relatório. Imprima planos de corte para adicionar automaticamente.</p>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-[#009b3a]/22">
                      <thead className="bg-[#e4e6ec]">
                        <tr>
                          <th className="px-2 py-2 text-center font-medium text-sm border bg-amber-50" title="Marcar como sobra: ao imprimir, peças marcadas vão para aba Sobra e não são impressas">SOBRA</th>
                          <th className="px-3 py-2 text-center font-medium text-sm border">CORTE</th>
                          <th className="px-3 py-2 text-center font-medium text-sm border">PEÇA</th>
                          <th className="px-2 py-2 text-center font-medium text-sm border">QTD</th>
                          <th className="px-2 py-2 text-center font-medium text-sm border">MEDIDA</th>
                          <th className="px-4 py-2 text-center font-medium text-sm border uppercase">MATERIAL</th>
                          <th className="px-2 py-2 text-center font-medium text-sm border bg-yellow-100">INÍCIO</th>
                          <th className="px-2 py-2 text-center font-medium text-sm border bg-yellow-100">TéRMINO</th>
                          <th className="px-2 py-2 text-center font-medium text-sm border bg-yellow-100">TEMPO POR PEÇA</th>
                          <th className="px-2 py-2 text-center font-medium text-sm border">AçõES</th>
                        </tr>
                      </thead>
                      <tbody>
                        {relatorioItens.map((item, index) => (
                          <tr key={item.id} className={`hover:bg-[#eef0f4] ${sobraMarcados.has(item.id) ? 'bg-amber-50' : ''} ${item.ocultoRelatorio ? 'opacity-60' : ''}`}>
                            <td className="px-2 py-2 text-center border bg-amber-50/50">
                              <label className="flex items-center justify-center gap-1 cursor-pointer" title="Marcar como sobra">
                                <input type="checkbox" checked={sobraMarcados.has(item.id)} onChange={() => toggleSobraMarcado(item.id)} className="w-4 h-4 rounded border-[#009b3a]/22 text-amber-600" />
                                <span className="text-xs text-amber-700">Sobra</span>
                              </label>
                            </td>
                            <td className="px-2 py-2 text-center border">
                              <div className="flex flex-col items-center gap-1">
                                <span className="font-bold">{item.corteNumero}º</span>
                                {item.ocultoRelatorio && (
                                  <span className="text-[10px] font-semibold text-amber-700">OCULTA</span>
                                )}
                                <div className="flex gap-1">
                                  <button onClick={() => moverItemRelatorio(item.id, 'cima')} disabled={index === 0} className="p-1 text-neutral-600 hover:text-neutral-700 disabled:opacity-30"><ChevronUp className="w-4 h-4" /></button>
                                  <button onClick={() => moverItemRelatorio(item.id, 'baixo')} disabled={index === relatorioItens.length - 1} className="p-1 text-neutral-600 hover:text-neutral-700 disabled:opacity-30"><ChevronDown className="w-4 h-4" /></button>
                                </div>
                              </div>
                            </td>
                            <td className="px-2 py-2 border"><input type="text" value={item.nomePeca} onChange={(e) => editarItemRelatorio(item.id, 'nomePeca', e.target.value)} onKeyDown={(e) => onEnterProximaLinha(e, 'relatorio', index, 1, Math.max(0, relatorioItens.length - 1))} data-grid="relatorio" data-row={index} data-col={1} className="w-full px-1 py-1 text-sm border rounded" /></td>
                            <td className="px-2 py-2 border"><input type="number" value={item.quantidade} onChange={(e) => editarItemRelatorio(item.id, 'quantidade', Number(e.target.value))} onKeyDown={(e) => onEnterProximaLinha(e, 'relatorio', index, 2, Math.max(0, relatorioItens.length - 1))} data-grid="relatorio" data-row={index} data-col={2} className="w-full px-1 py-1 text-sm border rounded text-center font-bold" /></td>
                            <td className="px-2 py-2 border"><input type="text" value={`${item.medidaMenor}×${item.medidaMaior}`} onChange={(e) => {
                              const partes = e.target.value.split(/[×xX]/);
                              if (partes.length === 2) {
                                editarItemRelatorio(item.id, 'medidaMenor', Number(partes[0].trim()) || 0);
                                editarItemRelatorio(item.id, 'medidaMaior', Number(partes[1].trim()) || 0);
                              }
                            }} onKeyDown={(e) => onEnterProximaLinha(e, 'relatorio', index, 3, Math.max(0, relatorioItens.length - 1))} data-grid="relatorio" data-row={index} data-col={3} className="w-full px-1 py-1 text-sm border rounded text-center font-mono" /></td>
                            <td className="px-2 py-2 text-center border text-sm uppercase">{item.material === 'mdf' ? 'MDF' : 'AGLO'} - {item.espessura}MM</td>
                            <td className="px-2 py-2 border bg-yellow-50"><input type="text" value={item.inicio} onChange={(e) => editarItemRelatorio(item.id, 'inicio', e.target.value)} onKeyDown={(e) => onEnterProximaLinha(e, 'relatorio', index, 5, Math.max(0, relatorioItens.length - 1))} data-grid="relatorio" data-row={index} data-col={5} className="w-full px-1 py-1 text-sm border rounded" /></td>
                            <td className="px-2 py-2 border bg-yellow-50"><input type="text" value={item.termino} onChange={(e) => editarItemRelatorio(item.id, 'termino', e.target.value)} onKeyDown={(e) => onEnterProximaLinha(e, 'relatorio', index, 6, Math.max(0, relatorioItens.length - 1))} data-grid="relatorio" data-row={index} data-col={6} className="w-full px-1 py-1 text-sm border rounded" /></td>
                            <td className="px-2 py-2 border bg-yellow-50">
                              <input
                                type="text"
                                value={
                                  item.tempoPorPecaMinutos != null && !Number.isNaN(item.tempoPorPecaMinutos)
                                    ? formatarTempo(item.tempoPorPecaMinutos)
                                    : ''
                                }
                                onChange={(e) =>
                                  editarItemRelatorio(
                                    item.id,
                                    'tempoPorPecaMinutos',
                                    e.target.value.trim() === ''
                                      ? null
                                      : parseTempoToMinutos(e.target.value)
                                  )
                                }
                                onKeyDown={(e) =>
                                  onEnterProximaLinha(
                                    e,
                                    'relatorio',
                                    index,
                                    7,
                                    Math.max(0, relatorioItens.length - 1)
                                  )
                                }
                                data-grid="relatorio"
                                data-row={index}
                                data-col={7}
                                placeholder="00:00:00"
                                title="Preenchido automaticamente pelo Tempo de Corte (produto salvo + lote). Edite se precisar."
                                className="w-full px-1 py-1 text-sm border rounded font-mono"
                              />
                            </td>
                            <td className="px-2 py-2 text-center border">
                              <div className="flex items-center justify-center gap-2">
                                <button
                                  type="button"
                                  title={item.ocultoRelatorio ? 'Reexibir linha na impressão' : 'Ocultar linha da impressão'}
                                  onClick={() => toggleOcultoRelatorio(item.id)}
                                  className={`${item.ocultoRelatorio ? 'text-amber-700 hover:text-amber-800' : 'text-neutral-600 hover:text-neutral-800'}`}
                                >
                                  {item.ocultoRelatorio ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
                                </button>
                                <button onClick={() => removerItemRelatorio(item.id)} className="text-red-500 hover:text-red-700"><Trash2 className="w-4 h-4" /></button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                
              </div>
            )}

            {abaVisivel === 'produtoPorPalete' && (
              <ProdutoPorPalete lotesProdutos={lotesProdutos} />
            )}

            {abaVisivel === 'tempoEmbalar' && (
              <TempoParaEmbalar
                pontuacoesProdutos={pontuacoesProdutos}
                ativo={abaVisivel === 'tempoEmbalar'}
              />
            )}

            {abaVisivel === 'sobra' && (
              <div className="space-y-4">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h3 className="font-semibold text-black flex items-center gap-2">
                    <Package className="w-5 h-5" />
                    Peças em Sobra
                  </h3>
                  <button
                    type="button"
                    onClick={() => void recuperarSobraDoBackup()}
                    className="px-3 py-1.5 rounded-lg border border-amber-400 bg-amber-50 text-amber-900 text-xs font-medium hover:bg-amber-100 flex items-center gap-1.5"
                    title="Busca cards de sobra no IndexedDB e no backup localStorage (módulo Sobra)"
                  >
                    <RefreshCw className="w-3.5 h-3.5" />
                    Recuperar do backup
                  </button>
                </div>
                <div className="flex flex-wrap gap-2 border-b border-[#009b3a]/15 pb-3">
                  <button
                    type="button"
                    onClick={() => setPaginaSobraADE('lista')}
                    className={`px-4 py-2.5 rounded-xl text-sm font-semibold transition ${
                      paginaSobraADE === 'lista'
                        ? 'bg-amber-600 text-white shadow-md'
                        : 'bg-[#e4e6ec] text-black hover:bg-[#dde0e6]'
                    }`}
                  >
                    Lista de sobras
                  </button>
                  <button
                    type="button"
                    onClick={() => setPaginaSobraADE('pastas')}
                    className={`px-4 py-2.5 rounded-xl text-sm font-semibold transition ${
                      paginaSobraADE === 'pastas'
                        ? 'bg-amber-600 text-white shadow-md'
                        : 'bg-[#e4e6ec] text-black hover:bg-[#dde0e6]'
                    }`}
                  >
                    Pastas
                  </button>
                </div>
                {paginaSobraADE === 'lista' && (
                  <>
                <p className="text-sm text-neutral-600">
                  Cabeçalho do card mostra só <strong>Lote</strong>, <strong>Produto</strong> e <strong>Incluído</strong>. Aba <strong>Pastas</strong> exibe ícones grandes; na coluna <strong>PASTA</strong> cada linha pode ir para uma pasta diferente.
                </p>
                <div className="flex flex-wrap items-end gap-2 p-3 rounded-xl border border-amber-200 bg-amber-50/80">
                  <div className="flex-1 min-w-[200px]">
                    <label className="block text-xs font-medium text-amber-900 mb-1">Nova pasta</label>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        value={nomeNovaPastaSobra}
                        onChange={(e) => setNomeNovaPastaSobra(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && criarPastaSobraADE()}
                        placeholder="Ex.: Aruba — cliente X"
                        className="flex-1 px-3 py-2 rounded-lg border border-amber-300 text-sm bg-[#fafbfc]"
                      />
                      <button
                        type="button"
                        onClick={criarPastaSobraADE}
                        className="px-3 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold rounded-lg flex items-center gap-1"
                      >
                        <FolderPlus className="w-4 h-4" />
                        Criar
                      </button>
                    </div>
                  </div>
                  <div className="min-w-[180px]">
                    <label className="block text-xs font-medium text-amber-900 mb-1">Ver pasta</label>
                    <select
                      value={pastaFiltroSobra}
                      onChange={(e) => setPastaFiltroSobra(e.target.value as 'todas' | 'sem' | string)}
                      className="w-full px-3 py-2 rounded-lg border border-amber-300 text-sm bg-[#fafbfc]"
                    >
                      <option value="todas">Todas</option>
                      <option value="sem">Sem pasta</option>
                      {pastasSobra.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {pastasSobra.length > 0 && (
                  <div className="flex flex-wrap gap-2 items-center text-sm">
                    <span className="text-neutral-700 font-medium">Pastas (clique para ver só esta pasta):</span>
                    {pastasSobra.map((p) => (
                      <span
                        key={p.id}
                        className="inline-flex items-center gap-1 pl-2 pr-1 py-1 rounded-full bg-[#e4e6ec] border border-[#009b3a]/15 text-black"
                      >
                        <button
                          type="button"
                          onClick={() => setPastaFiltroSobra(p.id)}
                          className="inline-flex items-center gap-1 pl-0.5 pr-1 py-0.5 rounded-full hover:bg-amber-100/80 text-left"
                          title="Mostrar só sobras desta pasta"
                        >
                          <FolderOpen className="w-3.5 h-3.5 text-amber-600 shrink-0" />
                          <span className="max-w-[200px] truncate">{p.nome}</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => excluirPastaSobraADE(p.id)}
                          className="p-0.5 rounded text-rose-600 hover:bg-rose-100"
                          title="Excluir pasta"
                        >
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                      </span>
                    ))}
                  </div>
                )}
                {sobraItens.length > 0 && (
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="relative flex-1 max-w-md">
                      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-600" />
                      <input
                        type="text"
                        value={filtroSobra}
                        onChange={(e) => setFiltroSobra(e.target.value)}
                        placeholder="Buscar por lote, produto, peça, medida, material, obs..."
                        className="w-full pl-9 pr-4 py-2 rounded-lg border border-[#009b3a]/22 text-sm focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                      />
                    </div>
                    {(filtroSobra || pastaFiltroSobra !== 'todas') && (
                      <span className="text-xs text-neutral-600">
                        {sobraItensFiltrados.length} resultado(s)
                      </span>
                    )}
                    <button
                      type="button"
                      onClick={() =>
                        imprimirEntradasSobra(
                          sobraItensFiltrados
                            .filter((row) => sobraSelecionadosParaImpressao.has(row.entrada.id))
                            .map((row) => row.entrada)
                        )
                      }
                      disabled={
                        sobraItensFiltrados.filter((row) => sobraSelecionadosParaImpressao.has(row.entrada.id)).length ===
                        0
                      }
                      className="ade-btn-gold relative z-10 flex items-center gap-1 rounded-lg px-3 py-2 text-xs disabled:opacity-40"
                    >
                      <Printer className="w-3.5 h-3.5" />
                      Imprimir selecionados
                    </button>
                    {pastaFiltroSobra !== 'todas' && pastaFiltroSobra !== 'sem' && (
                      <button
                        type="button"
                        onClick={() => imprimirPastaSobraADE(pastaFiltroSobra)}
                        className="px-3 py-2 bg-amber-600 hover:bg-amber-700 text-white text-xs font-semibold rounded-lg flex items-center gap-1"
                      >
                        <Printer className="w-3.5 h-3.5" />
                        Imprimir pasta inteira
                      </button>
                    )}
                  </div>
                )}
                {sobraItens.length === 0 ? (
                  <p className="text-neutral-600 text-center py-8">Nenhuma peça em sobra. Marque peças no Relatório e clique em Imprimir para enviá-las aqui.</p>
                ) : sobraItensFiltrados.length === 0 ? (
                  <p className="text-neutral-600 text-center py-8">
                    {sobraItens.length > 0 && !filtroSobra.trim()
                      ? 'Nenhuma linha de peça nesta pasta (ou combinação de filtro). Troque &quot;Ver pasta&quot; ou mova linhas na coluna PASTA.'
                      : `Nenhum resultado encontrado${filtroSobra.trim() ? ` para "${filtroSobra}"` : ''}.`}
                  </p>
                ) : (
                  <div className="space-y-4">
                    {sobraItensFiltrados.map(({ entrada, itensVisiveis }) => (
                      <div key={entrada.id} className="border-2 border-[#009b3a]/15 rounded-xl overflow-hidden bg-[#fafbfc]">
                        <div className="bg-amber-50 px-4 py-3 flex flex-col gap-3 border-b border-amber-200 sm:flex-row sm:items-start sm:justify-between">
                          <div className="flex flex-wrap gap-3 text-sm items-center">
                            <label className="inline-flex items-center gap-2">
                              <input
                                type="checkbox"
                                checked={sobraSelecionadosParaImpressao.has(entrada.id)}
                                onChange={() => toggleSelecionarSobraParaImpressao(entrada.id)}
                                className="rounded border-[#009b3a]/22"
                              />
                              <span className="text-xs font-semibold text-black">Juntar impressão</span>
                            </label>
                            <span><strong>Lote:</strong> {entrada.cabecalho.lote || '-'}</span>
                            <span><strong>Produto:</strong> {entrada.cabecalho.nomeProduto || '-'}</span>
                            <span className="text-neutral-700">
                              <strong>Incluído:</strong> {new Date(entrada.dataAdicao).toLocaleString('pt-BR')}
                            </span>
                          </div>
                          <div className="flex items-center gap-2 shrink-0">
                            <button
                              type="button"
                              onClick={() => imprimirEntradasSobra([entrada])}
                              className="px-2.5 py-1.5 ade-btn-gold relative z-10 text-xs font-semibold rounded-lg flex items-center gap-1"
                            >
                              <Printer className="w-3.5 h-3.5" />
                              Imprimir
                            </button>
                            <button
                              onClick={() => {
                                setSobraSelecionadosParaImpressao((prev) => {
                                  const next = new Set(prev);
                                  next.delete(entrada.id);
                                  return next;
                                });
                                registrarExclusaoEntradaSobra(entrada.id);
                                for (const it of entrada.itens || []) {
                                  if (it?.id) registrarExclusaoLinhaSobra(entrada.id, it.id);
                                }
                                setSobraItens((prev) => {
                                  const next = prev.filter((e) => e.id !== entrada.id);
                                  ignorarSaveSobraRef.current = true;
                                  void persistirSobraDireto(next).then(() => {
                                    notificarSyncDesktop('sobra');
                                  });
                                  return next;
                                });
                              }}
                              className="text-red-500 hover:text-red-700"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                        <div className="px-3 py-2 bg-amber-50/90 border-b border-amber-200 text-[11px] text-amber-950">
                          {pastasSobra.length === 0 ? (
                            <span>
                              <strong>Nova pasta</strong> acima — depois use a coluna <strong>PASTA</strong> em cada linha da tabela.
                            </span>
                          ) : (
                            <span>
                              <strong>Pasta por linha:</strong> cada peça pode ir para uma pasta diferente (coluna PASTA). O cabeçalho do card é só referência comum.
                            </span>
                          )}
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full border-collapse">
                            <thead><tr className="bg-[#e4e6ec] text-left text-sm">
                              <th className="px-2 py-2 border w-10"></th>
                              <th className="px-2 py-2 border bg-amber-50 min-w-[160px]">PASTA</th>
                              <th className="px-3 py-2 border">CORTE</th>
                              <th className="px-3 py-2 border">PEÇA</th>
                              <th className="px-2 py-2 border">QTD</th>
                              <th className="px-2 py-2 border">MEDIDA</th>
                              <th className="px-3 py-2 border">MATERIAL</th>
                              <th className="px-2 py-2 border">PRODUTO</th>
                              <th className="px-2 py-2 border">OBS</th>
                              <th className="px-2 py-2 border w-14 text-center">AçãO</th>
                            </tr></thead>
                            <tbody>
                              {itensVisiveis.map(item => {
                                const chaveRiscado = `${entrada.id}-${item.id}`;
                                const riscado = Boolean(item.riscadoSobra) || sobraRiscados.has(chaveRiscado);
                                return (
                                  <tr
                                    key={item.id}
                                    className={`border-b border-[#009b3a]/10 ${
                                      riscado
                                        ? '[&>td:not(:first-child):not(:last-child)]:line-through'
                                        : ''
                                    }`}
                                  >
                                    <td className="px-2 py-2 border">
                                      <label className="flex items-center justify-center cursor-pointer">
                                        <input
                                          type="checkbox"
                                          checked={riscado}
                                          onChange={() => toggleSobraRiscado(entrada.id, item.id)}
                                          className="rounded border-[#009b3a]/22"
                                        />
                                      </label>
                                    </td>
                                    <td className="px-1 py-1.5 border align-top bg-amber-50/40">
                                      <select
                                        value={item.pastaSobraId ?? ''}
                                        onChange={(e) => {
                                          const v = e.target.value;
                                          setSobraItens((prev) => {
                                            const next = prev.map((ex) =>
                                              ex.id !== entrada.id
                                                ? ex
                                                : {
                                                    ...ex,
                                                    itens: ex.itens.map((it) =>
                                                      it.id === item.id
                                                        ? { ...it, pastaSobraId: v === '' ? null : v }
                                                        : it
                                                    ),
                                                  }
                                            );
                                            ignorarSaveSobraRef.current = true;
                                            void persistirSobraDireto(next).then(() => {
                                              notificarSyncDesktop('sobra');
                                            });
                                            return next;
                                          });
                                        }}
                                        className="w-full max-w-[200px] text-[11px] px-1.5 py-1.5 rounded-md border border-amber-400 bg-[#fafbfc] font-medium text-black"
                                      >
                                        <option value="">Sem pasta</option>
                                        {pastasSobra.map((p) => (
                                          <option key={p.id} value={p.id}>
                                            {p.nome}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td className="px-3 py-2 font-bold">{item.corteNumero}º</td>
                                    <td className="px-3 py-2">{item.nomePeca || '-'}</td>
                                    <td className="px-2 py-2 text-center font-bold">
                                      <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={String(item.quantidade ?? '')}
                                        onChange={(e) =>
                                          atualizarQuantidadeLinhaSobraADE(
                                            entrada.id,
                                            item.id,
                                            e.target.value
                                          )
                                        }
                                        onBlur={() => normalizarQuantidadeLinhaSobraADE(entrada.id, item.id)}
                                        className="input-numerico w-16 rounded border border-[#009b3a]/30 bg-[#fafbfc] px-2 py-1 text-center text-sm font-semibold text-black"
                                        aria-label="Quantidade da linha de sobra"
                                      />
                                    </td>
                                    <td className="px-2 py-2 text-center font-mono">{item.medidaMenor}×{item.medidaMaior}</td>
                                    <td className="px-3 py-2 text-sm uppercase">{item.material === 'mdf' ? 'MDF' : 'AGLO'} - {item.espessura}MM</td>
                                    <td className="px-2 py-2">{item.inicio || '-'}</td>
                                    <td className="px-2 py-2">
                                      <input
                                        type="text"
                                        value={item.observacao || ''}
                                        onChange={(e) => {
                                          const obs = e.target.value;
                                          setSobraItens((prev) =>
                                            prev.map((ex) =>
                                              ex.id !== entrada.id
                                                ? ex
                                                : {
                                                    ...ex,
                                                    itens: ex.itens.map((it) =>
                                                      it.id === item.id ? { ...it, observacao: obs } : it
                                                    ),
                                                  }
                                            )
                                          );
                                        }}
                                        className="w-full rounded border border-[#009b3a]/30 bg-[#fafbfc] px-2 py-1 text-sm text-black"
                                        placeholder="Digite observação"
                                      />
                                    </td>
                                    <td className="px-1 py-2 border text-center align-middle">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          if (
                                            !confirm(
                                              'Remover esta linha (peça) deste card de sobra?'
                                            )
                                          )
                                            return;
                                          removerLinhaSobraADE(entrada.id, item.id);
                                        }}
                                        className="inline-flex p-1.5 rounded-lg text-rose-600 hover:bg-rose-100"
                                        title="Remover só esta linha"
                                      >
                                        <Trash2 className="w-4 h-4" />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                  </>
                )}
                {paginaSobraADE === 'pastas' && (
                  <div className="space-y-4 pt-2">
                    <p className="text-sm text-neutral-700">
                      Pastas com ícones grandes. Na <strong>Lista de sobras</strong> você cria pastas, classifica linhas e imprime.
                    </p>
                    {(pastasSobra.length > 0 || linhasSemPastaSobraCount > 0) && (
                      <div className="flex flex-wrap items-center gap-2">
                        <div className="relative flex-1 min-w-[200px] max-w-md">
                          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-500 pointer-events-none" />
                          <input
                            type="search"
                            value={filtroNomePastasSobra}
                            onChange={(e) => setFiltroNomePastasSobra(e.target.value)}
                            placeholder="Buscar pasta por nome..."
                            className="w-full pl-9 pr-9 py-2 rounded-lg border border-amber-300 text-sm bg-[#fafbfc] focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                          />
                          {filtroNomePastasSobra.trim() && (
                            <button
                              type="button"
                              onClick={() => setFiltroNomePastasSobra('')}
                              className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-neutral-500 hover:text-black hover:bg-neutral-100"
                              title="Limpar busca"
                            >
                              <X className="w-4 h-4" />
                            </button>
                          )}
                        </div>
                        {filtroNomePastasSobra.trim() && (
                          <span className="text-xs text-neutral-600">
                            {(mostrarCardSemPastaSobra ? 1 : 0) + pastasSobraFiltradasPorNome.length}{' '}
                            pasta(s)
                          </span>
                        )}
                      </div>
                    )}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {mostrarCardSemPastaSobra && (
                        <div className="rounded-2xl border-2 border-dashed border-[#009b3a]/22 bg-[#eef0f4] p-6 flex flex-col items-center justify-center text-center gap-3 min-h-[240px]">
                          <FolderOpen className="w-24 h-24 text-neutral-600" />
                          <p className="font-bold text-black text-lg">Sem pasta</p>
                          <p className="text-sm text-neutral-700">{linhasSemPastaSobraCount} linha(s)</p>
                          <button
                            type="button"
                            onClick={() => {
                              setPastaFiltroSobra('sem');
                              setPaginaSobraADE('lista');
                            }}
                            className="px-4 py-2 rounded-xl bg-slate-700 text-white text-sm font-semibold hover:bg-[#3d424c]"
                          >
                            Ver na lista
                          </button>
                        </div>
                      )}
                      {pastasSobraFiltradasPorNome.map((p) => (
                        <div
                          key={p.id}
                          className="rounded-2xl border-2 border-amber-200 bg-gradient-to-b from-amber-50 to-white p-6 flex flex-col items-center text-center gap-3 min-h-[240px] shadow-sm"
                        >
                          <FolderOpen className="w-24 h-24 text-amber-500 drop-shadow" />
                          <p className="font-bold text-black text-lg leading-tight px-1">{p.nome}</p>
                          <p className="text-sm text-neutral-700">
                            {contagemLinhasPorPastaSobra.get(p.id) ?? 0} linha(s)
                          </p>
                          <div className="flex flex-wrap gap-2 justify-center mt-auto">
                            <button
                              type="button"
                              onClick={() => {
                                setPastaFiltroSobra(p.id);
                                setPaginaSobraADE('lista');
                              }}
                              className="px-4 py-2 rounded-xl bg-slate-700 text-white text-sm font-semibold hover:bg-[#3d424c]"
                            >
                              Ver na lista
                            </button>
                            <button
                              type="button"
                              onClick={() => imprimirPastaSobraADE(p.id)}
                              className="ade-btn-gold relative z-10 flex items-center gap-1.5 rounded-xl px-4 py-2 text-sm"
                            >
                              <Printer className="w-4 h-4" />
                              Imprimir pasta
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    {filtroNomePastasSobra.trim() &&
                      !mostrarCardSemPastaSobra &&
                      pastasSobraFiltradasPorNome.length === 0 && (
                        <p className="text-center text-neutral-600 py-12 text-sm">
                          Nenhuma pasta encontrada para &quot;{filtroNomePastasSobra.trim()}&quot;.
                        </p>
                      )}
                    {!filtroNomePastasSobra.trim() &&
                      pastasSobra.length === 0 &&
                      linhasSemPastaSobraCount === 0 && (
                      <p className="text-center text-neutral-600 py-12 text-sm">
                        Nenhuma sobra ainda. Use a <strong>Lista de sobras</strong> após enviar peças do Relatório.
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}

            {montarComponentePesado(isJanelaFilha, moduloFixo, 'resultadosCopa', abaVisivel) && (
            <div className={abaVisivel === 'resultadosCopa' ? '' : 'hidden'} aria-hidden={abaVisivel !== 'resultadosCopa'}>
              <ResultadosCopa />
            </div>
            )}

        {abaVisivel === 'projeto' && (
        <>
        {/* Lançamento de Peças */}
        <div className="bg-[#fafbfc] rounded-2xl shadow-neu p-6 border border-[#009b3a]/15">
          <h2 className="text-xl font-semibold text-black mb-4 flex items-center gap-2"><span className="w-8 h-8 bg-[#e8f5ec] rounded-lg flex items-center justify-center text-[#009b3a] text-sm font-bold">1</span>Lançamento de Peças</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div><label className="block text-sm font-medium text-black mb-2">Código</label><select value={novaPeca.codigo} onChange={(e) => setNovaPeca({ ...novaPeca, codigo: Number(e.target.value) as EixoCodigo })} className={`w-full px-4 py-3 rounded-xl border-2 transition-all text-lg font-semibold cursor-pointer ${novaPeca.codigo === 3 ? 'border-[#009b3a]/40 bg-[#f0faf3] text-black' : novaPeca.codigo === 5 ? 'border-[#009b3a]/50 bg-[#eef0f4] text-black' : 'border-[#009b3a]/35 bg-[#fafbfc] text-black'}`}><option value={3}>3 - Longitudinal</option><option value={4}>4 - Transversal</option><option value={44}>44 - Transversal</option><option value={5}>5 - Longitudinal (3º corte)</option></select></div>
            <div><label className="block text-sm font-medium text-black mb-2">Medida (mm)</label><input type="number" value={novaPeca.medida || ''} onChange={(e) => setNovaPeca({ ...novaPeca, medida: Number(e.target.value) })} onKeyDown={handleKeyDown} placeholder="Ex: 1328" className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 text-lg" /></div>
            <div><label className="block text-sm font-medium text-black mb-2">Quantidade</label><input type="number" value={novaPeca.quantidade} onChange={(e) => setNovaPeca({ ...novaPeca, quantidade: Number(e.target.value) })} onKeyDown={handleKeyDown} min={1} className="w-full px-4 py-3 rounded-xl border border-[#009b3a]/22 text-lg" /></div>
            <div className="flex items-end gap-2"><button onClick={handleAdicionar} disabled={novaPeca.medida <= 0 || novaPeca.quantidade <= 0} className="ade-btn-gold relative z-10 flex flex-1 items-center justify-center gap-2 rounded-xl px-6 py-3 disabled:opacity-40"><Plus className="w-5 h-5" />Adicionar</button><button onClick={() => { setErroLancamentoPeca(''); novoGrupo(); }} title="Novo Grupo" className="px-4 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-xl"><Layers className="w-5 h-5" /></button></div>
          </div>
          {erroLancamentoPeca && (
            <p className="mt-3 text-sm font-semibold text-red-600 bg-red-50 border border-red-300 rounded-lg px-3 py-2">
              {erroLancamentoPeca}
            </p>
          )}
        </div>
        
        {/* Visualização */}
        {resultado.grupos.length > 0 && (
          <div className="bg-[#fafbfc] rounded-2xl shadow-neu p-6 border border-[#009b3a]/15">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-xl font-semibold text-black flex items-center gap-2"><span className="w-8 h-8 bg-[#e8f5ec] rounded-lg flex items-center justify-center text-[#009b3a] text-sm font-bold">2</span>Visualização</h2>
              <div className="flex gap-2"><button onClick={girarDesenho} className="px-4 py-2 bg-slate-600 hover:bg-slate-700 text-white font-semibold rounded-lg flex items-center gap-2"><RotateCw className="w-4 h-4" />Girar</button><button onClick={imprimir} className="px-4 py-2 ade-btn-gold relative z-10 font-semibold rounded-lg flex items-center gap-2"><Printer className="w-4 h-4" />Imprimir</button></div>
            </div>
            <p className="mb-3 text-xs text-neutral-600">
              Impressão usa o plano atual:{' '}
              <span className="font-semibold text-black">
                {layoutConfig.tipoMaterial === 'mdf' ? 'MDF' : 'Aglomerado'} · {layoutConfig.espessuraMaterial}mm ·{' '}
                {Number(layoutConfig.quantidadeChapas) || 0} chapa(s)
              </span>
              {layoutConfig.observacoes.trim() ? (
                <span className="text-neutral-600"> · obs. preenchida</span>
              ) : null}
              {(layoutConfig.caixasTexto?.length ?? 0) > 0 ? (
                <span className="text-neutral-600"> · {(layoutConfig.caixasTexto?.length ?? 0)} caixa(s) de texto</span>
              ) : null}
            </p>
            <VisualizacaoCorte
              grupos={resultado.grupos}
              configuracao={configuracao}
              projeto={projeto}
              rotacao={rotacaoDesenho}
              pecasAcabadas={resultado.pecasAcabadas}
              caixasTexto={layoutConfig.caixasTexto ?? []}
              onCaixasTextoChange={(caixasTexto) => setLayoutConfig((prev) => ({ ...prev, caixasTexto }))}
            />
          </div>
        )}
        
        {/* Tabela de Grupos */}
        {resultado.grupos.length > 0 && (
          <div className="bg-[#fafbfc] rounded-2xl shadow-neu p-6 border border-[#009b3a]/15">
            <h2 className="text-xl font-semibold text-black mb-4 flex items-center gap-2"><span className="w-8 h-8 bg-[#e8f5ec] rounded-lg flex items-center justify-center text-[#009b3a] text-sm font-bold">3</span>Detalhamento por Grupo</h2>
            <p className="mb-3 text-xs text-neutral-600">
              Errou uma medida? Clique no lápis na linha — código, eixo e sequência permanecem; só medida ou quantidade mudam.
            </p>
            {erroLancamentoPeca && pecaEditandoId && (
              <p className="mb-3 text-sm font-semibold text-red-600 bg-red-50 border border-red-300 rounded-lg px-3 py-2">
                {erroLancamentoPeca}
              </p>
            )}
            <div className="space-y-4">{resultado.grupos.map((grupo, grupoIndex) => (
              <div key={grupo.id} className="border-2 border-[#009b3a]/15 rounded-xl overflow-hidden">
                <div className="bg-[#e4e6ec] px-4 py-3 flex items-center justify-between"><h3 className="font-semibold text-black flex items-center gap-2"><Layers className="w-4 h-4 text-amber-500" />Grupo {grupoIndex + 1}</h3><div className="flex gap-4 text-sm"><span className={`px-2 py-1 rounded ${(grupo.larguraDisponivel ?? 0) < 0 ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>Largura: {(Number(grupo.larguraDisponivel) || 0).toLocaleString('pt-BR')} mm</span><span className={`px-2 py-1 rounded ${(grupo.comprimentoDisponivel ?? 0) < 0 ? 'bg-red-100 text-red-700' : 'bg-[#e4eaf5] text-blue-700'}`}>Comprimento: {(Number(grupo.comprimentoDisponivel) || 0).toLocaleString('pt-BR')} mm</span></div></div>
                <div className="overflow-x-auto"><table className="w-full"><thead><tr className="border-b border-[#009b3a]/15 bg-[#eef0f4]"><th className="text-left py-2 px-3 font-medium text-neutral-700 text-sm">#</th><th className="text-center py-2 px-3 font-medium text-neutral-700 text-sm">Código</th><th className="text-center py-2 px-3 font-medium text-neutral-700 text-sm">Eixo</th><th className="text-center py-2 px-3 font-medium text-neutral-700 text-sm">Medida</th><th className="text-center py-2 px-3 font-medium text-neutral-700 text-sm">Qtd</th><th className="text-center py-2 px-3 font-medium text-neutral-700 text-sm">Consumo</th><th className="text-center py-2 px-3 font-medium text-neutral-700 text-sm">Ações</th></tr></thead>
                  <tbody>
                    {grupo.pecas.map((peca, index) => {
                      const editando = pecaEditandoId === peca.id;
                      const medidaExibir = editando ? editMedida : peca.medida;
                      const qtdExibir = editando ? editQuantidade : peca.quantidade;
                      return (
                        <tr key={peca.id} className={`border-b border-[#009b3a]/10 ${getCorCodigo(peca.codigo)}`}>
                          <td className="py-2 px-3 font-medium text-sm">{index + 1}</td>
                          <td className="py-2 px-3 text-center font-bold text-sm">{peca.codigo}</td>
                          <td className="py-2 px-3 text-center text-xs">{getEixoNome(peca.codigo)}</td>
                          <td className="py-2 px-3 text-center font-mono text-sm">
                            {editando ? (
                              <input
                                type="number"
                                value={editMedida || ''}
                                onChange={(e) => setEditMedida(Number(e.target.value))}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') confirmarEdicaoPeca();
                                  if (e.key === 'Escape') cancelarEdicaoPeca();
                                }}
                                className="w-20 rounded border border-[#009b3a]/35 px-2 py-1 text-center text-sm"
                                autoFocus
                              />
                            ) : (
                              peca.medida
                            )}
                          </td>
                          <td className="py-2 px-3 text-center font-semibold text-sm">
                            {editando ? (
                              <input
                                type="number"
                                min={1}
                                value={editQuantidade}
                                onChange={(e) => setEditQuantidade(Number(e.target.value))}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') confirmarEdicaoPeca();
                                  if (e.key === 'Escape') cancelarEdicaoPeca();
                                }}
                                className="w-14 rounded border border-[#009b3a]/35 px-2 py-1 text-center text-sm"
                              />
                            ) : (
                              peca.quantidade
                            )}
                          </td>
                          <td className="py-2 px-3 text-center font-bold font-mono text-sm">
                            {((medidaExibir + configuracao.espessuraSerra) * qtdExibir).toLocaleString('pt-BR')} mm
                          </td>
                          <td className="py-2 px-3 text-center">
                            <div className="flex items-center justify-center gap-1">
                              {editando ? (
                                <>
                                  <button
                                    type="button"
                                    onClick={confirmarEdicaoPeca}
                                    className="p-1 text-[#009b3a] hover:bg-[#e8f5ec] rounded"
                                    title="Salvar alteração"
                                  >
                                    <Check className="w-4 h-4" />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={cancelarEdicaoPeca}
                                    className="p-1 text-neutral-600 hover:bg-neutral-100 rounded"
                                    title="Cancelar"
                                  >
                                    <X className="w-4 h-4" />
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => iniciarEdicaoPeca(peca)}
                                    className="p-1 text-[#009b3a] hover:bg-[#e8f5ec] rounded"
                                    title="Editar medida ou quantidade"
                                  >
                                    <Pencil className="w-4 h-4" />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => removerPeca(peca.id)}
                                    className="p-1 text-red-600 hover:bg-red-100 rounded"
                                    title="Excluir linha"
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table></div>
              </div>
            ))}</div>
          </div>
        )}
        
        {pecas.length === 0 && <div className="bg-[#fafbfc] rounded-2xl shadow-neu p-6 border border-[#009b3a]/15 text-center py-12 text-neutral-600"><Calculator className="w-16 h-16 mx-auto mb-4 opacity-50" /><p className="text-lg">Nenhuma peça lançada ainda</p></div>}
        </>
        )}
        
      </div>
    </main>

    <nav
      className="ade-glass-tabbar print:hidden fixed bottom-4 left-1/2 z-40 max-w-[98vw] -translate-x-1/2 px-2 py-2"
      aria-label="Acesso rápido"
    >
      <div className="flex max-w-[92vw] gap-1 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:thin] sm:max-w-4xl [&::-webkit-scrollbar]:h-1 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-[#009b3a]/35">
        {tabBarRapida.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => navegarParaAba(t.id)}
            className={`flex shrink-0 flex-col items-center gap-0.5 rounded-2xl px-3 py-2 text-[10px] font-semibold transition sm:px-4 ${
              (nwDisponivel()
                ? isJanelaFilha
                  ? moduloFixo === t.id
                  : t.id === 'projeto'
                : abaVisivel === t.id)
                ? 'bg-[#e8e8ed] text-black shadow-neu-in ring-2 ring-[#009b3a]/40'
                : 'text-neutral-600 hover:bg-[#f0f0f5] hover:text-black'
            }`}
          >
            <t.icon className="h-5 w-5 sm:h-6 sm:w-6" />
            <span className="max-w-[4.5rem] truncate sm:max-w-none">{t.label}</span>
          </button>
        ))}
      </div>
    </nav>

    <ColarExcelRelatorioModal
      aberto={modalColarExcelAberto}
      onFechar={() => setModalColarExcelAberto(false)}
      onImportar={importarLinhasColadasExcel}
      proximoCorteNumero={relatorioItens.length + 1}
    />
  </div>
);
} // Fecha a function CalculadoraCorte

